'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chatSdkJavascript = require('@cometchat/chat-sdk-javascript');
var rxjs = require('rxjs');

class CometChatUIKitConstants {
}
CometChatUIKitConstants.MessageCategory = Object.freeze({
    message: chatSdkJavascript.CometChat.CATEGORY_MESSAGE,
    custom: chatSdkJavascript.CometChat.CATEGORY_CUSTOM,
    action: chatSdkJavascript.CometChat.CATEGORY_ACTION,
    call: chatSdkJavascript.CometChat.CATEGORY_CALL,
    interactive: chatSdkJavascript.CometChat.CATEGORY_INTERACTIVE
});
CometChatUIKitConstants.MessageTypes = Object.freeze({
    text: chatSdkJavascript.CometChat.MESSAGE_TYPE.TEXT,
    file: chatSdkJavascript.CometChat.MESSAGE_TYPE.FILE,
    image: chatSdkJavascript.CometChat.MESSAGE_TYPE.IMAGE,
    audio: chatSdkJavascript.CometChat.MESSAGE_TYPE.AUDIO,
    video: chatSdkJavascript.CometChat.MESSAGE_TYPE.VIDEO,
    delete: "delete",
    edited: "edited",
    groupMember: "groupMember",
    form: "form",
    card: "card",
    customInteractive: "customInteractive"
});
CometChatUIKitConstants.groupMemberAction = Object.freeze({
    ROLE: "role",
    BLOCK: "block",
    REMOVE: "remove",
    JOINED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_JOINED,
    LEFT: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_LEFT,
    ADDED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_ADDED,
    BANNED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_BANNED,
    UNBANNED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_UNBANNED,
    KICKED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_KICKED,
    INVITED: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_INVITED,
    SCOPE_CHANGE: chatSdkJavascript.CometChat.ACTION_TYPE.MEMBER_SCOPE_CHANGED,
});
CometChatUIKitConstants.MessageReceiverType = Object.freeze({
    user: chatSdkJavascript.CometChat.RECEIVER_TYPE.USER,
    group: chatSdkJavascript.CometChat.RECEIVER_TYPE.GROUP,
});
CometChatUIKitConstants.userStatusType = Object.freeze({
    online: chatSdkJavascript.CometChat.USER_STATUS.ONLINE,
    offline: chatSdkJavascript.CometChat.USER_STATUS.OFFLINE,
});
CometChatUIKitConstants.MessageOption = Object.freeze({
    editMessage: "edit",
    deleteMessage: "delete",
    replyMessage: "reply",
    replyInThread: "replyInThread",
    translateMessage: "translate",
    reactToMessage: "react",
    messageInformation: "messageInformation",
    copyMessage: "copy",
    shareMessage: "share",
    forwardMessage: "forward",
    sendMessagePrivately: "sendMessagePrivately",
    replyMessagePrivately: "replyMessagePrivately",
});
CometChatUIKitConstants.GroupOptions = Object.freeze({
    leave: "leave",
    delete: "delete",
    viewMembers: "viewMembers",
    addMembers: "addMembers",
    bannedMembers: "bannedMembers",
});
CometChatUIKitConstants.GroupMemberOptions = Object.freeze({
    kick: "kick",
    ban: "ban",
    unban: "unban",
    changeScope: "changeScope",
});
CometChatUIKitConstants.groupMemberScope = Object.freeze({
    owner: "owner",
    admin: chatSdkJavascript.CometChat.GROUP_MEMBER_SCOPE.ADMIN,
    participant: chatSdkJavascript.CometChat.GROUP_MEMBER_SCOPE.PARTICIPANT,
    moderator: chatSdkJavascript.CometChat.GROUP_MEMBER_SCOPE.MODERATOR
});
CometChatUIKitConstants.UserOptions = Object.freeze({
    block: "block",
    unblock: "unblock",
    viewProfile: "viewProfile",
});
CometChatUIKitConstants.ConversationOptions = Object.freeze({
    delete: "delete"
});
CometChatUIKitConstants.GroupTypes = Object.freeze({
    private: chatSdkJavascript.CometChat.GROUP_TYPE.PRIVATE,
    password: chatSdkJavascript.CometChat.GROUP_TYPE.PASSWORD,
    public: chatSdkJavascript.CometChat.GROUP_TYPE.PUBLIC
});
CometChatUIKitConstants.liveReaction = Object.freeze({
    timeout: 1500
});
CometChatUIKitConstants.messages = Object.freeze({
    MESSAGE_DELIVERED: "onMessagesDelivered",
    MESSAGE_READ: "onMessagesRead",
    MESSAGE_DELETED: "onMessageDeleted",
    MESSAGE_EDITED: "onMessageEdited",
    MESSAGE_SENT: "messageSent",
    TEXT_MESSAGE_RECEIVED: "onTextMessageReceived",
    MEDIA_MESSAGE_RECEIVED: "onMediaMessageReceived",
    CUSTOM_MESSAGE_RECEIVED: "onCustomMessageReceived",
    TRANSIENT_MESSAGE_RECEIVED: "onTransientMessageReceived",
    INTERACTIVE_MESSAGE_RECEIVED: "onInteractiveMessageReceived",
    INTERACTION_GOAL_COMPLETED: "onInteractionGoalCompleted",
    DELIVERY: "delivery",
    READ: "read",
    APP_SYSTEM: "app_system"
});
CometChatUIKitConstants.details = Object.freeze({
    primary: "primary",
    secondary: "secondary"
});
CometChatUIKitConstants.calls = Object.freeze({
    meeting: "meeting",
    ongoing: chatSdkJavascript.CometChat.CALL_STATUS.ONGOING,
    ended: chatSdkJavascript.CometChat.CALL_STATUS.ENDED,
    initiated: chatSdkJavascript.CometChat.CALL_STATUS.INITIATED,
    cancelled: chatSdkJavascript.CometChat.CALL_STATUS.CANCELLED,
    rejected: chatSdkJavascript.CometChat.CALL_STATUS.REJECTED,
    unanswered: chatSdkJavascript.CometChat.CALL_STATUS.UNANSWERED,
    busy: chatSdkJavascript.CometChat.CALL_STATUS.BUSY,
    activecall: "cometchat:activecall",
    default: chatSdkJavascript.CometChat.CALL_MODE.DEFAULT,
    grid: chatSdkJavascript.CometChat.CALL_MODE.GRID,
    single: chatSdkJavascript.CometChat.CALL_MODE.SINGLE,
    spotlight: chatSdkJavascript.CometChat.CALL_MODE.SPOTLIGHT,
    tile: chatSdkJavascript.CometChat.CALL_MODE.TILE,
});
CometChatUIKitConstants.goalType = Object.freeze({
    allOf: chatSdkJavascript.CometChat.GoalType.ALL_OF,
    anyOf: chatSdkJavascript.CometChat.GoalType.ANY_OF,
    anyAction: chatSdkJavascript.CometChat.GoalType.ANY_ACTION,
    none: chatSdkJavascript.CometChat.GoalType.NONE
});

var USERS$c = "المستخدمون";
var CHATS$c = "دردشات";
var GROUPS$c = "المجموعات";
var IN_A_THREAD$1 = "في موضوع";
var MORE$c = "المزيد";
var MESSAGE_IMAGE$c = "📷 صورة";
var MESSAGE_FILE$c = "📁 ملف";
var NO_USERS_SELECTED$c = "لم يتم تحديد مستخدمين";
var NO_GROUPS_SELECTED$c = "لم يتم تحديد مجموعات";
var MESSAGE_VIDEO$c = "📹 فيديو";
var SHOW_UNSAFE_CONTENT$c = "هل أنت متأكد من رغبتك في رؤية محتوى غير آمن؟";
var REACT_TO_MESSAGE$c = "رد على الرسالة";
var NO_RECIPIENT$c = "لا يوجد مستلم";
var AI$c = "منظمة العفو الدولية";
var SMART_REPLIES$c = "الردود الذكية";
var NO_REPLIES_FOUND$c = "لم يتم العثور على أي ردود";
var CONVERSATION_STARTER$c = "بداية المحادثة";
var MESSAGE$c = "رسالة";
var RECEIPT_INFORMATION$c = "معلومات الاستلام";
var NO_RECIPIENTS$c = "لا يوجد مستلمون";
var MESSAGE_AUDIO$c = "🎵 الصوت";
var READ$c = "اقرأ";
var VOICE_RECORDING$c = "التسجيل الصوتي";
var SUGGEST_A_REPLY$c = "اقترح ردًا";
var GENERATING_ICEBREAKERS$c = "توليد كاسحات الجليد";
var GENERATING_REPLIES$c = "توليد الردود";
var MESSAGE_INFORMATION$c = "معلومات الرسالة";
var CUSTOM_MESSAGE$c = "لديك رسالة";
var MISSED_VOICE_CALL$c = "مكالمة صوتية غاب";
var MISSED_VIDEO_CALL$c = "مكالمة فيديو غاب";
var CUSTOM_MESSAGE_POLL$c = "📊 استطلاع للرأي";
var CUSTOM_MESSAGE_STICKER$c = "💟 ملصق";
var CUSTOM_MESSAGE_DOCUMENT$c = "📃 وثيقة";
var CUSTOM_MESSAGE_WHITEBOARD$c = "📝 السبورة";
var ONLINE$c = "عبر الإنترنت";
var SHARED_FILE$4 = "ملف مشترك";
var TRANSFER_OWNERSHIP$c = "نقل الملكية";
var NO_CALLS_SELECTED$c = "لا يوجد مكالمات محددة";
var SELECT__USER$c = "اختر مستخدمًا لبدء المراسلة";
var CANT__LOAD__CHATS$c = "لا يمكن تحميل المحادثات";
var OUTGOING_CALL$c = "مكالمة صادرة";
var INCOMING_CALL$c = "مكالمة واردة";
var MISSED_CALL$c = "مكالمة فائتة";
var TRANSLATED_MESSAGE$c = "رسالة مترجمة";
var ANSWER$c = "الجواب";
var ADD_ANOTHER_ANSWER$c = "إضافة إجابة أخرى";
var DRAW_WHITEBOARD_TOGETHER$b = "فتح السبورة البيضاء للرسم معًا";
var OPEN_WHITEBOARD$b = "فتح السبورة البيضاء";
var DRAW_DOCUMENT_TOGETHER$b = "فتح المستند لتحرير المحتوى معًا";
var OPEN_DOCUMENT$b = "فتح المستند";
var SET_THE_ANSWERS$c = "تعيين الإجابات";
var CLICK_TO_START_CONVERSATION$c = "انقر لبدء المحادثة";
var SHARED_LOCATION$c = "الموقع المشترك";
var CALL_DETAILS$c = "تفاصيل المكالمة";
var POLLS$c = "استطلاعات";
var ADMIN$c = "لمشرف";
var ADMINISTRATOR$c = "مدير";
var SHARED$2 = "مشترك";
var SOUND_MANAGER$2 = "مدير الصوت";
var THEME$2 = "سمة";
var LOCALIZE$2 = "توطين";
var CONVERSATION_LIST_ITEM$2 = "عنصر قائمة المحادثة";
var DATA_ITEM$2 = "عنصر البيانات";
var STATUS_INDICATOR$2 = "مؤشر الحالة";
var BADGE_COUNT$2 = "عدد الشارة";
var MESSAGE_RECEIPT$2 = "إيصال الرسالة";
var CONVERSATIONS_WITH_MESSAGES$2 = "المحادثات مع الرسائل";
var CONVERSATIONS$2 = "المحادثات";
var CONVERSATION_LIST$2 = "قائمة المحادثة";
var MESSAGES$2 = "رسائل";
var MESSAGE_HEADER$2 = "رأس الرسالة";
var MESSAGE_LIST$2 = "قائمة الرسائل";
var MESSAGE_COMPOSER$2 = "مؤلف الرسالة";
var USERS_WITH_MESSAGES$2 = "المستخدمون الذين لديهم رسائل";
var USER_LIST$2 = "قائمة المستخدم";
var GROUP_LIST$2 = "قائمة المجموعة";
var GROUPS_WITH_MESSAGES$2 = "مجموعات مع الرسائل";
var NEW__GROUP$c = "مجموعة جديدة";
var PASSWORD$c = "كلمة المرور";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$c = "هل ترغب في حذف هذه المحادثة؟ سيتم حذف هذه المحادثة من جميع أجهزتك.";
var CONTINUE$c = "يكمل";
var NO_CHATS_SELECTED$c = "لم يتم تحديد الدردشات";
var SELECT__GROUP$c = "حدد مجموعة لبدء المراسلة";
var DELETE_CONVERSATION$c = "مسح المحادثة؟";
var ADD_TO_CHAT$c = "أضف إلى الدردشة";
var COPY_MESSAGE$4 = "ينسخ";
var REMOVE$5 = "يزيل";
var BLOCK$5 = "حاجز";
var CHANGE_ROLE$5 = "تغيير الدور";
var MODERATOR$c = "مدير الجلسة";
var PARTICIPANT$c = "مشارك";
var PUBLIC$c = "عامة";
var PRIVATE$c = "خاص";
var VIEW$b = "منظر";
var PASSWORD_PROTECTED$c = "محمية بكلمة مرور";
var PRIVACY_AND_SECURITY$c = "الخصوصية والأمان";
var PREFERENCES$c = "التفضيلات";
var MEMBERS$c = "الأعضاء";
var MEMBER$1 = "لأعضاء";
var TODAY$c = "اليوم";
var YESTERDAY$c = "البارحة";
var SUNDAY$c = "الأحد";
var MONDAY$c = "الإثنين";
var TUESDAY$c = "الثلاثاء";
var WEDNESDAY$c = "الأربعاء";
var THURSDAY$c = "الخميس";
var FRIDAY$c = "الجمعة";
var SATURDAY$c = "يوم السبت";
var TYPING$c = "كتابة...";
var IS_TYPING$c = "هو كتابة...";
var CLOSE$c = "إغلاق";
var ENTER_GROUP_NAME$c = "أدخل اسم المجموعة";
var ADD_MEMBERS$c = "إضافة أعضاء";
var SEND_MESSAGE$c = "ارسل رسالة";
var UNBLOCK_USER$c = "إلغاء حظر المستخدم";
var BLOCK_USER$c = "كتلة المستخدم";
var DELETE_AND_EXIT$c = "حذف وخروج";
var LEAVE_GROUP$c = "ترك المجموعة";
var CREATE_GROUP$c = "إنشاء مجموعة";
var SHARED_MEDIA$c = "وسائل الإعلام المشتركة";
var VIDEO_CALL$c = "مكالمة فيديو";
var AUDIO_CALL$c = "مكالمة صوتية";
var LOADING$c = "التحميل...";
var REPLY$c = "الرد";
var REPLIES$c = "الردود";
var LAUNCH$c = "إطلاق";
var SHARED_COLLABORATIVE_DOCUMENT$c = "وقد شارك وثيقة تعاونية";
var SHARED_COLLABORATIVE_WHITEBOARD$c = "مشاركة السبورة التعاونية";
var CREATED_WHITEBOARD$c = "لقد قمت بإنشاء لوحة بيضاء تعاونية جديدة";
var CREATED_DOCUMENT$c = "لقد قمت بإنشاء مستند تعاوني جديد";
var PHOTOS$c = "صور";
var VIDEOS$c = "فيديوهات";
var DOCUMENT$c = "مستند";
var YOU_DELETED_THIS_MESSAGE$c = "⚠️ قمت بحذف هذه الرسالة";
var THIS_MESSAGE_DELETED$c = "⚠️ تم حذف هذه الرسالة";
var MESSAGE_IS_DELETED$c = "تم حذف الرسالة";
var VIEW_ON_YOUTUBE$c = "عرض على يوتيوب";
var SEARCH$c = "البحث";
var NO_USERS_FOUND$c = "لم يتم العثور على المستخدمين";
var ERROR$c = "خطأ";
var NO_GROUPS_FOUND$c = "لم يتم العثور على مجموعات";
var NO_CHATS_FOUND$c = "لم يتم العثور على دردشات";
var MEDIA_MESSAGE$c = "رسالة إعلامية";
var INCOMING_AUDIO_CALL$c = "مكالمة صوتية واردة";
var INCOMING_VIDEO_CALL$c = "مكالمة فيديو واردة";
var DECLINE$c = "انخفاض";
var ACCEPT$c = "قبول";
var CALL_INITIATED$c = "بدأ الاتصال";
var OUTGOING_AUDIO_CALL$c = "مكالمة صوتية صادرة";
var OUTGOING_VIDEO_CALL$c = "مكالمة فيديو صادرة";
var CALL_REJECTED$c = "تم رفض المكالمة";
var REJECTED_CALL$c = "مكالمة مرفوضة";
var CALL_ACCEPTED$c = "تم قبول المكالمة";
var JOINED$c = "انضم";
var LEFT_THE_CALL$c = "ترك المكالمة";
var UNANSWERED_AUDIO_CALL$c = "مكالمة صوتية لم تتم الإجابة عليها";
var UNANSWERED_VIDEO_CALL$c = "مكالمة فيديو لم تتم الإجابة عليها";
var CALL_ENDED$c = "انتهت المكالمة";
var CALL_CANCELLED$c = "تم إلغاء المكالمة";
var CALL_BUSY$c = "استدعاء مشغول";
var CALLING$c = "الدعوة...";
var ADD$c = "إضافة";
var NO_BANNED_MEMBERS_FOUND$c = "لم يتم العثور على أعضاء محظورين";
var BANNED_MEMBERS$c = "الأعضاء المحظورين";
var NAME$c = "اسم";
var SCOPE$c = "النطاق";
var UNBAN$c = "نبان";
var SELECT_GROUP_TYPE$c = "تحديد نوع المجموعة";
var ENTER_GROUP_PASSWORD$c = "أدخل كلمة مرور المجموعة";
var CREATE$c = "إنشاء";
var CREATE_POLL$c = "إنشاء استطلاع للرأي";
var QUESTION$c = "سؤال";
var ENTER_YOUR_QUESTION$c = "أدخل سؤالك";
var OPTIONS$c = "خيارات";
var ENTER_YOUR_OPTION$c = "أدخل الخيار الخاص بك";
var ADD_NEW_OPTION$c = "إضافة خيار جديد";
var VIEW_MEMBERS$c = "عرض الأعضاء";
var DETAILS$c = "تفاصيل";
var NOTIFICATIONS$c = "الإشعارات";
var OTHER$c = "أخرى";
var HELP$c = "مساعدة";
var REPORT_PROBLEM$c = "الإبلاغ عن مشكلة";
var GROUP_MEMBERS$c = "أعضاء المجموعة";
var BAN$c = "بان";
var KICK$c = "ركلة";
var PICK_YOUR_EMOJI$c = "اختيار الرموز التعبيرية الخاصة بك";
var PRIVATE_GROUP$c = "مجموعة خاصة";
var PROTECTED_GROUP$c = "المجموعة المحمية";
var VISIT$c = "زيارة";
var ATTACH$c = "إرفاق";
var ATTACH_FILE$c = "إرفاق ملف";
var ATTACH_VIDEO$c = "إرفاق الفيديو";
var ATTACH_AUDIO$c = "إرفاق الصوت";
var ATTACH_IMAGE$c = "إرفاق صورة";
var COLLABORATE_USING_DOCUMENT$c = "التعاون باستخدام مستند";
var COLLABORATE_USING_WHITEBOARD$c = "التعاون باستخدام لوح معلومات";
var EMOJI$c = "رمز تعبيري";
var ENTER_YOUR_MESSAGE_HERE$c = "أدخل رسالتك هنا";
var NO_MESSAGES_FOUND$c = "لم يتم العثور على رسائل";
var THREAD$c = "الموضوع";
var COLLABORATIVE_DOCUMENT$c = "وثيقة تعاونية";
var COLLABORATIVE_WHITEBOARD$c = "السبورة التعاونية";
var ADD_REACTION$c = "إضافة رد فعل";
var NO_STICKERS_FOUND$c = "لم يتم العثور على ملصقات";
var REPLY_TO_THREAD$c = "الرد على موضوع";
var REPLY_IN_THREAD$c = "الرد في موضوع";
var DELETE_MESSAGE$c = "حذف الرسالة";
var EDIT_MESSAGE$c = "تحرير الرسالة";
var OWNER$c = "مالك";
var CHANGE_SCOPE$c = "تغيير النطاق";
var STICKER$c = "ملصق";
var LAST_ACTIVE_AT$c = "آخر نشط في";
var VOICE_CALL$c = "مكالمة صوتية";
var VIEW_DETAIL$c = "عرض التفاصيل";
var VOTES$c = "التصويت";
var VOTE$c = "تصويت";
var NO_VOTE$c = "لا تصويت";
var REACTED$c = "رد فعل";
var ADDED$c = "أضاف";
var UNBANNED$c = "غير محظور";
var MADE$c = "صنع";
var CALL_UNANSWERED$c = "اتصل دون إجابة";
var MISSED_AUDIO_CALL$c = "مكالمة صوتية فائتة";
var ENTER_YOUR_PASSWORD$c = "أدخل كلمة المرور";
var DOCS$c = "مستندات";
var NO_RECORDS_FOUND$c = "لم يتم العثور على سجلات";
var LIVE_REACTION$c = "رد فعل حي";
var SMILEY_PEOPLE$c = "الوجوه الضاحكة والناس";
var ANIMALES_NATURE$c = "الحيوانات والطبيعة";
var FOOD_DRINK$c = "الطعام والشراب";
var ACTIVITY$c = "النشاط";
var TRAVEL_PLACES$c = "السفر والأماكن";
var OBJECTS$c = "كائنات";
var SYMBOLS$c = "الرموز";
var FLAGS$c = "أعلام";
var SENT$c = "أرسلت";
var SEEN$c = "شاهد";
var DELIVERED$c = "سلمت";
var TRANSLATE_MESSAGE$c = "ترجمة الرسالة";
var LEFT$c = "يسار";
var KICKED$c = "ركل";
var BANNED$c = "محظور";
var NEW_MESSAGES$c = "رسائل جديدة";
var NEW_MESSAGE$c = "رسالة جديدة";
var JUMP$c = "القفز";
var SELECT_VIDEO_SOURCE$c = "حدد مصدر الفيديو";
var SELECT_INPUT_AUDIO_SOURCE$c = "حدد مصدر صوت الإدخال";
var SELECT_OUTPUT_AUDIO_SOURCE$c = "حدد مصدر الصوت الناتج";
var INITIATED_GROUP_CALL$c = "بدأت مكالمة جماعية";
var YOU_INITIATED_GROUP_CALL$c = "لقد بدأت مكالمة جماعية";
var IGNORE$c = "تجاهل";
var ON_ANOTHER_CALL$c = "هو على مكالمة أخرى";
var CREATING$c = "خلق";
var AVATAR$c = "أفاتار";
var GROUP_NAME_BLANK$c = "اسم المجموعة لا يمكن أن تكون فارغة";
var GROUP_TYPE_BLANK$c = "نوع المجموعة لا يمكن أن تكون فارغة";
var GROUP_PASSWORD_BLANK$c = "كلمة مرور المجموعة لا يمكن أن تكون فارغة";
var POLL_QUESTION_BLANK$b = "السؤال لا يمكن أن تكون فارغة";
var POLL_OPTION_BLANK$b = "الخيار لا يمكن أن تكون فارغة";
var ONGOING_CALL$c = "مكالمة مستمرة";
var YOU_ALREADY_ONGOING_CALL$c = "أنت بالفعل في مكالمة مستمرة";
var RESIZE$c = "تغيير حجم";
var SETTINGS$c = "الإعدادات";
var ACTIONS$c = "الإجراءات";
var VIEW_PROFILE$c = "عرض الملف الشخصي";
var SEND_MESSAGE_IN_PRIVATE$c = "إرسال رسالة خاصة";
var DELETE$c = "حذف";
var DELETE_CONFIRM$c = "هل تريد بالتأكيد الحذف؟";
var CANCEL$c = "إلغاء";
var LEAVE_CONFIRM$c = "هل أنت متأكد أنك تريد مغادرة المجموعة؟";
var TRANSFER_CONFIRM$c = "أنت مالك المجموعة، يرجى نقل الملكية إلى عضو قبل مغادرة المجموعة";
var ADDING$c = "إضافة...";
var TRANSFER$c = "نقل";
var TRANSFERRING$c = "نقل";
var YES$c = "نعم";
var NO$c = "لا";
var SOMETHING_WRONG$c = "حدث خطأ ما، يرجى المحاولة مرة أخرى";
var INVALID_GROUP_NAME$c = "الرجاء إدخال اسم صالح للمجموعة والمحاولة مرة أخرى";
var INVALID_GROUP_TYPE$c = "الرجاء إدخال نوع صالح للمجموعة والمحاولة مرة أخرى";
var INVALID_PASSWORD$c = "الرجاء إدخال كلمة مرور صالحة للمجموعة والمحاولة مرة أخرى";
var WRONG_PASSWORD$c = "الرجاء إدخال كلمة المرور الصحيحة والمحاولة مرة أخرى";
var INVALID_POLL_QUESTION$c = "الرجاء إدخال السؤال المطلوب قبل إنشاء استطلاع للرأي";
var INVALID_POLL_OPTION$c = "الرجاء إدخال الإجابة المطلوبة قبل إنشاء استطلاع للرأي";
var SAME_LANGUAGE_MESSAGE$c = "لغة محددة للترجمة مشابهة للغة الرسالة الأصلية";
var LEAVE$c = "اترك";
var CALLS$c = "المكالمات";
var CUSTOM_MESSAGE_LOCATION$c = "📍 الموقع";
var OFFLINE$c = "غير متصل";
var YOU$c = "أنت";
var PRIVACY$c = "الخصوصية";
var BLOCKED_USERS$c = "المستخدمون المحظورون";
var NO_PHOTOS$c = "لا توجد صور";
var NO_VIDEOS$c = "لا توجد فيديوهات";
var NO_DOCUMENTS$c = "لا توجد وثائق";
var JOIN$c = "انضم";
var NEW_CHAT$c = "دردشة جديدة";
var FORM_COMPLETION_MESSAGE$c = "شكرًا لك على ملء النموذج.";
var FORM$c = "نموذج";
var CARD$c = "بطاقة";
var HISTORY$b = "التاريخ";
var CANCELLED_AUDIO_CALL$c = "مكالمة صوتية ملغاة";
var CANCELLED_VIDEO_CALL$c = "مكالمة فيديو ملغاة";
var REJECTED_AUDIO_CALL$c = "مكالمة صوتية مرفوضة";
var REJECTED_VIDEO_CALL$c = "مكالمة فيديو مرفوضة";
var CANCELLED_CALL$c = "مكالمة ملغاة";
var UNANSWERED_CALL$c = "مكالمة لم يتم الرد عليها";
var RECORDING$c = "التسجيل";
var PARTICIPANTS$c = "مشاركون";
var CALL_HISTORY$c = "سجل المكالمات";
var NO_CALLS_FOUND$c = "لم يتم العثور على مكالمات";
var ONGOING_AUDIO_CALL$c = "مكالمة صوتية مستمرة";
var ONGOING_VIDEO_CALL$c = "مكالمة فيديو مستمرة";
var CALL_DETAIL$c = "تفاصيل المكالمة";
var GENERATING_SUMMARY$c = "ملخص التوليد";
var CONVERSATION_SUMMARY$c = "ملخص المحادثة";
var GENERATE_SUMMARY$c = "قم بإنشاء ملخص";
var COMETCHAT_BOT_FIRST_MESSAGE$c = "كيف يمكنني مساعدتك في هذه المحادثة؟ من فضلك اسألني سؤالاً وسأنصحك 🙂";
var COMETCHAT_ASK_BOT$c = "اسأل";
var COMETCHAT_ASK_AI_BOT$c = "اسأل روبوتات الذكاء الاصطناعي";
var COMETCHAT_ASK_BOT_SUBTITLE$c = "بوت الذكاء الاصطناعي";
var translationAR = {
	USERS: USERS$c,
	CHATS: CHATS$c,
	GROUPS: GROUPS$c,
	IN_A_THREAD: IN_A_THREAD$1,
	MORE: MORE$c,
	MESSAGE_IMAGE: MESSAGE_IMAGE$c,
	MESSAGE_FILE: MESSAGE_FILE$c,
	NO_USERS_SELECTED: NO_USERS_SELECTED$c,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$c,
	MESSAGE_VIDEO: MESSAGE_VIDEO$c,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$c,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$c,
	NO_RECIPIENT: NO_RECIPIENT$c,
	AI: AI$c,
	SMART_REPLIES: SMART_REPLIES$c,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$c,
	CONVERSATION_STARTER: CONVERSATION_STARTER$c,
	MESSAGE: MESSAGE$c,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$c,
	NO_RECIPIENTS: NO_RECIPIENTS$c,
	MESSAGE_AUDIO: MESSAGE_AUDIO$c,
	READ: READ$c,
	VOICE_RECORDING: VOICE_RECORDING$c,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$c,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$c,
	GENERATING_REPLIES: GENERATING_REPLIES$c,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$c,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$c,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$c,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$c,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$c,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$c,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$c,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$c,
	ONLINE: ONLINE$c,
	SHARED_FILE: SHARED_FILE$4,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$c,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$c,
	SELECT__USER: SELECT__USER$c,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$c,
	OUTGOING_CALL: OUTGOING_CALL$c,
	INCOMING_CALL: INCOMING_CALL$c,
	MISSED_CALL: MISSED_CALL$c,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$c,
	ANSWER: ANSWER$c,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$c,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$b,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$b,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$b,
	OPEN_DOCUMENT: OPEN_DOCUMENT$b,
	SET_THE_ANSWERS: SET_THE_ANSWERS$c,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$c,
	SHARED_LOCATION: SHARED_LOCATION$c,
	CALL_DETAILS: CALL_DETAILS$c,
	POLLS: POLLS$c,
	ADMIN: ADMIN$c,
	ADMINISTRATOR: ADMINISTRATOR$c,
	SHARED: SHARED$2,
	SOUND_MANAGER: SOUND_MANAGER$2,
	THEME: THEME$2,
	LOCALIZE: LOCALIZE$2,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$2,
	DATA_ITEM: DATA_ITEM$2,
	STATUS_INDICATOR: STATUS_INDICATOR$2,
	BADGE_COUNT: BADGE_COUNT$2,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$2,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$2,
	CONVERSATIONS: CONVERSATIONS$2,
	CONVERSATION_LIST: CONVERSATION_LIST$2,
	MESSAGES: MESSAGES$2,
	MESSAGE_HEADER: MESSAGE_HEADER$2,
	MESSAGE_LIST: MESSAGE_LIST$2,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$2,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$2,
	USER_LIST: USER_LIST$2,
	GROUP_LIST: GROUP_LIST$2,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$2,
	NEW__GROUP: NEW__GROUP$c,
	PASSWORD: PASSWORD$c,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$c,
	CONTINUE: CONTINUE$c,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$c,
	SELECT__GROUP: SELECT__GROUP$c,
	DELETE_CONVERSATION: DELETE_CONVERSATION$c,
	ADD_TO_CHAT: ADD_TO_CHAT$c,
	COPY_MESSAGE: COPY_MESSAGE$4,
	REMOVE: REMOVE$5,
	BLOCK: BLOCK$5,
	CHANGE_ROLE: CHANGE_ROLE$5,
	MODERATOR: MODERATOR$c,
	PARTICIPANT: PARTICIPANT$c,
	PUBLIC: PUBLIC$c,
	PRIVATE: PRIVATE$c,
	VIEW: VIEW$b,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$c,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$c,
	PREFERENCES: PREFERENCES$c,
	MEMBERS: MEMBERS$c,
	MEMBER: MEMBER$1,
	TODAY: TODAY$c,
	YESTERDAY: YESTERDAY$c,
	SUNDAY: SUNDAY$c,
	MONDAY: MONDAY$c,
	TUESDAY: TUESDAY$c,
	WEDNESDAY: WEDNESDAY$c,
	THURSDAY: THURSDAY$c,
	FRIDAY: FRIDAY$c,
	SATURDAY: SATURDAY$c,
	TYPING: TYPING$c,
	IS_TYPING: IS_TYPING$c,
	CLOSE: CLOSE$c,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$c,
	ADD_MEMBERS: ADD_MEMBERS$c,
	SEND_MESSAGE: SEND_MESSAGE$c,
	UNBLOCK_USER: UNBLOCK_USER$c,
	BLOCK_USER: BLOCK_USER$c,
	DELETE_AND_EXIT: DELETE_AND_EXIT$c,
	LEAVE_GROUP: LEAVE_GROUP$c,
	CREATE_GROUP: CREATE_GROUP$c,
	SHARED_MEDIA: SHARED_MEDIA$c,
	VIDEO_CALL: VIDEO_CALL$c,
	AUDIO_CALL: AUDIO_CALL$c,
	LOADING: LOADING$c,
	REPLY: REPLY$c,
	REPLIES: REPLIES$c,
	LAUNCH: LAUNCH$c,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$c,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$c,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$c,
	CREATED_DOCUMENT: CREATED_DOCUMENT$c,
	PHOTOS: PHOTOS$c,
	VIDEOS: VIDEOS$c,
	DOCUMENT: DOCUMENT$c,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$c,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$c,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$c,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$c,
	SEARCH: SEARCH$c,
	NO_USERS_FOUND: NO_USERS_FOUND$c,
	ERROR: ERROR$c,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$c,
	NO_CHATS_FOUND: NO_CHATS_FOUND$c,
	MEDIA_MESSAGE: MEDIA_MESSAGE$c,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$c,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$c,
	DECLINE: DECLINE$c,
	ACCEPT: ACCEPT$c,
	CALL_INITIATED: CALL_INITIATED$c,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$c,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$c,
	CALL_REJECTED: CALL_REJECTED$c,
	REJECTED_CALL: REJECTED_CALL$c,
	CALL_ACCEPTED: CALL_ACCEPTED$c,
	JOINED: JOINED$c,
	LEFT_THE_CALL: LEFT_THE_CALL$c,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$c,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$c,
	CALL_ENDED: CALL_ENDED$c,
	CALL_CANCELLED: CALL_CANCELLED$c,
	CALL_BUSY: CALL_BUSY$c,
	CALLING: CALLING$c,
	ADD: ADD$c,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$c,
	BANNED_MEMBERS: BANNED_MEMBERS$c,
	NAME: NAME$c,
	SCOPE: SCOPE$c,
	UNBAN: UNBAN$c,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$c,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$c,
	CREATE: CREATE$c,
	CREATE_POLL: CREATE_POLL$c,
	QUESTION: QUESTION$c,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$c,
	OPTIONS: OPTIONS$c,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$c,
	ADD_NEW_OPTION: ADD_NEW_OPTION$c,
	VIEW_MEMBERS: VIEW_MEMBERS$c,
	DETAILS: DETAILS$c,
	NOTIFICATIONS: NOTIFICATIONS$c,
	OTHER: OTHER$c,
	HELP: HELP$c,
	REPORT_PROBLEM: REPORT_PROBLEM$c,
	GROUP_MEMBERS: GROUP_MEMBERS$c,
	BAN: BAN$c,
	KICK: KICK$c,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$c,
	PRIVATE_GROUP: PRIVATE_GROUP$c,
	PROTECTED_GROUP: PROTECTED_GROUP$c,
	VISIT: VISIT$c,
	ATTACH: ATTACH$c,
	ATTACH_FILE: ATTACH_FILE$c,
	ATTACH_VIDEO: ATTACH_VIDEO$c,
	ATTACH_AUDIO: ATTACH_AUDIO$c,
	ATTACH_IMAGE: ATTACH_IMAGE$c,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$c,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$c,
	EMOJI: EMOJI$c,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$c,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$c,
	THREAD: THREAD$c,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$c,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$c,
	ADD_REACTION: ADD_REACTION$c,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$c,
	REPLY_TO_THREAD: REPLY_TO_THREAD$c,
	REPLY_IN_THREAD: REPLY_IN_THREAD$c,
	DELETE_MESSAGE: DELETE_MESSAGE$c,
	EDIT_MESSAGE: EDIT_MESSAGE$c,
	OWNER: OWNER$c,
	CHANGE_SCOPE: CHANGE_SCOPE$c,
	STICKER: STICKER$c,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$c,
	VOICE_CALL: VOICE_CALL$c,
	VIEW_DETAIL: VIEW_DETAIL$c,
	VOTES: VOTES$c,
	VOTE: VOTE$c,
	NO_VOTE: NO_VOTE$c,
	REACTED: REACTED$c,
	ADDED: ADDED$c,
	UNBANNED: UNBANNED$c,
	MADE: MADE$c,
	CALL_UNANSWERED: CALL_UNANSWERED$c,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$c,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$c,
	DOCS: DOCS$c,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$c,
	LIVE_REACTION: LIVE_REACTION$c,
	SMILEY_PEOPLE: SMILEY_PEOPLE$c,
	ANIMALES_NATURE: ANIMALES_NATURE$c,
	FOOD_DRINK: FOOD_DRINK$c,
	ACTIVITY: ACTIVITY$c,
	TRAVEL_PLACES: TRAVEL_PLACES$c,
	OBJECTS: OBJECTS$c,
	SYMBOLS: SYMBOLS$c,
	FLAGS: FLAGS$c,
	SENT: SENT$c,
	SEEN: SEEN$c,
	DELIVERED: DELIVERED$c,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$c,
	LEFT: LEFT$c,
	KICKED: KICKED$c,
	BANNED: BANNED$c,
	NEW_MESSAGES: NEW_MESSAGES$c,
	NEW_MESSAGE: NEW_MESSAGE$c,
	JUMP: JUMP$c,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$c,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$c,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$c,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$c,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$c,
	IGNORE: IGNORE$c,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$c,
	CREATING: CREATING$c,
	AVATAR: AVATAR$c,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$c,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$c,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$c,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$b,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$b,
	ONGOING_CALL: ONGOING_CALL$c,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$c,
	RESIZE: RESIZE$c,
	SETTINGS: SETTINGS$c,
	ACTIONS: ACTIONS$c,
	VIEW_PROFILE: VIEW_PROFILE$c,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$c,
	DELETE: DELETE$c,
	DELETE_CONFIRM: DELETE_CONFIRM$c,
	CANCEL: CANCEL$c,
	LEAVE_CONFIRM: LEAVE_CONFIRM$c,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$c,
	ADDING: ADDING$c,
	TRANSFER: TRANSFER$c,
	TRANSFERRING: TRANSFERRING$c,
	YES: YES$c,
	NO: NO$c,
	SOMETHING_WRONG: SOMETHING_WRONG$c,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$c,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$c,
	INVALID_PASSWORD: INVALID_PASSWORD$c,
	WRONG_PASSWORD: WRONG_PASSWORD$c,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$c,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$c,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$c,
	LEAVE: LEAVE$c,
	CALLS: CALLS$c,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$c,
	OFFLINE: OFFLINE$c,
	YOU: YOU$c,
	PRIVACY: PRIVACY$c,
	BLOCKED_USERS: BLOCKED_USERS$c,
	"YOU'VE_BLOCKED": "لقد حظرت",
	NO_PHOTOS: NO_PHOTOS$c,
	NO_VIDEOS: NO_VIDEOS$c,
	NO_DOCUMENTS: NO_DOCUMENTS$c,
	JOIN: JOIN$c,
	NEW_CHAT: NEW_CHAT$c,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$c,
	FORM: FORM$c,
	CARD: CARD$c,
	HISTORY: HISTORY$b,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$c,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$c,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$c,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$c,
	CANCELLED_CALL: CANCELLED_CALL$c,
	UNANSWERED_CALL: UNANSWERED_CALL$c,
	RECORDING: RECORDING$c,
	PARTICIPANTS: PARTICIPANTS$c,
	CALL_HISTORY: CALL_HISTORY$c,
	NO_CALLS_FOUND: NO_CALLS_FOUND$c,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$c,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$c,
	CALL_DETAIL: CALL_DETAIL$c,
	GENERATING_SUMMARY: GENERATING_SUMMARY$c,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$c,
	GENERATE_SUMMARY: GENERATE_SUMMARY$c,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$c,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$c,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$c,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$c
};

var USERS$b = "Nutzer";
var CHATS$b = "Chats";
var GROUPS$b = "Gruppen";
var MORE$b = "mehr";
var NEW__GROUP$b = "Neue Gruppe";
var PASSWORD$b = "Passwort";
var CONTINUE$b = "Fortsetzen";
var READ$b = "Lesen";
var AI$b = "AI";
var SMART_REPLIES$b = "Intelligente Antworten";
var CONVERSATION_STARTER$b = "Gesprächsstarter";
var VOICE_RECORDING$b = "Sprachaufnahme";
var MESSAGE_INFORMATION$b = "Informationen zur Nachricht";
var REACT_TO_MESSAGE$b = "Auf eine Nachricht reagieren";
var MESSAGE$b = "Nachricht";
var RECEIPT_INFORMATION$b = "Informationen zur Quittung";
var NO_USERS_SELECTED$b = "Keine Benutzer ausgewählt";
var NO_GROUPS_SELECTED$b = "Keine Gruppen ausgewählt";
var SHOW_UNSAFE_CONTENT$b = "Sind Sie sicher, dass Sie unsicheren Inhalt anzeigen möchten?";
var NO_CHATS_SELECTED$b = "Keine Chats ausgewählt";
var SELECT__GROUP$b = "Wählen Sie eine Gruppe aus, um die Nachrichtenübermittlung zu starten";
var DELETE_CONVERSATION$b = "Konversation löschen?";
var NO_RECIPIENT$b = "Kein Empfänger";
var NO_RECIPIENTS$b = "Keine Empfänger";
var NO_REPLIES_FOUND$b = "Keine Antworten gefunden";
var ADD_TO_CHAT$b = "Zum Chat hinzufügen";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$b = "Möchten Sie diese Konversation löschen? Diese Konversation wird von allen Ihren Geräten gelöscht.";
var COPY_MESSAGE$3 = "Kopieren";
var MESSAGE_IMAGE$b = "📷 Bild";
var MESSAGE_FILE$b = "📁 Datei";
var MESSAGE_VIDEO$b = "📹 Video";
var MESSAGE_AUDIO$b = "🎵 Audio";
var SUGGEST_A_REPLY$b = "Schlage eine Antwort vor";
var GENERATING_ICEBREAKERS$b = "Eisbrecher erzeugen";
var GENERATING_REPLIES$b = "Antworten generieren";
var DRAW_WHITEBOARD_TOGETHER$a = "Whiteboard zum gemeinsamen Zeichnen öffnen";
var OPEN_WHITEBOARD$a = "Whiteboard öffnen";
var DRAW_DOCUMENT_TOGETHER$a = "Dokument zum gemeinsamen Bearbeiten des Inhalts öffnen";
var CUSTOM_MESSAGE$b = "Du hast eine Nachricht";
var MISSED_VOICE_CALL$b = "Sprachanruf verpasst";
var NO_CALLS_SELECTED$b = "Keine Anrufe ausgewählt";
var SELECT__USER$b = "Wähle einen Benutzer, um mit der Nachrichtenübermittlung zu beginnen";
var CANT__LOAD__CHATS$b = "Chats können nicht geladen werden";
var OPEN_DOCUMENT$a = "Dokument öffnen";
var OUTGOING_CALL$b = "Ausgehender Anruf";
var INCOMING_CALL$b = "Eingehender Anruf";
var ADMIN$b = "Admin";
var MISSED_CALL$b = "Verpasster Anruf";
var TRANSLATED_MESSAGE$b = "Übersetzte Nachricht";
var ANSWER$b = "Antwort";
var ADD_ANOTHER_ANSWER$b = "Weitere Antwort hinzufügen";
var SET_THE_ANSWERS$b = "Antworten festlegen";
var CLICK_TO_START_CONVERSATION$b = "Klicken Sie hier, um das Gespräch zu beginnen";
var SHARED_LOCATION$b = "Geteilte Position";
var CALL_DETAILS$b = "Anrufdetails";
var POLLS$b = "Umfragen";
var MISSED_VIDEO_CALL$b = "Videoanruf verpasst";
var CUSTOM_MESSAGE_POLL$b = "📊 Umfrage";
var TRANSFER_OWNERSHIP$b = "Eigentum übertragen";
var REMOVE$4 = "entfernen";
var BLOCK$4 = "Blockieren";
var CHANGE_ROLE$4 = "Rolle ändern";
var VIEW$a = "Sicht";
var CUSTOM_MESSAGE_STICKER$b = "💟 Aufkleber";
var CUSTOM_MESSAGE_DOCUMENT$b = "📃 Dokument";
var CUSTOM_MESSAGE_WHITEBOARD$b = "📝 Whiteboard";
var ONLINE$b = "Online";
var ADMINISTRATOR$b = "Verwalter";
var MODERATOR$b = "Moderator";
var PARTICIPANT$b = "Teilnehmerin";
var PUBLIC$b = "Öffentlich";
var PRIVATE$b = "Privat";
var PASSWORD_PROTECTED$b = "Passwort-geschützt";
var PRIVACY_AND_SECURITY$b = "Datenschutz und Sicherheit";
var PREFERENCES$b = "Präferenzen";
var MEMBERS$b = "Mitglieder";
var TODAY$b = "heute";
var YESTERDAY$b = "Gestern";
var SUNDAY$b = "Sonntag";
var MONDAY$b = "Montag";
var TUESDAY$b = "Dienstag";
var WEDNESDAY$b = "Mittwoch";
var THURSDAY$b = "Donnerstag";
var FRIDAY$b = "Freitag";
var SATURDAY$b = "samstag";
var TYPING$b = "tippen...";
var IS_TYPING$b = "tippt...";
var CLOSE$b = "schliessen";
var ENTER_GROUP_NAME$b = "Gruppennamen eingeben";
var ADD_MEMBERS$b = "Mitglieder hinzufügen";
var SEND_MESSAGE$b = "Nachricht senden";
var UNBLOCK_USER$b = "Benutzer entsperren";
var BLOCK_USER$b = "Benutzer blockieren";
var DELETE_AND_EXIT$b = "Löschen und beenden";
var LEAVE_GROUP$b = "Verlasse die Gruppe";
var CREATE_GROUP$b = "Gruppe erstellen";
var SHARED_MEDIA$b = "Geteilte Medien";
var VIDEO_CALL$b = "Videoanruf";
var AUDIO_CALL$b = "Audio-Anruf";
var LOADING$b = "Wird geladen...";
var REPLY$b = "Antwort";
var REPLIES$b = "Antworten";
var LAUNCH$b = "starten";
var SHARED_COLLABORATIVE_DOCUMENT$b = "hat ein gemeinschaftliches Dokument geteilt";
var SHARED_COLLABORATIVE_WHITEBOARD$b = "hat ein kollaboratives Whiteboard geteilt";
var CREATED_WHITEBOARD$b = "Du hast ein neues kollaboratives Whiteboard erstellt";
var CREATED_DOCUMENT$b = "Sie haben ein neues kollaboratives Dokument erstellt";
var PHOTOS$b = "Fotos";
var VIDEOS$b = "VIDEOS";
var DOCUMENT$b = "dokument";
var YOU_DELETED_THIS_MESSAGE$b = "⚠️ Du hast diese Nachricht gelöscht";
var THIS_MESSAGE_DELETED$b = "⚠️ Diese Nachricht wurde gelöscht";
var MESSAGE_IS_DELETED$b = "Nachricht ist gelöscht";
var VIEW_ON_YOUTUBE$b = "Auf Youtube ansehen";
var SEARCH$b = "Suche";
var NO_USERS_FOUND$b = "Keine Benutzer gefunden";
var ERROR$b = "Fehler";
var NO_GROUPS_FOUND$b = "Keine Gruppen gefunden";
var NO_CHATS_FOUND$b = "Keine Chats gefunden";
var MEDIA_MESSAGE$b = "Mediale Botschaft";
var INCOMING_AUDIO_CALL$b = "Eingehender Audioanruf";
var INCOMING_VIDEO_CALL$b = "Eingehender Videoanruf";
var DECLINE$b = "Rückgang";
var ACCEPT$b = "Akzeptieren";
var CALL_INITIATED$b = "Anruf initiiert";
var OUTGOING_AUDIO_CALL$b = "Ausgehender Audioanruf";
var OUTGOING_VIDEO_CALL$b = "Ausgehender Videoanruf";
var CALL_REJECTED$b = "Anruf abgelehnt";
var REJECTED_CALL$b = "Anruf abgelehnt";
var CALL_ACCEPTED$b = "Anruf akzeptiert";
var JOINED$b = "verbunden";
var LEFT_THE_CALL$b = "hat den Anruf verlassen";
var UNANSWERED_AUDIO_CALL$b = "Unbeantworteter Audioan";
var UNANSWERED_VIDEO_CALL$b = "Unbeantworteter Videoan";
var CALL_ENDED$b = "Anruf endete";
var CALL_CANCELLED$b = "Anruf wurde abgebrochen";
var CALL_BUSY$b = "Anruf beschäftigt";
var CALLING$b = "Rufen...";
var ADD$b = "Add";
var NO_BANNED_MEMBERS_FOUND$b = "Keine verbotenen Mitglieder gefunden";
var BANNED_MEMBERS$b = "Verbotene Mitglieder";
var NAME$b = "Nennen";
var SCOPE$b = "Scope";
var UNBAN$b = "Unban";
var SELECT_GROUP_TYPE$b = "Gruppentyp wählen";
var ENTER_GROUP_PASSWORD$b = "Gruppenkennwort eingeben";
var CREATE$b = "Erstellen";
var CREATE_POLL$b = "Umfrage erstellen";
var QUESTION$b = "Frage";
var ENTER_YOUR_QUESTION$b = "Gib deine Frage ein";
var OPTIONS$b = "Optionen";
var ENTER_YOUR_OPTION$b = "Geben Sie Ihre Option";
var ADD_NEW_OPTION$b = "Neue Option hinzufügen";
var VIEW_MEMBERS$b = "Mitglieder ansehen";
var DETAILS$b = "Einzelheiten";
var NOTIFICATIONS$b = "Benachrichtigungen";
var OTHER$b = "andere";
var HELP$b = "Hilfe";
var REPORT_PROBLEM$b = "Melden Sie ein Problem";
var GROUP_MEMBERS$b = "Mitglieder der Gruppe";
var BAN$b = "Ban";
var KICK$b = "Tritt";
var PICK_YOUR_EMOJI$b = "Wähle dein Emoji";
var PRIVATE_GROUP$b = "Private Gruppe";
var PROTECTED_GROUP$b = "Geschützte Gruppe";
var VISIT$b = "Besuch";
var ATTACH$b = "anhängen";
var ATTACH_FILE$b = "Datei anhängen";
var ATTACH_VIDEO$b = "Video anhängen";
var ATTACH_AUDIO$b = "Anhängen von Audio";
var ATTACH_IMAGE$b = "Bild anhängen";
var COLLABORATE_USING_DOCUMENT$b = "Zusammenarbeit mit einem Dokument";
var COLLABORATE_USING_WHITEBOARD$b = "Arbeiten Sie mit einem Whiteboard zusammen";
var EMOJI$b = "Emoji";
var ENTER_YOUR_MESSAGE_HERE$b = "Gib hier deine Nachricht ein";
var NO_MESSAGES_FOUND$b = "Keine Nachrichten gefunden";
var THREAD$b = "Gewinde";
var COLLABORATIVE_DOCUMENT$b = "Gemeinschaftliches Dokument";
var COLLABORATIVE_WHITEBOARD$b = "Kollaboratives Whiteboard";
var ADD_REACTION$b = "Reaktion hinzufügen";
var NO_STICKERS_FOUND$b = "Keine Aufkleber gefunden";
var REPLY_TO_THREAD$b = "Antwort auf Thread";
var REPLY_IN_THREAD$b = "Antwort im Thread";
var DELETE_MESSAGE$b = "Nachricht löschen";
var EDIT_MESSAGE$b = "Nachricht bearbeiten";
var OWNER$b = "Inhaber";
var CHANGE_SCOPE$b = "Umfang ändern";
var STICKER$b = "aufkleber";
var LAST_ACTIVE_AT$b = "Zuletzt aktiv bei";
var VOICE_CALL$b = "Sprach-Anruf";
var VIEW_DETAIL$b = "Details anzeigen";
var VOTES$b = "Wahlen";
var VOTE$b = "Abstimmung";
var NO_VOTE$b = "Keine Abstimmung";
var REACTED$b = "reagiert";
var ADDED$b = "hinzugefügt";
var UNBANNED$b = "unverbannt";
var MADE$b = "hergestellt";
var CALL_UNANSWERED$b = "Anruf unbeantwortet";
var MISSED_AUDIO_CALL$b = "Audioanruf verpasst";
var ENTER_YOUR_PASSWORD$b = "Geben Sie Ihr Passwort ein";
var DOCS$b = "docs";
var NO_RECORDS_FOUND$b = "Keine Aufzeichnungen gefunden";
var LIVE_REACTION$b = "Live-Reaktion";
var SMILEY_PEOPLE$b = "Smileys & Leute";
var ANIMALES_NATURE$b = "Tiere & Natur";
var FOOD_DRINK$b = "Essen & Trinken";
var ACTIVITY$b = "Die Aktivität";
var TRAVEL_PLACES$b = "Reisen & Orte";
var OBJECTS$b = "objekte";
var SYMBOLS$b = "Die Symbole";
var FLAGS$b = "Flaggen";
var SENT$b = "Gesendet";
var SEEN$b = "Gesehen";
var DELIVERED$b = "Ausgeliefert";
var TRANSLATE_MESSAGE$b = "Nachricht übersetzen";
var LEFT$b = "links";
var KICKED$b = "getreten";
var BANNED$b = "unerlaubt";
var NEW_MESSAGES$b = "neue Nachrichten";
var NEW_MESSAGE$b = "neue Nachricht";
var JUMP$b = "springen";
var SELECT_VIDEO_SOURCE$b = "Wählen Sie Videoquelle";
var SELECT_INPUT_AUDIO_SOURCE$b = "Wählen Sie die Audioquelle";
var SELECT_OUTPUT_AUDIO_SOURCE$b = "Wählen Sie die Ausgangs-Audioquelle";
var INITIATED_GROUP_CALL$b = "hat einen Gruppenanruf initiiert";
var YOU_INITIATED_GROUP_CALL$b = "Du hast einen Gruppenanruf initiiert";
var IGNORE$b = "ignorieren";
var ON_ANOTHER_CALL$b = "ist in einem anderen Anruf";
var CREATING$b = "Erstellen";
var AVATAR$b = "Avatar";
var GROUP_NAME_BLANK$b = "Gruppenname ist nicht leer";
var GROUP_TYPE_BLANK$b = "Gruppentyp ist nicht leer";
var GROUP_PASSWORD_BLANK$b = "Gruppenkennwort darf nicht leer sein";
var POLL_QUESTION_BLANK$a = "Frage wird nicht leer sein";
var POLL_OPTION_BLANK$a = "Option kannte nicht leer sein";
var ONGOING_CALL$b = "Laufender Aufruf";
var YOU_ALREADY_ONGOING_CALL$b = "Sie befinden sich bereits in einem laufenden Anruf";
var RESIZE$b = "Größe ändern";
var SETTINGS$b = "Einstellungen";
var ACTIONS$b = "Aktionen";
var VIEW_PROFILE$b = "Profil ansehen";
var SEND_MESSAGE_IN_PRIVATE$b = "Nachricht privat senden";
var DELETE$b = "löschen";
var DELETE_CONFIRM$b = "Bist du sicher, dass du löschen möchtest?";
var CANCEL$b = "Abbrechen";
var LEAVE_CONFIRM$b = "Bist du sicher, dass du die Gruppe verlassen willst?";
var TRANSFER_CONFIRM$b = "Sie sind der Gruppeninhaber, bitte übertragen Sie das Eigentum an ein Mitglied, bevor Sie die Gruppe verlassen";
var ADDING$b = "Hinzufügen...";
var TRANSFER$b = "Übertragen";
var TRANSFERRING$b = "Übertragen";
var YES$b = "ja";
var NO$b = "Nein";
var SOMETHING_WRONG$b = "Etwas ist schief gelaufen, bitte versuche es noch einmal";
var INVALID_GROUP_NAME$b = "Bitte geben Sie einen gültigen Namen für die Gruppe ein und versuchen Sie es erneut";
var INVALID_GROUP_TYPE$b = "Bitte geben Sie einen gültigen Typ für die Gruppe ein und versuchen Sie es erneut";
var INVALID_PASSWORD$b = "Bitte geben Sie ein gültiges Passwort für die Gruppe ein und versuchen Sie es erneut";
var WRONG_PASSWORD$b = "Bitte geben Sie das richtige Passwort ein und versuchen Sie es erneut";
var INVALID_POLL_QUESTION$b = "Bitte geben Sie die gewünschte Frage ein, bevor Sie eine Umfrage erstellen";
var INVALID_POLL_OPTION$b = "Bitte geben Sie die erforderliche Antwort ein, bevor Sie eine Umfrage erstellen";
var SAME_LANGUAGE_MESSAGE$b = "Die ausgewählte Sprache für die Übersetzung ähnelt der Sprache der Originalnachricht";
var LEAVE$b = "Verlassen";
var CALLS$b = "Anrufe";
var CUSTOM_MESSAGE_LOCATION$b = "📍 Standort";
var OFFLINE$b = "Offline";
var YOU$b = "Du";
var PRIVACY$b = "Datenschutz";
var BLOCKED_USERS$b = "Gesperrte";
var NO_PHOTOS$b = "Keine Fotos";
var NO_VIDEOS$b = "Keine Videos";
var NO_DOCUMENTS$b = "Keine Dokumente";
var JOIN$b = "Beitreten";
var NEW_CHAT$b = "Neuer Chat";
var FORM_COMPLETION_MESSAGE$b = "Vielen Dank für das Ausfüllen des Formulars.";
var FORM$b = "Formular";
var CANCELLED_AUDIO_CALL$b = "Abgebrochener Audioanruf";
var CANCELLED_VIDEO_CALL$b = "Videoanruf abgesagt";
var REJECTED_AUDIO_CALL$b = "Abgelehnter Audioanruf";
var REJECTED_VIDEO_CALL$b = "Abgelehnter Videoanruf";
var CANCELLED_CALL$b = "Anruf abgesagt";
var UNANSWERED_CALL$b = "Unbeantworteter Anruf";
var RECORDING$b = "Aufnahme";
var PARTICIPANTS$b = "Teilnehmer";
var CALL_HISTORY$b = "Anrufliste";
var NO_CALLS_FOUND$b = "Keine Anrufe gefunden";
var ONGOING_AUDIO_CALL$b = "Laufender Audioanruf";
var ONGOING_VIDEO_CALL$b = "Laufender Videoanruf";
var CALL_DETAIL$b = "Detail des Anrufs";
var CARD$b = "Karte";
var GENERATING_SUMMARY$b = "Zusammenfassung wird generiert";
var CONVERSATION_SUMMARY$b = "Zusammenfassung der Konversation";
var GENERATE_SUMMARY$b = "Generieren Sie eine Zusammenfassung";
var COMETCHAT_BOT_FIRST_MESSAGE$b = "Wie kann ich dir bei diesem Gespräch helfen? Bitte stell mir eine Frage und ich berate dich 🙂";
var COMETCHAT_ASK_BOT$b = "Frag";
var COMETCHAT_ASK_AI_BOT$b = "Fragen Sie KI-Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$b = "KI-Bot";
var translationDE = {
	USERS: USERS$b,
	CHATS: CHATS$b,
	GROUPS: GROUPS$b,
	MORE: MORE$b,
	NEW__GROUP: NEW__GROUP$b,
	PASSWORD: PASSWORD$b,
	CONTINUE: CONTINUE$b,
	READ: READ$b,
	AI: AI$b,
	SMART_REPLIES: SMART_REPLIES$b,
	CONVERSATION_STARTER: CONVERSATION_STARTER$b,
	VOICE_RECORDING: VOICE_RECORDING$b,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$b,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$b,
	MESSAGE: MESSAGE$b,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$b,
	NO_USERS_SELECTED: NO_USERS_SELECTED$b,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$b,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$b,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$b,
	SELECT__GROUP: SELECT__GROUP$b,
	DELETE_CONVERSATION: DELETE_CONVERSATION$b,
	NO_RECIPIENT: NO_RECIPIENT$b,
	NO_RECIPIENTS: NO_RECIPIENTS$b,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$b,
	ADD_TO_CHAT: ADD_TO_CHAT$b,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$b,
	COPY_MESSAGE: COPY_MESSAGE$3,
	MESSAGE_IMAGE: MESSAGE_IMAGE$b,
	MESSAGE_FILE: MESSAGE_FILE$b,
	MESSAGE_VIDEO: MESSAGE_VIDEO$b,
	MESSAGE_AUDIO: MESSAGE_AUDIO$b,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$b,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$b,
	GENERATING_REPLIES: GENERATING_REPLIES$b,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$a,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$a,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$a,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$b,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$b,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$b,
	SELECT__USER: SELECT__USER$b,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$b,
	OPEN_DOCUMENT: OPEN_DOCUMENT$a,
	OUTGOING_CALL: OUTGOING_CALL$b,
	INCOMING_CALL: INCOMING_CALL$b,
	ADMIN: ADMIN$b,
	MISSED_CALL: MISSED_CALL$b,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$b,
	ANSWER: ANSWER$b,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$b,
	SET_THE_ANSWERS: SET_THE_ANSWERS$b,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$b,
	SHARED_LOCATION: SHARED_LOCATION$b,
	CALL_DETAILS: CALL_DETAILS$b,
	POLLS: POLLS$b,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$b,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$b,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$b,
	REMOVE: REMOVE$4,
	BLOCK: BLOCK$4,
	CHANGE_ROLE: CHANGE_ROLE$4,
	VIEW: VIEW$a,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$b,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$b,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$b,
	ONLINE: ONLINE$b,
	ADMINISTRATOR: ADMINISTRATOR$b,
	MODERATOR: MODERATOR$b,
	PARTICIPANT: PARTICIPANT$b,
	PUBLIC: PUBLIC$b,
	PRIVATE: PRIVATE$b,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$b,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$b,
	PREFERENCES: PREFERENCES$b,
	MEMBERS: MEMBERS$b,
	TODAY: TODAY$b,
	YESTERDAY: YESTERDAY$b,
	SUNDAY: SUNDAY$b,
	MONDAY: MONDAY$b,
	TUESDAY: TUESDAY$b,
	WEDNESDAY: WEDNESDAY$b,
	THURSDAY: THURSDAY$b,
	FRIDAY: FRIDAY$b,
	SATURDAY: SATURDAY$b,
	TYPING: TYPING$b,
	IS_TYPING: IS_TYPING$b,
	CLOSE: CLOSE$b,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$b,
	ADD_MEMBERS: ADD_MEMBERS$b,
	SEND_MESSAGE: SEND_MESSAGE$b,
	UNBLOCK_USER: UNBLOCK_USER$b,
	BLOCK_USER: BLOCK_USER$b,
	DELETE_AND_EXIT: DELETE_AND_EXIT$b,
	LEAVE_GROUP: LEAVE_GROUP$b,
	CREATE_GROUP: CREATE_GROUP$b,
	SHARED_MEDIA: SHARED_MEDIA$b,
	VIDEO_CALL: VIDEO_CALL$b,
	AUDIO_CALL: AUDIO_CALL$b,
	LOADING: LOADING$b,
	REPLY: REPLY$b,
	REPLIES: REPLIES$b,
	LAUNCH: LAUNCH$b,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$b,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$b,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$b,
	CREATED_DOCUMENT: CREATED_DOCUMENT$b,
	PHOTOS: PHOTOS$b,
	VIDEOS: VIDEOS$b,
	DOCUMENT: DOCUMENT$b,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$b,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$b,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$b,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$b,
	SEARCH: SEARCH$b,
	NO_USERS_FOUND: NO_USERS_FOUND$b,
	ERROR: ERROR$b,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$b,
	NO_CHATS_FOUND: NO_CHATS_FOUND$b,
	MEDIA_MESSAGE: MEDIA_MESSAGE$b,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$b,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$b,
	DECLINE: DECLINE$b,
	ACCEPT: ACCEPT$b,
	CALL_INITIATED: CALL_INITIATED$b,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$b,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$b,
	CALL_REJECTED: CALL_REJECTED$b,
	REJECTED_CALL: REJECTED_CALL$b,
	CALL_ACCEPTED: CALL_ACCEPTED$b,
	JOINED: JOINED$b,
	LEFT_THE_CALL: LEFT_THE_CALL$b,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$b,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$b,
	CALL_ENDED: CALL_ENDED$b,
	CALL_CANCELLED: CALL_CANCELLED$b,
	CALL_BUSY: CALL_BUSY$b,
	CALLING: CALLING$b,
	ADD: ADD$b,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$b,
	BANNED_MEMBERS: BANNED_MEMBERS$b,
	NAME: NAME$b,
	SCOPE: SCOPE$b,
	UNBAN: UNBAN$b,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$b,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$b,
	CREATE: CREATE$b,
	CREATE_POLL: CREATE_POLL$b,
	QUESTION: QUESTION$b,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$b,
	OPTIONS: OPTIONS$b,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$b,
	ADD_NEW_OPTION: ADD_NEW_OPTION$b,
	VIEW_MEMBERS: VIEW_MEMBERS$b,
	DETAILS: DETAILS$b,
	NOTIFICATIONS: NOTIFICATIONS$b,
	OTHER: OTHER$b,
	HELP: HELP$b,
	REPORT_PROBLEM: REPORT_PROBLEM$b,
	GROUP_MEMBERS: GROUP_MEMBERS$b,
	BAN: BAN$b,
	KICK: KICK$b,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$b,
	PRIVATE_GROUP: PRIVATE_GROUP$b,
	PROTECTED_GROUP: PROTECTED_GROUP$b,
	VISIT: VISIT$b,
	ATTACH: ATTACH$b,
	ATTACH_FILE: ATTACH_FILE$b,
	ATTACH_VIDEO: ATTACH_VIDEO$b,
	ATTACH_AUDIO: ATTACH_AUDIO$b,
	ATTACH_IMAGE: ATTACH_IMAGE$b,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$b,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$b,
	EMOJI: EMOJI$b,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$b,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$b,
	THREAD: THREAD$b,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$b,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$b,
	ADD_REACTION: ADD_REACTION$b,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$b,
	REPLY_TO_THREAD: REPLY_TO_THREAD$b,
	REPLY_IN_THREAD: REPLY_IN_THREAD$b,
	DELETE_MESSAGE: DELETE_MESSAGE$b,
	EDIT_MESSAGE: EDIT_MESSAGE$b,
	OWNER: OWNER$b,
	CHANGE_SCOPE: CHANGE_SCOPE$b,
	STICKER: STICKER$b,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$b,
	VOICE_CALL: VOICE_CALL$b,
	VIEW_DETAIL: VIEW_DETAIL$b,
	VOTES: VOTES$b,
	VOTE: VOTE$b,
	NO_VOTE: NO_VOTE$b,
	REACTED: REACTED$b,
	ADDED: ADDED$b,
	UNBANNED: UNBANNED$b,
	MADE: MADE$b,
	CALL_UNANSWERED: CALL_UNANSWERED$b,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$b,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$b,
	DOCS: DOCS$b,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$b,
	LIVE_REACTION: LIVE_REACTION$b,
	SMILEY_PEOPLE: SMILEY_PEOPLE$b,
	ANIMALES_NATURE: ANIMALES_NATURE$b,
	FOOD_DRINK: FOOD_DRINK$b,
	ACTIVITY: ACTIVITY$b,
	TRAVEL_PLACES: TRAVEL_PLACES$b,
	OBJECTS: OBJECTS$b,
	SYMBOLS: SYMBOLS$b,
	FLAGS: FLAGS$b,
	SENT: SENT$b,
	SEEN: SEEN$b,
	DELIVERED: DELIVERED$b,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$b,
	LEFT: LEFT$b,
	KICKED: KICKED$b,
	BANNED: BANNED$b,
	NEW_MESSAGES: NEW_MESSAGES$b,
	NEW_MESSAGE: NEW_MESSAGE$b,
	JUMP: JUMP$b,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$b,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$b,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$b,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$b,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$b,
	IGNORE: IGNORE$b,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$b,
	CREATING: CREATING$b,
	AVATAR: AVATAR$b,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$b,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$b,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$b,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$a,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$a,
	ONGOING_CALL: ONGOING_CALL$b,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$b,
	RESIZE: RESIZE$b,
	SETTINGS: SETTINGS$b,
	ACTIONS: ACTIONS$b,
	VIEW_PROFILE: VIEW_PROFILE$b,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$b,
	DELETE: DELETE$b,
	DELETE_CONFIRM: DELETE_CONFIRM$b,
	CANCEL: CANCEL$b,
	LEAVE_CONFIRM: LEAVE_CONFIRM$b,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$b,
	ADDING: ADDING$b,
	TRANSFER: TRANSFER$b,
	TRANSFERRING: TRANSFERRING$b,
	YES: YES$b,
	NO: NO$b,
	SOMETHING_WRONG: SOMETHING_WRONG$b,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$b,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$b,
	INVALID_PASSWORD: INVALID_PASSWORD$b,
	WRONG_PASSWORD: WRONG_PASSWORD$b,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$b,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$b,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$b,
	LEAVE: LEAVE$b,
	CALLS: CALLS$b,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$b,
	OFFLINE: OFFLINE$b,
	YOU: YOU$b,
	PRIVACY: PRIVACY$b,
	BLOCKED_USERS: BLOCKED_USERS$b,
	"YOU'VE_BLOCKED": "Du hast geblockt",
	NO_PHOTOS: NO_PHOTOS$b,
	NO_VIDEOS: NO_VIDEOS$b,
	NO_DOCUMENTS: NO_DOCUMENTS$b,
	JOIN: JOIN$b,
	NEW_CHAT: NEW_CHAT$b,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$b,
	FORM: FORM$b,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$b,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$b,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$b,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$b,
	CANCELLED_CALL: CANCELLED_CALL$b,
	UNANSWERED_CALL: UNANSWERED_CALL$b,
	RECORDING: RECORDING$b,
	PARTICIPANTS: PARTICIPANTS$b,
	CALL_HISTORY: CALL_HISTORY$b,
	NO_CALLS_FOUND: NO_CALLS_FOUND$b,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$b,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$b,
	CALL_DETAIL: CALL_DETAIL$b,
	CARD: CARD$b,
	GENERATING_SUMMARY: GENERATING_SUMMARY$b,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$b,
	GENERATE_SUMMARY: GENERATE_SUMMARY$b,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$b,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$b,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$b,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$b
};

var USERS$a = "Users";
var CHATS$a = "Chats";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$a = "Would you like to delete this conversation? This conversation will be deleted from all of your devices.";
var GROUPS$a = "Groups";
var SHARED$1 = "Shared";
var SOUND_MANAGER$1 = "Sound Manager";
var THEME$1 = "Theme";
var LOCALIZE$1 = "Localize";
var CONVERSATION_LIST_ITEM$1 = "Conversation List Item";
var DATA_ITEM$1 = "Data Item";
var STATUS_INDICATOR$1 = "Status Indicator";
var BADGE_COUNT$1 = "Badge Count";
var MESSAGE_RECEIPT$1 = "Message Receipt";
var MESSAGE$a = "Message";
var RECEIPT_INFORMATION$a = "Receipt Information";
var NO_RECIPIENT$a = "No Recipient";
var NO_RECIPIENTS$a = "No Recipients";
var CONVERSATIONS_WITH_MESSAGES$1 = "Conversations With Messages";
var CONVERSATIONS$1 = "Conversations";
var CONVERSATION_LIST$1 = "Conversation List";
var MESSAGES$1 = "Messages";
var MESSAGE_HEADER$1 = "Message Header";
var MESSAGE_LIST$1 = "Message List";
var MESSAGE_COMPOSER$1 = "Message Composer";
var USERS_WITH_MESSAGES$1 = "Users With Messages";
var USER_LIST$1 = "User List";
var GROUP_LIST$1 = "Group List";
var GROUPS_WITH_MESSAGES$1 = "Groups With Messages";
var NEW__GROUP$a = "New Group";
var PASSWORD$a = "Password";
var CONTINUE$a = "Continue";
var NO_CHATS_SELECTED$a = "No Chats Selected";
var NO_USERS_SELECTED$a = "No Users Selected";
var NO_GROUPS_SELECTED$a = "No Groups Selected";
var NO_CALLS_SELECTED$a = "No Calls Selected";
var SELECT__GROUP$a = "Select a group to start messaging";
var SELECT__USER$a = "Select a user to start messaging";
var GROUP_PASSWORD_BLANK$a = "Group password cannot be blank";
var GROUP_NAME_BLANK$a = "Group name cannot be blank";
var GROUP_TYPE_BLANK$a = "Group type cannot be blank";
var DELETE_CONVERSATION$a = "Delete Conversation?";
var ADD_TO_CHAT$a = "Add to Chat";
var MORE$a = "More";
var COPY_MESSAGE$2 = "Copy";
var VOICE_RECORDING$a = "Voice Recording";
var MESSAGE_IMAGE$a = "📷 Image";
var MESSAGE_FILE$a = "📁 File";
var MESSAGE_VIDEO$a = "📹 Video";
var MESSAGE_AUDIO$a = "🎵 Audio";
var CUSTOM_MESSAGE$a = "You have a message";
var MISSED_VOICE_CALL$a = "Missed voice call";
var MISSED_VIDEO_CALL$a = "Missed video call";
var CUSTOM_MESSAGE_POLL$a = "📊 Poll";
var CUSTOM_MESSAGE_STICKER$a = "💟 Sticker";
var CUSTOM_MESSAGE_DOCUMENT$a = "📃 Document";
var CUSTOM_MESSAGE_WHITEBOARD$a = "📝 Whiteboard";
var ONLINE$a = "Online";
var ADMINISTRATOR$a = "Administrator";
var ADMIN$a = "Admin";
var MODERATOR$a = "Moderator";
var PARTICIPANT$a = "Participant";
var PUBLIC$a = "Public";
var PRIVATE$a = "Private";
var PASSWORD_PROTECTED$a = "Password Protected";
var PRIVACY_AND_SECURITY$a = "Privacy and Security";
var PREFERENCES$a = "Preferences";
var MEMBERS$a = "Members";
var MEMBER = "Member";
var TODAY$a = "Today";
var YESTERDAY$a = "Yesterday";
var SUNDAY$a = "Sunday";
var MONDAY$a = "Monday";
var TUESDAY$a = "Tuesday";
var WEDNESDAY$a = "Wednesday";
var THURSDAY$a = "Thursday";
var FRIDAY$a = "Friday";
var SATURDAY$a = "Saturday";
var TYPING$a = "typing...";
var IS_TYPING$a = "is typing...";
var CLOSE$a = "Close";
var ENTER_GROUP_NAME$a = "Enter group name";
var ADD_MEMBERS$a = "Add Members";
var SEND_MESSAGE$a = "Send Message";
var UNBLOCK_USER$a = "Unblock User";
var BLOCK_USER$a = "Block User";
var DELETE_AND_EXIT$a = "Delete and Exit";
var LEAVE_GROUP$a = "Leave Group";
var CREATE_GROUP$a = "Create Group";
var SHARED_MEDIA$a = "Shared Media";
var SHARED_FILE$3 = "Shared File";
var VIDEO_CALL$a = "Video call";
var AUDIO_CALL$a = "Audio call";
var LOADING$a = "Loading...";
var REPLY$a = "reply";
var REPLIES$a = "replies";
var AI$a = "AI";
var SMART_REPLIES$a = "Smart Replies";
var CONVERSATION_STARTER$a = "Conversation Starter";
var LAUNCH$a = "Launch";
var SHARED_COLLABORATIVE_DOCUMENT$a = "has shared a collaborative document";
var SHARED_COLLABORATIVE_WHITEBOARD$a = "has shared a collaborative whiteboard";
var CREATED_WHITEBOARD$a = "You’ve created a new collaborative whiteboard";
var CREATED_DOCUMENT$a = "You’ve created a new collaborative document";
var PHOTOS$a = "Photos";
var VIDEOS$a = "Videos";
var DOCUMENT$a = "Document";
var YOU_DELETED_THIS_MESSAGE$a = "⚠️ You deleted this message";
var THIS_MESSAGE_DELETED$a = "⚠️ This message was deleted";
var MESSAGE_IS_DELETED$a = "Message is Deleted";
var VIEW_ON_YOUTUBE$a = "View on Youtube";
var SEARCH$a = "Search";
var NO_USERS_FOUND$a = "No users found";
var ERROR$a = "Error";
var NO_GROUPS_FOUND$a = "No groups found";
var NO_CHATS_FOUND$a = "No chats found";
var CANT__LOAD__CHATS$a = "Can't load chats";
var MEDIA_MESSAGE$a = "Media message";
var INCOMING_AUDIO_CALL$a = "Incoming audio call";
var INCOMING_VIDEO_CALL$a = "Incoming video call";
var DECLINE$a = "Decline";
var ACCEPT$a = "Accept";
var CALL_INITIATED$a = "Call initiated";
var OUTGOING_AUDIO_CALL$a = "Outgoing audio call";
var OUTGOING_VIDEO_CALL$a = "Outgoing video call";
var CALL_REJECTED$a = "Call rejected";
var REJECTED_CALL$a = "rejected call";
var CALL_ACCEPTED$a = "Call accepted";
var OUTGOING_CALL$a = "Outgoing call";
var INCOMING_CALL$a = "Incoming call";
var MISSED_CALL$a = "Missed call";
var JOINED$a = "joined";
var LEFT_THE_CALL$a = "left the call";
var UNANSWERED_AUDIO_CALL$a = "Unanswered audio call";
var UNANSWERED_VIDEO_CALL$a = "Unanswered video call";
var CALL_ENDED$a = "Call ended";
var CALL_CANCELLED$a = "Call cancelled";
var CALL_BUSY$a = "Call busy";
var CALLING$a = "Calling...";
var ADD$a = "Add";
var NO_BANNED_MEMBERS_FOUND$a = "No banned members found";
var BANNED_MEMBERS$a = "Banned Members";
var NAME$a = "Name";
var SCOPE$a = "Scope";
var UNBAN$a = "Unban";
var SELECT_GROUP_TYPE$a = "Select group type";
var ENTER_GROUP_PASSWORD$a = "Enter group password";
var CREATE$a = "Create";
var CREATE_POLL$a = "Create Poll";
var QUESTION$a = "Question";
var ENTER_YOUR_QUESTION$a = "Enter your question";
var OPTIONS$a = "Options";
var ENTER_YOUR_OPTION$a = "Enter your option";
var ADD_NEW_OPTION$a = "Add new option";
var VIEW_MEMBERS$a = "View Members";
var DETAILS$a = "Details";
var NOTIFICATIONS$a = "Notifications";
var OTHER$a = "Other";
var HELP$a = "Help";
var REPORT_PROBLEM$a = "Report a Problem";
var GROUP_MEMBERS$a = "Group Members";
var BAN$a = "Ban";
var KICK$a = "Kick";
var PICK_YOUR_EMOJI$a = "Pick your emoji";
var PRIVATE_GROUP$a = "Private Group";
var PROTECTED_GROUP$a = "Protected Group";
var VISIT$a = "Visit";
var ATTACH$a = "Attach";
var OPEN_WHITEBOARD$9 = "Open Whiteboard";
var ATTACH_FILE$a = "Attach file";
var GENERATING_REPLIES$a = "Generating replies";
var ATTACH_VIDEO$a = "Attach video";
var ATTACH_AUDIO$a = "Attach audio";
var ATTACH_IMAGE$a = "Attach image";
var COLLABORATE_USING_DOCUMENT$a = "Collaborate using a document";
var COLLABORATE_USING_WHITEBOARD$a = "Collaborate using a whiteboard";
var SUGGEST_A_REPLY$a = "Suggest a reply";
var GENERATING_ICEBREAKERS$a = "Generating icebreakers";
var EMOJI$a = "Emoji";
var NO_REPLIES_FOUND$a = "No Replies Found";
var ENTER_YOUR_MESSAGE_HERE$a = "Enter your message here";
var NO_MESSAGES_FOUND$a = "No messages found";
var THREAD$a = "Thread";
var COLLABORATIVE_DOCUMENT$a = "Collaborative Document";
var COLLABORATIVE_WHITEBOARD$a = "Collaborative Whiteboard";
var ADD_REACTION$a = "Add reaction";
var NO_STICKERS_FOUND$a = "No stickers found";
var REPLY_TO_THREAD$a = "Reply to thread";
var REPLY_IN_THREAD$a = "Reply in thread";
var VIEW$9 = "View";
var DELETE_MESSAGE$a = "Delete message";
var EDIT_MESSAGE$a = "Edit message";
var OWNER$a = "Owner";
var CHANGE_SCOPE$a = "Change Scope";
var STICKER$a = "Sticker";
var LAST_ACTIVE_AT$a = "Last Active At";
var VOICE_CALL$a = "Voice call";
var VIEW_DETAIL$a = "View Detail";
var VOTES$a = "votes";
var VOTE$a = "vote";
var NO_VOTE$a = "No vote";
var REACTED$a = "reacted";
var ADDED$a = "added";
var SHOW_UNSAFE_CONTENT$a = "Are you sure want to see unsafe content?";
var REACT_TO_MESSAGE$a = "React to a message";
var UNBANNED$a = "unbanned";
var MADE$a = "made";
var CALL_UNANSWERED$a = "Call unanswered";
var MISSED_AUDIO_CALL$a = "Missed audio call";
var ENTER_YOUR_PASSWORD$a = "Enter your password";
var DRAW_DOCUMENT_TOGETHER$9 = "Open document to edit content together";
var DOCS$a = "Docs";
var NO_RECORDS_FOUND$a = "No records found";
var LIVE_REACTION$a = "Live Reaction";
var SMILEY_PEOPLE$a = "Smileys & People";
var DRAW_WHITEBOARD_TOGETHER$9 = "Open whiteboard to draw together";
var ANIMALES_NATURE$a = "Animals & Nature";
var FOOD_DRINK$a = "Food & Drink";
var OPEN_DOCUMENT$9 = "Open Document";
var ACTIVITY$a = "Activity";
var TRAVEL_PLACES$a = "Travel & Places";
var OBJECTS$a = "Objects";
var SYMBOLS$a = "Symbols";
var FLAGS$a = "Flags";
var SENT$a = "Sent";
var SEEN$a = "Seen";
var DELIVERED$a = "Delivered";
var READ$a = "Read";
var MESSAGE_INFORMATION$a = "Message Information";
var TRANSLATE_MESSAGE$a = "Translate message";
var TRANSLATED_MESSAGE$a = "Translated message";
var LEFT$a = "left";
var KICKED$a = "kicked";
var BANNED$a = "banned";
var NEW_MESSAGES$a = "new messages";
var NEW_MESSAGE$a = "new message";
var JUMP$a = "Jump";
var SELECT_VIDEO_SOURCE$a = "Select video source";
var SELECT_INPUT_AUDIO_SOURCE$a = "Select input audio source";
var SELECT_OUTPUT_AUDIO_SOURCE$a = "Select output audio source";
var INITIATED_GROUP_CALL$a = "has initiated a group call";
var YOU_INITIATED_GROUP_CALL$a = "You’ve initiated a group call";
var IGNORE$a = "Ignore";
var ON_ANOTHER_CALL$a = "is on another call";
var CREATING$a = "Creating";
var AVATAR$a = "Avatar";
var ONGOING_CALL$a = "Ongoing call";
var YOU_ALREADY_ONGOING_CALL$a = "You are already in an ongoing call";
var RESIZE$a = "Resize";
var SETTINGS$a = "Settings";
var ACTIONS$a = "Actions";
var VIEW_PROFILE$a = "View Profile";
var SEND_MESSAGE_IN_PRIVATE$a = "Send message privately";
var DELETE$a = "Delete";
var DELETE_CONFIRM$a = "Are you sure you want to delete?";
var CANCEL$a = "Cancel";
var LEAVE_CONFIRM$a = "Are you sure you want to leave the group?";
var TRANSFER_CONFIRM$a = "You are the group owner, please transfer ownership to a member before leaving the group";
var ADDING$a = "Adding...";
var TRANSFER$a = "Transfer";
var TRANSFER_OWNERSHIP$a = "Transfer Ownership";
var TRANSFERRING$a = "Transferring";
var YES$a = "Yes";
var NO$a = "No";
var ANSWER$a = "Answer";
var ADD_ANOTHER_ANSWER$a = "Add Another Answer";
var SET_THE_ANSWERS$a = "SET THE ANSWERS";
var SOMETHING_WRONG$a = "Something went wrong, please try again";
var INVALID_GROUP_NAME$a = "Please enter a valid name for the group and try again";
var INVALID_PASSWORD$a = "Please enter a valid password for the group and try again";
var INVALID_GROUP_TYPE$a = "Please enter a valid type for the group and try again";
var WRONG_PASSWORD$a = "Please enter the correct password and try again";
var INVALID_POLL_QUESTION$a = "Please enter the required question before creating a poll";
var INVALID_POLL_OPTION$a = "Please enter the required answer before creating a poll";
var SAME_LANGUAGE_MESSAGE$a = "Selected language for translation is similar to the language of original message";
var LEAVE$a = "Leave";
var CLICK_TO_START_CONVERSATION$a = "Click to start conversation";
var CUSTOM_MESSAGE_LOCATION$a = "📍Location";
var SHARED_LOCATION$a = "Shared Location";
var IN_A_THREAD = "In a thread";
var CALLS$a = "Calls";
var CALL_DETAILS$a = "Call Details";
var OFFLINE$a = "Offline";
var POLLS$a = "Polls";
var YOU$a = "You";
var PRIVACY$a = "Privacy";
var BLOCKED_USERS$a = "Blocked Users";
var NO_PHOTOS$a = "No Photos";
var NO_VIDEOS$a = "No Videos";
var NO_DOCUMENTS$a = "No Documents";
var JOIN$a = "Join";
var REMOVE$3 = "Remove";
var BLOCK$3 = "Block";
var CHANGE_ROLE$3 = "Change Role";
var NEW_CHAT$a = "New Chat";
var FORM_COMPLETION_MESSAGE$a = "Thank you for filling out the form.";
var FORM$a = "Form";
var CARD$a = "Card";
var HISTORY$a = "History";
var CANCELLED_AUDIO_CALL$a = "Cancelled audio call";
var CANCELLED_VIDEO_CALL$a = "Cancelled video call";
var REJECTED_AUDIO_CALL$a = "Rejected audio call";
var REJECTED_VIDEO_CALL$a = "Rejected video call";
var CANCELLED_CALL$a = "Cancelled call";
var UNANSWERED_CALL$a = "Unanswered call";
var RECORDING$a = "Recording";
var PARTICIPANTS$a = "Participants";
var CALL_HISTORY$a = "Call History";
var NO_CALLS_FOUND$a = "No Calls Found";
var ONGOING_AUDIO_CALL$a = "Ongoing audio call";
var ONGOING_VIDEO_CALL$a = "Ongoing video call";
var CALL_DETAIL$a = "Call Detail";
var GENERATING_SUMMARY$a = "Generating summary";
var CONVERSATION_SUMMARY$a = "Conversation summary";
var GENERATE_SUMMARY$a = "Generate a summary";
var COMETCHAT_BOT_FIRST_MESSAGE$a = "How can I help you with this conversation? Please ask me a question and I’ll advice you 🙂";
var COMETCHAT_ASK_BOT$a = "Ask";
var COMETCHAT_ASK_AI_BOT$a = "Ask AI Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$a = "AI Bot";
var translationEN = {
	USERS: USERS$a,
	CHATS: CHATS$a,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$a,
	GROUPS: GROUPS$a,
	SHARED: SHARED$1,
	SOUND_MANAGER: SOUND_MANAGER$1,
	THEME: THEME$1,
	LOCALIZE: LOCALIZE$1,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM$1,
	DATA_ITEM: DATA_ITEM$1,
	STATUS_INDICATOR: STATUS_INDICATOR$1,
	BADGE_COUNT: BADGE_COUNT$1,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT$1,
	MESSAGE: MESSAGE$a,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$a,
	NO_RECIPIENT: NO_RECIPIENT$a,
	NO_RECIPIENTS: NO_RECIPIENTS$a,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES$1,
	CONVERSATIONS: CONVERSATIONS$1,
	CONVERSATION_LIST: CONVERSATION_LIST$1,
	MESSAGES: MESSAGES$1,
	MESSAGE_HEADER: MESSAGE_HEADER$1,
	MESSAGE_LIST: MESSAGE_LIST$1,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER$1,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES$1,
	USER_LIST: USER_LIST$1,
	GROUP_LIST: GROUP_LIST$1,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES$1,
	NEW__GROUP: NEW__GROUP$a,
	PASSWORD: PASSWORD$a,
	CONTINUE: CONTINUE$a,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$a,
	NO_USERS_SELECTED: NO_USERS_SELECTED$a,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$a,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$a,
	SELECT__GROUP: SELECT__GROUP$a,
	SELECT__USER: SELECT__USER$a,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$a,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$a,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$a,
	DELETE_CONVERSATION: DELETE_CONVERSATION$a,
	ADD_TO_CHAT: ADD_TO_CHAT$a,
	MORE: MORE$a,
	COPY_MESSAGE: COPY_MESSAGE$2,
	VOICE_RECORDING: VOICE_RECORDING$a,
	MESSAGE_IMAGE: MESSAGE_IMAGE$a,
	MESSAGE_FILE: MESSAGE_FILE$a,
	MESSAGE_VIDEO: MESSAGE_VIDEO$a,
	MESSAGE_AUDIO: MESSAGE_AUDIO$a,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$a,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$a,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$a,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$a,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$a,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$a,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$a,
	ONLINE: ONLINE$a,
	ADMINISTRATOR: ADMINISTRATOR$a,
	ADMIN: ADMIN$a,
	MODERATOR: MODERATOR$a,
	PARTICIPANT: PARTICIPANT$a,
	PUBLIC: PUBLIC$a,
	PRIVATE: PRIVATE$a,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$a,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$a,
	PREFERENCES: PREFERENCES$a,
	MEMBERS: MEMBERS$a,
	MEMBER: MEMBER,
	TODAY: TODAY$a,
	YESTERDAY: YESTERDAY$a,
	SUNDAY: SUNDAY$a,
	MONDAY: MONDAY$a,
	TUESDAY: TUESDAY$a,
	WEDNESDAY: WEDNESDAY$a,
	THURSDAY: THURSDAY$a,
	FRIDAY: FRIDAY$a,
	SATURDAY: SATURDAY$a,
	TYPING: TYPING$a,
	IS_TYPING: IS_TYPING$a,
	CLOSE: CLOSE$a,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$a,
	ADD_MEMBERS: ADD_MEMBERS$a,
	SEND_MESSAGE: SEND_MESSAGE$a,
	UNBLOCK_USER: UNBLOCK_USER$a,
	BLOCK_USER: BLOCK_USER$a,
	DELETE_AND_EXIT: DELETE_AND_EXIT$a,
	LEAVE_GROUP: LEAVE_GROUP$a,
	CREATE_GROUP: CREATE_GROUP$a,
	SHARED_MEDIA: SHARED_MEDIA$a,
	SHARED_FILE: SHARED_FILE$3,
	VIDEO_CALL: VIDEO_CALL$a,
	AUDIO_CALL: AUDIO_CALL$a,
	LOADING: LOADING$a,
	REPLY: REPLY$a,
	REPLIES: REPLIES$a,
	AI: AI$a,
	SMART_REPLIES: SMART_REPLIES$a,
	CONVERSATION_STARTER: CONVERSATION_STARTER$a,
	LAUNCH: LAUNCH$a,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$a,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$a,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$a,
	CREATED_DOCUMENT: CREATED_DOCUMENT$a,
	PHOTOS: PHOTOS$a,
	VIDEOS: VIDEOS$a,
	DOCUMENT: DOCUMENT$a,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$a,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$a,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$a,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$a,
	SEARCH: SEARCH$a,
	NO_USERS_FOUND: NO_USERS_FOUND$a,
	ERROR: ERROR$a,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$a,
	NO_CHATS_FOUND: NO_CHATS_FOUND$a,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$a,
	MEDIA_MESSAGE: MEDIA_MESSAGE$a,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$a,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$a,
	DECLINE: DECLINE$a,
	ACCEPT: ACCEPT$a,
	CALL_INITIATED: CALL_INITIATED$a,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$a,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$a,
	CALL_REJECTED: CALL_REJECTED$a,
	REJECTED_CALL: REJECTED_CALL$a,
	CALL_ACCEPTED: CALL_ACCEPTED$a,
	OUTGOING_CALL: OUTGOING_CALL$a,
	INCOMING_CALL: INCOMING_CALL$a,
	MISSED_CALL: MISSED_CALL$a,
	JOINED: JOINED$a,
	LEFT_THE_CALL: LEFT_THE_CALL$a,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$a,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$a,
	CALL_ENDED: CALL_ENDED$a,
	CALL_CANCELLED: CALL_CANCELLED$a,
	CALL_BUSY: CALL_BUSY$a,
	CALLING: CALLING$a,
	ADD: ADD$a,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$a,
	BANNED_MEMBERS: BANNED_MEMBERS$a,
	NAME: NAME$a,
	SCOPE: SCOPE$a,
	UNBAN: UNBAN$a,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$a,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$a,
	CREATE: CREATE$a,
	CREATE_POLL: CREATE_POLL$a,
	QUESTION: QUESTION$a,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$a,
	OPTIONS: OPTIONS$a,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$a,
	ADD_NEW_OPTION: ADD_NEW_OPTION$a,
	VIEW_MEMBERS: VIEW_MEMBERS$a,
	DETAILS: DETAILS$a,
	NOTIFICATIONS: NOTIFICATIONS$a,
	OTHER: OTHER$a,
	HELP: HELP$a,
	REPORT_PROBLEM: REPORT_PROBLEM$a,
	GROUP_MEMBERS: GROUP_MEMBERS$a,
	BAN: BAN$a,
	KICK: KICK$a,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$a,
	PRIVATE_GROUP: PRIVATE_GROUP$a,
	PROTECTED_GROUP: PROTECTED_GROUP$a,
	VISIT: VISIT$a,
	ATTACH: ATTACH$a,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$9,
	ATTACH_FILE: ATTACH_FILE$a,
	GENERATING_REPLIES: GENERATING_REPLIES$a,
	ATTACH_VIDEO: ATTACH_VIDEO$a,
	ATTACH_AUDIO: ATTACH_AUDIO$a,
	ATTACH_IMAGE: ATTACH_IMAGE$a,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$a,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$a,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$a,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$a,
	EMOJI: EMOJI$a,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$a,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$a,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$a,
	THREAD: THREAD$a,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$a,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$a,
	ADD_REACTION: ADD_REACTION$a,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$a,
	REPLY_TO_THREAD: REPLY_TO_THREAD$a,
	REPLY_IN_THREAD: REPLY_IN_THREAD$a,
	VIEW: VIEW$9,
	DELETE_MESSAGE: DELETE_MESSAGE$a,
	EDIT_MESSAGE: EDIT_MESSAGE$a,
	OWNER: OWNER$a,
	CHANGE_SCOPE: CHANGE_SCOPE$a,
	STICKER: STICKER$a,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$a,
	VOICE_CALL: VOICE_CALL$a,
	VIEW_DETAIL: VIEW_DETAIL$a,
	VOTES: VOTES$a,
	VOTE: VOTE$a,
	NO_VOTE: NO_VOTE$a,
	REACTED: REACTED$a,
	ADDED: ADDED$a,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$a,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$a,
	UNBANNED: UNBANNED$a,
	MADE: MADE$a,
	CALL_UNANSWERED: CALL_UNANSWERED$a,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$a,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$a,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$9,
	DOCS: DOCS$a,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$a,
	LIVE_REACTION: LIVE_REACTION$a,
	SMILEY_PEOPLE: SMILEY_PEOPLE$a,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$9,
	ANIMALES_NATURE: ANIMALES_NATURE$a,
	FOOD_DRINK: FOOD_DRINK$a,
	OPEN_DOCUMENT: OPEN_DOCUMENT$9,
	ACTIVITY: ACTIVITY$a,
	TRAVEL_PLACES: TRAVEL_PLACES$a,
	OBJECTS: OBJECTS$a,
	SYMBOLS: SYMBOLS$a,
	FLAGS: FLAGS$a,
	SENT: SENT$a,
	SEEN: SEEN$a,
	DELIVERED: DELIVERED$a,
	READ: READ$a,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$a,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$a,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$a,
	LEFT: LEFT$a,
	KICKED: KICKED$a,
	BANNED: BANNED$a,
	NEW_MESSAGES: NEW_MESSAGES$a,
	NEW_MESSAGE: NEW_MESSAGE$a,
	JUMP: JUMP$a,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$a,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$a,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$a,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$a,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$a,
	IGNORE: IGNORE$a,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$a,
	CREATING: CREATING$a,
	AVATAR: AVATAR$a,
	ONGOING_CALL: ONGOING_CALL$a,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$a,
	RESIZE: RESIZE$a,
	SETTINGS: SETTINGS$a,
	ACTIONS: ACTIONS$a,
	VIEW_PROFILE: VIEW_PROFILE$a,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$a,
	DELETE: DELETE$a,
	DELETE_CONFIRM: DELETE_CONFIRM$a,
	CANCEL: CANCEL$a,
	LEAVE_CONFIRM: LEAVE_CONFIRM$a,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$a,
	ADDING: ADDING$a,
	TRANSFER: TRANSFER$a,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$a,
	TRANSFERRING: TRANSFERRING$a,
	YES: YES$a,
	NO: NO$a,
	ANSWER: ANSWER$a,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$a,
	SET_THE_ANSWERS: SET_THE_ANSWERS$a,
	SOMETHING_WRONG: SOMETHING_WRONG$a,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$a,
	INVALID_PASSWORD: INVALID_PASSWORD$a,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$a,
	WRONG_PASSWORD: WRONG_PASSWORD$a,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$a,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$a,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$a,
	LEAVE: LEAVE$a,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$a,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$a,
	SHARED_LOCATION: SHARED_LOCATION$a,
	IN_A_THREAD: IN_A_THREAD,
	CALLS: CALLS$a,
	CALL_DETAILS: CALL_DETAILS$a,
	OFFLINE: OFFLINE$a,
	POLLS: POLLS$a,
	YOU: YOU$a,
	PRIVACY: PRIVACY$a,
	BLOCKED_USERS: BLOCKED_USERS$a,
	"YOU'VE_BLOCKED": "You've blocked",
	NO_PHOTOS: NO_PHOTOS$a,
	NO_VIDEOS: NO_VIDEOS$a,
	NO_DOCUMENTS: NO_DOCUMENTS$a,
	JOIN: JOIN$a,
	REMOVE: REMOVE$3,
	BLOCK: BLOCK$3,
	CHANGE_ROLE: CHANGE_ROLE$3,
	NEW_CHAT: NEW_CHAT$a,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$a,
	FORM: FORM$a,
	CARD: CARD$a,
	HISTORY: HISTORY$a,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$a,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$a,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$a,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$a,
	CANCELLED_CALL: CANCELLED_CALL$a,
	UNANSWERED_CALL: UNANSWERED_CALL$a,
	RECORDING: RECORDING$a,
	PARTICIPANTS: PARTICIPANTS$a,
	CALL_HISTORY: CALL_HISTORY$a,
	NO_CALLS_FOUND: NO_CALLS_FOUND$a,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$a,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$a,
	CALL_DETAIL: CALL_DETAIL$a,
	GENERATING_SUMMARY: GENERATING_SUMMARY$a,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$a,
	GENERATE_SUMMARY: GENERATE_SUMMARY$a,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$a,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$a,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$a,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$a
};

var USERS$9 = "Usuarios";
var CHATS$9 = "Chats";
var GROUPS$9 = "Grupos";
var NEW__GROUP$9 = "Nuevo grupo";
var PASSWORD$9 = "Clave";
var CONTINUE$9 = "Continuar";
var NO_CHATS_SELECTED$9 = "No se seleccionaron chats";
var SHOW_UNSAFE_CONTENT$9 = "¿Estás seguro/a de que quieres ver contenido inseguro?";
var SELECT__GROUP$9 = "Seleccione un grupo para comenzar a enviar mensajes";
var REACT_TO_MESSAGE$9 = "Reaccionar a un mensaje";
var DELETE_CONVERSATION$9 = "¿Eliminar la conversación?";
var ADD_TO_CHAT$9 = "Agregar al chat";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$9 = "¿Quieres eliminar esta conversación? Esta conversación se eliminará de todos tus dispositivos.";
var MORE$9 = "More";
var READ$9 = "Leer";
var SUGGEST_A_REPLY$9 = "Sugerir una respuesta";
var GENERATING_ICEBREAKERS$9 = "Generando rompehielos";
var GENERATING_REPLIES$9 = "Generación de respuestas";
var AI$9 = "I.A.";
var SMART_REPLIES$9 = "Respuestas inteligentes";
var CONVERSATION_STARTER$9 = "Iniciador de conversación";
var NO_RECIPIENT$9 = "Sin destinatario";
var MESSAGE$9 = "Mensaje";
var NO_REPLIES_FOUND$9 = "No se encontraron respuestas";
var RECEIPT_INFORMATION$9 = "Información sobre recibos";
var NO_RECIPIENTS$9 = "Sin destinatarios";
var VOICE_RECORDING$9 = "Grabación de voz";
var MESSAGE_INFORMATION$9 = "Información del mensaje";
var COPY_MESSAGE$1 = "Copiar";
var MESSAGE_IMAGE$9 = "📷 Imagen";
var NO_USERS_SELECTED$9 = "Ningún usuario seleccionado";
var NO_GROUPS_SELECTED$9 = "Ningún grupo seleccionado";
var MESSAGE_FILE$9 = "📁 Archivo";
var MESSAGE_VIDEO$9 = "📹 Vídeo";
var NO_CALLS_SELECTED$9 = "Ninguna llamada seleccionada";
var SELECT__USER$9 = "Selecciona un usuario para empezar a chatear";
var CANT__LOAD__CHATS$9 = "No se pueden cargar los chats";
var OUTGOING_CALL$9 = "Llamada saliente";
var OPEN_DOCUMENT$8 = "Abrir documento";
var OPEN_WHITEBOARD$8 = "Abrir pizarra blanca";
var DRAW_DOCUMENT_TOGETHER$8 = "Abrir documento para editar contenido juntos";
var ADMIN$9 = "Admin";
var DRAW_WHITEBOARD_TOGETHER$8 = "Abrir pizarra blanca para dibujar juntos";
var INCOMING_CALL$9 = "Llamada entrante";
var MISSED_CALL$9 = "Llamada perdida";
var TRANSLATED_MESSAGE$9 = "Mensaje traducido";
var ANSWER$9 = "Responder";
var ADD_ANOTHER_ANSWER$9 = "Agregar otra respuesta";
var SET_THE_ANSWERS$9 = "Establecer las respuestas";
var CLICK_TO_START_CONVERSATION$9 = "Haz clic para iniciar la conversación";
var SHARED_LOCATION$9 = "Ubicación compartida";
var CALL_DETAILS$9 = "Detalles de la llamada";
var POLLS$9 = "Encuestas";
var MESSAGE_AUDIO$9 = "🎵 Audio";
var CUSTOM_MESSAGE$9 = "Tienes un mensaje";
var MISSED_VOICE_CALL$9 = "Llamada de voz perdida";
var MISSED_VIDEO_CALL$9 = "Videollamada perdida";
var TRANSFER_OWNERSHIP$9 = "Transferir propiedad";
var REMOVE$2 = "eliminar";
var BLOCK$2 = "bloquear";
var CHANGE_ROLE$2 = "cambio de rol";
var VIEW$8 = "vista";
var CUSTOM_MESSAGE_POLL$9 = "📊 Encuesta";
var CUSTOM_MESSAGE_STICKER$9 = "💟 Pegatina";
var CUSTOM_MESSAGE_DOCUMENT$9 = "📃 Documento";
var CUSTOM_MESSAGE_WHITEBOARD$9 = "📝 Pizarra blanca";
var ONLINE$9 = "En línea";
var ADMINISTRATOR$9 = "Administrador";
var MODERATOR$9 = "Moderador";
var PARTICIPANT$9 = "Participante";
var PUBLIC$9 = "Público";
var PRIVATE$9 = "Privado";
var PASSWORD_PROTECTED$9 = "Protegido con contraseña";
var PRIVACY_AND_SECURITY$9 = "Privacidad y Seguridad";
var PREFERENCES$9 = "Preferencias";
var MEMBERS$9 = "Miembros";
var TODAY$9 = "Hoy";
var YESTERDAY$9 = "Ayer";
var SUNDAY$9 = "domingo";
var MONDAY$9 = "lunes";
var TUESDAY$9 = "martes";
var WEDNESDAY$9 = "miércoles";
var THURSDAY$9 = "jueves";
var FRIDAY$9 = "viernes";
var SATURDAY$9 = "sábado";
var TYPING$9 = "escribiendo...";
var IS_TYPING$9 = "está escribiendo...";
var CLOSE$9 = "Cerrar";
var ENTER_GROUP_NAME$9 = "Introducir nombre de grupo";
var ADD_MEMBERS$9 = "Agregar miembros";
var SEND_MESSAGE$9 = "Enviar mensaje";
var UNBLOCK_USER$9 = "Desbloquear usuario";
var BLOCK_USER$9 = "Bloquear usuario";
var DELETE_AND_EXIT$9 = "Eliminar y salir";
var LEAVE_GROUP$9 = "Salir del grupo";
var CREATE_GROUP$9 = "Crear grupo";
var SHARED_MEDIA$9 = "Medios compartidos";
var VIDEO_CALL$9 = "Videollamada";
var AUDIO_CALL$9 = "Llamada de audio";
var LOADING$9 = "Cargando...";
var REPLY$9 = "responder";
var REPLIES$9 = "respuestas";
var LAUNCH$9 = "Lanzamiento";
var SHARED_COLLABORATIVE_DOCUMENT$9 = "ha compartido un documento colaborativo";
var SHARED_COLLABORATIVE_WHITEBOARD$9 = "ha compartido una pizarra colaborativa";
var CREATED_WHITEBOARD$9 = "Has creado una nueva pizarra colaborativa";
var CREATED_DOCUMENT$9 = "Ha creado un nuevo documento colaborativo";
var PHOTOS$9 = "Fotos";
var VIDEOS$9 = "Vídeos";
var DOCUMENT$9 = "Documento";
var YOU_DELETED_THIS_MESSAGE$9 = "⚠️ Has eliminado este mensaje";
var THIS_MESSAGE_DELETED$9 = "⚠️ Este mensaje fue eliminado";
var MESSAGE_IS_DELETED$9 = "A mensagem foi excluída";
var VIEW_ON_YOUTUBE$9 = "Ver en Youtube";
var SEARCH$9 = "Buscar";
var NO_USERS_FOUND$9 = "No se han encontrado usuarios";
var ERROR$9 = "Error";
var NO_GROUPS_FOUND$9 = "No se han encontrado grupos";
var NO_CHATS_FOUND$9 = "No se encontraron chats";
var MEDIA_MESSAGE$9 = "Mensaje multimedia";
var INCOMING_AUDIO_CALL$9 = "Llamada de audio entrante";
var INCOMING_VIDEO_CALL$9 = "Videollamada entrante";
var DECLINE$9 = "Declive";
var ACCEPT$9 = "Aceptar";
var CALL_INITIATED$9 = "Llamada iniciada";
var OUTGOING_AUDIO_CALL$9 = "Llamada de audio saliente";
var OUTGOING_VIDEO_CALL$9 = "Videollamada saliente";
var CALL_REJECTED$9 = "Llamada rechazada";
var REJECTED_CALL$9 = "llamada rechazada";
var CALL_ACCEPTED$9 = "Llamada aceptada";
var JOINED$9 = "se unieron";
var LEFT_THE_CALL$9 = "dejó la llamada";
var UNANSWERED_AUDIO_CALL$9 = "Llamada de audio sin respuesta";
var UNANSWERED_VIDEO_CALL$9 = "Videollamada sin respuesta";
var CALL_ENDED$9 = "Llamada finalizada";
var CALL_CANCELLED$9 = "Llamada cancelada";
var CALL_BUSY$9 = "Llamada ocupada";
var CALLING$9 = "Llamando...";
var ADD$9 = "Añadir";
var NO_BANNED_MEMBERS_FOUND$9 = "No se encontraron miembros prohibidos";
var BANNED_MEMBERS$9 = "Miembros prohibidos";
var NAME$9 = "Nombre";
var SCOPE$9 = "Ámbito";
var UNBAN$9 = "Unban la prohibición";
var SELECT_GROUP_TYPE$9 = "Seleccionar tipo de grupo";
var ENTER_GROUP_PASSWORD$9 = "Introducir contraseña de grupo";
var CREATE$9 = "Crear";
var CREATE_POLL$9 = "Crear encuesta";
var QUESTION$9 = "Pregunta";
var ENTER_YOUR_QUESTION$9 = "Introduce tu pregunta";
var OPTIONS$9 = "Opciones";
var ENTER_YOUR_OPTION$9 = "Introduce tu opción";
var ADD_NEW_OPTION$9 = "Agregar nueva opción";
var VIEW_MEMBERS$9 = "Ver miembros";
var DETAILS$9 = "Detalles";
var NOTIFICATIONS$9 = "Notificaciones";
var OTHER$9 = "Otro";
var HELP$9 = "Ayudar";
var REPORT_PROBLEM$9 = "Informar de un problema";
var GROUP_MEMBERS$9 = "Miembros del grupo";
var BAN$9 = "Prohibición";
var KICK$9 = "Patada";
var PICK_YOUR_EMOJI$9 = "Elige tu emoji";
var PRIVATE_GROUP$9 = "Grupo Privado";
var PROTECTED_GROUP$9 = "Grupo protegido";
var VISIT$9 = "Visitar";
var ATTACH$9 = "Adjuntar";
var ATTACH_FILE$9 = "Adjuntar archivo";
var ATTACH_VIDEO$9 = "Adjuntar vídeo";
var ATTACH_AUDIO$9 = "Adjuntar audio";
var ATTACH_IMAGE$9 = "Adjuntar imagen";
var COLLABORATE_USING_DOCUMENT$9 = "Colaborar con un documento";
var COLLABORATE_USING_WHITEBOARD$9 = "Colaborar con una pizarra";
var EMOJI$9 = "Emoji";
var ENTER_YOUR_MESSAGE_HERE$9 = "Introduzca su mensaje aquí";
var NO_MESSAGES_FOUND$9 = "No se han encontrado mensajes";
var THREAD$9 = "Rosca";
var COLLABORATIVE_DOCUMENT$9 = "Documento colaborativo";
var COLLABORATIVE_WHITEBOARD$9 = "Pizarra colaborativa";
var ADD_REACTION$9 = "Añadir reacción";
var NO_STICKERS_FOUND$9 = "No se encontraron pegatinas";
var REPLY_TO_THREAD$9 = "Responder al hilo";
var REPLY_IN_THREAD$9 = "Responder en hilo";
var DELETE_MESSAGE$9 = "Eliminar mensaje";
var EDIT_MESSAGE$9 = "Editar mensaje";
var OWNER$9 = "Propietario";
var CHANGE_SCOPE$9 = "Cambiar ámbito";
var STICKER$9 = "Pegatina";
var LAST_ACTIVE_AT$9 = "Último activo en";
var VOICE_CALL$9 = "Llamada de voz";
var VIEW_DETAIL$9 = "Ver detalle";
var VOTES$9 = "votos";
var VOTE$9 = "Votar";
var NO_VOTE$9 = "Sin voto";
var REACTED$9 = "reaccionó";
var ADDED$9 = "añadido";
var UNBANNED$9 = "no prohibida";
var MADE$9 = "hecho";
var CALL_UNANSWERED$9 = "Llamada sin respuesta";
var MISSED_AUDIO_CALL$9 = "Llamada de audio perdida";
var ENTER_YOUR_PASSWORD$9 = "Introduce tu contraseña";
var DOCS$9 = "Documentos";
var NO_RECORDS_FOUND$9 = "No se encontraron registros";
var LIVE_REACTION$9 = "Reacción en vivo";
var SMILEY_PEOPLE$9 = "Smileys & Gente";
var ANIMALES_NATURE$9 = "Animales y Naturaleza";
var FOOD_DRINK$9 = "Comida y bebida";
var ACTIVITY$9 = "Actividad";
var TRAVEL_PLACES$9 = "Viajes y Lugares";
var OBJECTS$9 = "Objetos";
var SYMBOLS$9 = "Símbolos";
var FLAGS$9 = "Banderas";
var SENT$9 = "Enviado";
var SEEN$9 = "Visto";
var DELIVERED$9 = "Entregado";
var TRANSLATE_MESSAGE$9 = "Traducir mensaje";
var LEFT$9 = "izquierda";
var KICKED$9 = "patadas";
var BANNED$9 = "prohibido";
var NEW_MESSAGES$9 = "mensajes nuevos";
var NEW_MESSAGE$9 = "mensaje nuevo";
var JUMP$9 = "Saltar";
var SELECT_VIDEO_SOURCE$9 = "Seleccionar origen de vídeo";
var SELECT_INPUT_AUDIO_SOURCE$9 = "Seleccionar fuente de audio de entrada";
var SELECT_OUTPUT_AUDIO_SOURCE$9 = "Seleccionar fuente de audio de salida";
var INITIATED_GROUP_CALL$9 = "ha iniciado una llamada de grupo";
var YOU_INITIATED_GROUP_CALL$9 = "Ha iniciado una llamada grupal";
var IGNORE$9 = "Ignorar";
var ON_ANOTHER_CALL$9 = "está en otra llamada";
var CREATING$9 = "Creación";
var AVATAR$9 = "Avatar";
var GROUP_NAME_BLANK$9 = "El nombre del grupo no puede estar en blanco";
var GROUP_TYPE_BLANK$9 = "El tipo de grupo no puede estar en blanco";
var GROUP_PASSWORD_BLANK$9 = "La contraseña de grupo no puede estar en blanco";
var POLL_QUESTION_BLANK$9 = "La pregunta no puede estar en blanco";
var POLL_OPTION_BLANK$9 = "La opción no puede estar en blanco";
var ONGOING_CALL$9 = "Llamada en curso";
var YOU_ALREADY_ONGOING_CALL$9 = "Ya estás en una llamada en curso";
var RESIZE$9 = "Cambiar tamaño";
var SETTINGS$9 = "Configuración";
var ACTIONS$9 = "Acciones";
var VIEW_PROFILE$9 = "Ver perfil";
var SEND_MESSAGE_IN_PRIVATE$9 = "Enviar mensaje en privado";
var DELETE$9 = "Borrar";
var DELETE_CONFIRM$9 = "¿Está seguro de que desea eliminar?";
var CANCEL$9 = "Cancelar";
var LEAVE_CONFIRM$9 = "¿Estás seguro de que quieres dejar el grupo?";
var TRANSFER_CONFIRM$9 = "Usted es el propietario del grupo, por favor transfiera la propiedad a un miembro antes de abandonar el grupo";
var ADDING$9 = "Añadiendo...";
var TRANSFER$9 = "Transferencia";
var TRANSFERRING$9 = "Transferir";
var YES$9 = "Sí";
var NO$9 = "No";
var SOMETHING_WRONG$9 = "Algo salió mal, inténtalo de nuevo";
var INVALID_GROUP_NAME$9 = "Introduce un nombre válido para el grupo e inténtalo de nuevo";
var INVALID_GROUP_TYPE$9 = "Introduce un tipo válido para el grupo e inténtalo de nuevo";
var INVALID_PASSWORD$9 = "Introduce una contraseña válida para el grupo e inténtalo de nuevo";
var WRONG_PASSWORD$9 = "Introduce la contraseña correcta e inténtalo de nuevo";
var INVALID_POLL_QUESTION$9 = "Introduce la pregunta requerida antes de crear una encuesta";
var INVALID_POLL_OPTION$9 = "Introduce la respuesta requerida antes de crear una encuesta";
var SAME_LANGUAGE_MESSAGE$9 = "El idioma seleccionado para la traducción es similar al idioma del mensaje original";
var LEAVE$9 = "Dejar";
var CALLS$9 = "Llamadas";
var CUSTOM_MESSAGE_LOCATION$9 = "📍 Ubicación";
var OFFLINE$9 = "Offline";
var YOU$9 = "Usted";
var PRIVACY$9 = "Privacidad";
var BLOCKED_USERS$9 = "Usuarios bloqueados";
var NO_PHOTOS$9 = "No hay fotos";
var NO_VIDEOS$9 = "No hay vídeos";
var NO_DOCUMENTS$9 = "Sin documentos";
var JOIN$9 = "Unirse";
var NEW_CHAT$9 = "Nuevo chat";
var FORM_COMPLETION_MESSAGE$9 = "Gracias por rellenar el formulario.";
var FORM$9 = "Formulario";
var CARD$9 = "Tarjeta";
var HISTORY$9 = "Historia";
var CANCELLED_AUDIO_CALL$9 = "Llamada de audio cancelada";
var CANCELLED_VIDEO_CALL$9 = "Videollamada cancelada";
var REJECTED_AUDIO_CALL$9 = "Llamada de audio rechazada";
var REJECTED_VIDEO_CALL$9 = "Videollamada rechazada";
var CANCELLED_CALL$9 = "Llamada cancelada";
var UNANSWERED_CALL$9 = "Llamada sin respuesta";
var RECORDING$9 = "Grabación";
var PARTICIPANTS$9 = "Participantes";
var CALL_HISTORY$9 = "Historial de llamadas";
var NO_CALLS_FOUND$9 = "No se encontró ninguna llamada";
var ONGOING_AUDIO_CALL$9 = "Llamada de audio en curso";
var ONGOING_VIDEO_CALL$9 = "Videollamada en curso";
var CALL_DETAIL$9 = "Detalle de la llamada";
var GENERATING_SUMMARY$9 = "Generación de resumen";
var CONVERSATION_SUMMARY$9 = "Resumen de la conversación";
var GENERATE_SUMMARY$9 = "Generar un resumen";
var COMETCHAT_BOT_FIRST_MESSAGE$9 = "¿Cómo puedo ayudarte con esta conversación? Por favor, hazme una pregunta y te asesoraré 🙂";
var COMETCHAT_ASK_BOT$9 = "Preguntar";
var COMETCHAT_ASK_AI_BOT$9 = "Pregúntale a los bots de IA";
var COMETCHAT_ASK_BOT_SUBTITLE$9 = "Bot de IA";
var translationES = {
	USERS: USERS$9,
	CHATS: CHATS$9,
	GROUPS: GROUPS$9,
	NEW__GROUP: NEW__GROUP$9,
	PASSWORD: PASSWORD$9,
	CONTINUE: CONTINUE$9,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$9,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$9,
	SELECT__GROUP: SELECT__GROUP$9,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$9,
	DELETE_CONVERSATION: DELETE_CONVERSATION$9,
	ADD_TO_CHAT: ADD_TO_CHAT$9,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$9,
	MORE: MORE$9,
	READ: READ$9,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$9,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$9,
	GENERATING_REPLIES: GENERATING_REPLIES$9,
	AI: AI$9,
	SMART_REPLIES: SMART_REPLIES$9,
	CONVERSATION_STARTER: CONVERSATION_STARTER$9,
	NO_RECIPIENT: NO_RECIPIENT$9,
	MESSAGE: MESSAGE$9,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$9,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$9,
	NO_RECIPIENTS: NO_RECIPIENTS$9,
	VOICE_RECORDING: VOICE_RECORDING$9,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$9,
	COPY_MESSAGE: COPY_MESSAGE$1,
	MESSAGE_IMAGE: MESSAGE_IMAGE$9,
	NO_USERS_SELECTED: NO_USERS_SELECTED$9,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$9,
	MESSAGE_FILE: MESSAGE_FILE$9,
	MESSAGE_VIDEO: MESSAGE_VIDEO$9,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$9,
	SELECT__USER: SELECT__USER$9,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$9,
	OUTGOING_CALL: OUTGOING_CALL$9,
	OPEN_DOCUMENT: OPEN_DOCUMENT$8,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$8,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$8,
	ADMIN: ADMIN$9,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$8,
	INCOMING_CALL: INCOMING_CALL$9,
	MISSED_CALL: MISSED_CALL$9,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$9,
	ANSWER: ANSWER$9,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$9,
	SET_THE_ANSWERS: SET_THE_ANSWERS$9,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$9,
	SHARED_LOCATION: SHARED_LOCATION$9,
	CALL_DETAILS: CALL_DETAILS$9,
	POLLS: POLLS$9,
	MESSAGE_AUDIO: MESSAGE_AUDIO$9,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$9,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$9,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$9,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$9,
	REMOVE: REMOVE$2,
	BLOCK: BLOCK$2,
	CHANGE_ROLE: CHANGE_ROLE$2,
	VIEW: VIEW$8,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$9,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$9,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$9,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$9,
	ONLINE: ONLINE$9,
	ADMINISTRATOR: ADMINISTRATOR$9,
	MODERATOR: MODERATOR$9,
	PARTICIPANT: PARTICIPANT$9,
	PUBLIC: PUBLIC$9,
	PRIVATE: PRIVATE$9,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$9,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$9,
	PREFERENCES: PREFERENCES$9,
	MEMBERS: MEMBERS$9,
	TODAY: TODAY$9,
	YESTERDAY: YESTERDAY$9,
	SUNDAY: SUNDAY$9,
	MONDAY: MONDAY$9,
	TUESDAY: TUESDAY$9,
	WEDNESDAY: WEDNESDAY$9,
	THURSDAY: THURSDAY$9,
	FRIDAY: FRIDAY$9,
	SATURDAY: SATURDAY$9,
	TYPING: TYPING$9,
	IS_TYPING: IS_TYPING$9,
	CLOSE: CLOSE$9,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$9,
	ADD_MEMBERS: ADD_MEMBERS$9,
	SEND_MESSAGE: SEND_MESSAGE$9,
	UNBLOCK_USER: UNBLOCK_USER$9,
	BLOCK_USER: BLOCK_USER$9,
	DELETE_AND_EXIT: DELETE_AND_EXIT$9,
	LEAVE_GROUP: LEAVE_GROUP$9,
	CREATE_GROUP: CREATE_GROUP$9,
	SHARED_MEDIA: SHARED_MEDIA$9,
	VIDEO_CALL: VIDEO_CALL$9,
	AUDIO_CALL: AUDIO_CALL$9,
	LOADING: LOADING$9,
	REPLY: REPLY$9,
	REPLIES: REPLIES$9,
	LAUNCH: LAUNCH$9,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$9,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$9,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$9,
	CREATED_DOCUMENT: CREATED_DOCUMENT$9,
	PHOTOS: PHOTOS$9,
	VIDEOS: VIDEOS$9,
	DOCUMENT: DOCUMENT$9,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$9,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$9,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$9,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$9,
	SEARCH: SEARCH$9,
	NO_USERS_FOUND: NO_USERS_FOUND$9,
	ERROR: ERROR$9,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$9,
	NO_CHATS_FOUND: NO_CHATS_FOUND$9,
	MEDIA_MESSAGE: MEDIA_MESSAGE$9,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$9,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$9,
	DECLINE: DECLINE$9,
	ACCEPT: ACCEPT$9,
	CALL_INITIATED: CALL_INITIATED$9,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$9,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$9,
	CALL_REJECTED: CALL_REJECTED$9,
	REJECTED_CALL: REJECTED_CALL$9,
	CALL_ACCEPTED: CALL_ACCEPTED$9,
	JOINED: JOINED$9,
	LEFT_THE_CALL: LEFT_THE_CALL$9,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$9,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$9,
	CALL_ENDED: CALL_ENDED$9,
	CALL_CANCELLED: CALL_CANCELLED$9,
	CALL_BUSY: CALL_BUSY$9,
	CALLING: CALLING$9,
	ADD: ADD$9,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$9,
	BANNED_MEMBERS: BANNED_MEMBERS$9,
	NAME: NAME$9,
	SCOPE: SCOPE$9,
	UNBAN: UNBAN$9,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$9,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$9,
	CREATE: CREATE$9,
	CREATE_POLL: CREATE_POLL$9,
	QUESTION: QUESTION$9,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$9,
	OPTIONS: OPTIONS$9,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$9,
	ADD_NEW_OPTION: ADD_NEW_OPTION$9,
	VIEW_MEMBERS: VIEW_MEMBERS$9,
	DETAILS: DETAILS$9,
	NOTIFICATIONS: NOTIFICATIONS$9,
	OTHER: OTHER$9,
	HELP: HELP$9,
	REPORT_PROBLEM: REPORT_PROBLEM$9,
	GROUP_MEMBERS: GROUP_MEMBERS$9,
	BAN: BAN$9,
	KICK: KICK$9,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$9,
	PRIVATE_GROUP: PRIVATE_GROUP$9,
	PROTECTED_GROUP: PROTECTED_GROUP$9,
	VISIT: VISIT$9,
	ATTACH: ATTACH$9,
	ATTACH_FILE: ATTACH_FILE$9,
	ATTACH_VIDEO: ATTACH_VIDEO$9,
	ATTACH_AUDIO: ATTACH_AUDIO$9,
	ATTACH_IMAGE: ATTACH_IMAGE$9,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$9,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$9,
	EMOJI: EMOJI$9,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$9,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$9,
	THREAD: THREAD$9,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$9,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$9,
	ADD_REACTION: ADD_REACTION$9,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$9,
	REPLY_TO_THREAD: REPLY_TO_THREAD$9,
	REPLY_IN_THREAD: REPLY_IN_THREAD$9,
	DELETE_MESSAGE: DELETE_MESSAGE$9,
	EDIT_MESSAGE: EDIT_MESSAGE$9,
	OWNER: OWNER$9,
	CHANGE_SCOPE: CHANGE_SCOPE$9,
	STICKER: STICKER$9,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$9,
	VOICE_CALL: VOICE_CALL$9,
	VIEW_DETAIL: VIEW_DETAIL$9,
	VOTES: VOTES$9,
	VOTE: VOTE$9,
	NO_VOTE: NO_VOTE$9,
	REACTED: REACTED$9,
	ADDED: ADDED$9,
	UNBANNED: UNBANNED$9,
	MADE: MADE$9,
	CALL_UNANSWERED: CALL_UNANSWERED$9,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$9,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$9,
	DOCS: DOCS$9,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$9,
	LIVE_REACTION: LIVE_REACTION$9,
	SMILEY_PEOPLE: SMILEY_PEOPLE$9,
	ANIMALES_NATURE: ANIMALES_NATURE$9,
	FOOD_DRINK: FOOD_DRINK$9,
	ACTIVITY: ACTIVITY$9,
	TRAVEL_PLACES: TRAVEL_PLACES$9,
	OBJECTS: OBJECTS$9,
	SYMBOLS: SYMBOLS$9,
	FLAGS: FLAGS$9,
	SENT: SENT$9,
	SEEN: SEEN$9,
	DELIVERED: DELIVERED$9,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$9,
	LEFT: LEFT$9,
	KICKED: KICKED$9,
	BANNED: BANNED$9,
	NEW_MESSAGES: NEW_MESSAGES$9,
	NEW_MESSAGE: NEW_MESSAGE$9,
	JUMP: JUMP$9,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$9,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$9,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$9,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$9,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$9,
	IGNORE: IGNORE$9,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$9,
	CREATING: CREATING$9,
	AVATAR: AVATAR$9,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$9,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$9,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$9,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$9,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$9,
	ONGOING_CALL: ONGOING_CALL$9,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$9,
	RESIZE: RESIZE$9,
	SETTINGS: SETTINGS$9,
	ACTIONS: ACTIONS$9,
	VIEW_PROFILE: VIEW_PROFILE$9,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$9,
	DELETE: DELETE$9,
	DELETE_CONFIRM: DELETE_CONFIRM$9,
	CANCEL: CANCEL$9,
	LEAVE_CONFIRM: LEAVE_CONFIRM$9,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$9,
	ADDING: ADDING$9,
	TRANSFER: TRANSFER$9,
	TRANSFERRING: TRANSFERRING$9,
	YES: YES$9,
	NO: NO$9,
	SOMETHING_WRONG: SOMETHING_WRONG$9,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$9,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$9,
	INVALID_PASSWORD: INVALID_PASSWORD$9,
	WRONG_PASSWORD: WRONG_PASSWORD$9,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$9,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$9,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$9,
	LEAVE: LEAVE$9,
	CALLS: CALLS$9,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$9,
	OFFLINE: OFFLINE$9,
	YOU: YOU$9,
	PRIVACY: PRIVACY$9,
	BLOCKED_USERS: BLOCKED_USERS$9,
	"YOU'VE_BLOCKED": "Has bloqueado",
	NO_PHOTOS: NO_PHOTOS$9,
	NO_VIDEOS: NO_VIDEOS$9,
	NO_DOCUMENTS: NO_DOCUMENTS$9,
	JOIN: JOIN$9,
	NEW_CHAT: NEW_CHAT$9,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$9,
	FORM: FORM$9,
	CARD: CARD$9,
	HISTORY: HISTORY$9,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$9,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$9,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$9,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$9,
	CANCELLED_CALL: CANCELLED_CALL$9,
	UNANSWERED_CALL: UNANSWERED_CALL$9,
	RECORDING: RECORDING$9,
	PARTICIPANTS: PARTICIPANTS$9,
	CALL_HISTORY: CALL_HISTORY$9,
	NO_CALLS_FOUND: NO_CALLS_FOUND$9,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$9,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$9,
	CALL_DETAIL: CALL_DETAIL$9,
	GENERATING_SUMMARY: GENERATING_SUMMARY$9,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$9,
	GENERATE_SUMMARY: GENERATE_SUMMARY$9,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$9,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$9,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$9,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$9
};

var USERS$8 = "Utilisateurs";
var CHATS$8 = "Discussions";
var GROUPS$8 = "Groupes";
var MORE$8 = "Plus";
var MESSAGE_IMAGE$8 = "📷 Image";
var MESSAGE_FILE$8 = "📁 Fichier";
var NEW__GROUP$8 = "Nouveau groupe";
var PASSWORD$8 = "Mot de passe";
var CONTINUE$8 = "Continuer";
var READ$8 = "Lisez";
var AI$8 = "IA";
var SMART_REPLIES$8 = "Réponses intelligentes";
var CONVERSATION_STARTER$8 = "Démarreur de conversation";
var VOICE_RECORDING$8 = "Enregistrement vocal";
var MESSAGE_INFORMATION$8 = "Informations sur le message";
var NO_RECIPIENT$8 = "Aucun destinataire";
var MESSAGE$8 = "Message";
var RECEIPT_INFORMATION$8 = "Informations sur les reçus";
var NO_RECIPIENTS$8 = "Aucun bénéficiaire";
var REACT_TO_MESSAGE$8 = "Réagir à un message";
var SHOW_UNSAFE_CONTENT$8 = "Êtes-vous sûr de vouloir afficher du contenu dangereux ?";
var NO_CHATS_SELECTED$8 = "Aucun chat sélectionné";
var NO_REPLIES_FOUND$8 = "Aucune réponse trouvée";
var SUGGEST_A_REPLY$8 = "Suggérer une réponse";
var GENERATING_ICEBREAKERS$8 = "Génération de brise-glaces";
var GENERATING_REPLIES$8 = "Génération de réponses";
var SELECT__GROUP$8 = "Sélectionnez un groupe pour commencer à envoyer des messages";
var DELETE_CONVERSATION$8 = "Supprimer la conversation?";
var ADD_TO_CHAT$8 = "Ajouter au chat";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$8 = "Voulez-vous supprimer cette conversation ? Cette conversation sera supprimée de tous vos appareils.";
var MESSAGE_VIDEO$8 = "📹 Vidéo";
var SHARED_FILE$2 = "Fichier partagé";
var NO_USERS_SELECTED$8 = "Aucun utilisateur sélectionné";
var NO_GROUPS_SELECTED$8 = "Aucun groupe sélectionné";
var MESSAGE_AUDIO$8 = "🎵 Audio";
var NO_CALLS_SELECTED$8 = "Aucun appel sélectionné";
var SELECT__USER$8 = "Sélectionnez un utilisateur pour commencer à discuter";
var CANT__LOAD__CHATS$8 = "Impossible de charger les discussions";
var OUTGOING_CALL$8 = "Appel sortant";
var DRAW_DOCUMENT_TOGETHER$7 = "Ouvrir le document pour éditer le contenu ensemble";
var DRAW_WHITEBOARD_TOGETHER$7 = "Ouvrir le tableau blanc pour dessiner ensemble";
var ADMIN$8 = "Admin";
var OPEN_DOCUMENT$7 = "Ouvrir le document";
var INCOMING_CALL$8 = "Appel entrant";
var MISSED_CALL$8 = "Appel manqué";
var OPEN_WHITEBOARD$7 = "Ouvrir le tableau blanc";
var TRANSLATED_MESSAGE$8 = "Message traduit";
var ANSWER$8 = "Répondre";
var ADD_ANOTHER_ANSWER$8 = "Ajouter une autre réponse";
var SET_THE_ANSWERS$8 = "Définir les réponses";
var CLICK_TO_START_CONVERSATION$8 = "Cliquez pour commencer la conversation";
var SHARED_LOCATION$8 = "Emplacement partagé";
var CALL_DETAILS$8 = "Détails de l'appel";
var POLLS$8 = "Sondages";
var CUSTOM_MESSAGE$8 = "Vous avez un message";
var MISSED_VOICE_CALL$8 = "Appel vocal manqué";
var MISSED_VIDEO_CALL$8 = "Appel vidéo manqué";
var CUSTOM_MESSAGE_POLL$8 = "📊 Sondage";
var CUSTOM_MESSAGE_STICKER$8 = "💟 Autocollant";
var TRANSFER_OWNERSHIP$8 = "Transfert de propriété";
var CUSTOM_MESSAGE_DOCUMENT$8 = "📃 Document";
var REMOVE$1 = "retirer";
var BLOCK$1 = "bloc";
var CHANGE_ROLE$1 = "changer de rôle";
var VIEW$7 = "voir";
var CUSTOM_MESSAGE_WHITEBOARD$8 = "📝 Tableau blanc";
var ONLINE$8 = "En ligne";
var ADMINISTRATOR$8 = "Administrateur";
var MODERATOR$8 = "Modérateur";
var PARTICIPANT$8 = "Participant";
var PUBLIC$8 = "Public";
var PRIVATE$8 = "Privé";
var PASSWORD_PROTECTED$8 = "Mot de passe";
var PRIVACY_AND_SECURITY$8 = "Confidentialité et sécurité";
var PREFERENCES$8 = "Préférences";
var MEMBERS$8 = "Membres";
var TODAY$8 = "Aujourd'hui";
var YESTERDAY$8 = "Hier";
var SUNDAY$8 = "Dimanche";
var MONDAY$8 = "Lundi";
var TUESDAY$8 = "Mardi";
var WEDNESDAY$8 = "Mercredi";
var THURSDAY$8 = "Jeudi";
var FRIDAY$8 = "Vendredi";
var SATURDAY$8 = "Samedi";
var TYPING$8 = "dactylographie...";
var IS_TYPING$8 = "est en train de taper...";
var CLOSE$8 = "Fermer";
var ENTER_GROUP_NAME$8 = "Saisir le nom du groupe";
var ADD_MEMBERS$8 = "Ajouter des membres";
var SEND_MESSAGE$8 = "Envoyer un message";
var UNBLOCK_USER$8 = "Débloquer l'utilisateur";
var BLOCK_USER$8 = "Bloquer l'utilisateur";
var DELETE_AND_EXIT$8 = "Supprimer et quitter";
var LEAVE_GROUP$8 = "Groupe de congé";
var CREATE_GROUP$8 = "Créer un groupe";
var SHARED_MEDIA$8 = "Médias partagés";
var VIDEO_CALL$8 = "Appel vidéo";
var AUDIO_CALL$8 = "Appel audio";
var LOADING$8 = "Chargement...";
var REPLY$8 = "répondre";
var REPLIES$8 = "réponses";
var LAUNCH$8 = "Lancement";
var SHARED_COLLABORATIVE_DOCUMENT$8 = "a partagé un document collaboratif";
var SHARED_COLLABORATIVE_WHITEBOARD$8 = "a partagé un tableau blanc collaboratif";
var CREATED_WHITEBOARD$8 = "Vous avez créé un nouveau tableau blanc collaboratif";
var CREATED_DOCUMENT$8 = "Vous avez créé un nouveau document collaboratif";
var PHOTOS$8 = "Photos";
var VIDEOS$8 = "Vidéos";
var DOCUMENT$8 = "Document";
var YOU_DELETED_THIS_MESSAGE$8 = "⚠️ Vous avez supprimé ce message";
var THIS_MESSAGE_DELETED$8 = "⚠️ Ce message a été supprimé";
var MESSAGE_IS_DELETED$8 = "Le message est supprimé";
var VIEW_ON_YOUTUBE$8 = "Voir sur Youtube";
var SEARCH$8 = "Rechercher";
var NO_USERS_FOUND$8 = "Aucun utilisateur trouvé";
var ERROR$8 = "Erreur";
var NO_GROUPS_FOUND$8 = "Aucun groupe trouvé";
var NO_CHATS_FOUND$8 = "Aucun chat trouvé";
var MEDIA_MESSAGE$8 = "Message pour les médias";
var INCOMING_AUDIO_CALL$8 = "Appel audio entrant";
var INCOMING_VIDEO_CALL$8 = "Appel vidéo entrant";
var DECLINE$8 = "Refuser";
var ACCEPT$8 = "Accepter";
var CALL_INITIATED$8 = "Appel lancé";
var OUTGOING_AUDIO_CALL$8 = "Appel audio sortant";
var OUTGOING_VIDEO_CALL$8 = "Appel vidéo sortant";
var CALL_REJECTED$8 = "Appel rejeté";
var REJECTED_CALL$8 = "appel rejeté";
var CALL_ACCEPTED$8 = "Appel accepté";
var JOINED$8 = "joint";
var LEFT_THE_CALL$8 = "a quitté l'appel";
var UNANSWERED_AUDIO_CALL$8 = "Appel audio sans réponse";
var UNANSWERED_VIDEO_CALL$8 = "Appel vidéo sans réponse";
var CALL_ENDED$8 = "Appel terminé";
var CALL_CANCELLED$8 = "Appel annulé";
var CALL_BUSY$8 = "Appeler occupé";
var CALLING$8 = "Appeler...";
var ADD$8 = "Ajouter";
var NO_BANNED_MEMBERS_FOUND$8 = "Aucun membre interdit n'a été trouvé";
var BANNED_MEMBERS$8 = "Membres interdits";
var NAME$8 = "Nom";
var SCOPE$8 = "Portée";
var UNBAN$8 = "Unban";
var SELECT_GROUP_TYPE$8 = "Sélectionner le type de groupe";
var ENTER_GROUP_PASSWORD$8 = "Saisir le mot de passe";
var CREATE$8 = "Créer";
var CREATE_POLL$8 = "Créer un sondage";
var QUESTION$8 = "Question";
var ENTER_YOUR_QUESTION$8 = "Saisissez votre question";
var OPTIONS$8 = "Options";
var ENTER_YOUR_OPTION$8 = "Saisissez votre option";
var ADD_NEW_OPTION$8 = "Ajouter une nouvelle option";
var VIEW_MEMBERS$8 = "Afficher les membres";
var DETAILS$8 = "Détails";
var NOTIFICATIONS$8 = "Notifications";
var OTHER$8 = "Autres";
var HELP$8 = "Aide";
var REPORT_PROBLEM$8 = "Signaler un problème";
var GROUP_MEMBERS$8 = "Membres du groupe";
var BAN$8 = "Interdiction";
var KICK$8 = "Coup de pied";
var PICK_YOUR_EMOJI$8 = "Choisissez vos emoji";
var PRIVATE_GROUP$8 = "Groupe privé";
var PROTECTED_GROUP$8 = "Groupe protégé";
var VISIT$8 = "Visitez";
var ATTACH$8 = "Attacher";
var ATTACH_FILE$8 = "Joindre le fichier";
var ATTACH_VIDEO$8 = "Joindre une vidéo";
var ATTACH_AUDIO$8 = "Attacher audio";
var ATTACH_IMAGE$8 = "Joindre l'image";
var COLLABORATE_USING_DOCUMENT$8 = "Collaborer à l'aide d'un document";
var COLLABORATE_USING_WHITEBOARD$8 = "Collaborez à l'aide d'un tableau blanc";
var EMOJI$8 = "Emoji";
var ENTER_YOUR_MESSAGE_HERE$8 = "Entrez votre message ici";
var NO_MESSAGES_FOUND$8 = "Aucun message trouvé";
var THREAD$8 = "Fil";
var COLLABORATIVE_DOCUMENT$8 = "Document collaboratif";
var COLLABORATIVE_WHITEBOARD$8 = "Tableau blanc collaboratif";
var ADD_REACTION$8 = "Ajouter une réaction";
var NO_STICKERS_FOUND$8 = "Aucun autocollant trouvé";
var REPLY_TO_THREAD$8 = "Répondre au fil";
var REPLY_IN_THREAD$8 = "Répondre dans le thread";
var DELETE_MESSAGE$8 = "Supprimer un message";
var EDIT_MESSAGE$8 = "Modifier le message";
var OWNER$8 = "Propriétaire";
var CHANGE_SCOPE$8 = "Modifier l'étendue";
var STICKER$8 = "Autocollant";
var LAST_ACTIVE_AT$8 = "Dernier actif à";
var VOICE_CALL$8 = "Appel vocal";
var VIEW_DETAIL$8 = "Afficher les détails";
var VOTES$8 = "votes";
var VOTE$8 = "vote";
var NO_VOTE$8 = "Pas de vote";
var REACTED$8 = "réagissait";
var ADDED$8 = "ajoutée";
var UNBANNED$8 = "non interdite";
var MADE$8 = "confectionné";
var CALL_UNANSWERED$8 = "Appel sans réponse";
var MISSED_AUDIO_CALL$8 = "Appel audio manqué";
var ENTER_YOUR_PASSWORD$8 = "Entrez votre mot de passe";
var DOCS$8 = "Docs";
var NO_RECORDS_FOUND$8 = "Aucun enregistrement trouvé";
var LIVE_REACTION$8 = "Réaction en direct";
var SMILEY_PEOPLE$8 = "Smileys & Personnes";
var ANIMALES_NATURE$8 = "Animaux & Nature";
var FOOD_DRINK$8 = "Nourriture et boissons";
var ACTIVITY$8 = "Activité";
var TRAVEL_PLACES$8 = "Voyages & Lieux";
var OBJECTS$8 = "Objets";
var SYMBOLS$8 = "Symboles";
var FLAGS$8 = "Drapeaux";
var SENT$8 = "Envoyé";
var SEEN$8 = "Vu";
var DELIVERED$8 = "Livré";
var TRANSLATE_MESSAGE$8 = "Traduire message";
var LEFT$8 = "parti";
var KICKED$8 = "coup de pied";
var BANNED$8 = "interdit";
var NEW_MESSAGES$8 = "nouveaux messages";
var NEW_MESSAGE$8 = "nouveau message";
var JUMP$8 = "Sauter";
var SELECT_VIDEO_SOURCE$8 = "Sélectionner la source vidéo";
var SELECT_INPUT_AUDIO_SOURCE$8 = "Sélectionner la source audio d'entrée";
var SELECT_OUTPUT_AUDIO_SOURCE$8 = "Sélectionner la source audio de sortie";
var INITIATED_GROUP_CALL$8 = "a lancé un appel de groupe";
var YOU_INITIATED_GROUP_CALL$8 = "Vous avez lancé un appel de groupe";
var IGNORE$8 = "Ignore";
var ON_ANOTHER_CALL$8 = "est sur un autre appel";
var CREATING$8 = "Création";
var AVATAR$8 = "Avatar";
var GROUP_NAME_BLANK$8 = "Le nom du groupe ne peut pas être vide";
var GROUP_TYPE_BLANK$8 = "Le type de groupe ne peut pas être vide";
var GROUP_PASSWORD_BLANK$8 = "Le mot de passe du groupe ne peut pas être vide";
var POLL_QUESTION_BLANK$8 = "La question ne peut pas être vide";
var POLL_OPTION_BLANK$8 = "Option ne peut pas être vide";
var ONGOING_CALL$8 = "Appel en cours";
var YOU_ALREADY_ONGOING_CALL$8 = "Vous êtes déjà en cours d'appel";
var RESIZE$8 = "Redimensionner";
var SETTINGS$8 = "Paramètres";
var ACTIONS$8 = "Actions";
var VIEW_PROFILE$8 = "Voir le profil";
var SEND_MESSAGE_IN_PRIVATE$8 = "Envoyer un message privately";
var DELETE$8 = "Supprimer";
var DELETE_CONFIRM$8 = "Êtes-vous sûr de vouloir supprimer ?";
var CANCEL$8 = "Annuler";
var LEAVE_CONFIRM$8 = "Êtes-vous sûr de vouloir quitter le groupe ?";
var TRANSFER_CONFIRM$8 = "Vous êtes le propriétaire du groupe, veuillez transférer la propriété à un membre avant de quitter le groupe.";
var ADDING$8 = "Ajout de...";
var TRANSFER$8 = "Transfert";
var TRANSFERRING$8 = "Transfert";
var YES$8 = "Oui";
var NO$8 = "Non";
var SOMETHING_WRONG$8 = "Quelque chose s'est mal passé, veuillez réessayer";
var INVALID_GROUP_NAME$8 = "Veuillez saisir un nom valide pour le groupe et réessayer.";
var INVALID_GROUP_TYPE$8 = "Veuillez saisir un type valide pour le groupe, puis réessayer";
var INVALID_PASSWORD$8 = "Veuillez saisir un mot de passe valide pour le groupe, puis réessayer";
var WRONG_PASSWORD$8 = "Veuillez saisir le bon mot de passe et réessayer";
var INVALID_POLL_QUESTION$8 = "Veuillez saisir la question requise avant de créer un sondage";
var INVALID_POLL_OPTION$8 = "Veuillez saisir la réponse requise avant de créer un sondage";
var SAME_LANGUAGE_MESSAGE$8 = "La langue sélectionnée pour la traduction est similaire à la langue du message d'origine";
var LEAVE$8 = "Partez";
var CALLS$8 = "Appels";
var CUSTOM_MESSAGE_LOCATION$8 = "📍 Emplacement";
var OFFLINE$8 = "Hors ligne";
var YOU$8 = "Vous";
var PRIVACY$8 = "Vie privée";
var BLOCKED_USERS$8 = "Utilisateurs bloqués";
var NO_PHOTOS$8 = "Pas de photos";
var NO_VIDEOS$8 = "Pas de vidéos";
var NO_DOCUMENTS$8 = "Aucun document";
var JOIN$8 = "Rejoignez";
var NEW_CHAT$8 = "Nouveau chat";
var FORM_COMPLETION_MESSAGE$8 = "Merci d'avoir rempli le formulaire.";
var FORM$8 = "Formulaire";
var CARD$8 = "Carte";
var HISTORY$8 = "L'histoire";
var CANCELLED_AUDIO_CALL$8 = "Appel audio annulé";
var CANCELLED_VIDEO_CALL$8 = "Appel vidéo annulé";
var REJECTED_AUDIO_CALL$8 = "Appel audio rejeté";
var REJECTED_VIDEO_CALL$8 = "Appel vidéo refusé";
var CANCELLED_CALL$8 = "Appel annulé";
var UNANSWERED_CALL$8 = "Appel sans réponse";
var RECORDING$8 = "Enregistrement";
var PARTICIPANTS$8 = "Participants";
var CALL_HISTORY$8 = "Historique des appels";
var NO_CALLS_FOUND$8 = "Aucun appel n'a été trouvé";
var ONGOING_AUDIO_CALL$8 = "Appel audio en cours";
var ONGOING_VIDEO_CALL$8 = "Appel vidéo en cours";
var CALL_DETAIL$8 = "Détail de l'appel";
var GENERATING_SUMMARY$8 = "Génération d'un résumé";
var CONVERSATION_SUMMARY$8 = "Résumé de la conversation";
var GENERATE_SUMMARY$8 = "Générez un résumé";
var COMETCHAT_BOT_FIRST_MESSAGE$8 = "Comment puis-je vous aider dans cette conversation ? Posez-moi une question et je vous conseillerai 🙂";
var COMETCHAT_ASK_BOT$8 = "Demandez";
var COMETCHAT_ASK_AI_BOT$8 = "Demandez à AI Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$8 = "Robot IA";
var translationFR = {
	USERS: USERS$8,
	CHATS: CHATS$8,
	GROUPS: GROUPS$8,
	MORE: MORE$8,
	MESSAGE_IMAGE: MESSAGE_IMAGE$8,
	MESSAGE_FILE: MESSAGE_FILE$8,
	NEW__GROUP: NEW__GROUP$8,
	PASSWORD: PASSWORD$8,
	CONTINUE: CONTINUE$8,
	READ: READ$8,
	AI: AI$8,
	SMART_REPLIES: SMART_REPLIES$8,
	CONVERSATION_STARTER: CONVERSATION_STARTER$8,
	VOICE_RECORDING: VOICE_RECORDING$8,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$8,
	NO_RECIPIENT: NO_RECIPIENT$8,
	MESSAGE: MESSAGE$8,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$8,
	NO_RECIPIENTS: NO_RECIPIENTS$8,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$8,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$8,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$8,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$8,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$8,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$8,
	GENERATING_REPLIES: GENERATING_REPLIES$8,
	SELECT__GROUP: SELECT__GROUP$8,
	DELETE_CONVERSATION: DELETE_CONVERSATION$8,
	ADD_TO_CHAT: ADD_TO_CHAT$8,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$8,
	MESSAGE_VIDEO: MESSAGE_VIDEO$8,
	SHARED_FILE: SHARED_FILE$2,
	NO_USERS_SELECTED: NO_USERS_SELECTED$8,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$8,
	MESSAGE_AUDIO: MESSAGE_AUDIO$8,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$8,
	SELECT__USER: SELECT__USER$8,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$8,
	OUTGOING_CALL: OUTGOING_CALL$8,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$7,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$7,
	ADMIN: ADMIN$8,
	OPEN_DOCUMENT: OPEN_DOCUMENT$7,
	INCOMING_CALL: INCOMING_CALL$8,
	MISSED_CALL: MISSED_CALL$8,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$7,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$8,
	ANSWER: ANSWER$8,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$8,
	SET_THE_ANSWERS: SET_THE_ANSWERS$8,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$8,
	SHARED_LOCATION: SHARED_LOCATION$8,
	CALL_DETAILS: CALL_DETAILS$8,
	POLLS: POLLS$8,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$8,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$8,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$8,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$8,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$8,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$8,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$8,
	REMOVE: REMOVE$1,
	BLOCK: BLOCK$1,
	CHANGE_ROLE: CHANGE_ROLE$1,
	VIEW: VIEW$7,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$8,
	ONLINE: ONLINE$8,
	ADMINISTRATOR: ADMINISTRATOR$8,
	MODERATOR: MODERATOR$8,
	PARTICIPANT: PARTICIPANT$8,
	PUBLIC: PUBLIC$8,
	PRIVATE: PRIVATE$8,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$8,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$8,
	PREFERENCES: PREFERENCES$8,
	MEMBERS: MEMBERS$8,
	TODAY: TODAY$8,
	YESTERDAY: YESTERDAY$8,
	SUNDAY: SUNDAY$8,
	MONDAY: MONDAY$8,
	TUESDAY: TUESDAY$8,
	WEDNESDAY: WEDNESDAY$8,
	THURSDAY: THURSDAY$8,
	FRIDAY: FRIDAY$8,
	SATURDAY: SATURDAY$8,
	TYPING: TYPING$8,
	IS_TYPING: IS_TYPING$8,
	CLOSE: CLOSE$8,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$8,
	ADD_MEMBERS: ADD_MEMBERS$8,
	SEND_MESSAGE: SEND_MESSAGE$8,
	UNBLOCK_USER: UNBLOCK_USER$8,
	BLOCK_USER: BLOCK_USER$8,
	DELETE_AND_EXIT: DELETE_AND_EXIT$8,
	LEAVE_GROUP: LEAVE_GROUP$8,
	CREATE_GROUP: CREATE_GROUP$8,
	SHARED_MEDIA: SHARED_MEDIA$8,
	VIDEO_CALL: VIDEO_CALL$8,
	AUDIO_CALL: AUDIO_CALL$8,
	LOADING: LOADING$8,
	REPLY: REPLY$8,
	REPLIES: REPLIES$8,
	LAUNCH: LAUNCH$8,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$8,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$8,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$8,
	CREATED_DOCUMENT: CREATED_DOCUMENT$8,
	PHOTOS: PHOTOS$8,
	VIDEOS: VIDEOS$8,
	DOCUMENT: DOCUMENT$8,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$8,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$8,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$8,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$8,
	SEARCH: SEARCH$8,
	NO_USERS_FOUND: NO_USERS_FOUND$8,
	ERROR: ERROR$8,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$8,
	NO_CHATS_FOUND: NO_CHATS_FOUND$8,
	MEDIA_MESSAGE: MEDIA_MESSAGE$8,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$8,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$8,
	DECLINE: DECLINE$8,
	ACCEPT: ACCEPT$8,
	CALL_INITIATED: CALL_INITIATED$8,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$8,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$8,
	CALL_REJECTED: CALL_REJECTED$8,
	REJECTED_CALL: REJECTED_CALL$8,
	CALL_ACCEPTED: CALL_ACCEPTED$8,
	JOINED: JOINED$8,
	LEFT_THE_CALL: LEFT_THE_CALL$8,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$8,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$8,
	CALL_ENDED: CALL_ENDED$8,
	CALL_CANCELLED: CALL_CANCELLED$8,
	CALL_BUSY: CALL_BUSY$8,
	CALLING: CALLING$8,
	ADD: ADD$8,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$8,
	BANNED_MEMBERS: BANNED_MEMBERS$8,
	NAME: NAME$8,
	SCOPE: SCOPE$8,
	UNBAN: UNBAN$8,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$8,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$8,
	CREATE: CREATE$8,
	CREATE_POLL: CREATE_POLL$8,
	QUESTION: QUESTION$8,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$8,
	OPTIONS: OPTIONS$8,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$8,
	ADD_NEW_OPTION: ADD_NEW_OPTION$8,
	VIEW_MEMBERS: VIEW_MEMBERS$8,
	DETAILS: DETAILS$8,
	NOTIFICATIONS: NOTIFICATIONS$8,
	OTHER: OTHER$8,
	HELP: HELP$8,
	REPORT_PROBLEM: REPORT_PROBLEM$8,
	GROUP_MEMBERS: GROUP_MEMBERS$8,
	BAN: BAN$8,
	KICK: KICK$8,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$8,
	PRIVATE_GROUP: PRIVATE_GROUP$8,
	PROTECTED_GROUP: PROTECTED_GROUP$8,
	VISIT: VISIT$8,
	ATTACH: ATTACH$8,
	ATTACH_FILE: ATTACH_FILE$8,
	ATTACH_VIDEO: ATTACH_VIDEO$8,
	ATTACH_AUDIO: ATTACH_AUDIO$8,
	ATTACH_IMAGE: ATTACH_IMAGE$8,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$8,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$8,
	EMOJI: EMOJI$8,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$8,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$8,
	THREAD: THREAD$8,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$8,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$8,
	ADD_REACTION: ADD_REACTION$8,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$8,
	REPLY_TO_THREAD: REPLY_TO_THREAD$8,
	REPLY_IN_THREAD: REPLY_IN_THREAD$8,
	DELETE_MESSAGE: DELETE_MESSAGE$8,
	EDIT_MESSAGE: EDIT_MESSAGE$8,
	OWNER: OWNER$8,
	CHANGE_SCOPE: CHANGE_SCOPE$8,
	STICKER: STICKER$8,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$8,
	VOICE_CALL: VOICE_CALL$8,
	VIEW_DETAIL: VIEW_DETAIL$8,
	VOTES: VOTES$8,
	VOTE: VOTE$8,
	NO_VOTE: NO_VOTE$8,
	REACTED: REACTED$8,
	ADDED: ADDED$8,
	UNBANNED: UNBANNED$8,
	MADE: MADE$8,
	CALL_UNANSWERED: CALL_UNANSWERED$8,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$8,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$8,
	DOCS: DOCS$8,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$8,
	LIVE_REACTION: LIVE_REACTION$8,
	SMILEY_PEOPLE: SMILEY_PEOPLE$8,
	ANIMALES_NATURE: ANIMALES_NATURE$8,
	FOOD_DRINK: FOOD_DRINK$8,
	ACTIVITY: ACTIVITY$8,
	TRAVEL_PLACES: TRAVEL_PLACES$8,
	OBJECTS: OBJECTS$8,
	SYMBOLS: SYMBOLS$8,
	FLAGS: FLAGS$8,
	SENT: SENT$8,
	SEEN: SEEN$8,
	DELIVERED: DELIVERED$8,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$8,
	LEFT: LEFT$8,
	KICKED: KICKED$8,
	BANNED: BANNED$8,
	NEW_MESSAGES: NEW_MESSAGES$8,
	NEW_MESSAGE: NEW_MESSAGE$8,
	JUMP: JUMP$8,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$8,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$8,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$8,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$8,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$8,
	IGNORE: IGNORE$8,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$8,
	CREATING: CREATING$8,
	AVATAR: AVATAR$8,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$8,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$8,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$8,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$8,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$8,
	ONGOING_CALL: ONGOING_CALL$8,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$8,
	RESIZE: RESIZE$8,
	SETTINGS: SETTINGS$8,
	ACTIONS: ACTIONS$8,
	VIEW_PROFILE: VIEW_PROFILE$8,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$8,
	DELETE: DELETE$8,
	DELETE_CONFIRM: DELETE_CONFIRM$8,
	CANCEL: CANCEL$8,
	LEAVE_CONFIRM: LEAVE_CONFIRM$8,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$8,
	ADDING: ADDING$8,
	TRANSFER: TRANSFER$8,
	TRANSFERRING: TRANSFERRING$8,
	YES: YES$8,
	NO: NO$8,
	SOMETHING_WRONG: SOMETHING_WRONG$8,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$8,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$8,
	INVALID_PASSWORD: INVALID_PASSWORD$8,
	WRONG_PASSWORD: WRONG_PASSWORD$8,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$8,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$8,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$8,
	LEAVE: LEAVE$8,
	CALLS: CALLS$8,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$8,
	OFFLINE: OFFLINE$8,
	YOU: YOU$8,
	PRIVACY: PRIVACY$8,
	BLOCKED_USERS: BLOCKED_USERS$8,
	"YOU'VE_BLOCKED": "Vous avez bloqué",
	NO_PHOTOS: NO_PHOTOS$8,
	NO_VIDEOS: NO_VIDEOS$8,
	NO_DOCUMENTS: NO_DOCUMENTS$8,
	JOIN: JOIN$8,
	NEW_CHAT: NEW_CHAT$8,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$8,
	FORM: FORM$8,
	CARD: CARD$8,
	HISTORY: HISTORY$8,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$8,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$8,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$8,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$8,
	CANCELLED_CALL: CANCELLED_CALL$8,
	UNANSWERED_CALL: UNANSWERED_CALL$8,
	RECORDING: RECORDING$8,
	PARTICIPANTS: PARTICIPANTS$8,
	CALL_HISTORY: CALL_HISTORY$8,
	NO_CALLS_FOUND: NO_CALLS_FOUND$8,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$8,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$8,
	CALL_DETAIL: CALL_DETAIL$8,
	GENERATING_SUMMARY: GENERATING_SUMMARY$8,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$8,
	GENERATE_SUMMARY: GENERATE_SUMMARY$8,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$8,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$8,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$8,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$8
};

var USERS$7 = "उपयोक्ता";
var CHATS$7 = "चैट";
var GROUPS$7 = "समूह";
var SHARED = "साझा";
var SOUND_MANAGER = "ध्वनि प्रबंधक";
var THEME = "थीम";
var COPY_MESSAGE = "प्रतिलिपि";
var LOCALIZE = "स्थानीय बनाना";
var READ$7 = "पढ़ें";
var MESSAGE_INFORMATION$7 = "संदेश की जानकारी";
var CONVERSATION_LIST_ITEM = "वार्तालाप सूची आइटम";
var DATA_ITEM = "डेटा आइटम";
var AI$7 = "एआई";
var SMART_REPLIES$7 = "स्मार्ट रिप्लाई";
var CONVERSATION_STARTER$7 = "वार्तालाप स्टार्टर";
var STATUS_INDICATOR = "स्थिति संकेतक";
var REACT_TO_MESSAGE$7 = "संदेश पर प्रतिक्रिया करें";
var NO_RECIPIENT$7 = "कोई प्राप्तकर्ता नहीं";
var MESSAGE$7 = "सन्देश";
var RECEIPT_INFORMATION$7 = "रसीद की जानकारी";
var NO_REPLIES_FOUND$7 = "कोई जवाब नहीं मिला";
var NO_RECIPIENTS$7 = "कोई प्राप्तकर्ता नहीं";
var BADGE_COUNT = "बैज गणना";
var SHOW_UNSAFE_CONTENT$7 = "क्या आप सुरक्षित नहीं माने जाने वाली सामग्री देखना चाहते हैं?";
var MESSAGE_RECEIPT = "संदेश रसीद";
var CONVERSATIONS_WITH_MESSAGES = "संदेशों के साथ बातचीत";
var CONVERSATIONS = "बात चिट";
var VOICE_RECORDING$7 = "वॉइस रिकॉर्डिंग";
var SUGGEST_A_REPLY$7 = "जवाब सुझाएं";
var GENERATING_ICEBREAKERS$7 = "आइसब्रेकर उत्पन्न करना";
var GENERATING_REPLIES$7 = "जवाब जनरेट करना";
var CONVERSATION_LIST = "बातचीत की सूची";
var MESSAGES = "संदेशों";
var NO_USERS_SELECTED$7 = "कोई उपयोगकर्ता चयनित नहीं";
var NO_GROUPS_SELECTED$7 = "कोई समूह चयनित नहीं";
var SHARED_FILE$1 = "साझा फ़ाइल";
var TRANSFER_OWNERSHIP$7 = "स्थानांतरण स्वामित्व";
var MESSAGE_HEADER = "संदेश हैडर";
var NO_CHATS_SELECTED$7 = "कोई चैट चयनित नहीं";
var REMOVE = "निकालना";
var BLOCK = "अवरोध पैदा करना";
var OPEN_DOCUMENT$6 = "दस्तावेज़ खोलें";
var NO_CALLS_SELECTED$7 = "कोई कॉल चयनित नहीं है";
var SELECT__USER$7 = "संदेश भेजना शुरू करने के लिए एक उपयोगकर्ता का चयन करें";
var CANT__LOAD__CHATS$7 = "चैट्स लोड नहीं कर सकते";
var OUTGOING_CALL$7 = "आउटगोइंग कॉल";
var INCOMING_CALL$7 = "इनकमिंग कॉल";
var MISSED_CALL$7 = "मिस्ड कॉल";
var OPEN_WHITEBOARD$6 = "व्हाइटबोर्ड खोलें";
var DRAW_WHITEBOARD_TOGETHER$6 = "साथ मिलकर बोर्ड खोलें और ड्रा करें";
var TRANSLATED_MESSAGE$7 = "अनुवादित संदेश";
var ANSWER$7 = "जवाब";
var DRAW_DOCUMENT_TOGETHER$6 = "साथ मिलकर सामग्री संपादित करने के लिए दस्तावेज़ खोलें";
var ADMIN$7 = "एडमिन";
var ADD_ANOTHER_ANSWER$7 = "एक और जवाब जोड़ें";
var SET_THE_ANSWERS$7 = "जवाब सेट करें";
var CLICK_TO_START_CONVERSATION$7 = "बातचीत शुरू करने के लिए क्लिक करें";
var SHARED_LOCATION$7 = "साझा स्थान";
var CALL_DETAILS$7 = "कॉल विवरण";
var POLLS$7 = "सर्वेक्षण";
var CHANGE_ROLE = "भूमिका बदलें";
var VIEW$6 = "देखें";
var MESSAGE_LIST = "Mसंदेश सूची";
var MESSAGE_COMPOSER = "संदेश संगीतकार";
var USERS_WITH_MESSAGES = "संदेश वाले उपयोगकर्ता";
var USER_LIST = "उपयोगकर्ता सूची";
var GROUP_LIST = "समूह सूची";
var NEW__GROUP$7 = "नया समूह";
var PASSWORD$7 = "पासवर्ड";
var CONTINUE$7 = "जारी रखना";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$7 = "क्या आप इस वार्तालाप को हटाना चाहेंगे? यह वार्तालाप आपके सभी उपकरणों से हटा दिया जाएगा।";
var SELECT__GROUP$7 = "संदेश भेजना शुरू करने के लिए एक समूह का चयन करें";
var DELETE_CONVERSATION$7 = "बातचीत मिटाएं?";
var ADD_TO_CHAT$7 = "चैट में जोड़ें";
var GROUPS_WITH_MESSAGES = "संदेशों के साथ समूह";
var MORE$7 = "अधिक";
var MESSAGE_IMAGE$7 = "📷 छवि";
var MESSAGE_FILE$7 = "📁 फ़ाइल";
var MESSAGE_VIDEO$7 = "📹 वीडियो";
var MESSAGE_AUDIO$7 = "🎵 ऑडियो";
var CUSTOM_MESSAGE$7 = "आपके पास एक संदेश है";
var MISSED_VOICE_CALL$7 = "मिस्ड वॉयस कॉल";
var MISSED_VIDEO_CALL$7 = "मिस्ड वीडियो कॉल";
var CUSTOM_MESSAGE_POLL$7 = "📊 पोल";
var CUSTOM_MESSAGE_STICKER$7 = "💟 स्टीकर";
var CUSTOM_MESSAGE_DOCUMENT$7 = "📃 दस्तावेज़";
var CUSTOM_MESSAGE_WHITEBOARD$7 = "📝 व्हाइटबोर्ड";
var ONLINE$7 = "ऑनलाइन";
var ADMINISTRATOR$7 = "प्रशासक";
var MODERATOR$7 = "मॉडरेटर";
var PARTICIPANT$7 = "प्रतिभागी";
var PUBLIC$7 = "पब्लिक";
var PRIVATE$7 = "निजी";
var PASSWORD_PROTECTED$7 = "कूटशब्द सुरक्षित";
var PRIVACY_AND_SECURITY$7 = "गोपनीयता और सुरक्षा";
var PREFERENCES$7 = "प्राथमिकताएं";
var MEMBERS$7 = "सदस्य";
var TODAY$7 = "आज";
var YESTERDAY$7 = "कल";
var SUNDAY$7 = "रविवार";
var MONDAY$7 = "सोमवार";
var TUESDAY$7 = "मंगलवार";
var WEDNESDAY$7 = "बुधवार";
var THURSDAY$7 = "गुरुवार";
var FRIDAY$7 = "शुक्रवार";
var SATURDAY$7 = "शनिवार";
var TYPING$7 = "टाइपिंग...";
var IS_TYPING$7 = "टाइप कर रहा है...";
var CLOSE$7 = "बंद करें";
var ENTER_GROUP_NAME$7 = "समूह नाम भरें";
var ADD_MEMBERS$7 = "सदस्य जोड़ें";
var SEND_MESSAGE$7 = "संदेश भेजें";
var UNBLOCK_USER$7 = "उपयोगकर्ता अनवरोधित करें";
var BLOCK_USER$7 = "अवरोधित उपयोक्ता";
var DELETE_AND_EXIT$7 = "मिटाएँ और बाहर निकलें";
var LEAVE_GROUP$7 = "समूह छोड़ें";
var CREATE_GROUP$7 = "समूह बनाएँ";
var SHARED_MEDIA$7 = "साझा मीडिया";
var VIDEO_CALL$7 = "वीडियो कॉल";
var AUDIO_CALL$7 = "ऑडियो कॉल";
var LOADING$7 = "लोड हो रहा है...";
var REPLY$7 = "उत्तर";
var REPLIES$7 = "उत्तर";
var LAUNCH$7 = "लांच";
var SHARED_COLLABORATIVE_DOCUMENT$7 = "ने एक सहयोगी दस्तावेज़ साझा किया है";
var SHARED_COLLABORATIVE_WHITEBOARD$7 = "ने एक सहयोगी व्हाइटबोर्ड साझा किया है";
var CREATED_WHITEBOARD$7 = "आपने एक नया सहयोगी व्हाइटबोर्ड बनाया है";
var CREATED_DOCUMENT$7 = "आपने एक नया सहयोगी दस्तावेज़ बनाया है";
var PHOTOS$7 = "तस्वीरें";
var VIDEOS$7 = "वीडियो";
var DOCUMENT$7 = "दस्तावेज़";
var YOU_DELETED_THIS_MESSAGE$7 = "⚠️ आपने यह संदेश हटा दिया है";
var THIS_MESSAGE_DELETED$7 = "⚠️ यह संदेश मिटाया गया था";
var MESSAGE_IS_DELETED$7 = "संदेश हटा दिया गया है";
var VIEW_ON_YOUTUBE$7 = "यूट्यूब पर देखें";
var SEARCH$7 = "खोज";
var NO_USERS_FOUND$7 = "कोई उपयोक्ता नहीं मिला";
var ERROR$7 = "त्रुटि";
var NO_GROUPS_FOUND$7 = "कोई समूह नहीं मिला";
var NO_CHATS_FOUND$7 = "कोई चैट नहीं मिला";
var MEDIA_MESSAGE$7 = "मीडिया संदेश";
var INCOMING_AUDIO_CALL$7 = "आवक ऑडियो कॉल";
var INCOMING_VIDEO_CALL$7 = "आने वाली वीडियो कॉल";
var DECLINE$7 = "अस्वीकार";
var ACCEPT$7 = "स्वीकार करें";
var CALL_INITIATED$7 = "कॉल आरंभिक";
var OUTGOING_AUDIO_CALL$7 = "जावक ऑडियो कॉल";
var OUTGOING_VIDEO_CALL$7 = "जावक वीडियो कॉल";
var CALL_REJECTED$7 = "कॉल अस्वीकृत";
var REJECTED_CALL$7 = "अस्वीकृत कॉल";
var CALL_ACCEPTED$7 = "कॉल स्वीकृत";
var JOINED$7 = "शामिल हो गए";
var LEFT_THE_CALL$7 = "कॉल छोड़ दिया";
var UNANSWERED_AUDIO_CALL$7 = "अनुत्तरित ऑडियो कॉल";
var UNANSWERED_VIDEO_CALL$7 = "अनुत्तरित वीडियो कॉल";
var CALL_ENDED$7 = "कॉल समाप्त";
var CALL_CANCELLED$7 = "कॉल रद्द";
var CALL_BUSY$7 = "व्यस्त कॉल करें";
var CALLING$7 = "कॉल कर रहा है...";
var ADD$7 = "जोड़ें";
var NO_BANNED_MEMBERS_FOUND$7 = "कोई प्रतिबंधित सदस्य नहीं मिला";
var BANNED_MEMBERS$7 = "प्रतिबंधित सदस्य";
var NAME$7 = "नाम";
var SCOPE$7 = "स्कोप";
var UNBAN$7 = "Unban";
var SELECT_GROUP_TYPE$7 = "समूह क़िस्म चुनें";
var ENTER_GROUP_PASSWORD$7 = "समूह कूटशब्द भरें";
var CREATE$7 = "बनाएँ";
var CREATE_POLL$7 = "सर्वेक्षण बनाएँ";
var QUESTION$7 = "प्रश्न";
var ENTER_YOUR_QUESTION$7 = "अपना प्रश्न दर्ज करें";
var OPTIONS$7 = "विकल्प";
var ENTER_YOUR_OPTION$7 = "अपना विकल्प दर्ज करें";
var ADD_NEW_OPTION$7 = "नया विकल्प जोड़ें";
var VIEW_MEMBERS$7 = "सदस्य देखें";
var DETAILS$7 = "विवरण";
var NOTIFICATIONS$7 = "सूचनाएँ";
var OTHER$7 = "अन्य";
var HELP$7 = "मदद";
var REPORT_PROBLEM$7 = "किसी समस्या की रिपोर्ट करें";
var GROUP_MEMBERS$7 = "समूह के सदस्य";
var BAN$7 = "बान";
var KICK$7 = "लात";
var PICK_YOUR_EMOJI$7 = "अपने इमोजी उठाओ";
var PRIVATE_GROUP$7 = "निजी समूह";
var PROTECTED_GROUP$7 = "सुरक्षित समूह";
var VISIT$7 = "विज़िट करें";
var ATTACH$7 = "संलग्न करें";
var ATTACH_FILE$7 = "फ़ाइल संलग्न करें";
var ATTACH_VIDEO$7 = "वीडियो संलग्न करें";
var ATTACH_AUDIO$7 = "ऑडियो संलग्न करें";
var ATTACH_IMAGE$7 = "छवि संलग्न करें";
var COLLABORATE_USING_DOCUMENT$7 = "दस्तावेज़ का उपयोग करके सहयोग करें";
var COLLABORATE_USING_WHITEBOARD$7 = "व्हाइटबोर्ड का उपयोग करके सहयोग करें";
var EMOJI$7 = "इमोजी";
var ENTER_YOUR_MESSAGE_HERE$7 = "अपना संदेश यहाँ दर्ज करें";
var NO_MESSAGES_FOUND$7 = "कोई संदेश नहीं मिला";
var THREAD$7 = "धागा";
var COLLABORATIVE_DOCUMENT$7 = "सहयोगी दस्तावेज़";
var COLLABORATIVE_WHITEBOARD$7 = "सहयोगी व्हाइटबोर्ड";
var ADD_REACTION$7 = "प्रतिक्रिया जोड़ें";
var NO_STICKERS_FOUND$7 = "कोई स्टिकर नहीं मिला";
var REPLY_TO_THREAD$7 = "थ्रेड को जवाब दें";
var REPLY_IN_THREAD$7 = "थ्रेड में जवाब दें";
var DELETE_MESSAGE$7 = "संदेश मिटाएँ";
var EDIT_MESSAGE$7 = "संदेश संपादित करें";
var OWNER$7 = "मालिक";
var CHANGE_SCOPE$7 = "स्कोप बदलें";
var STICKER$7 = "स्टीकर";
var LAST_ACTIVE_AT$7 = "पर अंतिम सक्रिय";
var VOICE_CALL$7 = "वॉयस कॉल";
var VIEW_DETAIL$7 = "विवरण देखें";
var VOTES$7 = "वोट";
var VOTE$7 = "वोट";
var NO_VOTE$7 = "कोई वोट नहीं";
var REACTED$7 = "प्रतिक्रिया व्यक्त की";
var ADDED$7 = "जोड़ा गया";
var UNBANNED$7 = "अप्रतिबंधित";
var MADE$7 = "बनाया";
var CALL_UNANSWERED$7 = "अनुत्तरित कॉल करें";
var MISSED_AUDIO_CALL$7 = "मिस ऑडियो कॉल";
var ENTER_YOUR_PASSWORD$7 = "अपना पासवर्ड दर्ज करें";
var DOCS$7 = "डॉक्स";
var NO_RECORDS_FOUND$7 = "कोई रिकॉर्ड नहीं मिला";
var LIVE_REACTION$7 = "लाइव रिएक्शन";
var SMILEY_PEOPLE$7 = "स्माइली और लोग";
var ANIMALES_NATURE$7 = "पशु और प्रकृति";
var FOOD_DRINK$7 = "खाद्य और पेय";
var ACTIVITY$7 = "गतिविधि";
var TRAVEL_PLACES$7 = "यात्रा और स्थान";
var OBJECTS$7 = "वस्तुएँ";
var SYMBOLS$7 = "प्रतीक";
var FLAGS$7 = "झंडे";
var SENT$7 = "भेजा गया";
var SEEN$7 = "देखा";
var DELIVERED$7 = "डिलीवर";
var TRANSLATE_MESSAGE$7 = "संदेश का अनुवाद करें";
var LEFT$7 = "छोड़ दिया है";
var KICKED$7 = "लात मारी";
var BANNED$7 = "बारित";
var NEW_MESSAGES$7 = "नए संदेश";
var NEW_MESSAGE$7 = "नया संदेश";
var JUMP$7 = "कूदो";
var SELECT_VIDEO_SOURCE$7 = "वीडियो स्रोत चुनें";
var SELECT_INPUT_AUDIO_SOURCE$7 = "इनपुट ऑडियो स्रोत चुनें";
var SELECT_OUTPUT_AUDIO_SOURCE$7 = "आउटपुट ऑडियो स्रोत चुनें";
var INITIATED_GROUP_CALL$7 = "ने एक समूह कॉल शुरू की है";
var YOU_INITIATED_GROUP_CALL$7 = "आपने एक समूह कॉल शुरू की है";
var IGNORE$7 = "ध्यान न दें";
var ON_ANOTHER_CALL$7 = "एक और कॉल पर है";
var CREATING$7 = "बनाना";
var AVATAR$7 = "अवतार";
var GROUP_NAME_BLANK$7 = "समूह का नाम खाली नहीं होना चाहिए";
var GROUP_TYPE_BLANK$7 = "समूह प्रकार कैननॉट खाली हो";
var GROUP_PASSWORD_BLANK$7 = "समूह कूटशब्द खाली नहीं होना चाहिए";
var POLL_QUESTION_BLANK$7 = "प्रश्न कैनॉट खाली हो";
var POLL_OPTION_BLANK$7 = "विकल्प कैननॉट खाली हो";
var ONGOING_CALL$7 = "चल रही कॉल";
var YOU_ALREADY_ONGOING_CALL$7 = "आप पहले से ही चल रहे कॉल में हैं";
var RESIZE$7 = "आकार बदलें";
var SETTINGS$7 = "सेटिंग्स";
var ACTIONS$7 = "क्रियाएँ";
var VIEW_PROFILE$7 = "प्रोफ़ाइल देखें";
var SEND_MESSAGE_IN_PRIVATE$7 = "निजी तौर पर संदेश भेजें";
var DELETE$7 = "मिटाएँ";
var DELETE_CONFIRM$7 = "क्या आप वाकई मिटाना चाहते हैं?";
var CANCEL$7 = "रद्द करें";
var LEAVE_CONFIRM$7 = "क्या आप निश्चित हैं कि आप समूह छोड़ना चाहते हैं?";
var TRANSFER_CONFIRM$7 = "आप समूह स्वामी हैं, कृपया समूह छोड़ने से पहले किसी सदस्य को स्वामित्व स्थानांतरित करें";
var ADDING$7 = "जोड़ रहा है...";
var TRANSFER$7 = "ट्रांसफर";
var TRANSFERRING$7 = "ट्रांसफर";
var YES$7 = "हाँ";
var NO$7 = "नहीं";
var SOMETHING_WRONG$7 = "कुछ गलत हो गया, कृपया फिर से कोशिश करें";
var INVALID_GROUP_NAME$7 = "कृपया समूह के लिए एक वैध नाम दर्ज करें और पुनः प्रयास करें";
var INVALID_GROUP_TYPE$7 = "कृपया समूह के लिए एक वैध प्रकार दर्ज करें और पुनः प्रयास करें";
var INVALID_PASSWORD$7 = "कृपया समूह के लिए एक वैध पासवर्ड दर्ज करें और पुनः प्रयास करें";
var WRONG_PASSWORD$7 = "कृपया सही पासवर्ड दर्ज करें और पुनः प्रयास करें";
var INVALID_POLL_QUESTION$7 = "चुनाव बनाने से पहले कृपया आवश्यक प्रश्न दर्ज करें";
var INVALID_POLL_OPTION$7 = "चुनाव बनाने से पहले कृपया आवश्यक उत्तर दर्ज करें";
var SAME_LANGUAGE_MESSAGE$7 = "अनुवाद के लिए चुनी गई भाषा मूल संदेश की भाषा के समान है";
var LEAVE$7 = "लीव";
var CALLS$7 = "कॉल";
var CUSTOM_MESSAGE_LOCATION$7 = "📍 स्थान";
var OFFLINE$7 = "ऑफ़लाइन";
var YOU$7 = "आप";
var PRIVACY$7 = "निजता";
var BLOCKED_USERS$7 = "अवरोधित उपयोगकर्ता";
var NO_PHOTOS$7 = "कोई तस्वीरें नहीं";
var NO_VIDEOS$7 = "कोई वीडियो नहीं";
var NO_DOCUMENTS$7 = "कोई दस्तावेज़ नहीं";
var JOIN$7 = "शामिल हों";
var NEW_CHAT$7 = "नई चैट";
var FORM_COMPLETION_MESSAGE$7 = "फॉर्म भरने के लिए धन्यवाद।";
var FORM$7 = "प्रपत्र";
var CARD$7 = "कार्ड";
var HISTORY$7 = "इतिहास";
var CANCELLED_AUDIO_CALL$7 = "रद्द किया गया ऑडियो कॉल";
var CANCELLED_VIDEO_CALL$7 = "कैंसिल किया गया वीडियो कॉल";
var REJECTED_AUDIO_CALL$7 = "अस्वीकृत ऑडियो कॉल";
var REJECTED_VIDEO_CALL$7 = "अस्वीकृत वीडियो कॉल";
var CANCELLED_CALL$7 = "कैंसिल किया गया कॉल";
var UNANSWERED_CALL$7 = "अनुत्तरित कॉल";
var RECORDING$7 = "रिकार्डिंग";
var PARTICIPANTS$7 = "प्रतिभागी";
var CALL_HISTORY$7 = "कॉल हिस्ट्री";
var NO_CALLS_FOUND$7 = "कोई कॉल नहीं मिला";
var ONGOING_AUDIO_CALL$7 = "चल रही ऑडियो कॉल";
var ONGOING_VIDEO_CALL$7 = "चल रही वीडियो कॉल";
var CALL_DETAIL$7 = "कॉल विवरण";
var GENERATING_SUMMARY$7 = "सारांश तैयार करना";
var CONVERSATION_SUMMARY$7 = "बातचीत का सारांश";
var GENERATE_SUMMARY$7 = "एक सारांश जनरेट करें";
var COMETCHAT_BOT_FIRST_MESSAGE$7 = "मैं इस बातचीत में आपकी कैसे मदद कर सकता हूं? कृपया मुझसे एक प्रश्न पूछें और मैं आपको सलाह दूंगा 🙂";
var COMETCHAT_ASK_BOT$7 = "पूछो";
var COMETCHAT_ASK_AI_BOT$7 = "AI बॉट्स से पूछें";
var COMETCHAT_ASK_BOT_SUBTITLE$7 = "एआई बॉट";
var translationHI = {
	USERS: USERS$7,
	CHATS: CHATS$7,
	GROUPS: GROUPS$7,
	SHARED: SHARED,
	SOUND_MANAGER: SOUND_MANAGER,
	THEME: THEME,
	COPY_MESSAGE: COPY_MESSAGE,
	LOCALIZE: LOCALIZE,
	READ: READ$7,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$7,
	CONVERSATION_LIST_ITEM: CONVERSATION_LIST_ITEM,
	DATA_ITEM: DATA_ITEM,
	AI: AI$7,
	SMART_REPLIES: SMART_REPLIES$7,
	CONVERSATION_STARTER: CONVERSATION_STARTER$7,
	STATUS_INDICATOR: STATUS_INDICATOR,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$7,
	NO_RECIPIENT: NO_RECIPIENT$7,
	MESSAGE: MESSAGE$7,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$7,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$7,
	NO_RECIPIENTS: NO_RECIPIENTS$7,
	BADGE_COUNT: BADGE_COUNT,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$7,
	MESSAGE_RECEIPT: MESSAGE_RECEIPT,
	CONVERSATIONS_WITH_MESSAGES: CONVERSATIONS_WITH_MESSAGES,
	CONVERSATIONS: CONVERSATIONS,
	VOICE_RECORDING: VOICE_RECORDING$7,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$7,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$7,
	GENERATING_REPLIES: GENERATING_REPLIES$7,
	CONVERSATION_LIST: CONVERSATION_LIST,
	MESSAGES: MESSAGES,
	NO_USERS_SELECTED: NO_USERS_SELECTED$7,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$7,
	SHARED_FILE: SHARED_FILE$1,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$7,
	MESSAGE_HEADER: MESSAGE_HEADER,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$7,
	REMOVE: REMOVE,
	BLOCK: BLOCK,
	OPEN_DOCUMENT: OPEN_DOCUMENT$6,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$7,
	SELECT__USER: SELECT__USER$7,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$7,
	OUTGOING_CALL: OUTGOING_CALL$7,
	INCOMING_CALL: INCOMING_CALL$7,
	MISSED_CALL: MISSED_CALL$7,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$6,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$6,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$7,
	ANSWER: ANSWER$7,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$6,
	ADMIN: ADMIN$7,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$7,
	SET_THE_ANSWERS: SET_THE_ANSWERS$7,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$7,
	SHARED_LOCATION: SHARED_LOCATION$7,
	CALL_DETAILS: CALL_DETAILS$7,
	POLLS: POLLS$7,
	CHANGE_ROLE: CHANGE_ROLE,
	VIEW: VIEW$6,
	MESSAGE_LIST: MESSAGE_LIST,
	MESSAGE_COMPOSER: MESSAGE_COMPOSER,
	USERS_WITH_MESSAGES: USERS_WITH_MESSAGES,
	USER_LIST: USER_LIST,
	GROUP_LIST: GROUP_LIST,
	NEW__GROUP: NEW__GROUP$7,
	PASSWORD: PASSWORD$7,
	CONTINUE: CONTINUE$7,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$7,
	SELECT__GROUP: SELECT__GROUP$7,
	DELETE_CONVERSATION: DELETE_CONVERSATION$7,
	ADD_TO_CHAT: ADD_TO_CHAT$7,
	GROUPS_WITH_MESSAGES: GROUPS_WITH_MESSAGES,
	MORE: MORE$7,
	MESSAGE_IMAGE: MESSAGE_IMAGE$7,
	MESSAGE_FILE: MESSAGE_FILE$7,
	MESSAGE_VIDEO: MESSAGE_VIDEO$7,
	MESSAGE_AUDIO: MESSAGE_AUDIO$7,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$7,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$7,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$7,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$7,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$7,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$7,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$7,
	ONLINE: ONLINE$7,
	ADMINISTRATOR: ADMINISTRATOR$7,
	MODERATOR: MODERATOR$7,
	PARTICIPANT: PARTICIPANT$7,
	PUBLIC: PUBLIC$7,
	PRIVATE: PRIVATE$7,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$7,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$7,
	PREFERENCES: PREFERENCES$7,
	MEMBERS: MEMBERS$7,
	TODAY: TODAY$7,
	YESTERDAY: YESTERDAY$7,
	SUNDAY: SUNDAY$7,
	MONDAY: MONDAY$7,
	TUESDAY: TUESDAY$7,
	WEDNESDAY: WEDNESDAY$7,
	THURSDAY: THURSDAY$7,
	FRIDAY: FRIDAY$7,
	SATURDAY: SATURDAY$7,
	TYPING: TYPING$7,
	IS_TYPING: IS_TYPING$7,
	CLOSE: CLOSE$7,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$7,
	ADD_MEMBERS: ADD_MEMBERS$7,
	SEND_MESSAGE: SEND_MESSAGE$7,
	UNBLOCK_USER: UNBLOCK_USER$7,
	BLOCK_USER: BLOCK_USER$7,
	DELETE_AND_EXIT: DELETE_AND_EXIT$7,
	LEAVE_GROUP: LEAVE_GROUP$7,
	CREATE_GROUP: CREATE_GROUP$7,
	SHARED_MEDIA: SHARED_MEDIA$7,
	VIDEO_CALL: VIDEO_CALL$7,
	AUDIO_CALL: AUDIO_CALL$7,
	LOADING: LOADING$7,
	REPLY: REPLY$7,
	REPLIES: REPLIES$7,
	LAUNCH: LAUNCH$7,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$7,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$7,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$7,
	CREATED_DOCUMENT: CREATED_DOCUMENT$7,
	PHOTOS: PHOTOS$7,
	VIDEOS: VIDEOS$7,
	DOCUMENT: DOCUMENT$7,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$7,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$7,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$7,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$7,
	SEARCH: SEARCH$7,
	NO_USERS_FOUND: NO_USERS_FOUND$7,
	ERROR: ERROR$7,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$7,
	NO_CHATS_FOUND: NO_CHATS_FOUND$7,
	MEDIA_MESSAGE: MEDIA_MESSAGE$7,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$7,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$7,
	DECLINE: DECLINE$7,
	ACCEPT: ACCEPT$7,
	CALL_INITIATED: CALL_INITIATED$7,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$7,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$7,
	CALL_REJECTED: CALL_REJECTED$7,
	REJECTED_CALL: REJECTED_CALL$7,
	CALL_ACCEPTED: CALL_ACCEPTED$7,
	JOINED: JOINED$7,
	LEFT_THE_CALL: LEFT_THE_CALL$7,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$7,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$7,
	CALL_ENDED: CALL_ENDED$7,
	CALL_CANCELLED: CALL_CANCELLED$7,
	CALL_BUSY: CALL_BUSY$7,
	CALLING: CALLING$7,
	ADD: ADD$7,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$7,
	BANNED_MEMBERS: BANNED_MEMBERS$7,
	NAME: NAME$7,
	SCOPE: SCOPE$7,
	UNBAN: UNBAN$7,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$7,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$7,
	CREATE: CREATE$7,
	CREATE_POLL: CREATE_POLL$7,
	QUESTION: QUESTION$7,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$7,
	OPTIONS: OPTIONS$7,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$7,
	ADD_NEW_OPTION: ADD_NEW_OPTION$7,
	VIEW_MEMBERS: VIEW_MEMBERS$7,
	DETAILS: DETAILS$7,
	NOTIFICATIONS: NOTIFICATIONS$7,
	OTHER: OTHER$7,
	HELP: HELP$7,
	REPORT_PROBLEM: REPORT_PROBLEM$7,
	GROUP_MEMBERS: GROUP_MEMBERS$7,
	BAN: BAN$7,
	KICK: KICK$7,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$7,
	PRIVATE_GROUP: PRIVATE_GROUP$7,
	PROTECTED_GROUP: PROTECTED_GROUP$7,
	VISIT: VISIT$7,
	ATTACH: ATTACH$7,
	ATTACH_FILE: ATTACH_FILE$7,
	ATTACH_VIDEO: ATTACH_VIDEO$7,
	ATTACH_AUDIO: ATTACH_AUDIO$7,
	ATTACH_IMAGE: ATTACH_IMAGE$7,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$7,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$7,
	EMOJI: EMOJI$7,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$7,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$7,
	THREAD: THREAD$7,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$7,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$7,
	ADD_REACTION: ADD_REACTION$7,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$7,
	REPLY_TO_THREAD: REPLY_TO_THREAD$7,
	REPLY_IN_THREAD: REPLY_IN_THREAD$7,
	DELETE_MESSAGE: DELETE_MESSAGE$7,
	EDIT_MESSAGE: EDIT_MESSAGE$7,
	OWNER: OWNER$7,
	CHANGE_SCOPE: CHANGE_SCOPE$7,
	STICKER: STICKER$7,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$7,
	VOICE_CALL: VOICE_CALL$7,
	VIEW_DETAIL: VIEW_DETAIL$7,
	VOTES: VOTES$7,
	VOTE: VOTE$7,
	NO_VOTE: NO_VOTE$7,
	REACTED: REACTED$7,
	ADDED: ADDED$7,
	UNBANNED: UNBANNED$7,
	MADE: MADE$7,
	CALL_UNANSWERED: CALL_UNANSWERED$7,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$7,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$7,
	DOCS: DOCS$7,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$7,
	LIVE_REACTION: LIVE_REACTION$7,
	SMILEY_PEOPLE: SMILEY_PEOPLE$7,
	ANIMALES_NATURE: ANIMALES_NATURE$7,
	FOOD_DRINK: FOOD_DRINK$7,
	ACTIVITY: ACTIVITY$7,
	TRAVEL_PLACES: TRAVEL_PLACES$7,
	OBJECTS: OBJECTS$7,
	SYMBOLS: SYMBOLS$7,
	FLAGS: FLAGS$7,
	SENT: SENT$7,
	SEEN: SEEN$7,
	DELIVERED: DELIVERED$7,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$7,
	LEFT: LEFT$7,
	KICKED: KICKED$7,
	BANNED: BANNED$7,
	NEW_MESSAGES: NEW_MESSAGES$7,
	NEW_MESSAGE: NEW_MESSAGE$7,
	JUMP: JUMP$7,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$7,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$7,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$7,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$7,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$7,
	IGNORE: IGNORE$7,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$7,
	CREATING: CREATING$7,
	AVATAR: AVATAR$7,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$7,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$7,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$7,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$7,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$7,
	ONGOING_CALL: ONGOING_CALL$7,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$7,
	RESIZE: RESIZE$7,
	SETTINGS: SETTINGS$7,
	ACTIONS: ACTIONS$7,
	VIEW_PROFILE: VIEW_PROFILE$7,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$7,
	DELETE: DELETE$7,
	DELETE_CONFIRM: DELETE_CONFIRM$7,
	CANCEL: CANCEL$7,
	LEAVE_CONFIRM: LEAVE_CONFIRM$7,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$7,
	ADDING: ADDING$7,
	TRANSFER: TRANSFER$7,
	TRANSFERRING: TRANSFERRING$7,
	YES: YES$7,
	NO: NO$7,
	SOMETHING_WRONG: SOMETHING_WRONG$7,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$7,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$7,
	INVALID_PASSWORD: INVALID_PASSWORD$7,
	WRONG_PASSWORD: WRONG_PASSWORD$7,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$7,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$7,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$7,
	LEAVE: LEAVE$7,
	CALLS: CALLS$7,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$7,
	OFFLINE: OFFLINE$7,
	YOU: YOU$7,
	PRIVACY: PRIVACY$7,
	BLOCKED_USERS: BLOCKED_USERS$7,
	"YOU'VE_BLOCKED": "आपने अवरोधित किया है",
	NO_PHOTOS: NO_PHOTOS$7,
	NO_VIDEOS: NO_VIDEOS$7,
	NO_DOCUMENTS: NO_DOCUMENTS$7,
	JOIN: JOIN$7,
	NEW_CHAT: NEW_CHAT$7,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$7,
	FORM: FORM$7,
	CARD: CARD$7,
	HISTORY: HISTORY$7,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$7,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$7,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$7,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$7,
	CANCELLED_CALL: CANCELLED_CALL$7,
	UNANSWERED_CALL: UNANSWERED_CALL$7,
	RECORDING: RECORDING$7,
	PARTICIPANTS: PARTICIPANTS$7,
	CALL_HISTORY: CALL_HISTORY$7,
	NO_CALLS_FOUND: NO_CALLS_FOUND$7,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$7,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$7,
	CALL_DETAIL: CALL_DETAIL$7,
	GENERATING_SUMMARY: GENERATING_SUMMARY$7,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$7,
	GENERATE_SUMMARY: GENERATE_SUMMARY$7,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$7,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$7,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$7,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$7
};

var USERS$6 = "Pengguna";
var CHATS$6 = "Sembang";
var GROUPS$6 = "Kumpulan";
var MORE$6 = "Lagi";
var MESSAGE_IMAGE$6 = "📷 Imej";
var MESSAGE_FILE$6 = "📁 Fail";
var NEW__GROUP$6 = "Kumpulan Baru";
var PASSWORD$6 = "Kata laluan";
var REACT_TO_MESSAGE$6 = "Bertindak balas kepada mesej";
var SHOW_UNSAFE_CONTENT$6 = "Adakah anda pasti mahu melihat kandungan yang tidak selamat?";
var CONTINUE$6 = "teruskan";
var READ$6 = "Baca";
var VOICE_RECORDING$6 = "Rakaman Suara";
var MESSAGE_INFORMATION$6 = "Maklumat Mesej";
var NO_CHATS_SELECTED$6 = "Tiada Sembang Dipilih";
var MESSAGE$6 = "Pesanan";
var AI$6 = "KECERDASAN BUATAN";
var SMART_REPLIES$6 = "Balasan Pintar";
var NO_REPLIES_FOUND$6 = "Tiada Balasan Ditemui";
var CONVERSATION_STARTER$6 = "Permulaan Perbualan";
var RECEIPT_INFORMATION$6 = "Maklumat Resit";
var SUGGEST_A_REPLY$6 = "Cadangkan balasan";
var GENERATING_ICEBREAKERS$6 = "Menjana pemecah ais";
var GENERATING_REPLIES$6 = "Menjana balasan";
var NO_RECIPIENT$6 = "Tiada Penerima";
var NO_RECIPIENTS$6 = "Tiada Penerima";
var SELECT__GROUP$6 = "Pilih kumpulan untuk memulakan pemesejan";
var DELETE_CONVERSATION$6 = "Padamkan Perbualan?";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$6 = "Adakah anda mahu memadamkan perbualan ini? Perbualan ini akan dipadamkan daripada semua peranti anda.";
var ADD_TO_CHAT$6 = "Tambahkan pada Sembang";
var MESSAGE_VIDEO$6 = "📹 Video";
var MESSAGE_AUDIO$6 = "🎵 Audio";
var NO_USERS_SELECTED$6 = "Tiada Pengguna Dipilih";
var NO_GROUPS_SELECTED$6 = "Tiada Kumpulan Dipilih";
var CUSTOM_MESSAGE$6 = "Anda mempunyai mesej";
var NO_CALLS_SELECTED$6 = "Tiada Panggilan Dipilih";
var SELECT__USER$6 = "Pilih pengguna untuk mula berbual";
var ADMIN$6 = "Admin";
var CANT__LOAD__CHATS$6 = "Tidak dapat memuatkan perbualan";
var DRAW_WHITEBOARD_TOGETHER$5 = "Buka papan tulis putih untuk melukis bersama";
var OUTGOING_CALL$6 = "Panggilan Keluar";
var OPEN_DOCUMENT$5 = "Buka Dokumen";
var DRAW_DOCUMENT_TOGETHER$5 = "Buka dokumen untuk mengedit kandungan bersama";
var INCOMING_CALL$6 = "Panggilan Masuk";
var MISSED_CALL$6 = "Panggilan Terlepas";
var TRANSLATED_MESSAGE$6 = "Mesej diterjemah";
var ANSWER$6 = "Jawapan";
var ADD_ANOTHER_ANSWER$6 = "Tambah Jawapan Lain";
var OPEN_WHITEBOARD$5 = "Buka Papan Tulis Putih";
var SET_THE_ANSWERS$6 = "Tetapkan Jawapan";
var CLICK_TO_START_CONVERSATION$6 = "Klik untuk memulakan perbualan";
var SHARED_LOCATION$6 = "Lokasi dikongsi";
var CALL_DETAILS$6 = "Perincian Panggilan";
var POLLS$6 = "Undian";
var MISSED_VOICE_CALL$6 = "Panggilan suara tidak dijawab";
var MISSED_VIDEO_CALL$6 = "Panggilan video tidak dijawab";
var CUSTOM_MESSAGE_POLL$6 = "📊 Undian";
var CUSTOM_MESSAGE_STICKER$6 = "💟 Pelekat";
var TRANSFER_OWNERSHIP$6 = "Pemindahan Pemilikan";
var CUSTOM_MESSAGE_DOCUMENT$6 = "📃 Dokumen";
var CUSTOM_MESSAGE_WHITEBOARD$6 = "📝 Papan Putih";
var ONLINE$6 = "Dalam Talian";
var VIEW$5 = "melihat";
var ADMINISTRATOR$6 = "Pentadbir";
var MODERATOR$6 = "Moderator";
var PARTICIPANT$6 = "Peserta";
var PUBLIC$6 = "Awam";
var PRIVATE$6 = "Persendirian";
var PASSWORD_PROTECTED$6 = "Dilindungi";
var PRIVACY_AND_SECURITY$6 = "Privasi dan Keselamatan";
var PREFERENCES$6 = "Keutamaan";
var MEMBERS$6 = "Ahli-ahli";
var TODAY$6 = "Hari ini";
var YESTERDAY$6 = "Semalam";
var SUNDAY$6 = "Ahad";
var MONDAY$6 = "Isnin";
var TUESDAY$6 = "Selasa";
var WEDNESDAY$6 = "Rabu";
var THURSDAY$6 = "Khamis";
var FRIDAY$6 = "Jumaat";
var SATURDAY$6 = "Sabtu";
var TYPING$6 = "menaip...";
var IS_TYPING$6 = "sedang menaip...";
var CLOSE$6 = "Tutup";
var ENTER_GROUP_NAME$6 = "Masukkan nama kumpulan";
var ADD_MEMBERS$6 = "Tambah Ahli";
var SEND_MESSAGE$6 = "Hantar Mesej";
var UNBLOCK_USER$6 = "Nyahsekat Pengguna";
var BLOCK_USER$6 = "Sekat Pengguna";
var DELETE_AND_EXIT$6 = "Padam dan Keluar";
var LEAVE_GROUP$6 = "Tinggalkan Kumpulan";
var CREATE_GROUP$6 = "Cipta Kumpulan";
var SHARED_MEDIA$6 = "Media Kongsi";
var VIDEO_CALL$6 = "Panggilan video";
var AUDIO_CALL$6 = "Panggilan audio";
var LOADING$6 = "Memuatkan...";
var REPLY$6 = "jawapan";
var REPLIES$6 = "balasannya";
var LAUNCH$6 = "Pelancaran";
var SHARED_COLLABORATIVE_DOCUMENT$6 = "telah berkongsi dokumen kolaboratif";
var SHARED_COLLABORATIVE_WHITEBOARD$6 = "telah berkongsi papan putih kolaboratif";
var CREATED_WHITEBOARD$6 = "Anda telah membuat papan putih kolaboratif baru";
var CREATED_DOCUMENT$6 = "Anda telah membuat dokumen kolaboratif baru";
var PHOTOS$6 = "Foto";
var VIDEOS$6 = "Video";
var DOCUMENT$6 = "Dokumen";
var YOU_DELETED_THIS_MESSAGE$6 = "⚠️ Anda memadam mesej ini";
var THIS_MESSAGE_DELETED$6 = "⚠️ Mesej ini telah dipadamkan";
var MESSAGE_IS_DELETED$6 = "Mesej Dipadamkan";
var VIEW_ON_YOUTUBE$6 = "Lihat di Youtube";
var SEARCH$6 = "Cari";
var NO_USERS_FOUND$6 = "Tiada pengguna ditemui";
var ERROR$6 = "Ralat";
var NO_GROUPS_FOUND$6 = "Tiada kumpulan ditemui";
var NO_CHATS_FOUND$6 = "Tiada sembang ditemui";
var MEDIA_MESSAGE$6 = "Mesej media";
var INCOMING_AUDIO_CALL$6 = "Panggilan audio masuk";
var INCOMING_VIDEO_CALL$6 = "Panggilan video masuk";
var DECLINE$6 = "Tolak";
var ACCEPT$6 = "Terima";
var CALL_INITIATED$6 = "Panggilan dimulakan";
var OUTGOING_AUDIO_CALL$6 = "Panggilan audio keluar";
var OUTGOING_VIDEO_CALL$6 = "Panggilan video keluar";
var CALL_REJECTED$6 = "Panggilan ditolak";
var REJECTED_CALL$6 = "panggilan ditolak";
var CALL_ACCEPTED$6 = "Panggilan diterima";
var JOINED$6 = "menyertai";
var LEFT_THE_CALL$6 = "meninggalkan panggilan";
var UNANSWERED_AUDIO_CALL$6 = "Panggilan audio tidak dijawab";
var UNANSWERED_VIDEO_CALL$6 = "Panggilan video tidak dijawab";
var CALL_ENDED$6 = "Panggilan berakhir";
var CALL_CANCELLED$6 = "Panggilan dibatalkan";
var CALL_BUSY$6 = "Panggilan sibuk";
var CALLING$6 = "Memanggil...";
var ADD$6 = "Tambah";
var NO_BANNED_MEMBERS_FOUND$6 = "Tiada ahli yang diharamkan ditemui";
var BANNED_MEMBERS$6 = "Ahli diharamkan";
var NAME$6 = "Nama";
var SCOPE$6 = "Skop";
var UNBAN$6 = "Unban";
var SELECT_GROUP_TYPE$6 = "Pilih jenis kumpulan";
var ENTER_GROUP_PASSWORD$6 = "Masukkan kata laluan kumpulan";
var CREATE$6 = "Cipta";
var CREATE_POLL$6 = "Buat Undian";
var QUESTION$6 = "Soalan";
var ENTER_YOUR_QUESTION$6 = "Masukkan soalan anda";
var OPTIONS$6 = "Pilihan";
var ENTER_YOUR_OPTION$6 = "Masukkan pilihan anda";
var ADD_NEW_OPTION$6 = "Tambah opsyen baru";
var VIEW_MEMBERS$6 = "Lihat Ahli";
var DETAILS$6 = "Perincian";
var NOTIFICATIONS$6 = "Pemberitahuan";
var OTHER$6 = "Lain-lain";
var HELP$6 = "Bantuan";
var REPORT_PROBLEM$6 = "Laporkan Masalah";
var GROUP_MEMBERS$6 = "Ahli Kumpulan";
var BAN$6 = "Ban";
var KICK$6 = "Kick";
var PICK_YOUR_EMOJI$6 = "Pilih emoji anda";
var PRIVATE_GROUP$6 = "Kumpulan Persendirian";
var PROTECTED_GROUP$6 = "Kumpulan Terlindung";
var VISIT$6 = "Lawati";
var ATTACH$6 = "Lampirkan";
var ATTACH_FILE$6 = "Lampirkan fail";
var ATTACH_VIDEO$6 = "Lampirkan video";
var ATTACH_AUDIO$6 = "Lampirkan audio";
var ATTACH_IMAGE$6 = "Lampirkan imej";
var COLLABORATE_USING_DOCUMENT$6 = "Berkolaborasi menggunakan dokumen";
var COLLABORATE_USING_WHITEBOARD$6 = "Berkolaborasi menggunakan papan putih";
var EMOJI$6 = "Emotikon";
var ENTER_YOUR_MESSAGE_HERE$6 = "Masukkan mesej anda di sini";
var NO_MESSAGES_FOUND$6 = "Tiada mesej ditemui";
var THREAD$6 = "Thread";
var COLLABORATIVE_DOCUMENT$6 = "Dokumen Kerjasama";
var COLLABORATIVE_WHITEBOARD$6 = "Papan Putih Kolaboratif";
var ADD_REACTION$6 = "Tambah reaksi";
var NO_STICKERS_FOUND$6 = "Tiada pelekat ditemui";
var REPLY_TO_THREAD$6 = "Balas kepada bebenang";
var REPLY_IN_THREAD$6 = "Balas dalam bebenang";
var DELETE_MESSAGE$6 = "Padam mesej";
var EDIT_MESSAGE$6 = "Sunting mesej";
var OWNER$6 = "Pemilik";
var CHANGE_SCOPE$6 = "Tukar Skop";
var STICKER$6 = "Pelekat";
var LAST_ACTIVE_AT$6 = "Terakhir Aktif di";
var VOICE_CALL$6 = "Panggilan suara";
var VIEW_DETAIL$6 = "Lihat Perincian";
var VOTES$6 = "undi";
var VOTE$6 = "undi";
var NO_VOTE$6 = "Tiada undi";
var REACTED$6 = "bertindak balas";
var ADDED$6 = "campurkan";
var UNBANNED$6 = "tidak diharamkan";
var MADE$6 = "diperbuat";
var CALL_UNANSWERED$6 = "Panggilan tidak dijawab";
var MISSED_AUDIO_CALL$6 = "Panggilan audio tidak dijawab";
var ENTER_YOUR_PASSWORD$6 = "Masukkan kata laluan anda";
var DOCS$6 = "Dokumen";
var NO_RECORDS_FOUND$6 = "Tiada rekod ditemui";
var LIVE_REACTION$6 = "Reaksi Langsung";
var SMILEY_PEOPLE$6 = "Smiley & People";
var ANIMALES_NATURE$6 = "Haiwan & Alam Semula Jadi";
var FOOD_DRINK$6 = "Makanan & Minuman";
var ACTIVITY$6 = "Aktiviti";
var TRAVEL_PLACES$6 = "Perjalanan & Tempat";
var OBJECTS$6 = "Objek";
var SYMBOLS$6 = "Simbol";
var FLAGS$6 = "Bendera";
var SENT$6 = "Dihantar";
var SEEN$6 = "Seen";
var DELIVERED$6 = "Dihantar";
var TRANSLATE_MESSAGE$6 = "Terjemah mesej";
var LEFT$6 = "ditinggalkan";
var KICKED$6 = "ditendang";
var BANNED$6 = "diharamkan";
var NEW_MESSAGES$6 = "mesej baru";
var NEW_MESSAGE$6 = "mesej baru";
var JUMP$6 = "Lompat";
var SELECT_VIDEO_SOURCE$6 = "Pilih Sumber video";
var SELECT_INPUT_AUDIO_SOURCE$6 = "Pilih sumber audio input";
var SELECT_OUTPUT_AUDIO_SOURCE$6 = "Pilih sumber audio output";
var INITIATED_GROUP_CALL$6 = "telah memulakan panggilan kumpulan";
var YOU_INITIATED_GROUP_CALL$6 = "Anda telah memulakan panggilan kumpulan";
var IGNORE$6 = "Abaikan";
var ON_ANOTHER_CALL$6 = "adalah pada panggilan lain";
var CREATING$6 = "Mencipta";
var AVATAR$6 = "Avatar";
var GROUP_NAME_BLANK$6 = "Nama kumpulan tidak boleh kosong";
var GROUP_TYPE_BLANK$6 = "Jenis kumpulan meriam tidak kosong";
var GROUP_PASSWORD_BLANK$6 = "Kata laluan kumpulan tidak boleh kosong";
var POLL_QUESTION_BLANK$6 = "Soalan meriam tidak kosong";
var POLL_OPTION_BLANK$6 = "Opsyen meriam tidak kosong";
var ONGOING_CALL$6 = "Panggilan berterusan";
var YOU_ALREADY_ONGOING_CALL$6 = "Anda sudah berada dalam panggilan berterusan";
var RESIZE$6 = "Saiz semula";
var SETTINGS$6 = "Tetapan";
var ACTIONS$6 = "Tindakan";
var VIEW_PROFILE$6 = "Lihat Profil";
var SEND_MESSAGE_IN_PRIVATE$6 = "Hantar mesej secara peribadi";
var DELETE$6 = "Padam";
var DELETE_CONFIRM$6 = "Apakah Anda yakin ingin menghapus?";
var CANCEL$6 = "Batal";
var LEAVE_CONFIRM$6 = "Apakah Anda yakin ingin meninggalkan grup?";
var TRANSFER_CONFIRM$6 = "Anda adalah pemilik kumpulan, sila pindahkan pemilikan kepada ahli sebelum meninggalkan kumpulan";
var ADDING$6 = "Menambah...";
var TRANSFER$6 = "Pemindahan";
var TRANSFERRING$6 = "Memindahkan";
var YES$6 = "Ya";
var NO$6 = "Tidak";
var SOMETHING_WRONG$6 = "Sesuatu yang tidak kena, sila cuba lagi";
var INVALID_GROUP_NAME$6 = "Sila masukkan nama yang sah untuk kumpulan dan cuba lagi";
var INVALID_GROUP_TYPE$6 = "Sila masukkan jenis yang sah untuk kumpulan dan cuba lagi";
var INVALID_PASSWORD$6 = "Sila masukkan kata laluan yang sah untuk kumpulan dan cuba lagi";
var WRONG_PASSWORD$6 = "Sila masukkan kata laluan yang betul dan cuba lagi";
var INVALID_POLL_QUESTION$6 = "Sila masukkan soalan yang diperlukan sebelum membuat pengundian";
var INVALID_POLL_OPTION$6 = "Sila masukkan jawapan yang diperlukan sebelum mencipta pengundian";
var SAME_LANGUAGE_MESSAGE$6 = "Bahasa yang dipilih untuk terjemahan adalah sama dengan bahasa mesej asal";
var LEAVE$6 = "Tinggalkan";
var CALLS$6 = "Panggilan";
var CUSTOM_MESSAGE_LOCATION$6 = "📍 Lokasi";
var OFFLINE$6 = "Luar Talian";
var YOU$6 = "Anda";
var PRIVACY$6 = "Privasi";
var BLOCKED_USERS$6 = "Pengguna Dihalang";
var NO_PHOTOS$6 = "Tiada Foto";
var NO_VIDEOS$6 = "Tiada Video";
var NO_DOCUMENTS$6 = "Tiada Dokumen";
var JOIN$6 = "Sertai";
var NEW_CHAT$6 = "Sembang Baru";
var FORM_COMPLETION_MESSAGE$6 = "Terima kasih kerana mengisi borang.";
var FORM$6 = "Borang";
var CARD$6 = "Kad";
var HISTORY$6 = "Sejarah";
var CANCELLED_AUDIO_CALL$6 = "Panggilan Audio Dibatalkan";
var CANCELLED_VIDEO_CALL$6 = "Panggilan Video Dibatalkan";
var REJECTED_AUDIO_CALL$6 = "Panggilan Audio Ditolak";
var REJECTED_VIDEO_CALL$6 = "Panggilan Video Ditolak";
var CANCELLED_CALL$6 = "Panggilan Dibatalkan";
var UNANSWERED_CALL$6 = "Panggilan Tidak Dijawab";
var RECORDING$6 = "Rakaman";
var PARTICIPANTS$6 = "Peserta";
var CALL_HISTORY$6 = "Sejarah Panggilan";
var NO_CALLS_FOUND$6 = "Tiada Panggilan Ditemui";
var ONGOING_AUDIO_CALL$6 = "Panggilan Audio Berterusan";
var ONGOING_VIDEO_CALL$6 = "Panggilan Video Berterusan";
var CALL_DETAIL$6 = "Butiran Panggilan";
var GENERATING_SUMMARY$6 = "Menjana Ringkasan";
var CONVERSATION_SUMMARY$6 = "Ringkasan Perbualan";
var GENERATE_SUMMARY$6 = "Menjana ringkasan";
var COMETCHAT_BOT_FIRST_MESSAGE$6 = "Bagaimana saya boleh membantu anda dalam perbualan ini? Sila tanya saya soalan dan saya akan memberi nasihat kepada anda 🙂";
var COMETCHAT_ASK_BOT$6 = "Tanya";
var COMETCHAT_ASK_AI_BOT$6 = "Tanya AI Bots";
var COMETCHAT_ASK_BOT_SUBTITLE$6 = "AI Bot";
var translationMS = {
	USERS: USERS$6,
	CHATS: CHATS$6,
	GROUPS: GROUPS$6,
	MORE: MORE$6,
	MESSAGE_IMAGE: MESSAGE_IMAGE$6,
	MESSAGE_FILE: MESSAGE_FILE$6,
	NEW__GROUP: NEW__GROUP$6,
	PASSWORD: PASSWORD$6,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$6,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$6,
	CONTINUE: CONTINUE$6,
	READ: READ$6,
	VOICE_RECORDING: VOICE_RECORDING$6,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$6,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$6,
	MESSAGE: MESSAGE$6,
	AI: AI$6,
	SMART_REPLIES: SMART_REPLIES$6,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$6,
	CONVERSATION_STARTER: CONVERSATION_STARTER$6,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$6,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$6,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$6,
	GENERATING_REPLIES: GENERATING_REPLIES$6,
	NO_RECIPIENT: NO_RECIPIENT$6,
	NO_RECIPIENTS: NO_RECIPIENTS$6,
	SELECT__GROUP: SELECT__GROUP$6,
	DELETE_CONVERSATION: DELETE_CONVERSATION$6,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$6,
	ADD_TO_CHAT: ADD_TO_CHAT$6,
	MESSAGE_VIDEO: MESSAGE_VIDEO$6,
	MESSAGE_AUDIO: MESSAGE_AUDIO$6,
	NO_USERS_SELECTED: NO_USERS_SELECTED$6,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$6,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$6,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$6,
	SELECT__USER: SELECT__USER$6,
	ADMIN: ADMIN$6,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$6,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$5,
	OUTGOING_CALL: OUTGOING_CALL$6,
	OPEN_DOCUMENT: OPEN_DOCUMENT$5,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$5,
	INCOMING_CALL: INCOMING_CALL$6,
	MISSED_CALL: MISSED_CALL$6,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$6,
	ANSWER: ANSWER$6,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$6,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$5,
	SET_THE_ANSWERS: SET_THE_ANSWERS$6,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$6,
	SHARED_LOCATION: SHARED_LOCATION$6,
	CALL_DETAILS: CALL_DETAILS$6,
	POLLS: POLLS$6,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$6,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$6,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$6,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$6,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$6,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$6,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$6,
	ONLINE: ONLINE$6,
	VIEW: VIEW$5,
	ADMINISTRATOR: ADMINISTRATOR$6,
	MODERATOR: MODERATOR$6,
	PARTICIPANT: PARTICIPANT$6,
	PUBLIC: PUBLIC$6,
	PRIVATE: PRIVATE$6,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$6,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$6,
	PREFERENCES: PREFERENCES$6,
	MEMBERS: MEMBERS$6,
	TODAY: TODAY$6,
	YESTERDAY: YESTERDAY$6,
	SUNDAY: SUNDAY$6,
	MONDAY: MONDAY$6,
	TUESDAY: TUESDAY$6,
	WEDNESDAY: WEDNESDAY$6,
	THURSDAY: THURSDAY$6,
	FRIDAY: FRIDAY$6,
	SATURDAY: SATURDAY$6,
	TYPING: TYPING$6,
	IS_TYPING: IS_TYPING$6,
	CLOSE: CLOSE$6,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$6,
	ADD_MEMBERS: ADD_MEMBERS$6,
	SEND_MESSAGE: SEND_MESSAGE$6,
	UNBLOCK_USER: UNBLOCK_USER$6,
	BLOCK_USER: BLOCK_USER$6,
	DELETE_AND_EXIT: DELETE_AND_EXIT$6,
	LEAVE_GROUP: LEAVE_GROUP$6,
	CREATE_GROUP: CREATE_GROUP$6,
	SHARED_MEDIA: SHARED_MEDIA$6,
	VIDEO_CALL: VIDEO_CALL$6,
	AUDIO_CALL: AUDIO_CALL$6,
	LOADING: LOADING$6,
	REPLY: REPLY$6,
	REPLIES: REPLIES$6,
	LAUNCH: LAUNCH$6,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$6,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$6,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$6,
	CREATED_DOCUMENT: CREATED_DOCUMENT$6,
	PHOTOS: PHOTOS$6,
	VIDEOS: VIDEOS$6,
	DOCUMENT: DOCUMENT$6,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$6,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$6,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$6,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$6,
	SEARCH: SEARCH$6,
	NO_USERS_FOUND: NO_USERS_FOUND$6,
	ERROR: ERROR$6,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$6,
	NO_CHATS_FOUND: NO_CHATS_FOUND$6,
	MEDIA_MESSAGE: MEDIA_MESSAGE$6,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$6,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$6,
	DECLINE: DECLINE$6,
	ACCEPT: ACCEPT$6,
	CALL_INITIATED: CALL_INITIATED$6,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$6,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$6,
	CALL_REJECTED: CALL_REJECTED$6,
	REJECTED_CALL: REJECTED_CALL$6,
	CALL_ACCEPTED: CALL_ACCEPTED$6,
	JOINED: JOINED$6,
	LEFT_THE_CALL: LEFT_THE_CALL$6,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$6,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$6,
	CALL_ENDED: CALL_ENDED$6,
	CALL_CANCELLED: CALL_CANCELLED$6,
	CALL_BUSY: CALL_BUSY$6,
	CALLING: CALLING$6,
	ADD: ADD$6,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$6,
	BANNED_MEMBERS: BANNED_MEMBERS$6,
	NAME: NAME$6,
	SCOPE: SCOPE$6,
	UNBAN: UNBAN$6,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$6,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$6,
	CREATE: CREATE$6,
	CREATE_POLL: CREATE_POLL$6,
	QUESTION: QUESTION$6,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$6,
	OPTIONS: OPTIONS$6,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$6,
	ADD_NEW_OPTION: ADD_NEW_OPTION$6,
	VIEW_MEMBERS: VIEW_MEMBERS$6,
	DETAILS: DETAILS$6,
	NOTIFICATIONS: NOTIFICATIONS$6,
	OTHER: OTHER$6,
	HELP: HELP$6,
	REPORT_PROBLEM: REPORT_PROBLEM$6,
	GROUP_MEMBERS: GROUP_MEMBERS$6,
	BAN: BAN$6,
	KICK: KICK$6,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$6,
	PRIVATE_GROUP: PRIVATE_GROUP$6,
	PROTECTED_GROUP: PROTECTED_GROUP$6,
	VISIT: VISIT$6,
	ATTACH: ATTACH$6,
	ATTACH_FILE: ATTACH_FILE$6,
	ATTACH_VIDEO: ATTACH_VIDEO$6,
	ATTACH_AUDIO: ATTACH_AUDIO$6,
	ATTACH_IMAGE: ATTACH_IMAGE$6,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$6,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$6,
	EMOJI: EMOJI$6,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$6,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$6,
	THREAD: THREAD$6,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$6,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$6,
	ADD_REACTION: ADD_REACTION$6,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$6,
	REPLY_TO_THREAD: REPLY_TO_THREAD$6,
	REPLY_IN_THREAD: REPLY_IN_THREAD$6,
	DELETE_MESSAGE: DELETE_MESSAGE$6,
	EDIT_MESSAGE: EDIT_MESSAGE$6,
	OWNER: OWNER$6,
	CHANGE_SCOPE: CHANGE_SCOPE$6,
	STICKER: STICKER$6,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$6,
	VOICE_CALL: VOICE_CALL$6,
	VIEW_DETAIL: VIEW_DETAIL$6,
	VOTES: VOTES$6,
	VOTE: VOTE$6,
	NO_VOTE: NO_VOTE$6,
	REACTED: REACTED$6,
	ADDED: ADDED$6,
	UNBANNED: UNBANNED$6,
	MADE: MADE$6,
	CALL_UNANSWERED: CALL_UNANSWERED$6,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$6,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$6,
	DOCS: DOCS$6,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$6,
	LIVE_REACTION: LIVE_REACTION$6,
	SMILEY_PEOPLE: SMILEY_PEOPLE$6,
	ANIMALES_NATURE: ANIMALES_NATURE$6,
	FOOD_DRINK: FOOD_DRINK$6,
	ACTIVITY: ACTIVITY$6,
	TRAVEL_PLACES: TRAVEL_PLACES$6,
	OBJECTS: OBJECTS$6,
	SYMBOLS: SYMBOLS$6,
	FLAGS: FLAGS$6,
	SENT: SENT$6,
	SEEN: SEEN$6,
	DELIVERED: DELIVERED$6,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$6,
	LEFT: LEFT$6,
	KICKED: KICKED$6,
	BANNED: BANNED$6,
	NEW_MESSAGES: NEW_MESSAGES$6,
	NEW_MESSAGE: NEW_MESSAGE$6,
	JUMP: JUMP$6,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$6,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$6,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$6,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$6,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$6,
	IGNORE: IGNORE$6,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$6,
	CREATING: CREATING$6,
	AVATAR: AVATAR$6,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$6,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$6,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$6,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$6,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$6,
	ONGOING_CALL: ONGOING_CALL$6,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$6,
	RESIZE: RESIZE$6,
	SETTINGS: SETTINGS$6,
	ACTIONS: ACTIONS$6,
	VIEW_PROFILE: VIEW_PROFILE$6,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$6,
	DELETE: DELETE$6,
	DELETE_CONFIRM: DELETE_CONFIRM$6,
	CANCEL: CANCEL$6,
	LEAVE_CONFIRM: LEAVE_CONFIRM$6,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$6,
	ADDING: ADDING$6,
	TRANSFER: TRANSFER$6,
	TRANSFERRING: TRANSFERRING$6,
	YES: YES$6,
	NO: NO$6,
	SOMETHING_WRONG: SOMETHING_WRONG$6,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$6,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$6,
	INVALID_PASSWORD: INVALID_PASSWORD$6,
	WRONG_PASSWORD: WRONG_PASSWORD$6,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$6,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$6,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$6,
	LEAVE: LEAVE$6,
	CALLS: CALLS$6,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$6,
	OFFLINE: OFFLINE$6,
	YOU: YOU$6,
	PRIVACY: PRIVACY$6,
	BLOCKED_USERS: BLOCKED_USERS$6,
	"YOU'VE_BLOCKED": "Anda telah menyekat",
	NO_PHOTOS: NO_PHOTOS$6,
	NO_VIDEOS: NO_VIDEOS$6,
	NO_DOCUMENTS: NO_DOCUMENTS$6,
	JOIN: JOIN$6,
	NEW_CHAT: NEW_CHAT$6,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$6,
	FORM: FORM$6,
	CARD: CARD$6,
	HISTORY: HISTORY$6,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$6,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$6,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$6,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$6,
	CANCELLED_CALL: CANCELLED_CALL$6,
	UNANSWERED_CALL: UNANSWERED_CALL$6,
	RECORDING: RECORDING$6,
	PARTICIPANTS: PARTICIPANTS$6,
	CALL_HISTORY: CALL_HISTORY$6,
	NO_CALLS_FOUND: NO_CALLS_FOUND$6,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$6,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$6,
	CALL_DETAIL: CALL_DETAIL$6,
	GENERATING_SUMMARY: GENERATING_SUMMARY$6,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$6,
	GENERATE_SUMMARY: GENERATE_SUMMARY$6,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$6,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$6,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$6,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$6
};

var USERS$5 = "Usuários";
var CHATS$5 = "Bate-papo";
var GROUPS$5 = "Grupos";
var MORE$5 = "Mais";
var MESSAGE_IMAGE$5 = "📷 Imagem";
var MESSAGE_FILE$5 = "📁 Arquivo";
var MESSAGE_VIDEO$5 = "📹 Vídeo";
var NEW__GROUP$5 = "Novo grupo";
var READ$5 = "Leia";
var MESSAGE_INFORMATION$5 = "Informações da mensagem";
var PASSWORD$5 = "Senha";
var CONTINUE$5 = "Continuar";
var VOICE_RECORDING$5 = "Gravação de voz";
var NO_RECIPIENT$5 = "Nenhum destinatário";
var NO_RECIPIENTS$5 = "Sem destinatários";
var MESSAGE$5 = "Mensagem";
var AI$5 = "AI";
var SMART_REPLIES$5 = "Respostas inteligentes";
var CONVERSATION_STARTER$5 = "Iniciador de conversa";
var RECEIPT_INFORMATION$5 = "Informações de recibo";
var SHOW_UNSAFE_CONTENT$5 = "Tem certeza de que deseja ver conteúdo inseguro?";
var REACT_TO_MESSAGE$5 = "Reagir a uma mensagem";
var NO_CALLS_SELECTED$5 = "Nenhum chamada selecionada";
var SELECT__USER$5 = "Selecione um usuário para iniciar a mensagem";
var CANT__LOAD__CHATS$5 = "Não foi possível carregar as conversas";
var OUTGOING_CALL$5 = "Chamada de saída";
var NO_USERS_SELECTED$5 = "Nenhum usuário selecionado";
var NO_GROUPS_SELECTED$5 = "Nenhum grupo selecionado";
var NO_REPLIES_FOUND$5 = "Nenhuma resposta encontrada";
var INCOMING_CALL$5 = "Chamada recebida";
var SUGGEST_A_REPLY$5 = "Sugira uma resposta";
var GENERATING_ICEBREAKERS$5 = "Gerando quebra-gelos";
var GENERATING_REPLIES$5 = "Gerando respostas";
var MISSED_CALL$5 = "Chamada perdida";
var TRANSLATED_MESSAGE$5 = "Mensagem traduzida";
var ADMIN$5 = "Admin";
var ANSWER$5 = "Responder";
var ADD_ANOTHER_ANSWER$5 = "Adicionar outra resposta";
var SET_THE_ANSWERS$5 = "Definir as respostas";
var CLICK_TO_START_CONVERSATION$5 = "Clique para iniciar a conversa";
var SHARED_LOCATION$5 = "Local compartilhado";
var CALL_DETAILS$5 = "Detalhes da chamada";
var OPEN_WHITEBOARD$4 = "Abrir quadro branco";
var POLLS$5 = "Enquetes";
var NO_CHATS_SELECTED$5 = "Nenhum bate-papo selecionado";
var SELECT__GROUP$5 = "Selecione um grupo para começar a enviar mensagens";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$5 = "Deseja excluir esta conversa? Esta conversa será excluída de todos os seus dispositivos.";
var DELETE_CONVERSATION$5 = "Apagar conversa?";
var ADD_TO_CHAT$5 = "Adicionar ao bate-papo";
var MESSAGE_AUDIO$5 = "🎵 Áudio";
var CUSTOM_MESSAGE$5 = "Você tem uma mensagem";
var MISSED_VOICE_CALL$5 = "Chamada de voz perdida";
var MISSED_VIDEO_CALL$5 = "Chamada de vídeo perdida";
var CUSTOM_MESSAGE_POLL$5 = "📊 Enquete";
var CUSTOM_MESSAGE_STICKER$5 = "💟 Adesivo";
var CUSTOM_MESSAGE_DOCUMENT$5 = "📃 Documento";
var TRANSFER_OWNERSHIP$5 = "Transferir propriedade";
var CUSTOM_MESSAGE_WHITEBOARD$5 = "📝 quadro branco";
var ONLINE$5 = "On-line";
var VIEW$4 = "visualizar";
var ADMINISTRATOR$5 = "Administrador";
var MODERATOR$5 = "Moderador";
var PARTICIPANT$5 = "Participante";
var PUBLIC$5 = "Público";
var PRIVATE$5 = "Privado";
var PASSWORD_PROTECTED$5 = "Protegido por senha";
var PRIVACY_AND_SECURITY$5 = "Privacidade e Segurança";
var PREFERENCES$5 = "Preferências";
var MEMBERS$5 = "Membros";
var TODAY$5 = "Hoje";
var YESTERDAY$5 = "Ontem";
var SUNDAY$5 = "domingo";
var MONDAY$5 = "Segunda-feira";
var TUESDAY$5 = "terça";
var WEDNESDAY$5 = "Quarta-feira";
var THURSDAY$5 = "Quinta-feira";
var FRIDAY$5 = "Sexta-feira";
var SATURDAY$5 = "sábado";
var TYPING$5 = "digitando...";
var IS_TYPING$5 = "está digitando...";
var CLOSE$5 = "Fechar";
var ENTER_GROUP_NAME$5 = "Digite o nome do grupo";
var ADD_MEMBERS$5 = "Adicionar Membros";
var SEND_MESSAGE$5 = "Enviar Mensagem";
var UNBLOCK_USER$5 = "Desbloquear Usuário";
var BLOCK_USER$5 = "Bloquear usuário";
var DELETE_AND_EXIT$5 = "Excluir e sair";
var LEAVE_GROUP$5 = "Sair do grupo";
var CREATE_GROUP$5 = "Criar grupo";
var SHARED_MEDIA$5 = "Mídia compartilhada";
var VIDEO_CALL$5 = "Chamada de vídeo";
var AUDIO_CALL$5 = "Chamada de áudio";
var LOADING$5 = "Carregando...";
var REPLY$5 = "resposta";
var REPLIES$5 = "respostas";
var LAUNCH$5 = "Lançamento";
var SHARED_COLLABORATIVE_DOCUMENT$5 = "compartilhou um documento colaborativo";
var SHARED_COLLABORATIVE_WHITEBOARD$5 = "compartilhou um quadro de comunicações colaborativo";
var CREATED_WHITEBOARD$5 = "Você criou um novo quadro de comunicações colaborativo";
var CREATED_DOCUMENT$5 = "Você criou um novo documento colaborativo";
var PHOTOS$5 = "Fotos";
var VIDEOS$5 = "Vídeos";
var DOCUMENT$5 = "Documento";
var YOU_DELETED_THIS_MESSAGE$5 = "⚠️ Você excluiu esta mensagem";
var THIS_MESSAGE_DELETED$5 = "⚠️ Esta mensagem foi excluída";
var MESSAGE_IS_DELETED$5 = "A mensagem foi excluída";
var VIEW_ON_YOUTUBE$5 = "Ver no Youtube";
var SEARCH$5 = "Pesquisar";
var NO_USERS_FOUND$5 = "Nenhum usuário encontrado";
var ERROR$5 = "Erro";
var NO_GROUPS_FOUND$5 = "Nenhum grupo encontrado";
var NO_CHATS_FOUND$5 = "Não foram encontrados chats";
var MEDIA_MESSAGE$5 = "Mensagem de mídia";
var INCOMING_AUDIO_CALL$5 = "Chamada de áudio recebida";
var INCOMING_VIDEO_CALL$5 = "Chamada de vídeo recebida";
var DECLINE$5 = "Declínio";
var ACCEPT$5 = "Aceitar";
var CALL_INITIATED$5 = "Chamada iniciada";
var OUTGOING_AUDIO_CALL$5 = "Chamada de áudio de saída";
var OUTGOING_VIDEO_CALL$5 = "Chamada de vídeo de saída";
var CALL_REJECTED$5 = "Chamada rejeitada";
var REJECTED_CALL$5 = "chamada rejeitada";
var CALL_ACCEPTED$5 = "Chamada aceita";
var JOINED$5 = "ingressou";
var LEFT_THE_CALL$5 = "deixou a chamada";
var UNANSWERED_AUDIO_CALL$5 = "Chamada de áudio sem resposta";
var UNANSWERED_VIDEO_CALL$5 = "Chamada de vídeo sem resposta";
var CALL_ENDED$5 = "Chamada encerrada";
var CALL_CANCELLED$5 = "Chamada cancelada";
var CALL_BUSY$5 = "Ligue ocupado";
var CALLING$5 = "Chamando...";
var ADD$5 = "Adicionar";
var NO_BANNED_MEMBERS_FOUND$5 = "Não foram encontrados membros proibidos";
var BANNED_MEMBERS$5 = "Membros Banidos";
var NAME$5 = "Nome";
var SCOPE$5 = "Âmbito";
var UNBAN$5 = "Unban";
var SELECT_GROUP_TYPE$5 = "Selecionar tipo de grupo";
var ENTER_GROUP_PASSWORD$5 = "Digite a senha do grupo";
var CREATE$5 = "Criar";
var CREATE_POLL$5 = "Criar enquete";
var QUESTION$5 = "Pergunta";
var ENTER_YOUR_QUESTION$5 = "Insira sua pergunta";
var OPTIONS$5 = "Opções";
var ENTER_YOUR_OPTION$5 = "Introduza a sua opção";
var ADD_NEW_OPTION$5 = "Adicionar nova opção";
var VIEW_MEMBERS$5 = "Ver Membros";
var DETAILS$5 = "Detalhes";
var NOTIFICATIONS$5 = "Notificações";
var OTHER$5 = "Outros";
var HELP$5 = "Ajuda";
var REPORT_PROBLEM$5 = "Denunciar um problema";
var GROUP_MEMBERS$5 = "Membros do Grupo";
var BAN$5 = "Proibição";
var KICK$5 = "Chute";
var PICK_YOUR_EMOJI$5 = "Escolha o seu emoji";
var PRIVATE_GROUP$5 = "Grupo Privado";
var PROTECTED_GROUP$5 = "Grupo protegido";
var VISIT$5 = "Visitar";
var ATTACH$5 = "Anexar";
var ATTACH_FILE$5 = "Anexar arquivo";
var ATTACH_VIDEO$5 = "Anexar vídeo";
var ATTACH_AUDIO$5 = "Anexar áudio";
var ATTACH_IMAGE$5 = "Anexar imagem";
var COLLABORATE_USING_DOCUMENT$5 = "Colaborar usando um documento";
var COLLABORATE_USING_WHITEBOARD$5 = "Colaborar usando um quadro branco";
var EMOJI$5 = "Emoji";
var ENTER_YOUR_MESSAGE_HERE$5 = "Introduza aqui a sua mensagem";
var NO_MESSAGES_FOUND$5 = "Nenhuma mensagem encontrada";
var THREAD$5 = "Rosca";
var COLLABORATIVE_DOCUMENT$5 = "Documento Colaborativo";
var COLLABORATIVE_WHITEBOARD$5 = "Quadro Colaborativo";
var ADD_REACTION$5 = "Adicionar reação";
var NO_STICKERS_FOUND$5 = "Não foram encontrados adesivos";
var REPLY_TO_THREAD$5 = "Responder ao thread";
var REPLY_IN_THREAD$5 = "Responder no tópico";
var DELETE_MESSAGE$5 = "Excluir mensagem";
var EDIT_MESSAGE$5 = "Editar mensagem";
var OWNER$5 = "Proprietário";
var CHANGE_SCOPE$5 = "Alterar escopo";
var STICKER$5 = "Adesivo";
var LAST_ACTIVE_AT$5 = "Último ativo em";
var VOICE_CALL$5 = "Chamada de voz";
var VIEW_DETAIL$5 = "Ver detalhes";
var VOTES$5 = "vota";
var VOTE$5 = "votar";
var NO_VOTE$5 = "Sem votação";
var REACTED$5 = "reagiu";
var ADDED$5 = "adicionada";
var UNBANNED$5 = "não banido";
var MADE$5 = "fez";
var CALL_UNANSWERED$5 = "Chamada sem resposta";
var MISSED_AUDIO_CALL$5 = "Chamada de áudio perdida";
var ENTER_YOUR_PASSWORD$5 = "Digite sua senha";
var DOCS$5 = "Documentos";
var NO_RECORDS_FOUND$5 = "Nenhum registro encontrado";
var LIVE_REACTION$5 = "Reação ao vivo";
var SMILEY_PEOPLE$5 = "Smileys & Pessoas";
var ANIMALES_NATURE$5 = "Animais & Natureza";
var FOOD_DRINK$5 = "Comidas & Bebidas";
var ACTIVITY$5 = "Atividade";
var TRAVEL_PLACES$5 = "Viagens e lugares";
var OBJECTS$5 = "Objetos";
var SYMBOLS$5 = "Símbolos";
var FLAGS$5 = "Bandeiras";
var SENT$5 = "Enviado";
var SEEN$5 = "Visto";
var DELIVERED$5 = "Entregue";
var TRANSLATE_MESSAGE$5 = "Traduzir mensagem";
var LEFT$5 = "esquerdo";
var KICKED$5 = "chutado";
var BANNED$5 = "banido";
var NEW_MESSAGES$5 = "novas mensagens";
var NEW_MESSAGE$5 = "nova mensagem";
var JUMP$5 = "Saltar";
var SELECT_VIDEO_SOURCE$5 = "Selecionar fonte de vídeo";
var SELECT_INPUT_AUDIO_SOURCE$5 = "Selecionar fonte de áudio de entrada";
var SELECT_OUTPUT_AUDIO_SOURCE$5 = "Selecionar fonte de áudio de saída";
var INITIATED_GROUP_CALL$5 = "iniciou uma chamada de grupo";
var YOU_INITIATED_GROUP_CALL$5 = "Você iniciou uma chamada em grupo";
var IGNORE$5 = "Ignorar";
var ON_ANOTHER_CALL$5 = "está em outra chamada";
var CREATING$5 = "Criando";
var AVATAR$5 = "Avatar";
var GROUP_NAME_BLANK$5 = "O nome do grupo não pode estar em branco";
var GROUP_TYPE_BLANK$5 = "Tipo de grupo não pode estar em branco";
var GROUP_PASSWORD_BLANK$5 = "A senha do grupo não pode estar em branco";
var POLL_QUESTION_BLANK$5 = "Pergunta não pode ser em branco";
var POLL_OPTION_BLANK$5 = "Opção não estar em branco";
var ONGOING_CALL$5 = "Chamada em curso";
var YOU_ALREADY_ONGOING_CALL$5 = "Você já está em uma chamada em andamento";
var RESIZE$5 = "Redimensionar";
var SETTINGS$5 = "Configurações";
var ACTIONS$5 = "Ações";
var VIEW_PROFILE$5 = "Ver Perfil";
var SEND_MESSAGE_IN_PRIVATE$5 = "Enviar mensagem privada";
var DELETE$5 = "Excluir";
var DELETE_CONFIRM$5 = "Tem certeza de que deseja excluir?";
var CANCEL$5 = "Cancelar";
var LEAVE_CONFIRM$5 = "Tem certeza que quer deixar o grupo?";
var TRANSFER_CONFIRM$5 = "Você é o proprietário do grupo. Por favor, transfira a propriedade para um membro antes de sair do grupo";
var ADDING$5 = "Adicionando...";
var TRANSFER$5 = "Transferir";
var TRANSFERRING$5 = "Transferindo";
var YES$5 = "sim";
var NO$5 = "Não";
var SOMETHING_WRONG$5 = "Algo deu errado, tente novamente";
var INVALID_GROUP_NAME$5 = "Insira um nome válido para o grupo e tente novamente";
var INVALID_GROUP_TYPE$5 = "Insira um tipo válido para o grupo e tente novamente";
var INVALID_PASSWORD$5 = "Insira uma senha válida para o grupo e tente novamente";
var WRONG_PASSWORD$5 = "Digite a senha correta e tente novamente";
var INVALID_POLL_QUESTION$5 = "Insira a pergunta necessária antes de criar uma enquete";
var INVALID_POLL_OPTION$5 = "Insira a resposta necessária antes de criar uma enquete";
var SAME_LANGUAGE_MESSAGE$5 = "O idioma selecionado para tradução é semelhante ao idioma da mensagem original";
var LEAVE$5 = "Sair";
var CALLS$5 = "Chamadas";
var CUSTOM_MESSAGE_LOCATION$5 = "📍 Localização";
var OFFLINE$5 = "Offline";
var YOU$5 = "Você";
var PRIVACY$5 = "Privacidade";
var BLOCKED_USERS$5 = "Usuários bloqueados";
var NO_PHOTOS$5 = "Sem Fotos";
var NO_VIDEOS$5 = "Sem vídeos";
var NO_DOCUMENTS$5 = "Sem Documentos";
var JOIN$5 = "Junte-se";
var NEW_CHAT$5 = "Novo bate-papo";
var FORM_COMPLETION_MESSAGE$5 = "Obrigado por preencher o formulário.";
var FORM$5 = "Formulário";
var CARD$5 = "Cartão";
var HISTORY$5 = "História";
var CANCELLED_AUDIO_CALL$5 = "Chamada de áudio cancelada";
var CANCELLED_VIDEO_CALL$5 = "Chamada de vídeo cancelada";
var REJECTED_AUDIO_CALL$5 = "Chamada de áudio rejeitada";
var REJECTED_VIDEO_CALL$5 = "Chamada de vídeo rejeitada";
var CANCELLED_CALL$5 = "Chamada cancelada";
var UNANSWERED_CALL$5 = "Chamada não atendida";
var RECORDING$5 = "Gravação";
var PARTICIPANTS$5 = "Participantes";
var CALL_HISTORY$5 = "Histórico de chamadas";
var NO_CALLS_FOUND$5 = "Nenhuma chamada encontrada";
var ONGOING_AUDIO_CALL$5 = "Chamada de áudio em andamento";
var ONGOING_VIDEO_CALL$5 = "Chamada de vídeo em andamento";
var CALL_DETAIL$5 = "Detalhe da chamada";
var GENERATING_SUMMARY$5 = "Gerando resumo";
var CONVERSATION_SUMMARY$5 = "Resumo da conversa";
var GENERATE_SUMMARY$5 = "Gere um resumo";
var COMETCHAT_BOT_FIRST_MESSAGE$5 = "Como posso te ajudar nessa conversa? Por favor, me faça uma pergunta e eu vou te aconselhar 🙂";
var COMETCHAT_ASK_BOT$5 = "Pergunte";
var COMETCHAT_ASK_AI_BOT$5 = "Pergunte aos robôs de IA";
var COMETCHAT_ASK_BOT_SUBTITLE$5 = "Robô de IA";
var translationPT = {
	USERS: USERS$5,
	CHATS: CHATS$5,
	GROUPS: GROUPS$5,
	MORE: MORE$5,
	MESSAGE_IMAGE: MESSAGE_IMAGE$5,
	MESSAGE_FILE: MESSAGE_FILE$5,
	MESSAGE_VIDEO: MESSAGE_VIDEO$5,
	NEW__GROUP: NEW__GROUP$5,
	READ: READ$5,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$5,
	PASSWORD: PASSWORD$5,
	CONTINUE: CONTINUE$5,
	VOICE_RECORDING: VOICE_RECORDING$5,
	NO_RECIPIENT: NO_RECIPIENT$5,
	NO_RECIPIENTS: NO_RECIPIENTS$5,
	MESSAGE: MESSAGE$5,
	AI: AI$5,
	SMART_REPLIES: SMART_REPLIES$5,
	CONVERSATION_STARTER: CONVERSATION_STARTER$5,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$5,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$5,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$5,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$5,
	SELECT__USER: SELECT__USER$5,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$5,
	OUTGOING_CALL: OUTGOING_CALL$5,
	NO_USERS_SELECTED: NO_USERS_SELECTED$5,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$5,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$5,
	INCOMING_CALL: INCOMING_CALL$5,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$5,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$5,
	GENERATING_REPLIES: GENERATING_REPLIES$5,
	MISSED_CALL: MISSED_CALL$5,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$5,
	ADMIN: ADMIN$5,
	ANSWER: ANSWER$5,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$5,
	SET_THE_ANSWERS: SET_THE_ANSWERS$5,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$5,
	SHARED_LOCATION: SHARED_LOCATION$5,
	CALL_DETAILS: CALL_DETAILS$5,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$4,
	POLLS: POLLS$5,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$5,
	SELECT__GROUP: SELECT__GROUP$5,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$5,
	DELETE_CONVERSATION: DELETE_CONVERSATION$5,
	ADD_TO_CHAT: ADD_TO_CHAT$5,
	MESSAGE_AUDIO: MESSAGE_AUDIO$5,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$5,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$5,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$5,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$5,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$5,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$5,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$5,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$5,
	ONLINE: ONLINE$5,
	VIEW: VIEW$4,
	ADMINISTRATOR: ADMINISTRATOR$5,
	MODERATOR: MODERATOR$5,
	PARTICIPANT: PARTICIPANT$5,
	PUBLIC: PUBLIC$5,
	PRIVATE: PRIVATE$5,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$5,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$5,
	PREFERENCES: PREFERENCES$5,
	MEMBERS: MEMBERS$5,
	TODAY: TODAY$5,
	YESTERDAY: YESTERDAY$5,
	SUNDAY: SUNDAY$5,
	MONDAY: MONDAY$5,
	TUESDAY: TUESDAY$5,
	WEDNESDAY: WEDNESDAY$5,
	THURSDAY: THURSDAY$5,
	FRIDAY: FRIDAY$5,
	SATURDAY: SATURDAY$5,
	TYPING: TYPING$5,
	IS_TYPING: IS_TYPING$5,
	CLOSE: CLOSE$5,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$5,
	ADD_MEMBERS: ADD_MEMBERS$5,
	SEND_MESSAGE: SEND_MESSAGE$5,
	UNBLOCK_USER: UNBLOCK_USER$5,
	BLOCK_USER: BLOCK_USER$5,
	DELETE_AND_EXIT: DELETE_AND_EXIT$5,
	LEAVE_GROUP: LEAVE_GROUP$5,
	CREATE_GROUP: CREATE_GROUP$5,
	SHARED_MEDIA: SHARED_MEDIA$5,
	VIDEO_CALL: VIDEO_CALL$5,
	AUDIO_CALL: AUDIO_CALL$5,
	LOADING: LOADING$5,
	REPLY: REPLY$5,
	REPLIES: REPLIES$5,
	LAUNCH: LAUNCH$5,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$5,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$5,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$5,
	CREATED_DOCUMENT: CREATED_DOCUMENT$5,
	PHOTOS: PHOTOS$5,
	VIDEOS: VIDEOS$5,
	DOCUMENT: DOCUMENT$5,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$5,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$5,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$5,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$5,
	SEARCH: SEARCH$5,
	NO_USERS_FOUND: NO_USERS_FOUND$5,
	ERROR: ERROR$5,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$5,
	NO_CHATS_FOUND: NO_CHATS_FOUND$5,
	MEDIA_MESSAGE: MEDIA_MESSAGE$5,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$5,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$5,
	DECLINE: DECLINE$5,
	ACCEPT: ACCEPT$5,
	CALL_INITIATED: CALL_INITIATED$5,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$5,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$5,
	CALL_REJECTED: CALL_REJECTED$5,
	REJECTED_CALL: REJECTED_CALL$5,
	CALL_ACCEPTED: CALL_ACCEPTED$5,
	JOINED: JOINED$5,
	LEFT_THE_CALL: LEFT_THE_CALL$5,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$5,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$5,
	CALL_ENDED: CALL_ENDED$5,
	CALL_CANCELLED: CALL_CANCELLED$5,
	CALL_BUSY: CALL_BUSY$5,
	CALLING: CALLING$5,
	ADD: ADD$5,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$5,
	BANNED_MEMBERS: BANNED_MEMBERS$5,
	NAME: NAME$5,
	SCOPE: SCOPE$5,
	UNBAN: UNBAN$5,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$5,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$5,
	CREATE: CREATE$5,
	CREATE_POLL: CREATE_POLL$5,
	QUESTION: QUESTION$5,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$5,
	OPTIONS: OPTIONS$5,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$5,
	ADD_NEW_OPTION: ADD_NEW_OPTION$5,
	VIEW_MEMBERS: VIEW_MEMBERS$5,
	DETAILS: DETAILS$5,
	NOTIFICATIONS: NOTIFICATIONS$5,
	OTHER: OTHER$5,
	HELP: HELP$5,
	REPORT_PROBLEM: REPORT_PROBLEM$5,
	GROUP_MEMBERS: GROUP_MEMBERS$5,
	BAN: BAN$5,
	KICK: KICK$5,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$5,
	PRIVATE_GROUP: PRIVATE_GROUP$5,
	PROTECTED_GROUP: PROTECTED_GROUP$5,
	VISIT: VISIT$5,
	ATTACH: ATTACH$5,
	ATTACH_FILE: ATTACH_FILE$5,
	ATTACH_VIDEO: ATTACH_VIDEO$5,
	ATTACH_AUDIO: ATTACH_AUDIO$5,
	ATTACH_IMAGE: ATTACH_IMAGE$5,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$5,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$5,
	EMOJI: EMOJI$5,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$5,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$5,
	THREAD: THREAD$5,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$5,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$5,
	ADD_REACTION: ADD_REACTION$5,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$5,
	REPLY_TO_THREAD: REPLY_TO_THREAD$5,
	REPLY_IN_THREAD: REPLY_IN_THREAD$5,
	DELETE_MESSAGE: DELETE_MESSAGE$5,
	EDIT_MESSAGE: EDIT_MESSAGE$5,
	OWNER: OWNER$5,
	CHANGE_SCOPE: CHANGE_SCOPE$5,
	STICKER: STICKER$5,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$5,
	VOICE_CALL: VOICE_CALL$5,
	VIEW_DETAIL: VIEW_DETAIL$5,
	VOTES: VOTES$5,
	VOTE: VOTE$5,
	NO_VOTE: NO_VOTE$5,
	REACTED: REACTED$5,
	ADDED: ADDED$5,
	UNBANNED: UNBANNED$5,
	MADE: MADE$5,
	CALL_UNANSWERED: CALL_UNANSWERED$5,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$5,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$5,
	DOCS: DOCS$5,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$5,
	LIVE_REACTION: LIVE_REACTION$5,
	SMILEY_PEOPLE: SMILEY_PEOPLE$5,
	ANIMALES_NATURE: ANIMALES_NATURE$5,
	FOOD_DRINK: FOOD_DRINK$5,
	ACTIVITY: ACTIVITY$5,
	TRAVEL_PLACES: TRAVEL_PLACES$5,
	OBJECTS: OBJECTS$5,
	SYMBOLS: SYMBOLS$5,
	FLAGS: FLAGS$5,
	SENT: SENT$5,
	SEEN: SEEN$5,
	DELIVERED: DELIVERED$5,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$5,
	LEFT: LEFT$5,
	KICKED: KICKED$5,
	BANNED: BANNED$5,
	NEW_MESSAGES: NEW_MESSAGES$5,
	NEW_MESSAGE: NEW_MESSAGE$5,
	JUMP: JUMP$5,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$5,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$5,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$5,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$5,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$5,
	IGNORE: IGNORE$5,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$5,
	CREATING: CREATING$5,
	AVATAR: AVATAR$5,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$5,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$5,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$5,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$5,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$5,
	ONGOING_CALL: ONGOING_CALL$5,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$5,
	RESIZE: RESIZE$5,
	SETTINGS: SETTINGS$5,
	ACTIONS: ACTIONS$5,
	VIEW_PROFILE: VIEW_PROFILE$5,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$5,
	DELETE: DELETE$5,
	DELETE_CONFIRM: DELETE_CONFIRM$5,
	CANCEL: CANCEL$5,
	LEAVE_CONFIRM: LEAVE_CONFIRM$5,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$5,
	ADDING: ADDING$5,
	TRANSFER: TRANSFER$5,
	TRANSFERRING: TRANSFERRING$5,
	YES: YES$5,
	NO: NO$5,
	SOMETHING_WRONG: SOMETHING_WRONG$5,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$5,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$5,
	INVALID_PASSWORD: INVALID_PASSWORD$5,
	WRONG_PASSWORD: WRONG_PASSWORD$5,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$5,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$5,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$5,
	LEAVE: LEAVE$5,
	CALLS: CALLS$5,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$5,
	OFFLINE: OFFLINE$5,
	YOU: YOU$5,
	PRIVACY: PRIVACY$5,
	BLOCKED_USERS: BLOCKED_USERS$5,
	"YOU'VE_BLOCKED": "Você bloqueou",
	NO_PHOTOS: NO_PHOTOS$5,
	NO_VIDEOS: NO_VIDEOS$5,
	NO_DOCUMENTS: NO_DOCUMENTS$5,
	JOIN: JOIN$5,
	NEW_CHAT: NEW_CHAT$5,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$5,
	FORM: FORM$5,
	CARD: CARD$5,
	HISTORY: HISTORY$5,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$5,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$5,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$5,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$5,
	CANCELLED_CALL: CANCELLED_CALL$5,
	UNANSWERED_CALL: UNANSWERED_CALL$5,
	RECORDING: RECORDING$5,
	PARTICIPANTS: PARTICIPANTS$5,
	CALL_HISTORY: CALL_HISTORY$5,
	NO_CALLS_FOUND: NO_CALLS_FOUND$5,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$5,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$5,
	CALL_DETAIL: CALL_DETAIL$5,
	GENERATING_SUMMARY: GENERATING_SUMMARY$5,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$5,
	GENERATE_SUMMARY: GENERATE_SUMMARY$5,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$5,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$5,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$5,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$5
};

var USERS$4 = "Пользователи";
var CHATS$4 = "Чаты";
var GROUPS$4 = "Группы";
var MORE$4 = "Еще";
var MESSAGE_IMAGE$4 = "📷 Изображение";
var NEW__GROUP$4 = "Новая группа";
var PASSWORD$4 = "Пароль";
var CONTINUE$4 = "Продолжать";
var NO_CHATS_SELECTED$4 = "Чаты не выбраны";
var SELECT__GROUP$4 = "Выберите группу, чтобы начать обмен сообщениями";
var DELETE_CONVERSATION$4 = "Удалить беседу?";
var REACT_TO_MESSAGE$4 = "Отреагировать на сообщение";
var ADD_TO_CHAT$4 = "Добавить в чат";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$4 = "Удалить этот разговор? Этот разговор будет удален со всех ваших устройств.";
var MESSAGE_FILE$4 = "📁 Файл";
var READ$4 = "Прочтите";
var MESSAGE$4 = "Послание";
var AI$4 = "ИСКУССТВЕННЫЙ ИНТЕЛЛЕКТ";
var SMART_REPLIES$4 = "Умные ответы";
var NO_REPLIES_FOUND$4 = "Ответов не найдено";
var CONVERSATION_STARTER$4 = "Начало беседы";
var RECEIPT_INFORMATION$4 = "Информация о чеке";
var VOICE_RECORDING$4 = "Запись голоса";
var SUGGEST_A_REPLY$4 = "Предложите ответ";
var GENERATING_ICEBREAKERS$4 = "Генерация ледоколов";
var GENERATING_REPLIES$4 = "Генерация ответов";
var NO_RECIPIENT$4 = "Нет получателя";
var NO_RECIPIENTS$4 = "Нет получателей";
var MESSAGE_INFORMATION$4 = "Информация о сообщении";
var MESSAGE_VIDEO$4 = "📹 Видео";
var NO_USERS_SELECTED$4 = "Пользователи не выбраны";
var NO_GROUPS_SELECTED$4 = "Группы не выбраны";
var SHOW_UNSAFE_CONTENT$4 = "Вы уверены, что хотите просмотреть небезопасный контент?";
var SHARED_FILE = "Общий файл";
var MESSAGE_AUDIO$4 = "🎵 Аудио";
var NO_CALLS_SELECTED$4 = "Нет выбранных звонков";
var SELECT__USER$4 = "Выберите пользователя, чтобы начать общение";
var CANT__LOAD__CHATS$4 = "Не удалось загрузить чаты";
var OUTGOING_CALL$4 = "Исходящий звонок";
var INCOMING_CALL$4 = "Входящий звонок";
var MISSED_CALL$4 = "Пропущенный звонок";
var TRANSLATED_MESSAGE$4 = "Переведенное сообщение";
var OPEN_WHITEBOARD$3 = "Открыть доску";
var OPEN_DOCUMENT$4 = "Открыть документ";
var ADMIN$4 = "Админ";
var DRAW_DOCUMENT_TOGETHER$4 = "Открыть документ для совместного редактирования содержимого";
var DRAW_WHITEBOARD_TOGETHER$4 = "Открыть доску для совместного";
var ANSWER$4 = "Ответить";
var ADD_ANOTHER_ANSWER$4 = "Добавить еще один ответ";
var SET_THE_ANSWERS$4 = "Установить ответы";
var CLICK_TO_START_CONVERSATION$4 = "Нажмите, чтобы начать разговор";
var SHARED_LOCATION$4 = "Общее местоположение";
var CALL_DETAILS$4 = "Сведения о звонке";
var POLLS$4 = "Опросы";
var CUSTOM_MESSAGE$4 = "У вас есть сообщение";
var MISSED_VOICE_CALL$4 = "Пропущенный голосовой вызов";
var MISSED_VIDEO_CALL$4 = "Пропущенный видеовызов";
var CUSTOM_MESSAGE_POLL$4 = "📊 Опрос";
var TRANSFER_OWNERSHIP$4 = "Передача права собственности";
var CUSTOM_MESSAGE_STICKER$4 = "💟 Стикер";
var CUSTOM_MESSAGE_DOCUMENT$4 = "📃 Документ";
var CUSTOM_MESSAGE_WHITEBOARD$4 = "📝 Доска";
var ONLINE$4 = "В сети";
var ADMINISTRATOR$4 = "Администратор";
var VIEW$3 = "вид";
var MODERATOR$4 = "Модератор";
var PARTICIPANT$4 = "Участник";
var PUBLIC$4 = "Публичный";
var PRIVATE$4 = "Частный";
var PASSWORD_PROTECTED$4 = "Защищено паролем";
var PRIVACY_AND_SECURITY$4 = "Конфиденциальность и безопасность";
var PREFERENCES$4 = "Предпочтения";
var MEMBERS$4 = "Участники";
var TODAY$4 = "Сегодня";
var YESTERDAY$4 = "Вчера";
var SUNDAY$4 = "Воскресенье";
var MONDAY$4 = "Понедельник";
var TUESDAY$4 = "Вторник";
var WEDNESDAY$4 = "Среда";
var THURSDAY$4 = "Четверг";
var FRIDAY$4 = "Пятница";
var SATURDAY$4 = "Суббота";
var TYPING$4 = "набор...";
var IS_TYPING$4 = "набирает...";
var CLOSE$4 = "Закрыть";
var ENTER_GROUP_NAME$4 = "Введите название группы";
var ADD_MEMBERS$4 = "Добавить участников";
var SEND_MESSAGE$4 = "Отправить сообщение";
var UNBLOCK_USER$4 = "Разблокировать пользователя";
var BLOCK_USER$4 = "Заблокировать пользователя";
var DELETE_AND_EXIT$4 = "Удалить и выйти";
var LEAVE_GROUP$4 = "Покинуть группу";
var CREATE_GROUP$4 = "Создать группу";
var SHARED_MEDIA$4 = "Общие медиафайлы";
var VIDEO_CALL$4 = "Видеозвонок";
var AUDIO_CALL$4 = "Аудиовызов";
var LOADING$4 = "Загрузка...";
var REPLY$4 = "ответить";
var REPLIES$4 = "ответы";
var LAUNCH$4 = "Запуск";
var SHARED_COLLABORATIVE_DOCUMENT$4 = "предоставил совместный доступ к документу";
var SHARED_COLLABORATIVE_WHITEBOARD$4 = "предоставил доступ к совместной доске";
var CREATED_WHITEBOARD$4 = "Вы создали новую интерактивную доску";
var CREATED_DOCUMENT$4 = "Вы создали новый совместный документ";
var PHOTOS$4 = "Фотографии";
var VIDEOS$4 = "Видео";
var DOCUMENT$4 = "Документ";
var YOU_DELETED_THIS_MESSAGE$4 = "⚠️ Вы удалили это сообщение";
var THIS_MESSAGE_DELETED$4 = "⚠️ Это сообщение удалено";
var MESSAGE_IS_DELETED$4 = "Сообщение удалено";
var VIEW_ON_YOUTUBE$4 = "Посмотреть на Youtube";
var SEARCH$4 = "Поиск";
var NO_USERS_FOUND$4 = "Пользователи не найдены";
var ERROR$4 = "Ошибка";
var NO_GROUPS_FOUND$4 = "Группы не найдены";
var NO_CHATS_FOUND$4 = "Чатов не найдено";
var MEDIA_MESSAGE$4 = "Сообщение СМИ";
var INCOMING_AUDIO_CALL$4 = "Входящий аудиовызов";
var INCOMING_VIDEO_CALL$4 = "Входящий видеозвонок";
var DECLINE$4 = "Отклонить";
var ACCEPT$4 = "Принять";
var CALL_INITIATED$4 = "Вызов инициирован";
var OUTGOING_AUDIO_CALL$4 = "Исходящий аудиовызов";
var OUTGOING_VIDEO_CALL$4 = "Исходящий видеозвонок";
var CALL_REJECTED$4 = "Вызов отклонен";
var REJECTED_CALL$4 = "отклоненный вызов";
var CALL_ACCEPTED$4 = "Вызов принят";
var JOINED$4 = "присоединился";
var LEFT_THE_CALL$4 = "покинул вызов";
var UNANSWERED_AUDIO_CALL$4 = "Аудиовызов без ответа";
var UNANSWERED_VIDEO_CALL$4 = "Видеозвонок без ответа";
var CALL_ENDED$4 = "Звонок завершен";
var CALL_CANCELLED$4 = "Вызов отменен";
var CALL_BUSY$4 = "Вызов занят";
var CALLING$4 = "Звонок...";
var ADD$4 = "Добавить";
var NO_BANNED_MEMBERS_FOUND$4 = "Заблокированных участников не найдено";
var BANNED_MEMBERS$4 = "Заблокированные участники";
var NAME$4 = "Имя";
var SCOPE$4 = "Сфера действия";
var UNBAN$4 = "Разблокировать";
var SELECT_GROUP_TYPE$4 = "Выбрать тип группы";
var ENTER_GROUP_PASSWORD$4 = "Введите пароль группы";
var CREATE$4 = "Создать";
var CREATE_POLL$4 = "Создать опрос";
var QUESTION$4 = "Вопрос";
var ENTER_YOUR_QUESTION$4 = "Введите свой вопрос";
var OPTIONS$4 = "Параметры";
var ENTER_YOUR_OPTION$4 = "Введите свой вариант";
var ADD_NEW_OPTION$4 = "Добавить новый вариант";
var VIEW_MEMBERS$4 = "Просмотр участников";
var DETAILS$4 = "Подробности";
var NOTIFICATIONS$4 = "Уведомления";
var OTHER$4 = "Другое";
var HELP$4 = "Помощь";
var REPORT_PROBLEM$4 = "Сообщить о проблеме";
var GROUP_MEMBERS$4 = "Участники группы";
var BAN$4 = "Заблокировать";
var KICK$4 = "Выгнать";
var PICK_YOUR_EMOJI$4 = "Выберите свой emoji";
var PRIVATE_GROUP$4 = "Частная группа";
var PROTECTED_GROUP$4 = "Защищенная группа";
var VISIT$4 = "Посещение";
var ATTACH$4 = "Прикрепить";
var ATTACH_FILE$4 = "Прикрепить файл";
var ATTACH_VIDEO$4 = "Прикрепить видео";
var ATTACH_AUDIO$4 = "Прикрепить аудио";
var ATTACH_IMAGE$4 = "Прикрепить изображение";
var COLLABORATE_USING_DOCUMENT$4 = "Совместная работа с помощью документа";
var COLLABORATE_USING_WHITEBOARD$4 = "Совместная работа с помощью доски";
var EMOJI$4 = "Emoji";
var ENTER_YOUR_MESSAGE_HERE$4 = "Введите свое сообщение здесь";
var NO_MESSAGES_FOUND$4 = "Сообщения не найдены";
var THREAD$4 = "Ветка";
var COLLABORATIVE_DOCUMENT$4 = "Общий документ";
var COLLABORATIVE_WHITEBOARD$4 = "Доска для совместной работы";
var ADD_REACTION$4 = "Добавить реакцию";
var NO_STICKERS_FOUND$4 = "Наклейки не найдены";
var REPLY_TO_THREAD$4 = "Ответить на ветку";
var REPLY_IN_THREAD$4 = "Ответить в ветке";
var DELETE_MESSAGE$4 = "Удалить сообщение";
var EDIT_MESSAGE$4 = "Редактировать сообщение";
var OWNER$4 = "Владелец";
var CHANGE_SCOPE$4 = "Изменить область действия";
var STICKER$4 = "Наклейка";
var LAST_ACTIVE_AT$4 = "Последняя активность в";
var VOICE_CALL$4 = "Голосовой вызов";
var VIEW_DETAIL$4 = "Подробнее";
var VOTES$4 = "голоса";
var VOTE$4 = "проголосовать";
var NO_VOTE$4 = "Нет голоса";
var REACTED$4 = "отреагировал";
var ADDED$4 = "добавлено";
var UNBANNED$4 = "разблокирован";
var MADE$4 = "сделано";
var CALL_UNANSWERED$4 = "Звонок остался без ответа";
var MISSED_AUDIO_CALL$4 = "Пропущенный аудиовызов";
var ENTER_YOUR_PASSWORD$4 = "Введите свой пароль";
var DOCS$4 = "Документы";
var NO_RECORDS_FOUND$4 = "Записей не найдено";
var LIVE_REACTION$4 = "Реакция";
var SMILEY_PEOPLE$4 = "Смайлы и люди";
var ANIMALES_NATURE$4 = "Животные и природа";
var FOOD_DRINK$4 = "Еда и напитки";
var ACTIVITY$4 = "Активность";
var TRAVEL_PLACES$4 = "Путешествия и места";
var OBJECTS$4 = "Объекты";
var SYMBOLS$4 = "Символы";
var FLAGS$4 = "Флаги";
var SENT$4 = "Отправлено";
var SEEN$4 = "Просмотрено";
var DELIVERED$4 = "Доставлено";
var TRANSLATE_MESSAGE$4 = "Перевести сообщение";
var LEFT$4 = "слева";
var KICKED$4 = "выгнан";
var BANNED$4 = "заблокирован";
var NEW_MESSAGES$4 = "новые сообщения";
var NEW_MESSAGE$4 = "новое сообщение";
var JUMP$4 = "Прыгать";
var SELECT_VIDEO_SOURCE$4 = "Выбрать источник видео";
var SELECT_INPUT_AUDIO_SOURCE$4 = "Выбрать источник входного аудиосигнала";
var SELECT_OUTPUT_AUDIO_SOURCE$4 = "Выбрать источник звука для вывода";
var INITIATED_GROUP_CALL$4 = "инициировал групповой вызов";
var YOU_INITIATED_GROUP_CALL$4 = "Вы инициировали групповой вызов";
var IGNORE$4 = "Игнорировать";
var ON_ANOTHER_CALL$4 = "на другом вызове";
var CREATING$4 = "Создание";
var AVATAR$4 = "Аватар";
var GROUP_NAME_BLANK$4 = "Имя группы не может быть пустым";
var GROUP_TYPE_BLANK$4 = "Тип группы не может быть пустым";
var GROUP_PASSWORD_BLANK$4 = "Пароль группы не может быть пустым";
var POLL_QUESTION_BLANK$4 = "Вопрос не может быть пустым";
var POLL_OPTION_BLANK$4 = "Параметр не может быть пустым";
var ONGOING_CALL$4 = "Текущий звонок";
var YOU_ALREADY_ONGOING_CALL$4 = "Вы уже находитесь в постоянном вызове";
var RESIZE$4 = "Изменить размер";
var SETTINGS$4 = "Настройки";
var ACTIONS$4 = "Действия";
var VIEW_PROFILE$4 = "Просмотреть профиль";
var SEND_MESSAGE_IN_PRIVATE$4 = "Отправить сообщение в частном порядке";
var DELETE$4 = "Удалить";
var DELETE_CONFIRM$4 = "Вы действительно хотите удалить?";
var CANCEL$4 = "Отменить";
var LEAVE_CONFIRM$4 = "Вы уверены, что хотите покинуть группу?";
var TRANSFER_CONFIRM$4 = "Вы являетесь владельцем группы, пожалуйста, передайте право собственности участнику перед выходом из группы";
var ADDING$4 = "Добавление...";
var TRANSFER$4 = "Трансфер";
var TRANSFERRING$4 = "Перенос";
var YES$4 = "Да";
var NO$4 = "Нет";
var SOMETHING_WRONG$4 = "Что-то пошло не так, повторите попытку";
var INVALID_GROUP_NAME$4 = "Введите действительное имя группы и повторите попытку";
var INVALID_GROUP_TYPE$4 = "Введите допустимый тип для группы и повторите попытку";
var INVALID_PASSWORD$4 = "Введите действительный пароль для группы и повторите попытку";
var WRONG_PASSWORD$4 = "Введите правильный пароль и повторите попытку";
var INVALID_POLL_QUESTION$4 = "Пожалуйста, введите требуемый вопрос перед созданием опроса";
var INVALID_POLL_OPTION$4 = "Пожалуйста, введите требуемый ответ перед созданием опроса";
var SAME_LANGUAGE_MESSAGE$4 = "Выбранный язык перевода аналогичен языку оригинального сообщения";
var LEAVE$4 = "Оставьте";
var CALLS$4 = "Звонки";
var CUSTOM_MESSAGE_LOCATION$4 = "📍 Местоположение";
var OFFLINE$4 = "Не в сети";
var YOU$4 = "Вы";
var PRIVACY$4 = "Конфиденциальность";
var BLOCKED_USERS$4 = "Заблокированные пользователи";
var NO_PHOTOS$4 = "Нет фотографий";
var NO_VIDEOS$4 = "Нет видео";
var NO_DOCUMENTS$4 = "Нет документов";
var JOIN$4 = "Присоединиться";
var NEW_CHAT$4 = "Новый чат";
var FORM_COMPLETION_MESSAGE$4 = "Спасибо за заполнение формы.";
var FORM$4 = "Форма";
var CARD$4 = "Карточка";
var HISTORY$4 = "История";
var CANCELLED_AUDIO_CALL$4 = "Отмененный аудиозвонок";
var CANCELLED_VIDEO_CALL$4 = "Отмененный видеозвонок";
var REJECTED_AUDIO_CALL$4 = "Отклоненный аудиозвонок";
var REJECTED_VIDEO_CALL$4 = "Отклоненный видеозвонок";
var CANCELLED_CALL$4 = "Отмененный звонок";
var UNANSWERED_CALL$4 = "Звонок без ответа";
var RECORDING$4 = "Запись";
var PARTICIPANTS$4 = "Участники";
var CALL_HISTORY$4 = "История звонков";
var NO_CALLS_FOUND$4 = "Звонки не найдены";
var ONGOING_AUDIO_CALL$4 = "Продолжающийся аудиозвонок";
var ONGOING_VIDEO_CALL$4 = "Продолжающийся видеозвонок";
var CALL_DETAIL$4 = "Сведения о звонке";
var GENERATING_SUMMARY$4 = "Создание сводки";
var CONVERSATION_SUMMARY$4 = "Краткое содержание беседы";
var GENERATE_SUMMARY$4 = "Сгенерируйте сводку";
var COMETCHAT_BOT_FIRST_MESSAGE$4 = "Чем я могу помочь вам в этом разговоре? Пожалуйста, задайте мне вопрос, и я дам вам совет 🙂";
var COMETCHAT_ASK_BOT$4 = "Спросите";
var COMETCHAT_ASK_AI_BOT$4 = "Спросите роботов AI";
var COMETCHAT_ASK_BOT_SUBTITLE$4 = "ИИ-бот";
var translationRU = {
	USERS: USERS$4,
	CHATS: CHATS$4,
	GROUPS: GROUPS$4,
	MORE: MORE$4,
	MESSAGE_IMAGE: MESSAGE_IMAGE$4,
	NEW__GROUP: NEW__GROUP$4,
	PASSWORD: PASSWORD$4,
	CONTINUE: CONTINUE$4,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$4,
	SELECT__GROUP: SELECT__GROUP$4,
	DELETE_CONVERSATION: DELETE_CONVERSATION$4,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$4,
	ADD_TO_CHAT: ADD_TO_CHAT$4,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$4,
	MESSAGE_FILE: MESSAGE_FILE$4,
	READ: READ$4,
	MESSAGE: MESSAGE$4,
	AI: AI$4,
	SMART_REPLIES: SMART_REPLIES$4,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$4,
	CONVERSATION_STARTER: CONVERSATION_STARTER$4,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$4,
	VOICE_RECORDING: VOICE_RECORDING$4,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$4,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$4,
	GENERATING_REPLIES: GENERATING_REPLIES$4,
	NO_RECIPIENT: NO_RECIPIENT$4,
	NO_RECIPIENTS: NO_RECIPIENTS$4,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$4,
	MESSAGE_VIDEO: MESSAGE_VIDEO$4,
	NO_USERS_SELECTED: NO_USERS_SELECTED$4,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$4,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$4,
	SHARED_FILE: SHARED_FILE,
	MESSAGE_AUDIO: MESSAGE_AUDIO$4,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$4,
	SELECT__USER: SELECT__USER$4,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$4,
	OUTGOING_CALL: OUTGOING_CALL$4,
	INCOMING_CALL: INCOMING_CALL$4,
	MISSED_CALL: MISSED_CALL$4,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$4,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$3,
	OPEN_DOCUMENT: OPEN_DOCUMENT$4,
	ADMIN: ADMIN$4,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$4,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$4,
	ANSWER: ANSWER$4,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$4,
	SET_THE_ANSWERS: SET_THE_ANSWERS$4,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$4,
	SHARED_LOCATION: SHARED_LOCATION$4,
	CALL_DETAILS: CALL_DETAILS$4,
	POLLS: POLLS$4,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$4,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$4,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$4,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$4,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$4,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$4,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$4,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$4,
	ONLINE: ONLINE$4,
	ADMINISTRATOR: ADMINISTRATOR$4,
	VIEW: VIEW$3,
	MODERATOR: MODERATOR$4,
	PARTICIPANT: PARTICIPANT$4,
	PUBLIC: PUBLIC$4,
	PRIVATE: PRIVATE$4,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$4,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$4,
	PREFERENCES: PREFERENCES$4,
	MEMBERS: MEMBERS$4,
	TODAY: TODAY$4,
	YESTERDAY: YESTERDAY$4,
	SUNDAY: SUNDAY$4,
	MONDAY: MONDAY$4,
	TUESDAY: TUESDAY$4,
	WEDNESDAY: WEDNESDAY$4,
	THURSDAY: THURSDAY$4,
	FRIDAY: FRIDAY$4,
	SATURDAY: SATURDAY$4,
	TYPING: TYPING$4,
	IS_TYPING: IS_TYPING$4,
	CLOSE: CLOSE$4,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$4,
	ADD_MEMBERS: ADD_MEMBERS$4,
	SEND_MESSAGE: SEND_MESSAGE$4,
	UNBLOCK_USER: UNBLOCK_USER$4,
	BLOCK_USER: BLOCK_USER$4,
	DELETE_AND_EXIT: DELETE_AND_EXIT$4,
	LEAVE_GROUP: LEAVE_GROUP$4,
	CREATE_GROUP: CREATE_GROUP$4,
	SHARED_MEDIA: SHARED_MEDIA$4,
	VIDEO_CALL: VIDEO_CALL$4,
	AUDIO_CALL: AUDIO_CALL$4,
	LOADING: LOADING$4,
	REPLY: REPLY$4,
	REPLIES: REPLIES$4,
	LAUNCH: LAUNCH$4,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$4,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$4,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$4,
	CREATED_DOCUMENT: CREATED_DOCUMENT$4,
	PHOTOS: PHOTOS$4,
	VIDEOS: VIDEOS$4,
	DOCUMENT: DOCUMENT$4,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$4,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$4,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$4,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$4,
	SEARCH: SEARCH$4,
	NO_USERS_FOUND: NO_USERS_FOUND$4,
	ERROR: ERROR$4,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$4,
	NO_CHATS_FOUND: NO_CHATS_FOUND$4,
	MEDIA_MESSAGE: MEDIA_MESSAGE$4,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$4,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$4,
	DECLINE: DECLINE$4,
	ACCEPT: ACCEPT$4,
	CALL_INITIATED: CALL_INITIATED$4,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$4,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$4,
	CALL_REJECTED: CALL_REJECTED$4,
	REJECTED_CALL: REJECTED_CALL$4,
	CALL_ACCEPTED: CALL_ACCEPTED$4,
	JOINED: JOINED$4,
	LEFT_THE_CALL: LEFT_THE_CALL$4,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$4,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$4,
	CALL_ENDED: CALL_ENDED$4,
	CALL_CANCELLED: CALL_CANCELLED$4,
	CALL_BUSY: CALL_BUSY$4,
	CALLING: CALLING$4,
	ADD: ADD$4,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$4,
	BANNED_MEMBERS: BANNED_MEMBERS$4,
	NAME: NAME$4,
	SCOPE: SCOPE$4,
	UNBAN: UNBAN$4,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$4,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$4,
	CREATE: CREATE$4,
	CREATE_POLL: CREATE_POLL$4,
	QUESTION: QUESTION$4,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$4,
	OPTIONS: OPTIONS$4,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$4,
	ADD_NEW_OPTION: ADD_NEW_OPTION$4,
	VIEW_MEMBERS: VIEW_MEMBERS$4,
	DETAILS: DETAILS$4,
	NOTIFICATIONS: NOTIFICATIONS$4,
	OTHER: OTHER$4,
	HELP: HELP$4,
	REPORT_PROBLEM: REPORT_PROBLEM$4,
	GROUP_MEMBERS: GROUP_MEMBERS$4,
	BAN: BAN$4,
	KICK: KICK$4,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$4,
	PRIVATE_GROUP: PRIVATE_GROUP$4,
	PROTECTED_GROUP: PROTECTED_GROUP$4,
	VISIT: VISIT$4,
	ATTACH: ATTACH$4,
	ATTACH_FILE: ATTACH_FILE$4,
	ATTACH_VIDEO: ATTACH_VIDEO$4,
	ATTACH_AUDIO: ATTACH_AUDIO$4,
	ATTACH_IMAGE: ATTACH_IMAGE$4,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$4,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$4,
	EMOJI: EMOJI$4,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$4,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$4,
	THREAD: THREAD$4,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$4,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$4,
	ADD_REACTION: ADD_REACTION$4,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$4,
	REPLY_TO_THREAD: REPLY_TO_THREAD$4,
	REPLY_IN_THREAD: REPLY_IN_THREAD$4,
	DELETE_MESSAGE: DELETE_MESSAGE$4,
	EDIT_MESSAGE: EDIT_MESSAGE$4,
	OWNER: OWNER$4,
	CHANGE_SCOPE: CHANGE_SCOPE$4,
	STICKER: STICKER$4,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$4,
	VOICE_CALL: VOICE_CALL$4,
	VIEW_DETAIL: VIEW_DETAIL$4,
	VOTES: VOTES$4,
	VOTE: VOTE$4,
	NO_VOTE: NO_VOTE$4,
	REACTED: REACTED$4,
	ADDED: ADDED$4,
	UNBANNED: UNBANNED$4,
	MADE: MADE$4,
	CALL_UNANSWERED: CALL_UNANSWERED$4,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$4,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$4,
	DOCS: DOCS$4,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$4,
	LIVE_REACTION: LIVE_REACTION$4,
	SMILEY_PEOPLE: SMILEY_PEOPLE$4,
	ANIMALES_NATURE: ANIMALES_NATURE$4,
	FOOD_DRINK: FOOD_DRINK$4,
	ACTIVITY: ACTIVITY$4,
	TRAVEL_PLACES: TRAVEL_PLACES$4,
	OBJECTS: OBJECTS$4,
	SYMBOLS: SYMBOLS$4,
	FLAGS: FLAGS$4,
	SENT: SENT$4,
	SEEN: SEEN$4,
	DELIVERED: DELIVERED$4,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$4,
	LEFT: LEFT$4,
	KICKED: KICKED$4,
	BANNED: BANNED$4,
	NEW_MESSAGES: NEW_MESSAGES$4,
	NEW_MESSAGE: NEW_MESSAGE$4,
	JUMP: JUMP$4,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$4,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$4,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$4,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$4,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$4,
	IGNORE: IGNORE$4,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$4,
	CREATING: CREATING$4,
	AVATAR: AVATAR$4,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$4,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$4,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$4,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$4,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$4,
	ONGOING_CALL: ONGOING_CALL$4,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$4,
	RESIZE: RESIZE$4,
	SETTINGS: SETTINGS$4,
	ACTIONS: ACTIONS$4,
	VIEW_PROFILE: VIEW_PROFILE$4,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$4,
	DELETE: DELETE$4,
	DELETE_CONFIRM: DELETE_CONFIRM$4,
	CANCEL: CANCEL$4,
	LEAVE_CONFIRM: LEAVE_CONFIRM$4,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$4,
	ADDING: ADDING$4,
	TRANSFER: TRANSFER$4,
	TRANSFERRING: TRANSFERRING$4,
	YES: YES$4,
	NO: NO$4,
	SOMETHING_WRONG: SOMETHING_WRONG$4,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$4,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$4,
	INVALID_PASSWORD: INVALID_PASSWORD$4,
	WRONG_PASSWORD: WRONG_PASSWORD$4,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$4,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$4,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$4,
	LEAVE: LEAVE$4,
	CALLS: CALLS$4,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$4,
	OFFLINE: OFFLINE$4,
	YOU: YOU$4,
	PRIVACY: PRIVACY$4,
	BLOCKED_USERS: BLOCKED_USERS$4,
	"YOU'VE_BLOCKED": "Вы заблокировали",
	NO_PHOTOS: NO_PHOTOS$4,
	NO_VIDEOS: NO_VIDEOS$4,
	NO_DOCUMENTS: NO_DOCUMENTS$4,
	JOIN: JOIN$4,
	NEW_CHAT: NEW_CHAT$4,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$4,
	FORM: FORM$4,
	CARD: CARD$4,
	HISTORY: HISTORY$4,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$4,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$4,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$4,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$4,
	CANCELLED_CALL: CANCELLED_CALL$4,
	UNANSWERED_CALL: UNANSWERED_CALL$4,
	RECORDING: RECORDING$4,
	PARTICIPANTS: PARTICIPANTS$4,
	CALL_HISTORY: CALL_HISTORY$4,
	NO_CALLS_FOUND: NO_CALLS_FOUND$4,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$4,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$4,
	CALL_DETAIL: CALL_DETAIL$4,
	GENERATING_SUMMARY: GENERATING_SUMMARY$4,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$4,
	GENERATE_SUMMARY: GENERATE_SUMMARY$4,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$4,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$4,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$4,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$4
};

var USERS$3 = "用户";
var CHATS$3 = "聊天";
var GROUPS$3 = "群组";
var MORE$3 = "更多";
var MESSAGE_IMAGE$3 = "📷 图片";
var NEW__GROUP$3 = "新集团";
var PASSWORD$3 = "密码";
var CONTINUE$3 = "继续";
var NO_CHATS_SELECTED$3 = "未选择任何聊天";
var SELECT__GROUP$3 = "选择一个群组以开始发送消息";
var REACT_TO_MESSAGE$3 = "对消息做出反应";
var READ$3 = "阅读";
var AI$3 = "AI";
var NO_REPLIES_FOUND$3 = "未找到回复";
var SMART_REPLIES$3 = "智能回复";
var CONVERSATION_STARTER$3 = "对话入门";
var MESSAGE_INFORMATION$3 = "留言信息";
var MESSAGE$3 = "消息";
var RECEIPT_INFORMATION$3 = "收据信息";
var DELETE_CONVERSATION$3 = "删除对话";
var SHOW_UNSAFE_CONTENT$3 = "您确定要查看不安全的内容吗？";
var NO_RECIPIENT$3 = "没有收件人";
var NO_RECIPIENTS$3 = "没有收件人";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$3 = "要删除此对话吗？此对话将从您的所有设备中删除。";
var ADD_TO_CHAT$3 = "添加到聊天";
var MESSAGE_FILE$3 = "📁 文件";
var MESSAGE_VIDEO$3 = "📹 视频";
var MESSAGE_AUDIO$3 = "🎵 音频";
var NO_USERS_SELECTED$3 = "未选择用户";
var NO_GROUPS_SELECTED$3 = "未选择群组";
var SUGGEST_A_REPLY$3 = "建议回复";
var GENERATING_ICEBREAKERS$3 = "生成破冰船";
var GENERATING_REPLIES$3 = "生成回复";
var VOICE_RECORDING$3 = "录音";
var CUSTOM_MESSAGE$3 = "你有一个消息";
var MISSED_VOICE_CALL$3 = "未接语音通话";
var MISSED_VIDEO_CALL$3 = "未接视频通话";
var CUSTOM_MESSAGE_POLL$3 = "📊 民意调查";
var OPEN_DOCUMENT$3 = "打开文档";
var CUSTOM_MESSAGE_STICKER$3 = "💟 贴纸";
var DRAW_WHITEBOARD_TOGETHER$3 = "打开白板以共同绘制";
var ADMIN$3 = "管理";
var CUSTOM_MESSAGE_DOCUMENT$3 = "📃 文档";
var NO_CALLS_SELECTED$3 = "未选中任何通话";
var SELECT__USER$3 = "选择用户开始聊天";
var CANT__LOAD__CHATS$3 = "无法加载聊天记录";
var OUTGOING_CALL$3 = "呼出电话";
var OPEN_WHITEBOARD$2 = "打开白板";
var DRAW_DOCUMENT_TOGETHER$3 = "打开文档以共同编辑内容";
var INCOMING_CALL$3 = "来电";
var MISSED_CALL$3 = "未接来电";
var TRANSLATED_MESSAGE$3 = "翻译消息";
var ANSWER$3 = "回答";
var ADD_ANOTHER_ANSWER$3 = "添加另一个答案";
var SET_THE_ANSWERS$3 = "设置答案";
var CLICK_TO_START_CONVERSATION$3 = "点击开始对话";
var SHARED_LOCATION$3 = "共享位置";
var CALL_DETAILS$3 = "通话详情";
var POLLS$3 = "投票";
var CUSTOM_MESSAGE_WHITEBOARD$3 = "📝 白板";
var TRANSFER_OWNERSHIP$3 = "所有权转让";
var ONLINE$3 = "在线";
var ADMINISTRATOR$3 = "管理员";
var VIEW$2 = "看法";
var MODERATOR$3 = "版主";
var PARTICIPANT$3 = "参与者";
var PUBLIC$3 = "公开";
var PRIVATE$3 = "私人";
var PASSWORD_PROTECTED$3 = "密码保护";
var PRIVACY_AND_SECURITY$3 = "隐私权与安全性";
var PREFERENCES$3 = "偏好";
var MEMBERS$3 = "会员";
var TODAY$3 = "今天";
var YESTERDAY$3 = "昨天";
var SUNDAY$3 = "周日";
var MONDAY$3 = "周一";
var TUESDAY$3 = "周二";
var WEDNESDAY$3 = "周三";
var THURSDAY$3 = "周四";
var FRIDAY$3 = "周五";
var SATURDAY$3 = "周六";
var TYPING$3 = "打字...";
var IS_TYPING$3 = "正在打字...";
var CLOSE$3 = "关闭";
var ENTER_GROUP_NAME$3 = "输入组名";
var ADD_MEMBERS$3 = "添加成员";
var SEND_MESSAGE$3 = "发送消息";
var UNBLOCK_USER$3 = "解除封锁使用者";
var BLOCK_USER$3 = "封锁使用者";
var DELETE_AND_EXIT$3 = "删除并退出";
var LEAVE_GROUP$3 = "离开群组";
var CREATE_GROUP$3 = "创建群组";
var SHARED_MEDIA$3 = "共享媒体";
var VIDEO_CALL$3 = "视频通话";
var AUDIO_CALL$3 = "音频通话";
var LOADING$3 = "正在加载...";
var REPLY$3 = "答复";
var REPLIES$3 = "回复";
var LAUNCH$3 = "启动";
var SHARED_COLLABORATIVE_DOCUMENT$3 = "已共用协同合作文件";
var SHARED_COLLABORATIVE_WHITEBOARD$3 = "已共用一个协同合作白板";
var CREATED_WHITEBOARD$3 = "您已建立新的协同合作白板";
var CREATED_DOCUMENT$3 = "您已建立新的协同合作文件";
var PHOTOS$3 = "照片";
var VIDEOS$3 = "视频";
var DOCUMENT$3 = "文档";
var YOU_DELETED_THIS_MESSAGE$3 = "⚠️ 你删除了此消息";
var THIS_MESSAGE_DELETED$3 = "⚠️ 此消息已删除";
var MESSAGE_IS_DELETED$3 = "消息已删除";
var VIEW_ON_YOUTUBE$3 = "在 YouTube 上观看";
var SEARCH$3 = "搜索";
var NO_USERS_FOUND$3 = "找不到用户";
var ERROR$3 = "错误";
var NO_GROUPS_FOUND$3 = "没有找到群组";
var NO_CHATS_FOUND$3 = "没有找到聊天";
var MEDIA_MESSAGE$3 = "媒体消息";
var INCOMING_AUDIO_CALL$3 = "音讯通话来电";
var INCOMING_VIDEO_CALL$3 = "视讯通话来电";
var DECLINE$3 = "拒绝";
var ACCEPT$3 = "接受";
var CALL_INITIATED$3 = "通话已启动";
var OUTGOING_AUDIO_CALL$3 = "拨出音讯通话";
var OUTGOING_VIDEO_CALL$3 = "拨出视讯通话";
var CALL_REJECTED$3 = "通话被拒绝";
var REJECTED_CALL$3 = "被拒绝的通话";
var CALL_ACCEPTED$3 = "已接听电话";
var JOINED$3 = "加入";
var LEFT_THE_CALL$3 = "已离开通话";
var UNANSWERED_AUDIO_CALL$3 = "未接听的音讯通话";
var UNANSWERED_VIDEO_CALL$3 = "未接听的视讯通话";
var CALL_ENDED$3 = "通话结束";
var CALL_CANCELLED$3 = "通话已取消";
var CALL_BUSY$3 = "对方正在忙碌";
var CALLING$3 = "正在拨打...";
var ADD$3 = "添加";
var NO_BANNED_MEMBERS_FOUND$3 = "没有找到被封锁的会员";
var BANNED_MEMBERS$3 = "被封锁的会员";
var NAME$3 = "姓名";
var SCOPE$3 = "范围";
var UNBAN$3 = "取消封锁";
var SELECT_GROUP_TYPE$3 = "选择群组类型";
var ENTER_GROUP_PASSWORD$3 = "输入群组密码";
var CREATE$3 = "创建";
var CREATE_POLL$3 = "创建投票";
var QUESTION$3 = "问题";
var ENTER_YOUR_QUESTION$3 = "输入你的问题";
var OPTIONS$3 = "选项";
var ENTER_YOUR_OPTION$3 = "输入你的选项";
var ADD_NEW_OPTION$3 = "添加新选项";
var VIEW_MEMBERS$3 = "查看会员";
var DETAILS$3 = "详情";
var NOTIFICATIONS$3 = "通知";
var OTHER$3 = "其他";
var HELP$3 = "帮助";
var REPORT_PROBLEM$3 = "报告问题";
var GROUP_MEMBERS$3 = "群组成员";
var BAN$3 = "封锁";
var KICK$3 = "踢走";
var PICK_YOUR_EMOJI$3 = "选择你的表情符号";
var PRIVATE_GROUP$3 = "私人群组";
var PROTECTED_GROUP$3 = "密码保护群组";
var VISIT$3 = "访问";
var ATTACH$3 = "发送";
var ATTACH_FILE$3 = "发送文件";
var ATTACH_VIDEO$3 = "发送视频";
var ATTACH_AUDIO$3 = "发送音频";
var ATTACH_IMAGE$3 = "发送图片";
var COLLABORATE_USING_DOCUMENT$3 = "使用协同合作文件";
var COLLABORATE_USING_WHITEBOARD$3 = "使用协同合作白板";
var EMOJI$3 = "表情符号";
var ENTER_YOUR_MESSAGE_HERE$3 = "在这里输入你的消息";
var NO_MESSAGES_FOUND$3 = "没有找到消息";
var THREAD$3 = "消息回复框";
var COLLABORATIVE_DOCUMENT$3 = "协作文档";
var COLLABORATIVE_WHITEBOARD$3 = "协作白板";
var ADD_REACTION$3 = "添加表情";
var NO_STICKERS_FOUND$3 = "找不到贴纸";
var REPLY_TO_THREAD$3 = "回复";
var REPLY_IN_THREAD$3 = "在回复框中回复";
var DELETE_MESSAGE$3 = "删除消息";
var EDIT_MESSAGE$3 = "编辑消息";
var OWNER$3 = "拥有者";
var CHANGE_SCOPE$3 = "更改范围";
var STICKER$3 = "贴纸";
var LAST_ACTIVE_AT$3 = "最后在线时间";
var VOICE_CALL$3 = "语音通话";
var VIEW_DETAIL$3 = "查看详情";
var VOTES$3 = "选票";
var VOTE$3 = "投票";
var NO_VOTE$3 = "没有投票";
var REACTED$3 = "反应";
var ADDED$3 = "添加";
var UNBANNED$3 = "未被封锁";
var MADE$3 = "制作";
var CALL_UNANSWERED$3 = "未接听来电";
var MISSED_AUDIO_CALL$3 = "未接听的音讯通话";
var ENTER_YOUR_PASSWORD$3 = "输入您的密码";
var DOCS$3 = "文件";
var NO_RECORDS_FOUND$3 = "没有找到记录";
var LIVE_REACTION$3 = "实时反应";
var SMILEY_PEOPLE$3 = "笑脸与人物";
var ANIMALES_NATURE$3 = "动物与自然";
var FOOD_DRINK$3 = "食物与饮料";
var ACTIVITY$3 = "活动";
var TRAVEL_PLACES$3 = "旅游与地点";
var OBJECTS$3 = "物件";
var SYMBOLS$3 = "符号";
var FLAGS$3 = "旗帜";
var SENT$3 = "已发送";
var SEEN$3 = "已读";
var DELIVERED$3 = "已接收";
var TRANSLATE_MESSAGE$3 = "翻译消息";
var LEFT$3 = "已离开";
var KICKED$3 = "踢走";
var BANNED$3 = "封锁";
var NEW_MESSAGES$3 = "新消息";
var NEW_MESSAGE$3 = "新消息";
var JUMP$3 = "跳";
var SELECT_VIDEO_SOURCE$3 = "选择视频源";
var SELECT_INPUT_AUDIO_SOURCE$3 = "选择输入音频源";
var SELECT_OUTPUT_AUDIO_SOURCE$3 = "选择输出音频源";
var INITIATED_GROUP_CALL$3 = "已发起群组通话";
var YOU_INITIATED_GROUP_CALL$3 = "你已经发起了群组通话";
var IGNORE$3 = "忽略";
var ON_ANOTHER_CALL$3 = "正在另一个电话";
var CREATING$3 = "创建";
var AVATAR$3 = "阿凡达";
var GROUP_NAME_BLANK$3 = "群組名稱不能空白";
var GROUP_TYPE_BLANK$3 = "群組類型不能空白";
var GROUP_PASSWORD_BLANK$3 = "群組密碼不能空白";
var POLL_QUESTION_BLANK$3 = "問題不能空白";
var POLL_OPTION_BLANK$3 = "選項不能空白";
var ONGOING_CALL$3 = "持续的电话";
var YOU_ALREADY_ONGOING_CALL$3 = "你已经在进行中的电话";
var RESIZE$3 = "调整大小";
var SETTINGS$3 = "设置";
var ACTIONS$3 = "动作";
var VIEW_PROFILE$3 = "查看档案";
var SEND_MESSAGE_IN_PRIVATE$3 = "私下发送消息";
var DELETE$3 = "删除";
var DELETE_CONFIRM$3 = "确定要删除吗？";
var CANCEL$3 = "取消";
var LEAVE_CONFIRM$3 = "你确定要离开小组吗？";
var TRANSFER_CONFIRM$3 = "您是群组所有者，请在离开群组之前将所有权转让给成员";
var ADDING$3 = "正在添加...";
var TRANSFER$3 = "转移";
var TRANSFERRING$3 = "转移";
var YES$3 = "是的";
var NO$3 = "不";
var SOMETHING_WRONG$3 = "出错了，请重试";
var INVALID_GROUP_NAME$3 = "请输入组的有效名称，然后重试";
var INVALID_GROUP_TYPE$3 = "请输入组的有效类型，然后重试";
var INVALID_PASSWORD$3 = "请输入组的有效密码然后重试";
var WRONG_PASSWORD$3 = "请输入正确的密码然后重试";
var INVALID_POLL_QUESTION$3 = "请在创建民意调查之前输入必填的问题";
var INVALID_POLL_OPTION$3 = "请在创建民意调查之前输入必填的答案";
var SAME_LANGUAGE_MESSAGE$3 = "选定的翻译语言类似于原始消息的语言";
var LEAVE$3 = "离开";
var CALLS$3 = "来电";
var CUSTOM_MESSAGE_LOCATION$3 = "📍 位置";
var OFFLINE$3 = "离线";
var YOU$3 = "你";
var PRIVACY$3 = "隐私";
var BLOCKED_USERS$3 = "已封锁的用户";
var NO_PHOTOS$3 = "没有照片";
var NO_VIDEOS$3 = "没有视频";
var NO_DOCUMENTS$3 = "没有文档";
var JOIN$3 = "加入";
var NEW_CHAT$3 = "新聊天";
var FORM_COMPLETION_MESSAGE$3 = "感谢您填写表格。";
var FORM$3 = "表格";
var CARD$3 = "卡片";
var HISTORY$3 = "历史";
var CANCELLED_AUDIO_CALL$3 = "已取消语音通话";
var CANCELLED_VIDEO_CALL$3 = "视频通话取消";
var REJECTED_AUDIO_CALL$3 = "音频通话被拒绝";
var REJECTED_VIDEO_CALL$3 = "视频通话被拒绝";
var CANCELLED_CALL$3 = "已取消通话";
var UNANSWERED_CALL$3 = "未接听的电话";
var RECORDING$3 = "录制";
var PARTICIPANTS$3 = "参与者";
var CALL_HISTORY$3 = "通话记录";
var NO_CALLS_FOUND$3 = "未找到任何来电";
var ONGOING_AUDIO_CALL$3 = "正在进行的语音通话";
var ONGOING_VIDEO_CALL$3 = "正在进行的视频通话";
var CALL_DETAIL$3 = "通话详情";
var GENERATING_SUMMARY$3 = "正在生成摘要";
var CONVERSATION_SUMMARY$3 = "对话摘要";
var GENERATE_SUMMARY$3 = "生成摘要";
var COMETCHAT_BOT_FIRST_MESSAGE$3 = "我怎样才能帮助你完成这次对话？请问我一个问题我会给你建议 🙂";
var COMETCHAT_ASK_BOT$3 = "问";
var COMETCHAT_ASK_AI_BOT$3 = "向 AI 机器人提问";
var COMETCHAT_ASK_BOT_SUBTITLE$3 = "AI Bot";
var translationZH = {
	USERS: USERS$3,
	CHATS: CHATS$3,
	GROUPS: GROUPS$3,
	MORE: MORE$3,
	MESSAGE_IMAGE: MESSAGE_IMAGE$3,
	NEW__GROUP: NEW__GROUP$3,
	PASSWORD: PASSWORD$3,
	CONTINUE: CONTINUE$3,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$3,
	SELECT__GROUP: SELECT__GROUP$3,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$3,
	READ: READ$3,
	AI: AI$3,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$3,
	SMART_REPLIES: SMART_REPLIES$3,
	CONVERSATION_STARTER: CONVERSATION_STARTER$3,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$3,
	MESSAGE: MESSAGE$3,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$3,
	DELETE_CONVERSATION: DELETE_CONVERSATION$3,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$3,
	NO_RECIPIENT: NO_RECIPIENT$3,
	NO_RECIPIENTS: NO_RECIPIENTS$3,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$3,
	ADD_TO_CHAT: ADD_TO_CHAT$3,
	MESSAGE_FILE: MESSAGE_FILE$3,
	MESSAGE_VIDEO: MESSAGE_VIDEO$3,
	MESSAGE_AUDIO: MESSAGE_AUDIO$3,
	NO_USERS_SELECTED: NO_USERS_SELECTED$3,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$3,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$3,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$3,
	GENERATING_REPLIES: GENERATING_REPLIES$3,
	VOICE_RECORDING: VOICE_RECORDING$3,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$3,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$3,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$3,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$3,
	OPEN_DOCUMENT: OPEN_DOCUMENT$3,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$3,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$3,
	ADMIN: ADMIN$3,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$3,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$3,
	SELECT__USER: SELECT__USER$3,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$3,
	OUTGOING_CALL: OUTGOING_CALL$3,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$2,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$3,
	INCOMING_CALL: INCOMING_CALL$3,
	MISSED_CALL: MISSED_CALL$3,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$3,
	ANSWER: ANSWER$3,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$3,
	SET_THE_ANSWERS: SET_THE_ANSWERS$3,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$3,
	SHARED_LOCATION: SHARED_LOCATION$3,
	CALL_DETAILS: CALL_DETAILS$3,
	POLLS: POLLS$3,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$3,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$3,
	ONLINE: ONLINE$3,
	ADMINISTRATOR: ADMINISTRATOR$3,
	VIEW: VIEW$2,
	MODERATOR: MODERATOR$3,
	PARTICIPANT: PARTICIPANT$3,
	PUBLIC: PUBLIC$3,
	PRIVATE: PRIVATE$3,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$3,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$3,
	PREFERENCES: PREFERENCES$3,
	MEMBERS: MEMBERS$3,
	TODAY: TODAY$3,
	YESTERDAY: YESTERDAY$3,
	SUNDAY: SUNDAY$3,
	MONDAY: MONDAY$3,
	TUESDAY: TUESDAY$3,
	WEDNESDAY: WEDNESDAY$3,
	THURSDAY: THURSDAY$3,
	FRIDAY: FRIDAY$3,
	SATURDAY: SATURDAY$3,
	TYPING: TYPING$3,
	IS_TYPING: IS_TYPING$3,
	CLOSE: CLOSE$3,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$3,
	ADD_MEMBERS: ADD_MEMBERS$3,
	SEND_MESSAGE: SEND_MESSAGE$3,
	UNBLOCK_USER: UNBLOCK_USER$3,
	BLOCK_USER: BLOCK_USER$3,
	DELETE_AND_EXIT: DELETE_AND_EXIT$3,
	LEAVE_GROUP: LEAVE_GROUP$3,
	CREATE_GROUP: CREATE_GROUP$3,
	SHARED_MEDIA: SHARED_MEDIA$3,
	VIDEO_CALL: VIDEO_CALL$3,
	AUDIO_CALL: AUDIO_CALL$3,
	LOADING: LOADING$3,
	REPLY: REPLY$3,
	REPLIES: REPLIES$3,
	LAUNCH: LAUNCH$3,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$3,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$3,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$3,
	CREATED_DOCUMENT: CREATED_DOCUMENT$3,
	PHOTOS: PHOTOS$3,
	VIDEOS: VIDEOS$3,
	DOCUMENT: DOCUMENT$3,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$3,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$3,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$3,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$3,
	SEARCH: SEARCH$3,
	NO_USERS_FOUND: NO_USERS_FOUND$3,
	ERROR: ERROR$3,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$3,
	NO_CHATS_FOUND: NO_CHATS_FOUND$3,
	MEDIA_MESSAGE: MEDIA_MESSAGE$3,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$3,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$3,
	DECLINE: DECLINE$3,
	ACCEPT: ACCEPT$3,
	CALL_INITIATED: CALL_INITIATED$3,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$3,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$3,
	CALL_REJECTED: CALL_REJECTED$3,
	REJECTED_CALL: REJECTED_CALL$3,
	CALL_ACCEPTED: CALL_ACCEPTED$3,
	JOINED: JOINED$3,
	LEFT_THE_CALL: LEFT_THE_CALL$3,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$3,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$3,
	CALL_ENDED: CALL_ENDED$3,
	CALL_CANCELLED: CALL_CANCELLED$3,
	CALL_BUSY: CALL_BUSY$3,
	CALLING: CALLING$3,
	ADD: ADD$3,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$3,
	BANNED_MEMBERS: BANNED_MEMBERS$3,
	NAME: NAME$3,
	SCOPE: SCOPE$3,
	UNBAN: UNBAN$3,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$3,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$3,
	CREATE: CREATE$3,
	CREATE_POLL: CREATE_POLL$3,
	QUESTION: QUESTION$3,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$3,
	OPTIONS: OPTIONS$3,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$3,
	ADD_NEW_OPTION: ADD_NEW_OPTION$3,
	VIEW_MEMBERS: VIEW_MEMBERS$3,
	DETAILS: DETAILS$3,
	NOTIFICATIONS: NOTIFICATIONS$3,
	OTHER: OTHER$3,
	HELP: HELP$3,
	REPORT_PROBLEM: REPORT_PROBLEM$3,
	GROUP_MEMBERS: GROUP_MEMBERS$3,
	BAN: BAN$3,
	KICK: KICK$3,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$3,
	PRIVATE_GROUP: PRIVATE_GROUP$3,
	PROTECTED_GROUP: PROTECTED_GROUP$3,
	VISIT: VISIT$3,
	ATTACH: ATTACH$3,
	ATTACH_FILE: ATTACH_FILE$3,
	ATTACH_VIDEO: ATTACH_VIDEO$3,
	ATTACH_AUDIO: ATTACH_AUDIO$3,
	ATTACH_IMAGE: ATTACH_IMAGE$3,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$3,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$3,
	EMOJI: EMOJI$3,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$3,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$3,
	THREAD: THREAD$3,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$3,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$3,
	ADD_REACTION: ADD_REACTION$3,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$3,
	REPLY_TO_THREAD: REPLY_TO_THREAD$3,
	REPLY_IN_THREAD: REPLY_IN_THREAD$3,
	DELETE_MESSAGE: DELETE_MESSAGE$3,
	EDIT_MESSAGE: EDIT_MESSAGE$3,
	OWNER: OWNER$3,
	CHANGE_SCOPE: CHANGE_SCOPE$3,
	STICKER: STICKER$3,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$3,
	VOICE_CALL: VOICE_CALL$3,
	VIEW_DETAIL: VIEW_DETAIL$3,
	VOTES: VOTES$3,
	VOTE: VOTE$3,
	NO_VOTE: NO_VOTE$3,
	REACTED: REACTED$3,
	ADDED: ADDED$3,
	UNBANNED: UNBANNED$3,
	MADE: MADE$3,
	CALL_UNANSWERED: CALL_UNANSWERED$3,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$3,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$3,
	DOCS: DOCS$3,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$3,
	LIVE_REACTION: LIVE_REACTION$3,
	SMILEY_PEOPLE: SMILEY_PEOPLE$3,
	ANIMALES_NATURE: ANIMALES_NATURE$3,
	FOOD_DRINK: FOOD_DRINK$3,
	ACTIVITY: ACTIVITY$3,
	TRAVEL_PLACES: TRAVEL_PLACES$3,
	OBJECTS: OBJECTS$3,
	SYMBOLS: SYMBOLS$3,
	FLAGS: FLAGS$3,
	SENT: SENT$3,
	SEEN: SEEN$3,
	DELIVERED: DELIVERED$3,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$3,
	LEFT: LEFT$3,
	KICKED: KICKED$3,
	BANNED: BANNED$3,
	NEW_MESSAGES: NEW_MESSAGES$3,
	NEW_MESSAGE: NEW_MESSAGE$3,
	JUMP: JUMP$3,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$3,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$3,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$3,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$3,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$3,
	IGNORE: IGNORE$3,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$3,
	CREATING: CREATING$3,
	AVATAR: AVATAR$3,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$3,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$3,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$3,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$3,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$3,
	ONGOING_CALL: ONGOING_CALL$3,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$3,
	RESIZE: RESIZE$3,
	SETTINGS: SETTINGS$3,
	ACTIONS: ACTIONS$3,
	VIEW_PROFILE: VIEW_PROFILE$3,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$3,
	DELETE: DELETE$3,
	DELETE_CONFIRM: DELETE_CONFIRM$3,
	CANCEL: CANCEL$3,
	LEAVE_CONFIRM: LEAVE_CONFIRM$3,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$3,
	ADDING: ADDING$3,
	TRANSFER: TRANSFER$3,
	TRANSFERRING: TRANSFERRING$3,
	YES: YES$3,
	NO: NO$3,
	SOMETHING_WRONG: SOMETHING_WRONG$3,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$3,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$3,
	INVALID_PASSWORD: INVALID_PASSWORD$3,
	WRONG_PASSWORD: WRONG_PASSWORD$3,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$3,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$3,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$3,
	LEAVE: LEAVE$3,
	CALLS: CALLS$3,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$3,
	OFFLINE: OFFLINE$3,
	YOU: YOU$3,
	PRIVACY: PRIVACY$3,
	BLOCKED_USERS: BLOCKED_USERS$3,
	"YOU'VE_BLOCKED": "你已经封锁了",
	NO_PHOTOS: NO_PHOTOS$3,
	NO_VIDEOS: NO_VIDEOS$3,
	NO_DOCUMENTS: NO_DOCUMENTS$3,
	JOIN: JOIN$3,
	NEW_CHAT: NEW_CHAT$3,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$3,
	FORM: FORM$3,
	CARD: CARD$3,
	HISTORY: HISTORY$3,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$3,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$3,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$3,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$3,
	CANCELLED_CALL: CANCELLED_CALL$3,
	UNANSWERED_CALL: UNANSWERED_CALL$3,
	RECORDING: RECORDING$3,
	PARTICIPANTS: PARTICIPANTS$3,
	CALL_HISTORY: CALL_HISTORY$3,
	NO_CALLS_FOUND: NO_CALLS_FOUND$3,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$3,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$3,
	CALL_DETAIL: CALL_DETAIL$3,
	GENERATING_SUMMARY: GENERATING_SUMMARY$3,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$3,
	GENERATE_SUMMARY: GENERATE_SUMMARY$3,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$3,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$3,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$3,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$3
};

var USERS$2 = "使用者";
var CHATS$2 = "聊天";
var GROUPS$2 = "群組";
var NEW__GROUP$2 = "新集团";
var PASSWORD$2 = "密码";
var CONTINUE$2 = "继续";
var NO_CHATS_SELECTED$2 = "未选择任何聊天";
var SELECT__GROUP$2 = "选择一个群组以开始发送消息";
var DELETE_CONVERSATION$2 = "删除对话";
var NO_RECIPIENT$2 = "沒有收件人";
var NO_RECIPIENTS$2 = "沒有收件者";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$2 = "要删除此对话吗？此对话将从您的所有设备中删除。";
var ADD_TO_CHAT$2 = "添加到聊天";
var MORE$2 = "更多";
var READ$2 = "閱讀";
var AI$2 = "艾";
var SMART_REPLIES$2 = "智能回复";
var NO_REPLIES_FOUND$2 = "找不到回覆";
var CONVERSATION_STARTER$2 = "對話入門";
var MESSAGE$2 = "留言";
var RECEIPT_INFORMATION$2 = "收據資料";
var MESSAGE_INFORMATION$2 = "訊息資訊";
var SHOW_UNSAFE_CONTENT$2 = "您確定要查看不安全的內容嗎？";
var REACT_TO_MESSAGE$2 = "回應訊息";
var VOICE_RECORDING$2 = "聲音錄音";
var MESSAGE_IMAGE$2 = "📷 圖片";
var MESSAGE_FILE$2 = "📁 檔案";
var MESSAGE_VIDEO$2 = "📹 影片";
var SUGGEST_A_REPLY$2 = "建議回覆";
var GENERATING_ICEBREAKERS$2 = "生成破冰船";
var GENERATING_REPLIES$2 = "生成回复";
var NO_USERS_SELECTED$2 = "未選擇使用者";
var NO_GROUPS_SELECTED$2 = "未選擇群組";
var MESSAGE_AUDIO$2 = "🎵 音訊";
var CUSTOM_MESSAGE$2 = "你有一個訊息";
var MISSED_VOICE_CALL$2 = "未接語音通話";
var MISSED_VIDEO_CALL$2 = "未接視訊通話";
var CUSTOM_MESSAGE_POLL$2 = "📊 投票";
var CUSTOM_MESSAGE_STICKER$2 = "💟 貼紙";
var CUSTOM_MESSAGE_DOCUMENT$2 = "📃 文件";
var CUSTOM_MESSAGE_WHITEBOARD$2 = "📝 白板";
var NO_CALLS_SELECTED$2 = "未选中任何通话";
var SELECT__USER$2 = "选择用户开始聊天";
var CANT__LOAD__CHATS$2 = "无法加载聊天记录";
var OUTGOING_CALL$2 = "呼出电话";
var INCOMING_CALL$2 = "来电";
var MISSED_CALL$2 = "未接来电";
var TRANSLATED_MESSAGE$2 = "翻译消息";
var ANSWER$2 = "回答";
var ADD_ANOTHER_ANSWER$2 = "添加另一个答案";
var SET_THE_ANSWERS$2 = "设置答案";
var CLICK_TO_START_CONVERSATION$2 = "点击开始对话";
var SHARED_LOCATION$2 = "共享位置";
var CALL_DETAILS$2 = "通话详情";
var POLLS$2 = "投票";
var ONLINE$2 = "線上";
var TRANSFER_OWNERSHIP$2 = "所有权转让";
var ADMINISTRATOR$2 = "管理員";
var MODERATOR$2 = "版主";
var PARTICIPANT$2 = "參與者";
var PUBLIC$2 = "公開";
var PRIVATE$2 = "私人";
var PASSWORD_PROTECTED$2 = "密碼保護";
var PRIVACY_AND_SECURITY$2 = "隱私權與安全性";
var PREFERENCES$2 = "偏好設定";
var MEMBERS$2 = "成員";
var TODAY$2 = "今天";
var YESTERDAY$2 = "昨天";
var TYPING$2 = "輸入...";
var IS_TYPING$2 = "正在輸入...";
var CLOSE$2 = "關閉";
var ENTER_GROUP_NAME$2 = "輸入群組名稱";
var ADD_MEMBERS$2 = "加入成員";
var SEND_MESSAGE$2 = "傳送訊息";
var UNBLOCK_USER$2 = "解除封鎖使用者";
var BLOCK_USER$2 = "封鎖使用者";
var DELETE_AND_EXIT$2 = "刪除並結束";
var LEAVE_GROUP$2 = "離開群組";
var CREATE_GROUP$2 = "建立群組";
var SHARED_MEDIA$2 = "共用媒體";
var VIDEO_CALL$2 = "視訊通話";
var AUDIO_CALL$2 = "音訊通話";
var LOADING$2 = "正在載入中...";
var REPLY$2 = "回覆";
var REPLIES$2 = "回覆";
var LAUNCH$2 = "啟動";
var SHARED_COLLABORATIVE_DOCUMENT$2 = "已共用協同合作文件";
var SHARED_COLLABORATIVE_WHITEBOARD$2 = "已共用一個協同合作白板";
var CREATED_WHITEBOARD$2 = "您已建立新的協同合作白板";
var CREATED_DOCUMENT$2 = "您已建立新的協同合作文件";
var PHOTOS$2 = "相片";
var VIDEOS$2 = "影片";
var DOCUMENT$2 = "文件";
var YOU_DELETED_THIS_MESSAGE$2 = "⚠️ 您刪除了此訊息";
var THIS_MESSAGE_DELETED$2 = "⚠️ 此訊息已被刪除";
var MESSAGE_IS_DELETED$2 = "消息已刪除";
var VIEW_ON_YOUTUBE$2 = "在 YouTube 上觀看";
var SEARCH$2 = "搜尋";
var NO_USERS_FOUND$2 = "找不到使用者";
var ERROR$2 = "錯誤";
var NO_GROUPS_FOUND$2 = "找不到群組";
var NO_CHATS_FOUND$2 = "找不到對話";
var MEDIA_MESSAGE$2 = "媒體訊息";
var INCOMING_AUDIO_CALL$2 = "音訊通話來電";
var INCOMING_VIDEO_CALL$2 = "視訊通話來電";
var DECLINE$2 = "拒絕";
var ACCEPT$2 = "接受";
var CALL_INITIATED$2 = "通話已啟動";
var OUTGOING_AUDIO_CALL$2 = "撥出音訊通話";
var OUTGOING_VIDEO_CALL$2 = "撥出視訊通話";
var CALL_REJECTED$2 = "電話拒絕";
var REJECTED_CALL$2 = "拒絕的呼叫";
var CALL_ACCEPTED$2 = "已接聽電話";
var JOINED$2 = "加入";
var LEFT_THE_CALL$2 = "已離開通話";
var UNANSWERED_AUDIO_CALL$2 = "未接聽的音訊通話";
var UNANSWERED_VIDEO_CALL$2 = "未接聽的視訊通話";
var CALL_ENDED$2 = "通話結束";
var CALL_CANCELLED$2 = "通話已取消";
var CALL_BUSY$2 = "對方正在忙碌";
var CALLING$2 = "正在撥打...";
var ADD$2 = "新增";
var NO_BANNED_MEMBERS_FOUND$2 = "沒有找到被封鎖的會員";
var BANNED_MEMBERS$2 = "被封鎖的會員";
var NAME$2 = "名稱";
var SCOPE$2 = "範圍";
var UNBAN$2 = "取消封鎖";
var SELECT_GROUP_TYPE$2 = "選取群組類型";
var ENTER_GROUP_PASSWORD$2 = "輸入群組密碼";
var CREATE$2 = "建立";
var CREATE_POLL$2 = "建立投票";
var QUESTION$2 = "問題";
var ENTER_YOUR_QUESTION$2 = "輸入您的問題";
var OPTIONS$2 = "選項";
var ENTER_YOUR_OPTION$2 = "輸入您的選項";
var ADD_NEW_OPTION$2 = "新增選項";
var VIEW_MEMBERS$2 = "檢視成員";
var DETAILS$2 = "詳細資料";
var NOTIFICATIONS$2 = "通知";
var OTHER$2 = "其他";
var HELP$2 = "幫助";
var REPORT_PROBLEM$2 = "報告問題";
var GROUP_MEMBERS$2 = "群組成員";
var BAN$2 = "封鎖";
var KICK$2 = "踢走";
var PICK_YOUR_EMOJI$2 = "挑選您的表情符號";
var PRIVATE_GROUP$2 = "私人群組";
var PROTECTED_GROUP$2 = "密碼保護群組";
var VISIT$2 = "訪問";
var ATTACH$2 = "發送";
var ATTACH_FILE$2 = "發送檔案";
var ATTACH_VIDEO$2 = "發送視訊";
var ATTACH_AUDIO$2 = "發送音訊";
var ATTACH_IMAGE$2 = "發送圖片";
var COLLABORATE_USING_DOCUMENT$2 = "使用協同合作文件";
var COLLABORATE_USING_WHITEBOARD$2 = "使用協同合作白板";
var EMOJI$2 = "表情符號";
var ENTER_YOUR_MESSAGE_HERE$2 = "在此輸入您的訊息";
var NO_MESSAGES_FOUND$2 = "找不到訊息";
var THREAD$2 = "訊息回覆框";
var COLLABORATIVE_DOCUMENT$2 = "協同合作文件";
var COLLABORATIVE_WHITEBOARD$2 = "協同合作白板";
var ADD_REACTION$2 = "加入表情";
var NO_STICKERS_FOUND$2 = "找不到貼紙";
var REPLY_TO_THREAD$2 = "回覆";
var REPLY_IN_THREAD$2 = "在回覆框中回覆";
var ADMIN$2 = "管理";
var DELETE_MESSAGE$2 = "刪除訊息";
var EDIT_MESSAGE$2 = "編輯訊息";
var SUNDAY$2 = "星期日";
var MONDAY$2 = "星期一";
var TUESDAY$2 = "星期二";
var WEDNESDAY$2 = "星期三";
var OPEN_DOCUMENT$2 = "打开文档";
var THURSDAY$2 = "星期四";
var FRIDAY$2 = "星期五";
var DRAW_DOCUMENT_TOGETHER$2 = "打开文档以共同编辑内容";
var SATURDAY$2 = "星期六";
var OWNER$2 = "擁有者";
var CHANGE_SCOPE$2 = "變更範圍";
var DRAW_WHITEBOARD_TOGETHER$2 = "打开白板以共同绘制";
var STICKER$2 = "貼紙";
var LAST_ACTIVE_AT$2 = "最後上線時間";
var VOICE_CALL$2 = "語音通話";
var VIEW_DETAIL$2 = "檢視詳細資料";
var VOTES$2 = "票";
var VOTE$2 = "投票";
var NO_VOTE$2 = "沒有投票";
var REACTED$2 = "反應";
var ADDED$2 = "添加";
var UNBANNED$2 = "取消封鎖";
var MADE$2 = "製作";
var CALL_UNANSWERED$2 = "未接聽來電";
var MISSED_AUDIO_CALL$2 = "未接聽的音訊通話";
var ENTER_YOUR_PASSWORD$2 = "輸入您的密碼";
var DOCS$2 = "文件";
var NO_RECORDS_FOUND$2 = "找不到記錄";
var LIVE_REACTION$2 = "即時反應";
var SMILEY_PEOPLE$2 = "笑臉與人物";
var ANIMALES_NATURE$2 = "動物與自然";
var FOOD_DRINK$2 = "食物與飲料";
var ACTIVITY$2 = "活動";
var TRAVEL_PLACES$2 = "旅遊與地點";
var OBJECTS$2 = "物件";
var SYMBOLS$2 = "符號";
var FLAGS$2 = "旗幟";
var SENT$2 = "已送出";
var SEEN$2 = "已讀";
var DELIVERED$2 = "已接收";
var TRANSLATE_MESSAGE$2 = "翻譯訊息";
var LEFT$2 = "已離開";
var KICKED$2 = "踢走";
var BANNED$2 = "封鎖";
var NEW_MESSAGES$2 = "新訊息";
var NEW_MESSAGE$2 = "新訊息";
var JUMP$2 = "跳";
var SELECT_VIDEO_SOURCE$2 = "選擇視訊來源";
var SELECT_INPUT_AUDIO_SOURCE$2 = "選擇輸入音訊來源";
var SELECT_OUTPUT_AUDIO_SOURCE$2 = "選擇輸出音訊來源";
var INITIATED_GROUP_CALL$2 = "已啟動群組通話";
var YOU_INITIATED_GROUP_CALL$2 = "您已啟動群組通話";
var IGNORE$2 = "忽略";
var ON_ANOTHER_CALL$2 = "正在另一個呼叫";
var CREATING$2 = "建立";
var AVATAR$2 = "阿凡達";
var GROUP_NAME_BLANK$2 = "群組名稱不能空白";
var GROUP_TYPE_BLANK$2 = "群組類型不能空白";
var GROUP_PASSWORD_BLANK$2 = "群組密碼不能空白";
var POLL_QUESTION_BLANK$2 = "問題不能空白";
var POLL_OPTION_BLANK$2 = "選項不能空白";
var ONGOING_CALL$2 = "進行中的呼叫";
var YOU_ALREADY_ONGOING_CALL$2 = "您已經在進行中通話";
var RESIZE$2 = "調整大小";
var SETTINGS$2 = "設定";
var ACTIONS$2 = "動作";
var VIEW_PROFILE$2 = "檢視縱斷面";
var SEND_MESSAGE_IN_PRIVATE$2 = "私下傳送訊息";
var DELETE$2 = "刪除";
var DELETE_CONFIRM$2 = "您確定要刪除嗎？";
var CANCEL$2 = "取消";
var LEAVE_CONFIRM$2 = "你確定要離開這個團體嗎";
var TRANSFER_CONFIRM$2 = "您是群組擁有者，請在離開群組前將所有權轉移給會員";
var ADDING$2 = "正在加入...";
var TRANSFER$2 = "轉移";
var TRANSFERRING$2 = "移轉";
var YES$2 = "是";
var NO$2 = "沒有";
var SOMETHING_WRONG$2 = "發生問題，請再試一次";
var INVALID_GROUP_NAME$2 = "請輸入群組的有效名稱，然後再試一次";
var INVALID_GROUP_TYPE$2 = "請輸入群組的有效類型，然後再試一次";
var INVALID_PASSWORD$2 = "請輸入群組的有效密碼，然後再試一次";
var WRONG_PASSWORD$2 = "請輸入正確的密碼，然後再試一次";
var INVALID_POLL_QUESTION$2 = "請在建立投票前輸入必要的問題";
var INVALID_POLL_OPTION$2 = "請在建立投票前輸入必要的答案";
var SAME_LANGUAGE_MESSAGE$2 = "選擇的翻譯語言與原始訊息的語言相似";
var LEAVE$2 = "離開";
var CALLS$2 = "來電";
var CUSTOM_MESSAGE_LOCATION$2 = "📍 位置";
var OFFLINE$2 = "離線";
var YOU$2 = "你";
var PRIVACY$2 = "隱私";
var BLOCKED_USERS$2 = "已封鎖的使用者";
var NO_PHOTOS$2 = "沒有相片";
var NO_VIDEOS$2 = "沒有視訊";
var NO_DOCUMENTS$2 = "沒有文件";
var JOIN$2 = "加入";
var NEW_CHAT$2 = "新聊天";
var FORM_COMPLETION_MESSAGE$2 = "感謝您填寫表格。";
var FORM$2 = "表格";
var CARD$2 = "卡";
var HISTORY$2 = "歷史";
var CANCELLED_AUDIO_CALL$2 = "已取消音訊通話";
var CANCELLED_VIDEO_CALL$2 = "已取消視訊通話";
var REJECTED_AUDIO_CALL$2 = "拒絕的音訊通話";
var REJECTED_VIDEO_CALL$2 = "拒絕的視訊通話";
var CANCELLED_CALL$2 = "已取消通話";
var UNANSWERED_CALL$2 = "未接聽的電話";
var RECORDING$2 = "錄音";
var PARTICIPANTS$2 = "參加者";
var CALL_HISTORY$2 = "通話記錄";
var NO_CALLS_FOUND$2 = "找不到電話";
var ONGOING_AUDIO_CALL$2 = "正在進行的音頻通話";
var ONGOING_VIDEO_CALL$2 = "正在進行的視頻通話";
var CALL_DETAIL$2 = "通話詳情";
var GENERATING_SUMMARY$2 = "產生摘要";
var CONVERSATION_SUMMARY$2 = "對話摘要";
var GENERATE_SUMMARY$2 = "產生摘要";
var COMETCHAT_BOT_FIRST_MESSAGE$2 = "我該如何幫助您進行這個對話？請問我一個問題，我會給你建議 🙂";
var COMETCHAT_ASK_BOT$2 = "詢問";
var COMETCHAT_ASK_AI_BOT$2 = "詢問 AI 機器人";
var COMETCHAT_ASK_BOT_SUBTITLE$2 = "人工智能機器人";
var translationZHTW = {
	USERS: USERS$2,
	CHATS: CHATS$2,
	GROUPS: GROUPS$2,
	NEW__GROUP: NEW__GROUP$2,
	PASSWORD: PASSWORD$2,
	CONTINUE: CONTINUE$2,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$2,
	SELECT__GROUP: SELECT__GROUP$2,
	DELETE_CONVERSATION: DELETE_CONVERSATION$2,
	NO_RECIPIENT: NO_RECIPIENT$2,
	NO_RECIPIENTS: NO_RECIPIENTS$2,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$2,
	ADD_TO_CHAT: ADD_TO_CHAT$2,
	MORE: MORE$2,
	READ: READ$2,
	AI: AI$2,
	SMART_REPLIES: SMART_REPLIES$2,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$2,
	CONVERSATION_STARTER: CONVERSATION_STARTER$2,
	MESSAGE: MESSAGE$2,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$2,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$2,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$2,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$2,
	VOICE_RECORDING: VOICE_RECORDING$2,
	MESSAGE_IMAGE: MESSAGE_IMAGE$2,
	MESSAGE_FILE: MESSAGE_FILE$2,
	MESSAGE_VIDEO: MESSAGE_VIDEO$2,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$2,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$2,
	GENERATING_REPLIES: GENERATING_REPLIES$2,
	NO_USERS_SELECTED: NO_USERS_SELECTED$2,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$2,
	MESSAGE_AUDIO: MESSAGE_AUDIO$2,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$2,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$2,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$2,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$2,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$2,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$2,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$2,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$2,
	SELECT__USER: SELECT__USER$2,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$2,
	OUTGOING_CALL: OUTGOING_CALL$2,
	INCOMING_CALL: INCOMING_CALL$2,
	MISSED_CALL: MISSED_CALL$2,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$2,
	ANSWER: ANSWER$2,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$2,
	SET_THE_ANSWERS: SET_THE_ANSWERS$2,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$2,
	SHARED_LOCATION: SHARED_LOCATION$2,
	CALL_DETAILS: CALL_DETAILS$2,
	POLLS: POLLS$2,
	ONLINE: ONLINE$2,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$2,
	ADMINISTRATOR: ADMINISTRATOR$2,
	MODERATOR: MODERATOR$2,
	PARTICIPANT: PARTICIPANT$2,
	PUBLIC: PUBLIC$2,
	PRIVATE: PRIVATE$2,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$2,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$2,
	PREFERENCES: PREFERENCES$2,
	MEMBERS: MEMBERS$2,
	TODAY: TODAY$2,
	YESTERDAY: YESTERDAY$2,
	TYPING: TYPING$2,
	IS_TYPING: IS_TYPING$2,
	CLOSE: CLOSE$2,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$2,
	ADD_MEMBERS: ADD_MEMBERS$2,
	SEND_MESSAGE: SEND_MESSAGE$2,
	UNBLOCK_USER: UNBLOCK_USER$2,
	BLOCK_USER: BLOCK_USER$2,
	DELETE_AND_EXIT: DELETE_AND_EXIT$2,
	LEAVE_GROUP: LEAVE_GROUP$2,
	CREATE_GROUP: CREATE_GROUP$2,
	SHARED_MEDIA: SHARED_MEDIA$2,
	VIDEO_CALL: VIDEO_CALL$2,
	AUDIO_CALL: AUDIO_CALL$2,
	LOADING: LOADING$2,
	REPLY: REPLY$2,
	REPLIES: REPLIES$2,
	LAUNCH: LAUNCH$2,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$2,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$2,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$2,
	CREATED_DOCUMENT: CREATED_DOCUMENT$2,
	PHOTOS: PHOTOS$2,
	VIDEOS: VIDEOS$2,
	DOCUMENT: DOCUMENT$2,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$2,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$2,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$2,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$2,
	SEARCH: SEARCH$2,
	NO_USERS_FOUND: NO_USERS_FOUND$2,
	ERROR: ERROR$2,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$2,
	NO_CHATS_FOUND: NO_CHATS_FOUND$2,
	MEDIA_MESSAGE: MEDIA_MESSAGE$2,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$2,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$2,
	DECLINE: DECLINE$2,
	ACCEPT: ACCEPT$2,
	CALL_INITIATED: CALL_INITIATED$2,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$2,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$2,
	CALL_REJECTED: CALL_REJECTED$2,
	REJECTED_CALL: REJECTED_CALL$2,
	CALL_ACCEPTED: CALL_ACCEPTED$2,
	JOINED: JOINED$2,
	LEFT_THE_CALL: LEFT_THE_CALL$2,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$2,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$2,
	CALL_ENDED: CALL_ENDED$2,
	CALL_CANCELLED: CALL_CANCELLED$2,
	CALL_BUSY: CALL_BUSY$2,
	CALLING: CALLING$2,
	ADD: ADD$2,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$2,
	BANNED_MEMBERS: BANNED_MEMBERS$2,
	NAME: NAME$2,
	SCOPE: SCOPE$2,
	UNBAN: UNBAN$2,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$2,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$2,
	CREATE: CREATE$2,
	CREATE_POLL: CREATE_POLL$2,
	QUESTION: QUESTION$2,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$2,
	OPTIONS: OPTIONS$2,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$2,
	ADD_NEW_OPTION: ADD_NEW_OPTION$2,
	VIEW_MEMBERS: VIEW_MEMBERS$2,
	DETAILS: DETAILS$2,
	NOTIFICATIONS: NOTIFICATIONS$2,
	OTHER: OTHER$2,
	HELP: HELP$2,
	REPORT_PROBLEM: REPORT_PROBLEM$2,
	GROUP_MEMBERS: GROUP_MEMBERS$2,
	BAN: BAN$2,
	KICK: KICK$2,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$2,
	PRIVATE_GROUP: PRIVATE_GROUP$2,
	PROTECTED_GROUP: PROTECTED_GROUP$2,
	VISIT: VISIT$2,
	ATTACH: ATTACH$2,
	ATTACH_FILE: ATTACH_FILE$2,
	ATTACH_VIDEO: ATTACH_VIDEO$2,
	ATTACH_AUDIO: ATTACH_AUDIO$2,
	ATTACH_IMAGE: ATTACH_IMAGE$2,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$2,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$2,
	EMOJI: EMOJI$2,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$2,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$2,
	THREAD: THREAD$2,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$2,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$2,
	ADD_REACTION: ADD_REACTION$2,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$2,
	REPLY_TO_THREAD: REPLY_TO_THREAD$2,
	REPLY_IN_THREAD: REPLY_IN_THREAD$2,
	ADMIN: ADMIN$2,
	DELETE_MESSAGE: DELETE_MESSAGE$2,
	EDIT_MESSAGE: EDIT_MESSAGE$2,
	SUNDAY: SUNDAY$2,
	MONDAY: MONDAY$2,
	TUESDAY: TUESDAY$2,
	WEDNESDAY: WEDNESDAY$2,
	OPEN_DOCUMENT: OPEN_DOCUMENT$2,
	THURSDAY: THURSDAY$2,
	FRIDAY: FRIDAY$2,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$2,
	SATURDAY: SATURDAY$2,
	OWNER: OWNER$2,
	CHANGE_SCOPE: CHANGE_SCOPE$2,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$2,
	STICKER: STICKER$2,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$2,
	VOICE_CALL: VOICE_CALL$2,
	VIEW_DETAIL: VIEW_DETAIL$2,
	VOTES: VOTES$2,
	VOTE: VOTE$2,
	NO_VOTE: NO_VOTE$2,
	REACTED: REACTED$2,
	ADDED: ADDED$2,
	UNBANNED: UNBANNED$2,
	MADE: MADE$2,
	CALL_UNANSWERED: CALL_UNANSWERED$2,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$2,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$2,
	DOCS: DOCS$2,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$2,
	LIVE_REACTION: LIVE_REACTION$2,
	SMILEY_PEOPLE: SMILEY_PEOPLE$2,
	ANIMALES_NATURE: ANIMALES_NATURE$2,
	FOOD_DRINK: FOOD_DRINK$2,
	ACTIVITY: ACTIVITY$2,
	TRAVEL_PLACES: TRAVEL_PLACES$2,
	OBJECTS: OBJECTS$2,
	SYMBOLS: SYMBOLS$2,
	FLAGS: FLAGS$2,
	SENT: SENT$2,
	SEEN: SEEN$2,
	DELIVERED: DELIVERED$2,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$2,
	LEFT: LEFT$2,
	KICKED: KICKED$2,
	BANNED: BANNED$2,
	NEW_MESSAGES: NEW_MESSAGES$2,
	NEW_MESSAGE: NEW_MESSAGE$2,
	JUMP: JUMP$2,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$2,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$2,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$2,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$2,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$2,
	IGNORE: IGNORE$2,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$2,
	CREATING: CREATING$2,
	AVATAR: AVATAR$2,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$2,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$2,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$2,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$2,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$2,
	ONGOING_CALL: ONGOING_CALL$2,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$2,
	RESIZE: RESIZE$2,
	SETTINGS: SETTINGS$2,
	ACTIONS: ACTIONS$2,
	VIEW_PROFILE: VIEW_PROFILE$2,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$2,
	DELETE: DELETE$2,
	DELETE_CONFIRM: DELETE_CONFIRM$2,
	CANCEL: CANCEL$2,
	LEAVE_CONFIRM: LEAVE_CONFIRM$2,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$2,
	ADDING: ADDING$2,
	TRANSFER: TRANSFER$2,
	TRANSFERRING: TRANSFERRING$2,
	YES: YES$2,
	NO: NO$2,
	SOMETHING_WRONG: SOMETHING_WRONG$2,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$2,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$2,
	INVALID_PASSWORD: INVALID_PASSWORD$2,
	WRONG_PASSWORD: WRONG_PASSWORD$2,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$2,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$2,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$2,
	LEAVE: LEAVE$2,
	CALLS: CALLS$2,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$2,
	OFFLINE: OFFLINE$2,
	YOU: YOU$2,
	PRIVACY: PRIVACY$2,
	BLOCKED_USERS: BLOCKED_USERS$2,
	"YOU'VE_BLOCKED": "你已經封鎖了",
	NO_PHOTOS: NO_PHOTOS$2,
	NO_VIDEOS: NO_VIDEOS$2,
	NO_DOCUMENTS: NO_DOCUMENTS$2,
	JOIN: JOIN$2,
	NEW_CHAT: NEW_CHAT$2,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$2,
	FORM: FORM$2,
	CARD: CARD$2,
	HISTORY: HISTORY$2,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$2,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$2,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$2,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$2,
	CANCELLED_CALL: CANCELLED_CALL$2,
	UNANSWERED_CALL: UNANSWERED_CALL$2,
	RECORDING: RECORDING$2,
	PARTICIPANTS: PARTICIPANTS$2,
	CALL_HISTORY: CALL_HISTORY$2,
	NO_CALLS_FOUND: NO_CALLS_FOUND$2,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$2,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$2,
	CALL_DETAIL: CALL_DETAIL$2,
	GENERATING_SUMMARY: GENERATING_SUMMARY$2,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$2,
	GENERATE_SUMMARY: GENERATE_SUMMARY$2,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$2,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$2,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$2,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$2
};

var USERS$1 = "Användare";
var CHATS$1 = "Chatt";
var GROUPS$1 = "Grupper";
var NEW__GROUP$1 = "Ny grupp";
var PASSWORD$1 = "Lösenord";
var CONTINUE$1 = "Fortsätta";
var NO_CHATS_SELECTED$1 = "Inga chattar har valts";
var SELECT__GROUP$1 = "Välj en grupp för att börja skicka meddelanden";
var DELETE_CONVERSATION$1 = "Radera konversation?";
var ADD_TO_CHAT$1 = "Lägg till i Chat";
var MORE$1 = "Mer";
var NO_RECIPIENT$1 = "Ingen mottagare";
var NO_RECIPIENTS$1 = "Inga mottagare";
var MESSAGE$1 = "Meddelande";
var RECEIPT_INFORMATION$1 = "Information om kvitto";
var AI$1 = "AI";
var SMART_REPLIES$1 = "Smarta svar";
var CONVERSATION_STARTER$1 = "Konversations startare";
var READ$1 = "Läs";
var MESSAGE_INFORMATION$1 = "Meddelande Information";
var SUGGEST_A_REPLY$1 = "Föreslå ett svar";
var GENERATING_ICEBREAKERS$1 = "Generera isbrytare";
var GENERATING_REPLIES$1 = "Generera svar";
var NO_REPLIES_FOUND$1 = "Inga svar hittades";
var NO_USERS_SELECTED$1 = "Inga användare valda";
var NO_GROUPS_SELECTED$1 = "Inga grupper valda";
var SHOW_UNSAFE_CONTENT$1 = "Är du säker på att du vill se osäkert innehåll?";
var REACT_TO_MESSAGE$1 = "Reagera på ett meddelande";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$1 = "Vill du ta bort den här konversationen? Den här konversationen kommer att raderas från alla dina enheter.";
var MESSAGE_IMAGE$1 = "📷 Bild";
var MESSAGE_FILE$1 = "📁 Fil";
var MESSAGE_VIDEO$1 = "📹 Video";
var VOICE_RECORDING$1 = "Röstinspelning";
var MESSAGE_AUDIO$1 = "🎵 Ljud";
var CUSTOM_MESSAGE$1 = "Du har ett meddelande";
var MISSED_VOICE_CALL$1 = "Missat telefonsamtal";
var MISSED_VIDEO_CALL$1 = "Misset videosamtal";
var CUSTOM_MESSAGE_POLL$1 = "📊 Poll";
var CUSTOM_MESSAGE_STICKER$1 = "💟 Sticker";
var CUSTOM_MESSAGE_DOCUMENT$1 = "📃 Dokument";
var NO_CALLS_SELECTED$1 = "Inga samtal valda";
var SELECT__USER$1 = "Välj en användare för att börja chatta";
var CANT__LOAD__CHATS$1 = "Kan inte ladda chattar";
var OUTGOING_CALL$1 = "Utgående samtal";
var INCOMING_CALL$1 = "Inkommande samtal";
var MISSED_CALL$1 = "Missat samtal";
var TRANSLATED_MESSAGE$1 = "Översatt meddelande";
var ANSWER$1 = "Svara";
var ADD_ANOTHER_ANSWER$1 = "Lägg till ett annat svar";
var SET_THE_ANSWERS$1 = "Ställ in svaren";
var CLICK_TO_START_CONVERSATION$1 = "Klicka för att starta konversationen";
var SHARED_LOCATION$1 = "Delad plats";
var CALL_DETAILS$1 = "Samtalsinformation";
var POLLS$1 = "Omröstningar";
var CUSTOM_MESSAGE_WHITEBOARD$1 = "📝 Whiteboard";
var TRANSFER_OWNERSHIP$1 = "Överlåta ägande";
var ONLINE$1 = "Online";
var ADMIN$1 = "Admin";
var ADMINISTRATOR$1 = "Administrator";
var VIEW$1 = "se";
var MODERATOR$1 = "Moderator";
var PARTICIPANT$1 = "Deltagare";
var DRAW_WHITEBOARD_TOGETHER$1 = "Öppna whiteboard för att rita tillsammans";
var PUBLIC$1 = "Publikt";
var PRIVATE$1 = "Privat";
var PASSWORD_PROTECTED$1 = "Lösenordsskyddat";
var PRIVACY_AND_SECURITY$1 = "Sekretess och säkerhet";
var OPEN_DOCUMENT$1 = "Öppna dokument";
var DRAW_DOCUMENT_TOGETHER$1 = "Öppna dokumentet för att redigera innehållet tillsammans";
var PREFERENCES$1 = "Inställningar";
var MEMBERS$1 = "Medlemmar";
var TODAY$1 = "Idag";
var YESTERDAY$1 = "Igår";
var SUNDAY$1 = "Söndag";
var MONDAY$1 = "Måndag";
var TUESDAY$1 = "Tisdag";
var OPEN_WHITEBOARD$1 = "Öppna whiteboard";
var WEDNESDAY$1 = "Onsdag";
var THURSDAY$1 = "Torsdag";
var FRIDAY$1 = "Fredag";
var SATURDAY$1 = "Lördag";
var TYPING$1 = "skriver...";
var IS_TYPING$1 = "skriver...";
var CLOSE$1 = "Stäng";
var ENTER_GROUP_NAME$1 = "Ange gruppnamn";
var ADD_MEMBERS$1 = "Lägg till medlemmar";
var SEND_MESSAGE$1 = "Skicka meddelande";
var UNBLOCK_USER$1 = "Ta bort blockering från användare";
var BLOCK_USER$1 = "Blockera användare";
var DELETE_AND_EXIT$1 = "Ta bort och stäng";
var LEAVE_GROUP$1 = "Lämna grupp";
var CREATE_GROUP$1 = "Skapa grupp";
var SHARED_MEDIA$1 = "Delade filer";
var VIDEO_CALL$1 = "Videosamtal";
var AUDIO_CALL$1 = "Telefonsamtal";
var LOADING$1 = "Laddar...";
var REPLY$1 = "svara";
var REPLIES$1 = "svar";
var LAUNCH$1 = "Öppna";
var SHARED_COLLABORATIVE_DOCUMENT$1 = "has shared a collaborative document";
var SHARED_COLLABORATIVE_WHITEBOARD$1 = "has shared a collaborative whiteboard";
var CREATED_WHITEBOARD$1 = "You’ve created a new collaborative whiteboard";
var CREATED_DOCUMENT$1 = "You’ve created a new collaborative document";
var PHOTOS$1 = "Bilder";
var VIDEOS$1 = "Videos";
var DOCUMENT$1 = "Dokument";
var YOU_DELETED_THIS_MESSAGE$1 = "⚠️ Du tog bort det här meddelandet";
var THIS_MESSAGE_DELETED$1 = "⚠️ Det här meddelandet är borttaget";
var MESSAGE_IS_DELETED$1 = "Meddelandet är raderat";
var VIEW_ON_YOUTUBE$1 = "Visa på Youtube";
var SEARCH$1 = "Sök";
var NO_USERS_FOUND$1 = "Inga användare hittades";
var ERROR$1 = "Fel";
var NO_GROUPS_FOUND$1 = "Inga grupper hittades";
var NO_CHATS_FOUND$1 = "Inga chatter hittades";
var MEDIA_MESSAGE$1 = "Filmeddelande";
var INCOMING_AUDIO_CALL$1 = "Inkommande telefonsamtal";
var INCOMING_VIDEO_CALL$1 = "Inkommande videosamtal";
var DECLINE$1 = "Avböj";
var ACCEPT$1 = "Acceptera";
var CALL_INITIATED$1 = "Samtal har påbörjat";
var OUTGOING_AUDIO_CALL$1 = "Utgående telefonsamtal";
var OUTGOING_VIDEO_CALL$1 = "Utgående videosamtal";
var CALL_REJECTED$1 = "Samtalet avböjdes";
var REJECTED_CALL$1 = "rejected call";
var CALL_ACCEPTED$1 = "Call accepted";
var JOINED$1 = "har gått med";
var LEFT_THE_CALL$1 = "lämnade chatten";
var UNANSWERED_AUDIO_CALL$1 = "Obesvarat telefonsamtal";
var UNANSWERED_VIDEO_CALL$1 = "Obesvarat videosamtal";
var CALL_ENDED$1 = "Samtal avslutat";
var CALL_CANCELLED$1 = "Samtal avslutat";
var CALL_BUSY$1 = "Upptagen i samtal";
var CALLING$1 = "Ringer...";
var ADD$1 = "Lägg till";
var NO_BANNED_MEMBERS_FOUND$1 = "Inga avstängda användare hittades";
var BANNED_MEMBERS$1 = "Avstängda användare";
var NAME$1 = "Namn";
var SCOPE$1 = "Rättigheter";
var UNBAN$1 = "Ta bort avstängningen";
var SELECT_GROUP_TYPE$1 = "Välj grupptyp";
var ENTER_GROUP_PASSWORD$1 = "Ange grupplösenord";
var CREATE$1 = "Skapa";
var CREATE_POLL$1 = "Skapa Poll";
var QUESTION$1 = "Fråga";
var ENTER_YOUR_QUESTION$1 = "Ange din fråga";
var OPTIONS$1 = "Alternativ";
var ENTER_YOUR_OPTION$1 = "Ange dina alternativ";
var ADD_NEW_OPTION$1 = "Lägg till nytt alternativ";
var VIEW_MEMBERS$1 = "Visa medlemmar";
var DETAILS$1 = "Detaljer";
var NOTIFICATIONS$1 = "Notifikationer";
var OTHER$1 = "Övrigt";
var HELP$1 = "Hjälp";
var REPORT_PROBLEM$1 = "Rapportera en bugg";
var GROUP_MEMBERS$1 = "Gruppmedlemmar";
var BAN$1 = "Stäng av";
var KICK$1 = "Kicka";
var PICK_YOUR_EMOJI$1 = "Välj din emoji";
var PRIVATE_GROUP$1 = "Privatgrupp";
var PROTECTED_GROUP$1 = "Skyddad grupp";
var VISIT$1 = "Besök";
var ATTACH$1 = "Bifoga";
var ATTACH_FILE$1 = "Bifoga fil";
var ATTACH_VIDEO$1 = "Bifoga video";
var ATTACH_AUDIO$1 = "Bifoga ljud";
var ATTACH_IMAGE$1 = "Bifoga bild";
var COLLABORATE_USING_DOCUMENT$1 = "Samarbeta på ett dokument";
var COLLABORATE_USING_WHITEBOARD$1 = "Samarbeta i en whiteboard";
var EMOJI$1 = "Emoji";
var ENTER_YOUR_MESSAGE_HERE$1 = "Skriv ditt meddelande här";
var NO_MESSAGES_FOUND$1 = "Inga meddelanden hittades";
var THREAD$1 = "Tråd";
var COLLABORATIVE_DOCUMENT$1 = "Samarbeta på ett dokument";
var COLLABORATIVE_WHITEBOARD$1 = "Samarbeta i en whiteboard";
var ADD_REACTION$1 = "Visa en reaktion";
var NO_STICKERS_FOUND$1 = "Inga stickers hittades";
var REPLY_TO_THREAD$1 = "Svara på tråden";
var REPLY_IN_THREAD$1 = "Svara i tråden";
var DELETE_MESSAGE$1 = "Ta bort meddelande";
var EDIT_MESSAGE$1 = "Ändra meddelande";
var OWNER$1 = "Ägare";
var CHANGE_SCOPE$1 = "Ändra rättigheter";
var STICKER$1 = "Sticker";
var LAST_ACTIVE_AT$1 = "Senast aktiv";
var VOICE_CALL$1 = "Telefonsamtal";
var VIEW_DETAIL$1 = "Visa detaljer";
var VOTES$1 = "Röster";
var VOTE$1 = "Röst";
var NO_VOTE$1 = "Inga röster";
var REACTED$1 = "Reagerade";
var ADDED$1 = "Tillagd";
var UNBANNED$1 = "Avstängning borttagen";
var MADE$1 = "skapad";
var CALL_UNANSWERED$1 = "Telefonsamtal obesvarat";
var MISSED_AUDIO_CALL$1 = "Missat ljudsamtal";
var ENTER_YOUR_PASSWORD$1 = "Skriv i ditt lösenord";
var DOCS$1 = "Dokumentation";
var NO_RECORDS_FOUND$1 = "Inget hittades";
var LIVE_REACTION$1 = "Riktig reaktioner";
var SMILEY_PEOPLE$1 = "Smileys & Människor";
var ANIMALES_NATURE$1 = "Djur & Natur";
var FOOD_DRINK$1 = "Mat & Dryck";
var ACTIVITY$1 = "Aktivitet";
var TRAVEL_PLACES$1 = "Resa & Ställen";
var OBJECTS$1 = "Objekt";
var SYMBOLS$1 = "Symboler";
var FLAGS$1 = "Flaggor";
var SENT$1 = "Skickat";
var SEEN$1 = "Läst";
var DELIVERED$1 = "Levererat";
var TRANSLATE_MESSAGE$1 = "Översätt meddelande";
var LEFT$1 = "Vänster";
var KICKED$1 = "Kickad";
var BANNED$1 = "Avstängd";
var NEW_MESSAGES$1 = "nya meddelanden";
var NEW_MESSAGE$1 = "nytt meddelande";
var JUMP$1 = "Hoppa";
var SELECT_VIDEO_SOURCE$1 = "Välj videokälla";
var SELECT_INPUT_AUDIO_SOURCE$1 = "Välj ingående ljudkälla";
var SELECT_OUTPUT_AUDIO_SOURCE$1 = "Välj utgående ljudkälla";
var INITIATED_GROUP_CALL$1 = "har startat ett gruppsamtal";
var YOU_INITIATED_GROUP_CALL$1 = "Du har startat ett gruppsamtal";
var IGNORE$1 = "Ignorera";
var ON_ANOTHER_CALL$1 = "är i ett annat samtal";
var CREATING$1 = "Skapar";
var AVATAR$1 = "Avatar";
var GROUP_NAME_BLANK$1 = "Gruppnamn är obligatoriskt";
var GROUP_TYPE_BLANK$1 = "Grupptyp är obligatoriskt";
var GROUP_PASSWORD_BLANK$1 = "Grupplösenord är obligatoriskt";
var POLL_QUESTION_BLANK$1 = "Fråga är obligatoriskt";
var POLL_OPTION_BLANK$1 = "Alternativ är obligatoriskt";
var ONGOING_CALL$1 = "Pågående samtal";
var YOU_ALREADY_ONGOING_CALL$1 = "Du är redan i ett pågående samtal";
var RESIZE$1 = "Ändra storlek";
var SETTINGS$1 = "Inställningar";
var ACTIONS$1 = "Åtgärder";
var VIEW_PROFILE$1 = "Visa profil";
var SEND_MESSAGE_IN_PRIVATE$1 = "Skicka meddelande privat";
var DELETE$1 = "Ta bort";
var DELETE_CONFIRM$1 = "Är du säker på att du vill radera?";
var CANCEL$1 = "Avbryta";
var LEAVE_CONFIRM$1 = "Är du säker på att du vill lämna gruppen?";
var TRANSFER_CONFIRM$1 = "Du är gruppägare. Överför äganderätten till en medlem innan du lämnar gruppen";
var ADDING$1 = "Lägger till...";
var TRANSFER$1 = "Överföring";
var TRANSFERRING$1 = "Överföra";
var YES$1 = "Javisst";
var NO$1 = "Nej";
var SOMETHING_WRONG$1 = "Något gick fel, snälla försök igen";
var INVALID_GROUP_NAME$1 = "Ange ett giltigt namn för gruppen och försök igen";
var INVALID_GROUP_TYPE$1 = "Ange en giltig typ för gruppen och försök igen";
var INVALID_PASSWORD$1 = "Ange ett giltigt lösenord för gruppen och försök igen";
var WRONG_PASSWORD$1 = "Ange rätt lösenord och försök igen";
var INVALID_POLL_QUESTION$1 = "Ange önskad fråga innan du skapar en enkät";
var INVALID_POLL_OPTION$1 = "Ange det svar som krävs innan du skapar en enkät";
var SAME_LANGUAGE_MESSAGE$1 = "Valt språk för översättning liknar språket i det ursprungliga meddelandet";
var LEAVE$1 = "Lämna";
var CALLS$1 = "Samtal";
var CUSTOM_MESSAGE_LOCATION$1 = "📍Plats";
var OFFLINE$1 = "Offline";
var YOU$1 = "Du";
var PRIVACY$1 = "Säkerhet";
var BLOCKED_USERS$1 = "Blockerade användare";
var NO_PHOTOS$1 = "Inga bilder";
var NO_VIDEOS$1 = "Inga videos";
var NO_DOCUMENTS$1 = "Inga dokument";
var JOIN$1 = "Anslut";
var NEW_CHAT$1 = "Ny chatt";
var FORM_COMPLETION_MESSAGE$1 = "Tack för att du fyller i formuläret.";
var FORM$1 = "Formulär";
var CARD$1 = "Kort";
var HISTORY$1 = "Historia";
var CANCELLED_AUDIO_CALL$1 = "Avbrutet ljudsamtal";
var CANCELLED_VIDEO_CALL$1 = "Avbrutet videosamtal";
var REJECTED_AUDIO_CALL$1 = "Avvisat ljudsamtal";
var REJECTED_VIDEO_CALL$1 = "Avvisat videosamtal";
var CANCELLED_CALL$1 = "Avbrutet samtal";
var UNANSWERED_CALL$1 = "Obesvarat samtal";
var RECORDING$1 = "Inspelning";
var PARTICIPANTS$1 = "Deltagare";
var CALL_HISTORY$1 = "Samtalshistorik";
var NO_CALLS_FOUND$1 = "Inga samtal hittades";
var ONGOING_AUDIO_CALL$1 = "Pågående ljudsamtal";
var ONGOING_VIDEO_CALL$1 = "Pågående videosamtal";
var CALL_DETAIL$1 = "Samtalsdetaljer";
var GENERATING_SUMMARY$1 = "Generera sammanfattning";
var CONVERSATION_SUMMARY$1 = "Konversationssammanfattning";
var GENERATE_SUMMARY$1 = "Skapa en sammanfattning";
var COMETCHAT_BOT_FIRST_MESSAGE$1 = "Hur kan jag hjälpa dig med det här samtalet? Ställ en fråga så ska jag ge dig råd 🙂";
var COMETCHAT_ASK_BOT$1 = "Fråga";
var COMETCHAT_ASK_AI_BOT$1 = "Fråga AI-bots";
var COMETCHAT_ASK_BOT_SUBTITLE$1 = "AI Bot";
var translationSV = {
	USERS: USERS$1,
	CHATS: CHATS$1,
	GROUPS: GROUPS$1,
	NEW__GROUP: NEW__GROUP$1,
	PASSWORD: PASSWORD$1,
	CONTINUE: CONTINUE$1,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED$1,
	SELECT__GROUP: SELECT__GROUP$1,
	DELETE_CONVERSATION: DELETE_CONVERSATION$1,
	ADD_TO_CHAT: ADD_TO_CHAT$1,
	MORE: MORE$1,
	NO_RECIPIENT: NO_RECIPIENT$1,
	NO_RECIPIENTS: NO_RECIPIENTS$1,
	MESSAGE: MESSAGE$1,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION$1,
	AI: AI$1,
	SMART_REPLIES: SMART_REPLIES$1,
	CONVERSATION_STARTER: CONVERSATION_STARTER$1,
	READ: READ$1,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION$1,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY$1,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS$1,
	GENERATING_REPLIES: GENERATING_REPLIES$1,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND$1,
	NO_USERS_SELECTED: NO_USERS_SELECTED$1,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED$1,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT$1,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE$1,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION$1,
	MESSAGE_IMAGE: MESSAGE_IMAGE$1,
	MESSAGE_FILE: MESSAGE_FILE$1,
	MESSAGE_VIDEO: MESSAGE_VIDEO$1,
	VOICE_RECORDING: VOICE_RECORDING$1,
	MESSAGE_AUDIO: MESSAGE_AUDIO$1,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE$1,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL$1,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL$1,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL$1,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER$1,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT$1,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED$1,
	SELECT__USER: SELECT__USER$1,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS$1,
	OUTGOING_CALL: OUTGOING_CALL$1,
	INCOMING_CALL: INCOMING_CALL$1,
	MISSED_CALL: MISSED_CALL$1,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE$1,
	ANSWER: ANSWER$1,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER$1,
	SET_THE_ANSWERS: SET_THE_ANSWERS$1,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION$1,
	SHARED_LOCATION: SHARED_LOCATION$1,
	CALL_DETAILS: CALL_DETAILS$1,
	POLLS: POLLS$1,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD$1,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP$1,
	ONLINE: ONLINE$1,
	ADMIN: ADMIN$1,
	ADMINISTRATOR: ADMINISTRATOR$1,
	VIEW: VIEW$1,
	MODERATOR: MODERATOR$1,
	PARTICIPANT: PARTICIPANT$1,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER$1,
	PUBLIC: PUBLIC$1,
	PRIVATE: PRIVATE$1,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED$1,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY$1,
	OPEN_DOCUMENT: OPEN_DOCUMENT$1,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER$1,
	PREFERENCES: PREFERENCES$1,
	MEMBERS: MEMBERS$1,
	TODAY: TODAY$1,
	YESTERDAY: YESTERDAY$1,
	SUNDAY: SUNDAY$1,
	MONDAY: MONDAY$1,
	TUESDAY: TUESDAY$1,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD$1,
	WEDNESDAY: WEDNESDAY$1,
	THURSDAY: THURSDAY$1,
	FRIDAY: FRIDAY$1,
	SATURDAY: SATURDAY$1,
	TYPING: TYPING$1,
	IS_TYPING: IS_TYPING$1,
	CLOSE: CLOSE$1,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME$1,
	ADD_MEMBERS: ADD_MEMBERS$1,
	SEND_MESSAGE: SEND_MESSAGE$1,
	UNBLOCK_USER: UNBLOCK_USER$1,
	BLOCK_USER: BLOCK_USER$1,
	DELETE_AND_EXIT: DELETE_AND_EXIT$1,
	LEAVE_GROUP: LEAVE_GROUP$1,
	CREATE_GROUP: CREATE_GROUP$1,
	SHARED_MEDIA: SHARED_MEDIA$1,
	VIDEO_CALL: VIDEO_CALL$1,
	AUDIO_CALL: AUDIO_CALL$1,
	LOADING: LOADING$1,
	REPLY: REPLY$1,
	REPLIES: REPLIES$1,
	LAUNCH: LAUNCH$1,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT$1,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD$1,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD$1,
	CREATED_DOCUMENT: CREATED_DOCUMENT$1,
	PHOTOS: PHOTOS$1,
	VIDEOS: VIDEOS$1,
	DOCUMENT: DOCUMENT$1,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE$1,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED$1,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED$1,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE$1,
	SEARCH: SEARCH$1,
	NO_USERS_FOUND: NO_USERS_FOUND$1,
	ERROR: ERROR$1,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND$1,
	NO_CHATS_FOUND: NO_CHATS_FOUND$1,
	MEDIA_MESSAGE: MEDIA_MESSAGE$1,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL$1,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL$1,
	DECLINE: DECLINE$1,
	ACCEPT: ACCEPT$1,
	CALL_INITIATED: CALL_INITIATED$1,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL$1,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL$1,
	CALL_REJECTED: CALL_REJECTED$1,
	REJECTED_CALL: REJECTED_CALL$1,
	CALL_ACCEPTED: CALL_ACCEPTED$1,
	JOINED: JOINED$1,
	LEFT_THE_CALL: LEFT_THE_CALL$1,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL$1,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL$1,
	CALL_ENDED: CALL_ENDED$1,
	CALL_CANCELLED: CALL_CANCELLED$1,
	CALL_BUSY: CALL_BUSY$1,
	CALLING: CALLING$1,
	ADD: ADD$1,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND$1,
	BANNED_MEMBERS: BANNED_MEMBERS$1,
	NAME: NAME$1,
	SCOPE: SCOPE$1,
	UNBAN: UNBAN$1,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE$1,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD$1,
	CREATE: CREATE$1,
	CREATE_POLL: CREATE_POLL$1,
	QUESTION: QUESTION$1,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION$1,
	OPTIONS: OPTIONS$1,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION$1,
	ADD_NEW_OPTION: ADD_NEW_OPTION$1,
	VIEW_MEMBERS: VIEW_MEMBERS$1,
	DETAILS: DETAILS$1,
	NOTIFICATIONS: NOTIFICATIONS$1,
	OTHER: OTHER$1,
	HELP: HELP$1,
	REPORT_PROBLEM: REPORT_PROBLEM$1,
	GROUP_MEMBERS: GROUP_MEMBERS$1,
	BAN: BAN$1,
	KICK: KICK$1,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI$1,
	PRIVATE_GROUP: PRIVATE_GROUP$1,
	PROTECTED_GROUP: PROTECTED_GROUP$1,
	VISIT: VISIT$1,
	ATTACH: ATTACH$1,
	ATTACH_FILE: ATTACH_FILE$1,
	ATTACH_VIDEO: ATTACH_VIDEO$1,
	ATTACH_AUDIO: ATTACH_AUDIO$1,
	ATTACH_IMAGE: ATTACH_IMAGE$1,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT$1,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD$1,
	EMOJI: EMOJI$1,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE$1,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND$1,
	THREAD: THREAD$1,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT$1,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD$1,
	ADD_REACTION: ADD_REACTION$1,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND$1,
	REPLY_TO_THREAD: REPLY_TO_THREAD$1,
	REPLY_IN_THREAD: REPLY_IN_THREAD$1,
	DELETE_MESSAGE: DELETE_MESSAGE$1,
	EDIT_MESSAGE: EDIT_MESSAGE$1,
	OWNER: OWNER$1,
	CHANGE_SCOPE: CHANGE_SCOPE$1,
	STICKER: STICKER$1,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT$1,
	VOICE_CALL: VOICE_CALL$1,
	VIEW_DETAIL: VIEW_DETAIL$1,
	VOTES: VOTES$1,
	VOTE: VOTE$1,
	NO_VOTE: NO_VOTE$1,
	REACTED: REACTED$1,
	ADDED: ADDED$1,
	UNBANNED: UNBANNED$1,
	MADE: MADE$1,
	CALL_UNANSWERED: CALL_UNANSWERED$1,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL$1,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD$1,
	DOCS: DOCS$1,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND$1,
	LIVE_REACTION: LIVE_REACTION$1,
	SMILEY_PEOPLE: SMILEY_PEOPLE$1,
	ANIMALES_NATURE: ANIMALES_NATURE$1,
	FOOD_DRINK: FOOD_DRINK$1,
	ACTIVITY: ACTIVITY$1,
	TRAVEL_PLACES: TRAVEL_PLACES$1,
	OBJECTS: OBJECTS$1,
	SYMBOLS: SYMBOLS$1,
	FLAGS: FLAGS$1,
	SENT: SENT$1,
	SEEN: SEEN$1,
	DELIVERED: DELIVERED$1,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE$1,
	LEFT: LEFT$1,
	KICKED: KICKED$1,
	BANNED: BANNED$1,
	NEW_MESSAGES: NEW_MESSAGES$1,
	NEW_MESSAGE: NEW_MESSAGE$1,
	JUMP: JUMP$1,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE$1,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE$1,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE$1,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL$1,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL$1,
	IGNORE: IGNORE$1,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL$1,
	CREATING: CREATING$1,
	AVATAR: AVATAR$1,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK$1,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK$1,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK$1,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK$1,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK$1,
	ONGOING_CALL: ONGOING_CALL$1,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL$1,
	RESIZE: RESIZE$1,
	SETTINGS: SETTINGS$1,
	ACTIONS: ACTIONS$1,
	VIEW_PROFILE: VIEW_PROFILE$1,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE$1,
	DELETE: DELETE$1,
	DELETE_CONFIRM: DELETE_CONFIRM$1,
	CANCEL: CANCEL$1,
	LEAVE_CONFIRM: LEAVE_CONFIRM$1,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM$1,
	ADDING: ADDING$1,
	TRANSFER: TRANSFER$1,
	TRANSFERRING: TRANSFERRING$1,
	YES: YES$1,
	NO: NO$1,
	SOMETHING_WRONG: SOMETHING_WRONG$1,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME$1,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE$1,
	INVALID_PASSWORD: INVALID_PASSWORD$1,
	WRONG_PASSWORD: WRONG_PASSWORD$1,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION$1,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION$1,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE$1,
	LEAVE: LEAVE$1,
	CALLS: CALLS$1,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION$1,
	OFFLINE: OFFLINE$1,
	YOU: YOU$1,
	PRIVACY: PRIVACY$1,
	BLOCKED_USERS: BLOCKED_USERS$1,
	"YOU'VE_BLOCKED": "Du har blockerats",
	NO_PHOTOS: NO_PHOTOS$1,
	NO_VIDEOS: NO_VIDEOS$1,
	NO_DOCUMENTS: NO_DOCUMENTS$1,
	JOIN: JOIN$1,
	NEW_CHAT: NEW_CHAT$1,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE$1,
	FORM: FORM$1,
	CARD: CARD$1,
	HISTORY: HISTORY$1,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL$1,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL$1,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL$1,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL$1,
	CANCELLED_CALL: CANCELLED_CALL$1,
	UNANSWERED_CALL: UNANSWERED_CALL$1,
	RECORDING: RECORDING$1,
	PARTICIPANTS: PARTICIPANTS$1,
	CALL_HISTORY: CALL_HISTORY$1,
	NO_CALLS_FOUND: NO_CALLS_FOUND$1,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL$1,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL$1,
	CALL_DETAIL: CALL_DETAIL$1,
	GENERATING_SUMMARY: GENERATING_SUMMARY$1,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY$1,
	GENERATE_SUMMARY: GENERATE_SUMMARY$1,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE$1,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT$1,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT$1,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE$1
};

var USERS = "Vartotojai";
var CHATS = "Susirašinėjimai";
var GROUPS = "Grupės";
var MORE = "Daugiau";
var MESSAGE_IMAGE = "📷 Nuotrauka";
var MESSAGE_FILE = "📁 Failas";
var MESSAGE_VIDEO = "📹 Vaizdo įrašas";
var NEW__GROUP = "Nuovo gruppo";
var PASSWORD = "Parola d'ordine";
var SHOW_UNSAFE_CONTENT = "Sei sicuro/a di voler visualizzare contenuti non sicuri?";
var REACT_TO_MESSAGE = "Reagisci a un messaggio";
var CONTINUE = "Continua";
var VOICE_RECORDING = "Registrazione vocale";
var READ = "Leggi";
var AI = "AI";
var SMART_REPLIES = "Risposte intelligenti";
var CONVERSATION_STARTER = "Avvio di conversazione";
var MESSAGE = "Messaggio";
var RECEIPT_INFORMATION = "Informazioni sulla ricevuta";
var MESSAGE_INFORMATION = "Informazioni sui messaggi";
var NO_CHATS_SELECTED = "Nessuna chat selezionata";
var SELECT__GROUP = "Seleziona un gruppo per iniziare a inviare messaggi";
var DELETE_CONVERSATION = "Cancella la conversazione?";
var WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION = "Vuoi eliminare questa conversazione? Questa conversazione verrà eliminata da tutti i tuoi dispositivi.";
var ADD_TO_CHAT = "Aggiungi alla chat";
var MESSAGE_AUDIO = "🎵 Garso įrašas";
var SUGGEST_A_REPLY = "Suggerisci una risposta";
var GENERATING_ICEBREAKERS = "Generazione di rompighiaccio";
var GENERATING_REPLIES = "Generazione di risposte";
var NO_REPLIES_FOUND = "Nessuna risposta trovata";
var NO_USERS_SELECTED = "Nessun utente selezionato";
var NO_GROUPS_SELECTED = "Nessun gruppo selezionato";
var CUSTOM_MESSAGE = "Gavote žinutę";
var NO_RECIPIENT = "Nessun destinatario";
var NO_RECIPIENTS = "Nessun destinatario";
var MISSED_VOICE_CALL = "Praleistas skambutis";
var MISSED_VIDEO_CALL = "Praleistas vaizdo skambutis";
var CUSTOM_MESSAGE_POLL = "📊 Balsavimas";
var CUSTOM_MESSAGE_STICKER = "💟 Lipdukas";
var TRANSFER_OWNERSHIP = "Trasferimento di proprietà";
var CUSTOM_MESSAGE_DOCUMENT = "📃 Dokumentas";
var NO_CALLS_SELECTED = "Nessuna chiamata selezionata";
var SELECT__USER = "Seleziona un utente per iniziare a chattare";
var CANT__LOAD__CHATS = "Impossibile caricare le chat";
var OUTGOING_CALL = "Chiamata in uscita";
var INCOMING_CALL = "Chiamata in arrivo";
var DRAW_DOCUMENT_TOGETHER = "Apri il documento per modificare il contenuto insieme";
var MISSED_CALL = "Chiamata persa";
var OPEN_DOCUMENT = "Apri il documento";
var TRANSLATED_MESSAGE = "Messaggio tradotto";
var ANSWER = "Rispondi";
var ADMIN = "Admin";
var DRAW_WHITEBOARD_TOGETHER = "Apri lavagna bianca per disegnare insieme";
var ADD_ANOTHER_ANSWER = "Aggiungi un'altra risposta";
var SET_THE_ANSWERS = "Imposta le risposte";
var CLICK_TO_START_CONVERSATION = "Clicca per iniziare la conversazione";
var SHARED_LOCATION = "Posizione condivisa";
var CALL_DETAILS = "Dettagli chiamata";
var POLLS = "Sondaggi";
var OPEN_WHITEBOARD = "Apri lavagna bianca";
var CUSTOM_MESSAGE_WHITEBOARD = "📝 Balta lenta";
var ONLINE = "Prisijungę";
var VIEW = "visualizzazione";
var ADMINISTRATOR = "Administratorius";
var MODERATOR = "Moderatorius";
var PARTICIPANT = "Dalyvis";
var PUBLIC = "Vieša";
var PRIVATE = "Privati";
var PASSWORD_PROTECTED = "Apsaugota slaptažodžiu";
var PRIVACY_AND_SECURITY = "Privatumas ir saugumas";
var PREFERENCES = "Pasirinkimai";
var MEMBERS = "Nariai";
var TODAY = "Šiandien";
var YESTERDAY = "Vakar";
var SUNDAY = "Sekmadienį";
var MONDAY = "Pirmadienį";
var TUESDAY = "Antradienį";
var WEDNESDAY = "Trečiadienį";
var THURSDAY = "Ketvirtadienį";
var FRIDAY = "Penktadienį";
var SATURDAY = "Šeštadienį";
var TYPING = "rašo...";
var IS_TYPING = "dabar rašo...";
var CLOSE = "Uždaryti";
var ENTER_GROUP_NAME = "Įrašykite grupės pavadinimą";
var ADD_MEMBERS = "Pridėti narius";
var SEND_MESSAGE = "Siųsti žinutę";
var UNBLOCK_USER = "Atblokuoti vartotoją";
var BLOCK_USER = "Užblokuoti vartotoją";
var DELETE_AND_EXIT = "Ištrinti ir išeiti";
var LEAVE_GROUP = "Palikti grupę";
var CREATE_GROUP = "Sukurti grupę";
var SHARED_MEDIA = "Pasidalinti failai";
var VIDEO_CALL = "Vaizdo skambutis";
var AUDIO_CALL = "Skambutis";
var LOADING = "Kraunasi...";
var REPLY = "atsakyti";
var REPLIES = "atsakymai";
var LAUNCH = "Įjungti";
var SHARED_COLLABORATIVE_DOCUMENT = "pasidalino bendru dokumentu";
var SHARED_COLLABORATIVE_WHITEBOARD = "pasidalino bendra balta lenta";
var CREATED_WHITEBOARD = "Jūs sukūrėte naują baltą lentą";
var CREATED_DOCUMENT = "Jūs sukūrėte naują bendrą dokumentą";
var PHOTOS = "Nuotraukos";
var VIDEOS = "Vaizdo įrašai";
var DOCUMENT = "Dokumentas";
var YOU_DELETED_THIS_MESSAGE = "⚠️ Jūs ištrynėte žinutę";
var THIS_MESSAGE_DELETED = "⚠️ Ši žinutė buvo ištrinta";
var MESSAGE_IS_DELETED = "Žinutė ištrinta";
var VIEW_ON_YOUTUBE = "Žiūrėti per Youtube";
var SEARCH = "Ieškoti";
var NO_USERS_FOUND = "Nerasta vartotojų";
var ERROR = "Klaida";
var NO_GROUPS_FOUND = "Nerasta grupių";
var NO_CHATS_FOUND = "Nerasta susirašinėjimų";
var MEDIA_MESSAGE = "Media žinutė";
var INCOMING_AUDIO_CALL = "Skambina";
var INCOMING_VIDEO_CALL = "Skambina su vaizdu";
var DECLINE = "Atmesti";
var ACCEPT = "Pakelti";
var CALL_INITIATED = "Skambutis pradėtas";
var OUTGOING_AUDIO_CALL = "Skambinama";
var OUTGOING_VIDEO_CALL = "Skambinama su vaizdu";
var CALL_REJECTED = "Skambutis atmestas";
var REJECTED_CALL = "atmestas skambutis";
var CALL_ACCEPTED = "Skambutis priimtas";
var JOINED = "prisijungė";
var LEFT_THE_CALL = "paliko skambutį";
var UNANSWERED_AUDIO_CALL = "Neatsakė į skambutį";
var UNANSWERED_VIDEO_CALL = "Neatsakė į vaizdo skambutį";
var CALL_ENDED = "Skambutis baigtas";
var CALL_CANCELLED = "Skambutis atšauktas";
var CALL_BUSY = "Užimta";
var CALLING = "Skambinama...";
var ADD = "Pridėti";
var NO_BANNED_MEMBERS_FOUND = "Nėra užblokuotų narių";
var BANNED_MEMBERS = "Užblokuoti nariai";
var NAME = "Vardas";
var SCOPE = "Sritis";
var UNBAN = "Atblokuoti";
var SELECT_GROUP_TYPE = "Pasirinkti grupės tipą";
var ENTER_GROUP_PASSWORD = "Įrašykite grupės slaptažodį";
var CREATE = "Sukurti";
var CREATE_POLL = "Sukurti balsavimą";
var QUESTION = "Klausimas";
var ENTER_YOUR_QUESTION = "Įrašykite klausimą";
var OPTIONS = "Pasirinkimai";
var ENTER_YOUR_OPTION = "Įrašykite pasirinkimą";
var ADD_NEW_OPTION = "Pridėti naują pasirinkimą";
var VIEW_MEMBERS = "Žiūrėti narius";
var DETAILS = "Detalės";
var NOTIFICATIONS = "Pranešimai";
var OTHER = "Kiti";
var HELP = "Pagalba";
var REPORT_PROBLEM = "Pranešti apie problemą";
var GROUP_MEMBERS = "Grupės nariai";
var BAN = "Užblokuoti";
var KICK = "Išmesti";
var PICK_YOUR_EMOJI = "Pasirinkite veiduką";
var PRIVATE_GROUP = "Privati grupė";
var PROTECTED_GROUP = "Apsaugota grupė";
var VISIT = "Žiūrėti";
var ATTACH = "Pridėti";
var ATTACH_FILE = "Pridėti failą";
var ATTACH_VIDEO = "Pridėti vaizdo įrašą";
var ATTACH_AUDIO = "Pridėti garso įrašą";
var ATTACH_IMAGE = "Pridėti nuotrauką";
var COLLABORATE_USING_DOCUMENT = "Bendradarbiauti dokumentu";
var COLLABORATE_USING_WHITEBOARD = "Bendradarbiauti balta lenta";
var EMOJI = "Veidukas";
var ENTER_YOUR_MESSAGE_HERE = "Įrašykite žinutę";
var NO_MESSAGES_FOUND = "Nerasta žinučių";
var THREAD = "Tema";
var COLLABORATIVE_DOCUMENT = "Bendras dokumentas";
var COLLABORATIVE_WHITEBOARD = "Bendra balta lenta";
var ADD_REACTION = "Pridėti reakciją";
var NO_STICKERS_FOUND = "Nerasta lipdukų";
var REPLY_TO_THREAD = "Atsakyti į temą";
var REPLY_IN_THREAD = "Atsakyti temoje";
var DELETE_MESSAGE = "Ištrinti žinutę";
var EDIT_MESSAGE = "Redaguoti žinutę";
var OWNER = "Savininkas";
var CHANGE_SCOPE = "Pakeisti sritį";
var STICKER = "Lipdukas";
var LAST_ACTIVE_AT = "Buvo aktyvus";
var VOICE_CALL = "Garso skambutis";
var VIEW_DETAIL = "Žiūrėti detales";
var VOTES = "balsai";
var VOTE = "balsas";
var NO_VOTE = "Nėra balsų";
var REACTED = "sureagavo";
var ADDED = "pridėjo";
var UNBANNED = "atblokavo";
var MADE = "sukūrė";
var CALL_UNANSWERED = "Skambutis neatsakytas";
var MISSED_AUDIO_CALL = "Praleistas skambutis";
var ENTER_YOUR_PASSWORD = "Įrašykite slaptažodį";
var DOCS = "Dokumentai";
var NO_RECORDS_FOUND = "Nerasta įrašų";
var LIVE_REACTION = "Gyva reakcija";
var SMILEY_PEOPLE = "Veidukai ir žmonės";
var ANIMALES_NATURE = "Gyvūnai ir gamta";
var FOOD_DRINK = "Maistas ir gėrimai";
var ACTIVITY = "Veikla";
var TRAVEL_PLACES = "Kelionės ir vietos";
var OBJECTS = "Objektai";
var SYMBOLS = "Simboliai";
var FLAGS = "Vėliavos";
var SENT = "Išsiuntė";
var SEEN = "Matė";
var DELIVERED = "Pristatyta";
var TRANSLATE_MESSAGE = "Išversti žinutę";
var LEFT = "paliko";
var KICKED = "buvo išspirtas";
var BANNED = "buvo užbanintas";
var NEW_MESSAGES = "naujos žinutės";
var NEW_MESSAGE = "nauja žinutė";
var JUMP = "Pašokti";
var SELECT_VIDEO_SOURCE = "Pasirinkite vaizdo šaltinį";
var SELECT_INPUT_AUDIO_SOURCE = "Pasirinkite įrašomo garso šaltinį";
var SELECT_OUTPUT_AUDIO_SOURCE = "Pasirinkite siunčiamos garso šaltinį";
var INITIATED_GROUP_CALL = "pradėjo grupės skambutį";
var YOU_INITIATED_GROUP_CALL = "Jūs pradėjote grupės skambutį";
var IGNORE = "Ignoruoti";
var ON_ANOTHER_CALL = "jau yra pokalbyje";
var CREATING = "Kuriame";
var AVATAR = "Avataras";
var GROUP_NAME_BLANK = "Grupės pavadinimas negali būti tuščias";
var GROUP_TYPE_BLANK = "Grupės tipas negali būti tuščias";
var GROUP_PASSWORD_BLANK = "Grupės slaptažodis negali būti tuščias";
var POLL_QUESTION_BLANK = "Klausimas negali būti tuščias";
var POLL_OPTION_BLANK = "Pasirinkimas negali būti tuščias";
var ONGOING_CALL = "Vykdomas skambutis";
var YOU_ALREADY_ONGOING_CALL = "Jūs jau esate vykstančiame skambutyje";
var RESIZE = "Pakeisti dydį";
var SETTINGS = "Nustatymai";
var ACTIONS = "veiksmai";
var VIEW_PROFILE = "Peržiūrėti profilį";
var SEND_MESSAGE_IN_PRIVATE = "Siųsti žinutę privačiai";
var DELETE = "Ištrinti";
var DELETE_CONFIRM = "Ar tikrai norite ištrinti?";
var CANCEL = "Atšaukti";
var LEAVE_CONFIRM = "Ar tikrai norite palikti grupę?";
var TRANSFER_CONFIRM = "Jūs esate grupės savininkas, prašome perduoti nuosavybės teisę nariui prieš išvykstant iš grupės";
var ADDING = "Pridedant...";
var TRANSFER = "Perdavimas";
var TRANSFERRING = "perkėlimas";
var YES = "Taip";
var NO = "Ne";
var SOMETHING_WRONG = "Kažkas nutiko, bandykite dar kartą";
var INVALID_GROUP_NAME = "Įveskite galiojantį grupės pavadinimą ir bandykite dar kartą";
var INVALID_GROUP_TYPE = "Įveskite galiojantį grupės tipą ir bandykite dar kartą";
var INVALID_PASSWORD = "Įveskite galiojantį grupės slaptažodį ir bandykite dar kartą";
var WRONG_PASSWORD = "Įveskite teisingą slaptažodį ir bandykite dar kartą";
var INVALID_POLL_QUESTION = "Prašome įvesti reikiamą klausimą prieš kurdami apklausą";
var INVALID_POLL_OPTION = "Prašome įvesti reikiamą atsakymą prieš kurdami apklausą";
var SAME_LANGUAGE_MESSAGE = "Pasirinkta vertimo kalba yra panaši į originalaus pranešimo kalbą";
var LEAVE = "Palikti";
var CALLS = "Skambučiai";
var CUSTOM_MESSAGE_LOCATION = "📍 Vieta";
var OFFLINE = "Atsijungęs";
var YOU = "Jūs";
var PRIVACY = "Privatumas";
var BLOCKED_USERS = "Užblokuoti nariai";
var NO_PHOTOS = "Nėra nuotraukų";
var NO_VIDEOS = "Nėra vaizdo įrašų";
var NO_DOCUMENTS = "Nėra dokumentų";
var JOIN = "Prisijungti";
var NEW_CHAT = "Nauja Pokalbiai";
var FORM_COMPLETION_MESSAGE = "Grazie per aver compilato il modulo.";
var FORM = "Modulo";
var CARD = "Carta";
var HISTORY = "Storia";
var CANCELLED_AUDIO_CALL = "Chiamata audio annullata";
var CANCELLED_VIDEO_CALL = "Videochiamata annullata";
var REJECTED_AUDIO_CALL = "Chiamata audio rifiutata";
var REJECTED_VIDEO_CALL = "Videochiamata rifiutata";
var CANCELLED_CALL = "Chiamata annullata";
var UNANSWERED_CALL = "Chiamata senza risposta";
var RECORDING = "Registrazione";
var PARTICIPANTS = "Partecipanti";
var CALL_HISTORY = "Cronologia chiamate";
var NO_CALLS_FOUND = "Nessuna chiamata trovata";
var ONGOING_AUDIO_CALL = "Chiamata audio in corso";
var ONGOING_VIDEO_CALL = "Videochiamata in corso";
var CALL_DETAIL = "Dettagli della chiamata";
var GENERATING_SUMMARY = "Generazione del riassunto";
var CONVERSATION_SUMMARY = "Riepilogo della conversazione";
var GENERATE_SUMMARY = "Genera un riepilogo";
var COMETCHAT_BOT_FIRST_MESSAGE = "Come posso aiutarti con questa conversazione? Per favore fammi una domanda e ti consiglierò 🙂";
var COMETCHAT_ASK_BOT = "Chiedere";
var COMETCHAT_ASK_AI_BOT = "Chiedi ai bot AI";
var COMETCHAT_ASK_BOT_SUBTITLE = "Bot AI";
var translationLT = {
	USERS: USERS,
	CHATS: CHATS,
	GROUPS: GROUPS,
	MORE: MORE,
	MESSAGE_IMAGE: MESSAGE_IMAGE,
	MESSAGE_FILE: MESSAGE_FILE,
	MESSAGE_VIDEO: MESSAGE_VIDEO,
	NEW__GROUP: NEW__GROUP,
	PASSWORD: PASSWORD,
	SHOW_UNSAFE_CONTENT: SHOW_UNSAFE_CONTENT,
	REACT_TO_MESSAGE: REACT_TO_MESSAGE,
	CONTINUE: CONTINUE,
	VOICE_RECORDING: VOICE_RECORDING,
	READ: READ,
	AI: AI,
	SMART_REPLIES: SMART_REPLIES,
	CONVERSATION_STARTER: CONVERSATION_STARTER,
	MESSAGE: MESSAGE,
	RECEIPT_INFORMATION: RECEIPT_INFORMATION,
	MESSAGE_INFORMATION: MESSAGE_INFORMATION,
	NO_CHATS_SELECTED: NO_CHATS_SELECTED,
	SELECT__GROUP: SELECT__GROUP,
	DELETE_CONVERSATION: DELETE_CONVERSATION,
	WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION,
	ADD_TO_CHAT: ADD_TO_CHAT,
	MESSAGE_AUDIO: MESSAGE_AUDIO,
	SUGGEST_A_REPLY: SUGGEST_A_REPLY,
	GENERATING_ICEBREAKERS: GENERATING_ICEBREAKERS,
	GENERATING_REPLIES: GENERATING_REPLIES,
	NO_REPLIES_FOUND: NO_REPLIES_FOUND,
	NO_USERS_SELECTED: NO_USERS_SELECTED,
	NO_GROUPS_SELECTED: NO_GROUPS_SELECTED,
	CUSTOM_MESSAGE: CUSTOM_MESSAGE,
	NO_RECIPIENT: NO_RECIPIENT,
	NO_RECIPIENTS: NO_RECIPIENTS,
	MISSED_VOICE_CALL: MISSED_VOICE_CALL,
	MISSED_VIDEO_CALL: MISSED_VIDEO_CALL,
	CUSTOM_MESSAGE_POLL: CUSTOM_MESSAGE_POLL,
	CUSTOM_MESSAGE_STICKER: CUSTOM_MESSAGE_STICKER,
	TRANSFER_OWNERSHIP: TRANSFER_OWNERSHIP,
	CUSTOM_MESSAGE_DOCUMENT: CUSTOM_MESSAGE_DOCUMENT,
	NO_CALLS_SELECTED: NO_CALLS_SELECTED,
	SELECT__USER: SELECT__USER,
	CANT__LOAD__CHATS: CANT__LOAD__CHATS,
	OUTGOING_CALL: OUTGOING_CALL,
	INCOMING_CALL: INCOMING_CALL,
	DRAW_DOCUMENT_TOGETHER: DRAW_DOCUMENT_TOGETHER,
	MISSED_CALL: MISSED_CALL,
	OPEN_DOCUMENT: OPEN_DOCUMENT,
	TRANSLATED_MESSAGE: TRANSLATED_MESSAGE,
	ANSWER: ANSWER,
	ADMIN: ADMIN,
	DRAW_WHITEBOARD_TOGETHER: DRAW_WHITEBOARD_TOGETHER,
	ADD_ANOTHER_ANSWER: ADD_ANOTHER_ANSWER,
	SET_THE_ANSWERS: SET_THE_ANSWERS,
	CLICK_TO_START_CONVERSATION: CLICK_TO_START_CONVERSATION,
	SHARED_LOCATION: SHARED_LOCATION,
	CALL_DETAILS: CALL_DETAILS,
	POLLS: POLLS,
	OPEN_WHITEBOARD: OPEN_WHITEBOARD,
	CUSTOM_MESSAGE_WHITEBOARD: CUSTOM_MESSAGE_WHITEBOARD,
	ONLINE: ONLINE,
	VIEW: VIEW,
	ADMINISTRATOR: ADMINISTRATOR,
	MODERATOR: MODERATOR,
	PARTICIPANT: PARTICIPANT,
	PUBLIC: PUBLIC,
	PRIVATE: PRIVATE,
	PASSWORD_PROTECTED: PASSWORD_PROTECTED,
	PRIVACY_AND_SECURITY: PRIVACY_AND_SECURITY,
	PREFERENCES: PREFERENCES,
	MEMBERS: MEMBERS,
	TODAY: TODAY,
	YESTERDAY: YESTERDAY,
	SUNDAY: SUNDAY,
	MONDAY: MONDAY,
	TUESDAY: TUESDAY,
	WEDNESDAY: WEDNESDAY,
	THURSDAY: THURSDAY,
	FRIDAY: FRIDAY,
	SATURDAY: SATURDAY,
	TYPING: TYPING,
	IS_TYPING: IS_TYPING,
	CLOSE: CLOSE,
	ENTER_GROUP_NAME: ENTER_GROUP_NAME,
	ADD_MEMBERS: ADD_MEMBERS,
	SEND_MESSAGE: SEND_MESSAGE,
	UNBLOCK_USER: UNBLOCK_USER,
	BLOCK_USER: BLOCK_USER,
	DELETE_AND_EXIT: DELETE_AND_EXIT,
	LEAVE_GROUP: LEAVE_GROUP,
	CREATE_GROUP: CREATE_GROUP,
	SHARED_MEDIA: SHARED_MEDIA,
	VIDEO_CALL: VIDEO_CALL,
	AUDIO_CALL: AUDIO_CALL,
	LOADING: LOADING,
	REPLY: REPLY,
	REPLIES: REPLIES,
	LAUNCH: LAUNCH,
	SHARED_COLLABORATIVE_DOCUMENT: SHARED_COLLABORATIVE_DOCUMENT,
	SHARED_COLLABORATIVE_WHITEBOARD: SHARED_COLLABORATIVE_WHITEBOARD,
	CREATED_WHITEBOARD: CREATED_WHITEBOARD,
	CREATED_DOCUMENT: CREATED_DOCUMENT,
	PHOTOS: PHOTOS,
	VIDEOS: VIDEOS,
	DOCUMENT: DOCUMENT,
	YOU_DELETED_THIS_MESSAGE: YOU_DELETED_THIS_MESSAGE,
	THIS_MESSAGE_DELETED: THIS_MESSAGE_DELETED,
	MESSAGE_IS_DELETED: MESSAGE_IS_DELETED,
	VIEW_ON_YOUTUBE: VIEW_ON_YOUTUBE,
	SEARCH: SEARCH,
	NO_USERS_FOUND: NO_USERS_FOUND,
	ERROR: ERROR,
	NO_GROUPS_FOUND: NO_GROUPS_FOUND,
	NO_CHATS_FOUND: NO_CHATS_FOUND,
	MEDIA_MESSAGE: MEDIA_MESSAGE,
	INCOMING_AUDIO_CALL: INCOMING_AUDIO_CALL,
	INCOMING_VIDEO_CALL: INCOMING_VIDEO_CALL,
	DECLINE: DECLINE,
	ACCEPT: ACCEPT,
	CALL_INITIATED: CALL_INITIATED,
	OUTGOING_AUDIO_CALL: OUTGOING_AUDIO_CALL,
	OUTGOING_VIDEO_CALL: OUTGOING_VIDEO_CALL,
	CALL_REJECTED: CALL_REJECTED,
	REJECTED_CALL: REJECTED_CALL,
	CALL_ACCEPTED: CALL_ACCEPTED,
	JOINED: JOINED,
	LEFT_THE_CALL: LEFT_THE_CALL,
	UNANSWERED_AUDIO_CALL: UNANSWERED_AUDIO_CALL,
	UNANSWERED_VIDEO_CALL: UNANSWERED_VIDEO_CALL,
	CALL_ENDED: CALL_ENDED,
	CALL_CANCELLED: CALL_CANCELLED,
	CALL_BUSY: CALL_BUSY,
	CALLING: CALLING,
	ADD: ADD,
	NO_BANNED_MEMBERS_FOUND: NO_BANNED_MEMBERS_FOUND,
	BANNED_MEMBERS: BANNED_MEMBERS,
	NAME: NAME,
	SCOPE: SCOPE,
	UNBAN: UNBAN,
	SELECT_GROUP_TYPE: SELECT_GROUP_TYPE,
	ENTER_GROUP_PASSWORD: ENTER_GROUP_PASSWORD,
	CREATE: CREATE,
	CREATE_POLL: CREATE_POLL,
	QUESTION: QUESTION,
	ENTER_YOUR_QUESTION: ENTER_YOUR_QUESTION,
	OPTIONS: OPTIONS,
	ENTER_YOUR_OPTION: ENTER_YOUR_OPTION,
	ADD_NEW_OPTION: ADD_NEW_OPTION,
	VIEW_MEMBERS: VIEW_MEMBERS,
	DETAILS: DETAILS,
	NOTIFICATIONS: NOTIFICATIONS,
	OTHER: OTHER,
	HELP: HELP,
	REPORT_PROBLEM: REPORT_PROBLEM,
	GROUP_MEMBERS: GROUP_MEMBERS,
	BAN: BAN,
	KICK: KICK,
	PICK_YOUR_EMOJI: PICK_YOUR_EMOJI,
	PRIVATE_GROUP: PRIVATE_GROUP,
	PROTECTED_GROUP: PROTECTED_GROUP,
	VISIT: VISIT,
	ATTACH: ATTACH,
	ATTACH_FILE: ATTACH_FILE,
	ATTACH_VIDEO: ATTACH_VIDEO,
	ATTACH_AUDIO: ATTACH_AUDIO,
	ATTACH_IMAGE: ATTACH_IMAGE,
	COLLABORATE_USING_DOCUMENT: COLLABORATE_USING_DOCUMENT,
	COLLABORATE_USING_WHITEBOARD: COLLABORATE_USING_WHITEBOARD,
	EMOJI: EMOJI,
	ENTER_YOUR_MESSAGE_HERE: ENTER_YOUR_MESSAGE_HERE,
	NO_MESSAGES_FOUND: NO_MESSAGES_FOUND,
	THREAD: THREAD,
	COLLABORATIVE_DOCUMENT: COLLABORATIVE_DOCUMENT,
	COLLABORATIVE_WHITEBOARD: COLLABORATIVE_WHITEBOARD,
	ADD_REACTION: ADD_REACTION,
	NO_STICKERS_FOUND: NO_STICKERS_FOUND,
	REPLY_TO_THREAD: REPLY_TO_THREAD,
	REPLY_IN_THREAD: REPLY_IN_THREAD,
	DELETE_MESSAGE: DELETE_MESSAGE,
	EDIT_MESSAGE: EDIT_MESSAGE,
	OWNER: OWNER,
	CHANGE_SCOPE: CHANGE_SCOPE,
	STICKER: STICKER,
	LAST_ACTIVE_AT: LAST_ACTIVE_AT,
	VOICE_CALL: VOICE_CALL,
	VIEW_DETAIL: VIEW_DETAIL,
	VOTES: VOTES,
	VOTE: VOTE,
	NO_VOTE: NO_VOTE,
	REACTED: REACTED,
	ADDED: ADDED,
	UNBANNED: UNBANNED,
	MADE: MADE,
	CALL_UNANSWERED: CALL_UNANSWERED,
	MISSED_AUDIO_CALL: MISSED_AUDIO_CALL,
	ENTER_YOUR_PASSWORD: ENTER_YOUR_PASSWORD,
	DOCS: DOCS,
	NO_RECORDS_FOUND: NO_RECORDS_FOUND,
	LIVE_REACTION: LIVE_REACTION,
	SMILEY_PEOPLE: SMILEY_PEOPLE,
	ANIMALES_NATURE: ANIMALES_NATURE,
	FOOD_DRINK: FOOD_DRINK,
	ACTIVITY: ACTIVITY,
	TRAVEL_PLACES: TRAVEL_PLACES,
	OBJECTS: OBJECTS,
	SYMBOLS: SYMBOLS,
	FLAGS: FLAGS,
	SENT: SENT,
	SEEN: SEEN,
	DELIVERED: DELIVERED,
	TRANSLATE_MESSAGE: TRANSLATE_MESSAGE,
	LEFT: LEFT,
	KICKED: KICKED,
	BANNED: BANNED,
	NEW_MESSAGES: NEW_MESSAGES,
	NEW_MESSAGE: NEW_MESSAGE,
	JUMP: JUMP,
	SELECT_VIDEO_SOURCE: SELECT_VIDEO_SOURCE,
	SELECT_INPUT_AUDIO_SOURCE: SELECT_INPUT_AUDIO_SOURCE,
	SELECT_OUTPUT_AUDIO_SOURCE: SELECT_OUTPUT_AUDIO_SOURCE,
	INITIATED_GROUP_CALL: INITIATED_GROUP_CALL,
	YOU_INITIATED_GROUP_CALL: YOU_INITIATED_GROUP_CALL,
	IGNORE: IGNORE,
	ON_ANOTHER_CALL: ON_ANOTHER_CALL,
	CREATING: CREATING,
	AVATAR: AVATAR,
	GROUP_NAME_BLANK: GROUP_NAME_BLANK,
	GROUP_TYPE_BLANK: GROUP_TYPE_BLANK,
	GROUP_PASSWORD_BLANK: GROUP_PASSWORD_BLANK,
	POLL_QUESTION_BLANK: POLL_QUESTION_BLANK,
	POLL_OPTION_BLANK: POLL_OPTION_BLANK,
	ONGOING_CALL: ONGOING_CALL,
	YOU_ALREADY_ONGOING_CALL: YOU_ALREADY_ONGOING_CALL,
	RESIZE: RESIZE,
	SETTINGS: SETTINGS,
	ACTIONS: ACTIONS,
	VIEW_PROFILE: VIEW_PROFILE,
	SEND_MESSAGE_IN_PRIVATE: SEND_MESSAGE_IN_PRIVATE,
	DELETE: DELETE,
	DELETE_CONFIRM: DELETE_CONFIRM,
	CANCEL: CANCEL,
	LEAVE_CONFIRM: LEAVE_CONFIRM,
	TRANSFER_CONFIRM: TRANSFER_CONFIRM,
	ADDING: ADDING,
	TRANSFER: TRANSFER,
	TRANSFERRING: TRANSFERRING,
	YES: YES,
	NO: NO,
	SOMETHING_WRONG: SOMETHING_WRONG,
	INVALID_GROUP_NAME: INVALID_GROUP_NAME,
	INVALID_GROUP_TYPE: INVALID_GROUP_TYPE,
	INVALID_PASSWORD: INVALID_PASSWORD,
	WRONG_PASSWORD: WRONG_PASSWORD,
	INVALID_POLL_QUESTION: INVALID_POLL_QUESTION,
	INVALID_POLL_OPTION: INVALID_POLL_OPTION,
	SAME_LANGUAGE_MESSAGE: SAME_LANGUAGE_MESSAGE,
	LEAVE: LEAVE,
	CALLS: CALLS,
	CUSTOM_MESSAGE_LOCATION: CUSTOM_MESSAGE_LOCATION,
	OFFLINE: OFFLINE,
	YOU: YOU,
	PRIVACY: PRIVACY,
	BLOCKED_USERS: BLOCKED_USERS,
	"YOU'VE_BLOCKED": "Jūs užblokavote",
	NO_PHOTOS: NO_PHOTOS,
	NO_VIDEOS: NO_VIDEOS,
	NO_DOCUMENTS: NO_DOCUMENTS,
	JOIN: JOIN,
	NEW_CHAT: NEW_CHAT,
	FORM_COMPLETION_MESSAGE: FORM_COMPLETION_MESSAGE,
	FORM: FORM,
	CARD: CARD,
	HISTORY: HISTORY,
	CANCELLED_AUDIO_CALL: CANCELLED_AUDIO_CALL,
	CANCELLED_VIDEO_CALL: CANCELLED_VIDEO_CALL,
	REJECTED_AUDIO_CALL: REJECTED_AUDIO_CALL,
	REJECTED_VIDEO_CALL: REJECTED_VIDEO_CALL,
	CANCELLED_CALL: CANCELLED_CALL,
	UNANSWERED_CALL: UNANSWERED_CALL,
	RECORDING: RECORDING,
	PARTICIPANTS: PARTICIPANTS,
	CALL_HISTORY: CALL_HISTORY,
	NO_CALLS_FOUND: NO_CALLS_FOUND,
	ONGOING_AUDIO_CALL: ONGOING_AUDIO_CALL,
	ONGOING_VIDEO_CALL: ONGOING_VIDEO_CALL,
	CALL_DETAIL: CALL_DETAIL,
	GENERATING_SUMMARY: GENERATING_SUMMARY,
	CONVERSATION_SUMMARY: CONVERSATION_SUMMARY,
	GENERATE_SUMMARY: GENERATE_SUMMARY,
	COMETCHAT_BOT_FIRST_MESSAGE: COMETCHAT_BOT_FIRST_MESSAGE,
	COMETCHAT_ASK_BOT: COMETCHAT_ASK_BOT,
	COMETCHAT_ASK_AI_BOT: COMETCHAT_ASK_AI_BOT,
	COMETCHAT_ASK_BOT_SUBTITLE: COMETCHAT_ASK_BOT_SUBTITLE
};

class CometChatLocalize {
    /**
     * Accepts the string to localize and return the localized string
     * @param {String} str
     * @returns {String} localized str
     */
    static localize(str) {
        let language = CometChatLocalize.getLocale();
        return CometChatLocalize.translations[language][str];
    }
}
/**Properties and constants */
CometChatLocalize.fallbackLanguage = "en";
CometChatLocalize.rtlLanguages = ["ar"];
CometChatLocalize.direction = Object.freeze({
    ltr: "ltr",
    rtl: "rtl",
});
CometChatLocalize.translations = {
    ar: translationAR,
    de: translationDE,
    en: translationEN,
    es: translationES,
    fr: translationFR,
    hi: translationHI,
    ms: translationMS,
    pt: translationPT,
    ru: translationRU,
    zh: translationZH,
    "zh-tw": translationZHTW,
    sv: translationSV,
    lt: translationLT,
};
/**
 * Needs to be called at the start of the application in order to set the language
 * @param {Object} - language & resources
 */
/**
 * @param  {string=""} language
 * @param  {object={}} resources
 */
CometChatLocalize.init = (language = "", resources = {}) => {
    if (language) {
        CometChatLocalize.locale = language;
    }
    else {
        CometChatLocalize.setDefaultLanguage();
    }
    /**Override resources */
    if (resources) {
        for (const resource in resources) {
            /**Add to the original array of translations if language code is not found */
            if (!CometChatLocalize.translations[resource]) {
                CometChatLocalize.translations[resource] = resources[resource];
            }
            else {
                for (const key in (resources[resource])) {
                    CometChatLocalize.translations[resource][key] = resources[resource][key];
                }
            }
        }
    }
};
/**
 * Returns the browser language
 * @returns {String} browser langauge i.e. en-US
 */
CometChatLocalize.getBrowserLanguage = () => {
    return (navigator.languages && navigator.languages[0]) || navigator.language;
};
/**
 * Returns the language code
 * @returns {String} language code i.e. en
 */
CometChatLocalize.getLanguageCode = () => {
    const languageCode = CometChatLocalize.getBrowserLanguage().toLowerCase();
    // check if the language set in the browser has hyphen(-), if yes split and take the first element of the array
    if (languageCode.indexOf("-") !== -1 && languageCode !== "zh-tw") {
        return languageCode.split("-")[0];
    }
    return languageCode;
};
/**
 * Returns the active language. Return fallback language if translation is not available for the active language
 * @returns {String} active language
 */
CometChatLocalize.getLocale = () => {
    let language = CometChatLocalize.locale;
    if (!CometChatLocalize.translations.hasOwnProperty(language)) {
        language = CometChatLocalize.fallbackLanguage;
    }
    return language;
};
/**
 * Set the active language
 * @param {String} language
 */
CometChatLocalize.setLocale = (language) => {
    CometChatLocalize.locale = language;
};
/**
 * Sets the default lannguage if no language is passed in init method
 */
CometChatLocalize.setDefaultLanguage = () => {
    // get the active language
    const activeLanguage = CometChatLocalize.getLocale();
    // get the browser language code
    let browserLanguageCode = CometChatLocalize.getLanguageCode();
    // if there is no active language or active language is different from browser language, update active language with browser language
    if (!activeLanguage || activeLanguage !== browserLanguageCode) {
        CometChatLocalize.setLocale(browserLanguageCode);
    }
};
/**
 * Returns true if the active language is rtl otherwise return false
 * @returns {Boolean} whether the language is rtl or not
 */
CometChatLocalize.isRTL = () => {
    if (CometChatLocalize.rtlLanguages.includes(CometChatLocalize.getLocale())) {
        return true;
    }
    return false;
};
/**
 * Returns rtl or ltr based on the active language
 * @returns {String} the direction of the active langauge
 */
CometChatLocalize.getDir = () => {
    if (CometChatLocalize.rtlLanguages.includes(CometChatLocalize.getLocale())) {
        return CometChatLocalize.direction.rtl;
    }
    return CometChatLocalize.direction.ltr;
};
const localize = (str) => CometChatLocalize.localize(str);

/**
 * @class PaletteItem
 * @param {String} light
 * @param {String} dark
 */
class PaletteItem {
    constructor({ light = "", dark = "" }) {
        this.light = "";
        this.dark = "";
        this.light = light;
        this.dark = dark;
    }
}
const modes = {
    light: "light",
    dark: "dark"
};
const opacity = {
    accent50: {
        [modes.light]: "0.04",
        [modes.dark]: "0.04",
    },
    accent100: {
        [modes.light]: "0.08",
        [modes.dark]: "0.08",
    },
    accent200: {
        [modes.light]: "0.15",
        [modes.dark]: "0.14",
    },
    accent300: {
        [modes.light]: "0.24",
        [modes.dark]: "0.23",
    },
    accent400: {
        [modes.light]: "0.33",
        [modes.dark]: "0.34",
    },
    accent500: {
        [modes.light]: "0.46",
        [modes.dark]: "0.46",
    },
    accent600: {
        [modes.light]: "0.58",
        [modes.dark]: "0.58",
    },
    accent700: {
        [modes.light]: "0.69",
        [modes.dark]: "0.71",
    },
    accent800: {
        [modes.light]: "0.82",
        [modes.dark]: "0.84",
    },
};
const getAccentOpacity = (colorCode, opacity) => {
    if (colorCode.startsWith("#")) {
        return hexToRGBA(colorCode, opacity);
    }
    return RGBToRGBA(colorCode, opacity);
};
const hexToRGBA = (hex, opacity) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return "rgba(" + +r + "," + +g + "," + +b + "," + opacity + ")";
};
const RGBToRGBA = (rgb, opacity) => {
    // Choose correct separator
    let sep = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(sep);
    let r = (+rgb[0]).toString(16), g = (+rgb[1]).toString(16), b = (+rgb[2]).toString(16);
    return "rgba(" + r + "," + g + "," + b + "," + opacity + ")";
};
class CometChatPalette {
    constructor({ mode = modes.light, background = new PaletteItem({
        [modes.light]: "rgba(255,255,255)",
        [modes.dark]: "rgba(0,0,0)",
    }), primary = new PaletteItem({
        [modes.light]: "rgba(51, 153, 255)",
        [modes.dark]: "rgba(51, 153, 255)",
    }), error = new PaletteItem({
        [modes.light]: "rgba(255, 59, 48)",
        [modes.dark]: "rgba(255, 59, 48)",
    }), accent = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20)",
        [modes.dark]: "rgba(255, 255, 255)",
    }), accent50 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.04)",
        [modes.dark]: "rgba(255, 255, 255, 0.4)",
    }), accent100 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.08)",
        [modes.dark]: "rgba(255, 255, 255, 0.08)",
    }), accent200 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.15)",
        [modes.dark]: "rgba(255, 255, 255, 0.14)",
    }), accent300 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.24)",
        [modes.dark]: "rgba(255, 255, 255, 0.23)",
    }), accent400 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.33)",
        [modes.dark]: "rgba(255, 255, 255, 0.34)",
    }), accent500 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.46)",
        [modes.dark]: "rgba(255, 255, 255, 0.46)",
    }), accent600 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.58)",
        [modes.dark]: "rgba(255, 255, 255, 0.58)",
    }), accent700 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.69)",
        [modes.dark]: "rgba(255, 255, 255, 0.71)",
    }), accent800 = new PaletteItem({
        [modes.light]: "rgba(20, 20, 20, 0.82)",
        [modes.dark]: "rgba(255, 255, 255, 0.84)",
    }), accent900 = new PaletteItem({
        [modes.light]: "rgba(255, 255, 255)",
        [modes.dark]: "rgb(20, 20, 20)",
    }), success = new PaletteItem({
        [modes.light]: "rgb(0, 200, 111)",
        [modes.dark]: "rgb(0, 200, 111)",
    }), secondary = new PaletteItem({
        [modes.light]: "rgba(248, 248, 248, 0.92)",
        [modes.dark]: "rgb(248, 248, 248, 0.92)",
    }) }) {
        this.mode = modes.light;
        this.background = new PaletteItem({
            [modes.light]: "rgba(255,255,255)",
            [modes.dark]: "rgba(0,0,0)",
        });
        this.primary = new PaletteItem({
            [modes.light]: "rgba(51, 153, 255)",
            [modes.dark]: "rgba(51, 153, 255)",
        });
        this.error = new PaletteItem({
            [modes.light]: "rgba(255, 59, 48)",
            [modes.dark]: "rgba(255, 59, 48)",
        });
        this.accent = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20)",
            [modes.dark]: "rgba(255, 255, 255)",
        });
        this.accent50 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.04)",
            [modes.dark]: "rgba(255, 255, 255, 0.4)",
        });
        this.accent100 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.08)",
            [modes.dark]: "rgba(255, 255, 255, 0.08)",
        });
        this.accent200 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.15)",
            [modes.dark]: "rgba(255, 255, 255, 0.14)",
        });
        this.accent300 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.24)",
            [modes.dark]: "rgba(255, 255, 255, 0.23)",
        });
        this.accent400 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.33)",
            [modes.dark]: "rgba(255, 255, 255, 0.34)",
        });
        this.accent500 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.46)",
            [modes.dark]: "rgba(255, 255, 255, 0.46)",
        });
        this.accent600 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.58)",
            [modes.dark]: "rgba(255, 255, 255, 0.58)",
        });
        this.accent700 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.69)",
            [modes.dark]: "rgba(255, 255, 255, 0.71)",
        });
        this.accent800 = new PaletteItem({
            [modes.light]: "rgba(20, 20, 20, 0.82)",
            [modes.dark]: "rgba(255, 255, 255, 0.84)",
        });
        this.accent900 = new PaletteItem({
            [modes.light]: "rgba(255, 255, 255)",
            [modes.dark]: "rgb(20, 20, 20)",
        });
        this.success = new PaletteItem({
            [modes.light]: "rgb(0, 200, 111)",
            [modes.dark]: "rgb(0, 200, 111)",
        });
        this.secondary = new PaletteItem({
            [modes.light]: "rgba(248, 248, 248, 0.92)",
            [modes.dark]: "rgb(248, 248, 248, 0.92)",
        });
        this.getAccent = (mode = this.mode) => {
            return this.accent[mode];
        };
        this.getAccent50 = (mode = this.mode) => {
            return this.accent50[mode];
        };
        this.getAccent100 = (mode = this.mode) => {
            return this.accent100[mode];
        };
        this.getAccent200 = (mode = this.mode) => {
            return this.accent200[mode];
        };
        this.getAccent300 = (mode = this.mode) => {
            return this.accent300[mode];
        };
        this.getAccent400 = (mode = this.mode) => {
            return this.accent400[mode];
        };
        this.getAccent500 = (mode = this.mode) => {
            return this.accent500[mode];
        };
        this.getAccent600 = (mode = this.mode) => {
            return this.accent600[mode];
        };
        this.getAccent700 = (mode = this.mode) => {
            return this.accent700[mode];
        };
        this.getAccent800 = (mode = this.mode) => {
            return this.accent800[mode];
        };
        this.getAccent900 = (mode = this.mode) => {
            return this.accent900[mode];
        };
        this.getSuccess = (mode = this.mode) => {
            return this.success[mode];
        };
        this.getError = (mode = this.mode) => {
            return this.error[mode];
        };
        this.getPrimary = (mode = this.mode) => {
            return this.primary[mode];
        };
        this.getSecondary = (mode = this.mode) => {
            return this.secondary[mode];
        };
        this.getBackground = (mode = this.mode) => {
            return this.background[mode];
        };
        this.mode = mode;
        this.background = background;
        this.primary = primary;
        this.secondary = secondary;
        this.error = error;
        this.success = success;
        this.accent = accent;
        this.accent50 = accent50;
        this.accent100 = accent100;
        this.accent200 = accent200;
        this.accent300 = accent300;
        this.accent400 = accent400;
        this.accent500 = accent500;
        this.accent600 = accent600;
        this.accent700 = accent700;
        this.accent800 = accent800;
        this.accent900 = accent900;
    }
    /**
     * @param  {string} mode
     */
    setMode(mode) {
        this.mode = mode;
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setBackground(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.background = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setPrimary(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.primary = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setSecondary(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.secondary = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setError(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.error = colorset;
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
            this.setAccent50({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent50[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent50[modes.dark]),
            });
            this.setAccent100({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent100[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent100[modes.dark]),
            });
            this.setAccent200({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent200[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent200[modes.dark]),
            });
            this.setAccent300({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent300[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent300[modes.dark]),
            });
            this.setAccent400({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent400[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent400[modes.dark]),
            });
            this.setAccent500({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent500[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent500[modes.dark]),
            });
            this.setAccent600({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent600[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent600[modes.dark]),
            });
            this.setAccent700({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent700[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent700[modes.dark]),
            });
            this.setAccent800({
                [modes.light]: getAccentOpacity(colorset.light, opacity.accent800[modes.light]),
                [modes.dark]: getAccentOpacity(colorset.dark, opacity.accent800[modes.dark]),
            });
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent50(colorset = new PaletteItem({})) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent50 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    setAccent100(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent100 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent200(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent200 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent300(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent300 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent400(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent400 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent500(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent500 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent600(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent600 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent700(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent700 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent800(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent800 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
    /**
     * @param  {PaletteItem} colorset
     */
    setAccent900(colorset) {
        if (colorset && colorset[modes.light] && colorset[modes.dark]) {
            this.accent900 = {
                [modes.light]: colorset[modes.light],
                [modes.dark]: colorset[modes.dark],
            };
        }
    }
}
new CometChatPalette({});

/**
 * @class CometChatFont
 * @param {String} fontFamily
 * @param {String} fontWeight
 * @param {String} fontSize
 */
class CometChatFont {
    constructor({ fontFamily = "", fontWeight = "", fontSize = "" }) {
        this.fontWeight = "";
        this.fontSize = "";
        this.fontFamily = fontFamily;
        this.fontWeight = fontWeight;
        this.fontSize = fontSize;
    }
}
/**
 * @class Typography
 * @param {String} fontFamily
 * @param {String} fontWeightRegular
 * @param {String} fontWeightMedium
 * @param {String} fontWeightSemibold
 * @param {String} fontWeightBold
 * @param {Object} heading
 * @param {Object} name
 * @param {Object} title1
 * @param {Object} title2
 * @param {Object} subtitle1
 * @param {Object} subtitle2
 * @param {Object} text1
 * @param {Object} text2
 * @param {Object} caption1
 * @param {Object} caption2
 */
class CometChatTypography {
    constructor({ fontFamily = "Inter,sans-serif", fontWeightRegular = "400", fontWeightMedium = "500", fontWeightSemibold = "600", fontWeightBold = "700", heading = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "700",
        fontSize: "22px",
    }), name = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "500",
        fontSize: "16px",
    }), title1 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "600",
        fontSize: "22px",
    }), title2 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "600",
        fontSize: "15px",
    }), subtitle1 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "400",
        fontSize: "15px",
    }), subtitle2 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "400",
        fontSize: "13px",
    }), text1 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "400",
        fontSize: "17px",
    }), text2 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "500",
        fontSize: "15px",
    }), text3 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "500",
        fontSize: "13px",
    }), caption1 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "500",
        fontSize: "12px",
    }), caption2 = new CometChatFont({
        fontFamily: "Inter,sans-serif",
        fontWeight: "500",
        fontSize: "11px",
    }) }) {
        this.fontFamily = "Inter,sans-serif";
        this.fontWeightRegular = "400";
        this.fontWeightMedium = "500";
        this.fontWeightSemibold = "600";
        this.fontWeightBold = "700";
        this.heading = new CometChatFont({});
        this.name = new CometChatFont({});
        this.title1 = new CometChatFont({});
        this.title2 = new CometChatFont({});
        this.subtitle1 = new CometChatFont({});
        this.subtitle2 = new CometChatFont({});
        this.text1 = new CometChatFont({});
        this.text2 = new CometChatFont({});
        this.text3 = new CometChatFont({});
        this.caption1 = new CometChatFont({});
        this.caption2 = new CometChatFont({});
        this.fontFamily = fontFamily;
        this.fontWeightRegular = fontWeightRegular;
        this.fontWeightMedium = fontWeightMedium;
        this.fontWeightSemibold = fontWeightSemibold;
        this.fontWeightBold = fontWeightBold;
        this.heading = heading;
        this.name = name;
        this.title1 = title1;
        this.title2 = title2;
        this.subtitle1 = subtitle1;
        this.subtitle2 = subtitle2;
        this.text1 = text1;
        this.text2 = text2;
        this.text3 = text3;
        this.caption1 = caption1;
        this.caption2 = caption2;
    }
    setFontFamily(fontFamily) {
        this.fontFamily = fontFamily;
        this.heading.fontFamily = fontFamily;
        this.name.fontFamily = fontFamily;
        this.title1.fontFamily = fontFamily;
        this.title2.fontFamily = fontFamily;
        this.subtitle1.fontFamily = fontFamily;
        this.subtitle2.fontFamily = fontFamily;
        this.text1.fontFamily = fontFamily;
        this.text2.fontFamily = fontFamily;
        this.text3.fontFamily = fontFamily;
        this.caption1.fontFamily = fontFamily;
        this.caption2.fontFamily = fontFamily;
    }
    setFontWeightRegular(fontWeightRegular) {
        this.fontWeightRegular = fontWeightRegular;
    }
    setFontWeightMedium(fontWeightMedium) {
        this.fontWeightMedium = fontWeightMedium;
    }
    setFontWeightSemibold(fontWeightSemibold) {
        this.fontWeightSemibold = fontWeightSemibold;
    }
    setFontWeightBold(fontWeightBold) {
        this.fontWeightBold = fontWeightBold;
    }
    setHeading(headingFont) {
        if (headingFont && headingFont.fontSize) {
            this.heading.fontSize = headingFont.fontSize;
        }
        if (headingFont && headingFont.fontWeight) {
            this.heading.fontWeight = headingFont.fontWeight;
        }
    }
    setName(nameFont) {
        if (nameFont && nameFont.fontSize) {
            this.name.fontSize = nameFont.fontSize;
        }
        if (nameFont && nameFont.fontWeight) {
            this.name.fontWeight = nameFont.fontWeight;
        }
    }
    setTitle1(titleFont) {
        if (titleFont && titleFont.fontSize) {
            this.title1.fontSize = titleFont.fontSize;
        }
        if (titleFont && titleFont.fontWeight) {
            this.title1.fontWeight = titleFont.fontWeight;
        }
    }
    setTitle2(titleFont) {
        if (titleFont && titleFont.fontSize) {
            this.title2.fontSize = titleFont.fontSize;
        }
        if (titleFont && titleFont.fontWeight) {
            this.title2.fontWeight = titleFont.fontWeight;
        }
    }
    setSubtitle1(subtitleFont) {
        if (subtitleFont && subtitleFont.fontSize) {
            this.subtitle1.fontSize = subtitleFont.fontSize;
        }
        if (subtitleFont && subtitleFont.fontWeight) {
            this.subtitle1.fontWeight = subtitleFont.fontWeight;
        }
    }
    setSubtitle2(subtitleFont) {
        if (subtitleFont && subtitleFont.fontSize) {
            this.subtitle2.fontSize = subtitleFont.fontSize;
        }
        if (subtitleFont && subtitleFont.fontWeight) {
            this.subtitle2.fontWeight = subtitleFont.fontWeight;
        }
    }
    setText1(textFont) {
        if (textFont && textFont.fontSize) {
            this.text1.fontSize = textFont.fontSize;
        }
        if (textFont && textFont.fontWeight) {
            this.text1.fontWeight = textFont.fontWeight;
        }
    }
    setText2(textFont) {
        if (textFont && textFont.fontSize) {
            this.text2.fontSize = textFont.fontSize;
        }
        if (textFont && textFont.fontWeight) {
            this.text2.fontWeight = textFont.fontWeight;
        }
    }
    setText3(textFont) {
        if (textFont && textFont.fontSize) {
            this.text3.fontSize = textFont.fontSize;
        }
        if (textFont && textFont.fontWeight) {
            this.text3.fontWeight = textFont.fontWeight;
        }
    }
    setCaption1(captionFont) {
        if (captionFont && captionFont.fontSize) {
            this.caption1.fontSize = captionFont.fontSize;
        }
        if (captionFont && captionFont.fontWeight) {
            this.caption1.fontWeight = captionFont.fontWeight;
        }
    }
    setCaption2(captionFont) {
        if (captionFont && captionFont.fontSize) {
            this.caption2.fontSize = captionFont.fontSize;
        }
        if (captionFont && captionFont.fontWeight) {
            this.caption2.fontWeight = captionFont.fontWeight;
        }
    }
}
const fontHelper = (obj) => {
    return `${obj.fontWeight} ${obj.fontSize} ${obj.fontFamily}`;
};
new CometChatTypography({});

class CometChatTheme {
    constructor({ palette = new CometChatPalette({}), typography = new CometChatTypography({}), }) {
        this.palette = new CometChatPalette({});
        this.typography = new CometChatTypography({});
        this.palette = palette;
        this.typography = typography;
    }
}

class CometChatMessageComposerAction {
    constructor(props) {
        this.id = "";
        this.iconURL = "";
        this.iconTint = "";
        this.onClick = null;
        this.title = "";
        this.titleFont = "";
        this.titleColor = "";
        this.background = "";
        this.borderRadius = ""; //create actionItem datamodel in web component
        Object.assign(this, props);
    }
}

class CometChatOption {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.titleFont = "";
        this.titleColor = "";
        this.backgroundColor = "";
        this.iconTint = "";
        this.onClick = null;
        Object.assign(this, props);
    }
}

/**
 * @class CometChatMessageOption
 * @description CometChatMessageOption class is used for defining the message options.
 *  * @param {string} id
 * @param {string} title
 * @param {string} iconURL
 * @param {any} onClick
 * @param {string} titleFont
 *  @param {string} titleColor
 *  @param {string} backgroundColor
 *   @param {string} iconTint
 */
class CometChatMessageOption extends CometChatOption {
    constructor({ id = "", title = "", iconURL = "", onClick = null, titleFont = "", titleColor = "", backgroundColor = "", iconTint = "" }) {
        super({ id, onClick, iconURL, title, titleFont, titleColor, backgroundColor, iconTint });
    }
    ;
}

// template
/**
 * @class CometChatMessageTemplate
 * @description CometChatMessageTemplate class is used for defining the message templates.
 *
 * @param {String} type
 *  @param {String} category
 * @param {any} contentView
 * @param {any} bubbleView
 * @param {any} headerView
 * @param {any} footerView
 * @param {typeof getMessageOptions} options
 */
class CometChatMessageTemplate {
    constructor(props) {
        this.contentView = null;
        this.category = "";
        Object.assign(this, props);
    }
}

class CometChatTabItem {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.style = {};
        this.childView = null;
        this.isActive = false;
        Object.assign(this, props);
    }
}

class CometChatDetailsOption {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.titleFont = "";
        this.titleColor = "";
        this.backgroundColor = "";
        this.iconTint = "";
        this.onClick = null;
        Object.assign(this, props);
    }
}

class CometChatDetailsTemplate {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.titleFont = "";
        this.titleColor = "";
        this.sectionSeparatorColor = "";
        this.itemSeparatorColor = "";
        this.hideSectionSeparator = true;
        this.hideItemSeparator = true;
        Object.assign(this, props);
    }
}

class CometChatCallDetailsOption {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.iconURL = "";
        this.titleFont = "";
        this.titleColor = "";
        this.backgroundColor = "";
        this.iconTint = "";
        this.onClick = null;
        Object.assign(this, props);
    }
}

class CometChatCallDetailsTemplate {
    constructor(props) {
        this.id = "";
        this.title = "";
        this.titleFont = "";
        this.titleColor = "";
        this.sectionSeparatorColor = "";
        this.itemSeparatorColor = "";
        this.hideSectionSeparator = true;
        this.hideItemSeparator = true;
        Object.assign(this, props);
    }
}

class CometChatActions {
    constructor(options) {
        this.id = options.id;
        this.title = options.title;
        this.iconURL = options.iconURL;
        this.titleFont = options.titleFont;
        this.iconTint = options.iconTint || "rgba(20, 20, 20, 0.58)";
        this.titleColor = options.titleColor;
        this.backgroundColor = options.backgroundColor;
    }
}

class CometChatActionsIcon extends CometChatActions {
    constructor(options) {
        super(options);
        this.onClick = options.onClick;
    }
}

class CometChatActionsView extends CometChatActions {
    constructor(options) {
        super(options);
        this.customView = options.customView;
    }
}

exports.DatePatterns = void 0;
(function (DatePatterns) {
    DatePatterns[DatePatterns["time"] = 0] = "time";
    DatePatterns[DatePatterns["DayDate"] = 1] = "DayDate";
    DatePatterns[DatePatterns["DayDateTime"] = 2] = "DayDateTime";
    DatePatterns[DatePatterns["DateTime"] = 3] = "DateTime";
})(exports.DatePatterns || (exports.DatePatterns = {}));
exports.AuxiliaryButtonAlignment = void 0;
(function (AuxiliaryButtonAlignment) {
    AuxiliaryButtonAlignment[AuxiliaryButtonAlignment["left"] = 0] = "left";
    AuxiliaryButtonAlignment[AuxiliaryButtonAlignment["right"] = 1] = "right";
})(exports.AuxiliaryButtonAlignment || (exports.AuxiliaryButtonAlignment = {}));
exports.Placement = void 0;
(function (Placement) {
    Placement["top"] = "top";
    Placement["right"] = "right";
    Placement["bottom"] = "bottom";
    Placement["left"] = "left";
})(exports.Placement || (exports.Placement = {}));
exports.MessageListAlignment = void 0;
(function (MessageListAlignment) {
    MessageListAlignment[MessageListAlignment["left"] = 0] = "left";
    MessageListAlignment[MessageListAlignment["standard"] = 1] = "standard";
})(exports.MessageListAlignment || (exports.MessageListAlignment = {}));
exports.MessageBubbleAlignment = void 0;
(function (MessageBubbleAlignment) {
    MessageBubbleAlignment[MessageBubbleAlignment["left"] = 0] = "left";
    MessageBubbleAlignment[MessageBubbleAlignment["right"] = 1] = "right";
    MessageBubbleAlignment[MessageBubbleAlignment["center"] = 2] = "center";
})(exports.MessageBubbleAlignment || (exports.MessageBubbleAlignment = {}));
exports.DocumentIconAlignment = void 0;
(function (DocumentIconAlignment) {
    DocumentIconAlignment[DocumentIconAlignment["left"] = 0] = "left";
    DocumentIconAlignment[DocumentIconAlignment["right"] = 1] = "right";
})(exports.DocumentIconAlignment || (exports.DocumentIconAlignment = {}));
exports.TabAlignment = void 0;
(function (TabAlignment) {
    TabAlignment[TabAlignment["top"] = 0] = "top";
    TabAlignment[TabAlignment["bottom"] = 1] = "bottom";
    TabAlignment[TabAlignment["left"] = 2] = "left";
    TabAlignment[TabAlignment["right"] = 3] = "right";
})(exports.TabAlignment || (exports.TabAlignment = {}));
exports.MessageStatus = void 0;
(function (MessageStatus) {
    MessageStatus[MessageStatus["inprogress"] = 0] = "inprogress";
    MessageStatus[MessageStatus["success"] = 1] = "success";
    MessageStatus[MessageStatus["error"] = 2] = "error";
})(exports.MessageStatus || (exports.MessageStatus = {}));
exports.Receipts = void 0;
(function (Receipts) {
    Receipts[Receipts["wait"] = 0] = "wait";
    Receipts[Receipts["sent"] = 1] = "sent";
    Receipts[Receipts["delivered"] = 2] = "delivered";
    Receipts[Receipts["read"] = 3] = "read";
    Receipts[Receipts["error"] = 4] = "error";
})(exports.Receipts || (exports.Receipts = {}));
exports.TitleAlignment = void 0;
(function (TitleAlignment) {
    TitleAlignment[TitleAlignment["left"] = 0] = "left";
    TitleAlignment[TitleAlignment["center"] = 1] = "center";
})(exports.TitleAlignment || (exports.TitleAlignment = {}));
exports.SelectionMode = void 0;
(function (SelectionMode) {
    SelectionMode[SelectionMode["single"] = 0] = "single";
    SelectionMode[SelectionMode["multiple"] = 1] = "multiple";
    SelectionMode[SelectionMode["none"] = 2] = "none";
})(exports.SelectionMode || (exports.SelectionMode = {}));
exports.States = void 0;
(function (States) {
    States[States["loading"] = 0] = "loading";
    States[States["empty"] = 1] = "empty";
    States[States["error"] = 2] = "error";
    States[States["loaded"] = 3] = "loaded";
})(exports.States || (exports.States = {}));
exports.TimestampAlignment = void 0;
(function (TimestampAlignment) {
    TimestampAlignment[TimestampAlignment["top"] = 0] = "top";
    TimestampAlignment[TimestampAlignment["bottom"] = 1] = "bottom";
})(exports.TimestampAlignment || (exports.TimestampAlignment = {}));
exports.IconButtonAlignment = void 0;
(function (IconButtonAlignment) {
    IconButtonAlignment["top"] = "column";
    IconButtonAlignment["bottom"] = "column-reverse";
    IconButtonAlignment["left"] = "row";
    IconButtonAlignment["right"] = "row-reverse";
})(exports.IconButtonAlignment || (exports.IconButtonAlignment = {}));
exports.RecordingType = void 0;
(function (RecordingType) {
    RecordingType[RecordingType["audio"] = 0] = "audio";
    RecordingType[RecordingType["video"] = 1] = "video";
})(exports.RecordingType || (exports.RecordingType = {}));
exports.TabsVisibility = void 0;
(function (TabsVisibility) {
    TabsVisibility[TabsVisibility["usersAndGroups"] = 0] = "usersAndGroups";
    TabsVisibility[TabsVisibility["users"] = 1] = "users";
    TabsVisibility[TabsVisibility["groups"] = 2] = "groups";
})(exports.TabsVisibility || (exports.TabsVisibility = {}));
exports.CallWorkflow = void 0;
(function (CallWorkflow) {
    CallWorkflow[CallWorkflow["defaultCalling"] = 0] = "defaultCalling";
    CallWorkflow[CallWorkflow["directCalling"] = 1] = "directCalling";
})(exports.CallWorkflow || (exports.CallWorkflow = {}));
exports.PanelAlignment = void 0;
(function (PanelAlignment) {
    PanelAlignment[PanelAlignment["composerHeader"] = 0] = "composerHeader";
    PanelAlignment[PanelAlignment["messageListHeader"] = 1] = "messageListHeader";
    PanelAlignment[PanelAlignment["messageListFooter"] = 2] = "messageListFooter";
    PanelAlignment[PanelAlignment["messages"] = 3] = "messages";
})(exports.PanelAlignment || (exports.PanelAlignment = {}));
exports.LabelAlignment = void 0;
(function (LabelAlignment) {
    LabelAlignment["top"] = "column";
    LabelAlignment["bottom"] = "column-reverse";
    LabelAlignment["left"] = "row";
    LabelAlignment["right"] = "row-reverse";
})(exports.LabelAlignment || (exports.LabelAlignment = {}));
exports.ElementType = void 0;
(function (ElementType) {
    ElementType["label"] = "label";
    ElementType["text"] = "textInput";
    ElementType["dropdown"] = "dropdown";
    ElementType["checkbox"] = "checkbox";
    ElementType["radio"] = "radio";
    ElementType["button"] = "button";
    ElementType["singleSelect"] = "singleSelect";
})(exports.ElementType || (exports.ElementType = {}));
exports.ButtonAction = void 0;
(function (ButtonAction) {
    ButtonAction["apiAction"] = "apiAction";
    ButtonAction["urlNavigation"] = "urlNavigation";
    ButtonAction["custom"] = "custom";
})(exports.ButtonAction || (exports.ButtonAction = {}));
exports.HTTPSRequestMethods = void 0;
(function (HTTPSRequestMethods) {
    HTTPSRequestMethods["POST"] = "POST";
    HTTPSRequestMethods["PUT"] = "PUT";
    HTTPSRequestMethods["PATCH"] = "PATCH";
    HTTPSRequestMethods["DELETE"] = "DELETE";
})(exports.HTTPSRequestMethods || (exports.HTTPSRequestMethods = {}));

/**
 * Represents an action that can be performed on a UI element, such as a button.
 */
class ActionEntity {
    /**
     * Creates an instance of the ActionEntity class.
     * @param {ButtonAction} actionType - The type of action that the button performs.
     */
    constructor(actionType) {
        this.actionType = actionType;
    }
    /**
     * Returns the type of action to perform when the UI element is interacted with.
     * @returns {ButtonAction} The type of action to perform when the UI element is interacted with.
     */
    getActionType() {
        return this.actionType;
    }
    static fromJSON(json) {
        switch (json.actionType) {
            case exports.ButtonAction.apiAction:
                return APIAction.fromJSON(json);
            case exports.ButtonAction.urlNavigation:
                return URLNavigationAction.fromJSON(json);
            default:
                return CustomAction.fromJSON();
        }
    }
}

/**
 * Represents an API action that can be performed on a dynamic form.
 */
class APIAction extends ActionEntity {
    /**
     * Creates a new instance of the APIAction class.
     * @param {string} url - The URL to which the API action should be performed.
     * @param {string} method - The HTTP method to be used for the API action.
     */
    constructor(url, method) {
        super(exports.ButtonAction.apiAction);
        /**
         * The payload to be sent with the API action.
         */
        this.payload = {};
        /**
         * The headers to be sent with the API action.
         */
        this.headers = {};
        /**
         * The key to be used to insert the data in the provided payload.
         */
        this.dataKey = "CometChatData";
        this.url = url || "https://example.com";
        this.method = method || exports.HTTPSRequestMethods.POST;
    }
    /**
     * Returns the URL to which the API action should be performed.
     * @returns {string} The URL to which the API action should be performed.
     */
    getURL() {
        return this.url;
    }
    /**
     * Returns the HTTP method to be used for the API action.
     * @returns {string} The HTTP method to be used for the API action.
     */
    getMethod() {
        return this.method;
    }
    /**
     * Returns the payload to be sent with the API action.
     * @returns {Object} The payload to be sent with the API action.
     */
    getPayload() {
        return this.payload;
    }
    /**
     * Sets the payload to be sent with the API action.
     * @param {Object} payload - The payload to be sent with the API action.
     */
    setPayload(payload) {
        this.payload = payload;
    }
    /**
     * Returns the headers to be sent with the API action.
     * @returns {Object} The headers to be sent with the API action.
     */
    getHeaders() {
        return this.headers;
    }
    /**
     * Sets the headers to be sent with the API action.
     * @param {Object} headers - The headers to be sent with the API action.
     */
    setHeaders(headers) {
        this.headers = headers;
    }
    /**
     * Returns the key to be used to insert the data in the provided payload.
     * @returns {string} The key to be used to insert the data in the provided payload.
     */
    getDataKey() {
        return this.dataKey;
    }
    /**
     * Sets the key to be used to insert the data in the provided payload.
     * @param {string} dataKey - The key to be used to insert the data in the provided payload.
     */
    setDataKey(dataKey) {
        this.dataKey = dataKey;
    }
    static fromJSON(json) {
        const apiAction = new APIAction(json.url, json.method);
        if (json.payload)
            apiAction.setPayload(json.payload);
        if (json.headers)
            apiAction.setHeaders(json.headers);
        if (json.dataKey)
            apiAction.setDataKey(json.dataKey);
        return apiAction;
    }
}

/**
 * Represents a URL navigation action that can be performed on a dynamic form.
 */
class URLNavigationAction extends ActionEntity {
    /**
     * Creates a new instance of the URLNavigationAction class.
     * @param {string} url - The URL to navigate to.
     */
    constructor(url) {
        super(exports.ButtonAction.urlNavigation);
        this.url = url || "https://example.com";
    }
    /**
     * Returns the URL to navigate to.
     * @returns {string} The URL to navigate to.
     */
    getURL() {
        return this.url;
    }
    static fromJSON(json) {
        return new URLNavigationAction(json.url);
    }
}

/**
 * Represents a custom action entity.
 */
class CustomAction extends ActionEntity {
    constructor() {
        super(exports.ButtonAction.custom);
    }
    /**
     * Creates a new CustomAction object from a JSON object.
     * @returns A new CustomAction object created from the JSON object.
     */
    static fromJSON() {
        return new CustomAction();
    }
}

/**
 * Represents the base input for a dynamic form element.
 */
class ElementEntity {
    constructor(elementId, elementType) {
        this.elementId = elementId || "";
        this.elementType = elementType || "";
    }
    /**
     * Returns the type of the form element.
     * @returns {string} The type of the form element.
     */
    getElementType() {
        return this.elementType;
    }
    /**
     * Returns the unique identifier of the form element.
     * @returns {string} The unique identifier of the form element.
     */
    getElementId() {
        return this.elementId;
    }
    static fromJSON(json) {
        switch (json.elementType) {
            case exports.ElementType.text:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.checkbox:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.dropdown:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.radio:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.singleSelect:
                return BaseInputElement.fromJSON(json);
            case exports.ElementType.button:
                return BaseInteractiveElement.fromJSON(json);
            case exports.ElementType.label:
                return LabelElement.fromJSON(json);
            default:
                return LabelElement.fromJSON({
                    elementId: "1",
                    elementType: exports.ElementType.label,
                    text: "unknown element type",
                });
        }
    }
}

/**
 * Represents the base input for a dynamic form element.
 */
class BaseInputElement extends ElementEntity {
    /**
     * Creates a new instance of the BaseInputElement class.
     * @param {string} elementId - The unique identifier of the form element.
     * @param {string} elementType - The type of the form element.
     */
    constructor(elementId, elementType) {
        super(elementId, elementType);
        /**
         * Whether the input element is optional or required.
         * */
        this.optional = true;
    }
    /**
     * Sets the response of an input.
     */
    setResponse(response) {
        this.response = response;
    }
    /**
     * Returns the response of an input.
     * @returns {T} The response of an input.
     */
    getResponse() {
        return this.response;
    }
    /**
 * Returns whether the element is optional or required.
 * @returns {boolean} Whether the element is optional or required.
 */
    getOptional() {
        return this.optional;
    }
    /**
     * Sets whether the element is optional or required.
     * @param {boolean} optional - Whether the element is optional or required.
     */
    setOptional(optional) {
        let optionalValue;
        if (typeof optional === "boolean" || typeof optional === "string") {
            optionalValue = optional === "true" ? true : optional === "false" ? false : optional;
        }
        else {
            optionalValue = true;
        }
        this.optional = optionalValue;
    }
    static fromJSON(json) {
        switch (json.elementType) {
            case exports.ElementType.text:
                const element = TextInputElement.fromJSON(json);
                element.setOptional(json.optional);
                return element;
            case exports.ElementType.checkbox:
                const checkboxElement = CheckboxElement.fromJSON(json);
                checkboxElement.setOptional(json.optional);
                return checkboxElement;
            case exports.ElementType.dropdown:
                const dropdownElement = DropdownElement.fromJSON(json);
                dropdownElement.setOptional(json.optional);
                return dropdownElement;
            case exports.ElementType.radio:
                const radioButtonElement = RadioButtonElement.fromJSON(json);
                radioButtonElement.setOptional(json.optional);
                return radioButtonElement;
            case exports.ElementType.singleSelect:
                const singleSelectElement = SingleSelectElement.fromJSON(json);
                singleSelectElement.setOptional(json.optional);
                return singleSelectElement;
            default:
                return TextInputElement.fromJSON({
                    elementId: "1",
                    elementType: exports.ElementType.text,
                    label: "Label",
                });
        }
    }
}

/**
 * Represents a base interactive element in a interactive message.
 */
class BaseInteractiveElement extends ElementEntity {
    constructor(elementId, elementType, action) {
        super(elementId, elementType);
        if (action instanceof APIAction || action instanceof URLNavigationAction || action instanceof CustomAction) {
            this.action = action;
        }
        else {
            this.action = ActionEntity.fromJSON(action);
        }
    }
    /**
     * Returns the action associated with the bubble.
     * @returns {APIAction | URLNavigationAction | CustomAction} The action associated with the bubble.
     */
    getAction() {
        return this.action;
    }
    static fromJSON(json) {
        switch (json.elementType) {
            case exports.ElementType.button:
                return ButtonElement.fromJSON(json);
            default:
                return ButtonElement.fromJSON({
                    elementId: "1",
                    elementType: exports.ElementType.button,
                    buttonText: "Button",
                    action: new CustomAction()
                });
        }
    }
}

/**
 * Represents a button element that can be added to a interactive bubble.
 */
class ButtonElement extends BaseInteractiveElement {
    /**
     * Creates an instance of ButtonInput.
     * @param elementId - The unique identifier for the button element.
     * @param action - The action to be performed when the button is clicked.
     * @param buttonText - The text to display on the button.
     */
    constructor(elementId, action, buttonText) {
        super(elementId, exports.ElementType.button, action);
        /**
         * Whether the button should be disabled after it is interacted with.
         * */
        this.disableAfterInteracted = true;
        this.buttonText = buttonText || "";
    }
    /**
     * Gets the text to display on the button.
     * @returns The text to display on the button.
     */
    getButtonText() {
        return this.buttonText;
    }
    /**
     * Gets whether the button should be disabled after it is interacted with.
     * @returns Whether the button should be disabled after it is interacted with.
     */
    getDisableAfterInteracted() {
        return this.disableAfterInteracted;
    }
    /**
     * Sets whether the button should be disabled after it is interacted with.
     * @param disableAfterInteracted - Whether the button should be disabled after it is interacted with.
     */
    setDisableAfterInteracted(disableAfterInteracted) {
        this.disableAfterInteracted = disableAfterInteracted;
    }
    static fromJSON(json) {
        const action = ActionEntity.fromJSON(json.action);
        const buttonElement = new ButtonElement(json.elementId, action, json.buttonText);
        if (json.disableAfterInteracted)
            buttonElement.setDisableAfterInteracted(json.disableAfterInteracted);
        return buttonElement;
    }
}

/**
 * Represents a checkbox input element.
 */
class CheckboxElement extends BaseInputElement {
    /**
     * Creates a new instance of the CheckboxInput class.
     * @param elementId The ID of the input element.
     * @param label The label of the input element.
     * @param options The options available for the checkbox input element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.checkbox);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Sets the default values to be selected in the checkbox.
     * @param defaultValue The default values to be selected in the checkbox.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the default values to be selected in the checkbox.
     * @returns The default values to be selected in the checkbox.
     * */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Gets the options available for the checkbox input element.
     * @returns The options available for the checkbox input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const checkboxElement = new CheckboxElement(json.elementId, json.label, options);
        if (json.defaultValue)
            checkboxElement.setDefaultValue(json.defaultValue);
        return checkboxElement;
    }
}

/**
 * Represents a dropdown input element.
 */
class DropdownElement extends BaseInputElement {
    /**
     * Creates a new instance of DropdownInput.
     * @param elementId - The ID of the input element.
     * @param label - The label of the input element.
     * @param options - The options available for the dropdown input element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.dropdown);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Gets the default value to be selected in the dropdown.
     * @returns The default value to be selected in the dropdown.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value to be selected in the dropdown.
     * @param defaultValue - The default value to be selected in the dropdown.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the options available for the dropdown input element.
     * @returns The options available for the dropdown input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const dropdownElement = new DropdownElement(json.elementId, json.label, options);
        if (json.defaultValue)
            dropdownElement.setDefaultValue(json.defaultValue);
        return dropdownElement;
    }
}

/**
 * Represents a label element.
 */
class LabelElement extends ElementEntity {
    /**
     * Creates a new instance of the LabelElement class.
     * @param {string} elementId - The unique identifier of the form element.
     * @param {string} text - The text to display in the label.
     */
    constructor(elementId, text) {
        super(elementId, exports.ElementType.label);
        this.text = text || "";
    }
    /**
     * Returns the text to display in the label.
     * @returns {string} The text to display in the label.
     */
    getText() {
        return this.text;
    }
    static fromJSON(json) {
        return new LabelElement(json.elementId, json.text);
    }
}

/**
 * Represents a option.
 */
class OptionElement {
    /**
     * Creates a new instance of the OptionElement class.
     * @param {string} label - The unique identifier for the option.
     * @param {string} value - The display value for the option.
     */
    constructor(label, value) {
        this.label = label || "";
        this.value = value || "";
    }
    /**
     * Returns the unique identifier for the option.
     * @returns {string} The unique identifier for the option.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Returns the display value for the option.
     * @returns {string} The display value for the option.
     */
    getValue() {
        return this.value;
    }
    static fromJSON(json) {
        return new OptionElement(json.label, json.value);
    }
}

/**
 * Represents a radio button input element.
 */
class RadioButtonElement extends BaseInputElement {
    /**
     * Creates a new instance of the RadioButtonElement class.
     * @param elementId The ID of the radio button element.
     * @param label The label of the radio button element.
     * @param options The options available for the radio button element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.radio);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Gets the default value of the input element.
     * @returns The default value of the input element.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value of the input element.
     * @param defaultValue The default value of the input element.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the options available for the radio input element.
     * @returns The options available for the radio input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const radioButtonElement = new RadioButtonElement(json.elementId, json.label, options);
        if (json.defaultValue)
            radioButtonElement.setDefaultValue(json.defaultValue);
        return radioButtonElement;
    }
}

/**
 * Represents a singleSelect button input element.
 */
class SingleSelectElement extends BaseInputElement {
    /**
     * Creates a new instance of the SingleSelectElement class.
     * @param elementId The ID of the singleSelect button element.
     * @param label The label of the singleSelect button element.
     * @param options The options available for the singleSelect button element.
     */
    constructor(elementId, label, options = []) {
        super(elementId, exports.ElementType.singleSelect);
        this.label = label || "";
        this.options = options.map((option) => {
            if (option instanceof OptionElement) {
                return option;
            }
            else {
                return OptionElement.fromJSON(option);
            }
        });
    }
    /**
     * Gets the label of the input element.
     * @returns The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Gets the default value of the input element.
     * @returns The default value of the input element.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value of the input element.
     * @param defaultValue The default value of the input element.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    /**
     * Gets the options available for the singleSelect input element.
     * @returns The options available for the singleSelect input element.
     */
    getOptions() {
        return this.options;
    }
    static fromJSON(json) {
        const options = ((json === null || json === void 0 ? void 0 : json.options) || []).map((option) => {
            return OptionElement.fromJSON(option);
        });
        const singleSelectElement = new SingleSelectElement(json.elementId, json.label, options);
        if (json.defaultValue)
            singleSelectElement.setDefaultValue(json.defaultValue);
        return singleSelectElement;
    }
}

/**
 * Represents a text input element.
 */
class TextInputElement extends BaseInputElement {
    /**
     * Creates a new instance of the TextInputElement class.
     * @param {string} elementId - The unique identifier of the form element.
     * @param {string} label - The label of the input element.
     */
    constructor(elementId, label) {
        super(elementId, exports.ElementType.text);
        /** The maximum number of lines for a multi-line text input element. */
        this.maxLines = 1;
        /** The placeholder text to display in the input element. */
        this.placeholder = {
            text: "Enter text here..."
        };
        this.label = label || "";
    }
    /**
     * Returns the label of the input element.
     * @returns {string} The label of the input element.
     */
    getLabel() {
        return this.label;
    }
    /**
     * Returns the maximum number of lines for a multi-line text input element.
     * @returns {number} The maximum number of lines for a multi-line text input element.
     */
    getMaxLines() {
        return this.maxLines;
    }
    /**
     * Sets the maximum number of lines for a multi-line text input element.
     * @param {number} maxLines - The maximum number of lines for a multi-line text input element.
     */
    setMaxLines(maxLines) {
        this.maxLines = maxLines;
    }
    /**
     * Returns the placeholder text to display in the input element.
     * @returns {string} The placeholder text to display in the input element.
     */
    getPlaceholder() {
        var _a;
        return (_a = this === null || this === void 0 ? void 0 : this.placeholder) === null || _a === void 0 ? void 0 : _a.text;
    }
    /**
     * Sets the placeholder text to display in the input element.
     * @param {string} placeholder - The placeholder text to display in the input element.
     */
    setPlaceholder(placeholder) {
        this.placeholder = {
            text: placeholder
        };
    }
    /**
     * Returns the default value in text input.
     * @returns {string} The default value in text input.
     */
    getDefaultValue() {
        return this.defaultValue;
    }
    /**
     * Sets the default value in text input.
     * @param {string} defaultValue - The default value in text input.
     * @returns {string} The default value in text input.
     */
    setDefaultValue(defaultValue) {
        this.defaultValue = defaultValue;
    }
    static fromJSON(json) {
        var _a;
        const textInput = new TextInputElement(json.elementId, json.label);
        if (json.maxLines)
            textInput.setMaxLines(json.maxLines);
        if (json.placeholder && json.placeholder.text)
            textInput.setPlaceholder((_a = json.placeholder) === null || _a === void 0 ? void 0 : _a.text);
        if (json.defaultValue)
            textInput.setDefaultValue(json.defaultValue);
        return textInput;
    }
}

/**
 * Represents a form message that extends CometChat's InteractiveMessage class.
 * @extends CometChat.InteractiveMessage
 */
class FormMessage extends chatSdkJavascript.CometChat.InteractiveMessage {
    /**
     * Represents a form message that can be sent via CometChat.
     */
    constructor(receiverId, receiverType, title, formFields, submitElement) {
        super(receiverId, receiverType, CometChatUIKitConstants.MessageTypes.form, {});
        this.title = title || "";
        this.formFields = formFields || [];
        this.submitElement = submitElement;
        this.setInteractiveData({ title, formFields, submitElement });
    }
    /**
     * Sets the interactive form data for the message.
     * @param {InteractiveFormData} interactiveFormData - The interactive form data to be set.
     */
    setInteractiveData(formData) {
        const title = formData.title || this.title;
        const formFields = formData.formFields || this.formFields;
        const submitElement = formData.submitElement || this.submitElement;
        const goalCompletionText = formData.goalCompletionText || this.goalCompletionText;
        const data = {
            title: title,
            formFields: formFields,
            submitElement: submitElement,
        };
        if (goalCompletionText) {
            data.goalCompletionText = goalCompletionText;
        }
        super.setInteractiveData(data);
        if (title)
            this.title = title;
        if (formFields)
            this.formFields = formFields;
        if (submitElement)
            this.submitElement = submitElement;
        if (goalCompletionText)
            this.goalCompletionText = goalCompletionText;
    }
    getInteractiveData() {
        const data = {
            title: this.title,
            formFields: this.formFields,
            submitElement: this.submitElement,
        };
        if (this.goalCompletionText) {
            data["goalCompletionText"] = this.goalCompletionText;
        }
        return data;
    }
    /**
     * Returns the form fields of the form.
     * @returns An array of form fields.
     */
    getFormFields() {
        return this.formFields;
    }
    /**
     * Returns the title of the form.
     * @returns The title of the form.
     */
    getTitle() {
        return this.title;
    }
    /**
     * Returns the submit button of the form.
     * @returns The submit button of the form.
     */
    getSubmitElement() {
        return this.submitElement;
    }
    /**
     * Returns the goal completion text of the form.
     * @returns The goal completion text of the form.
     */
    getGoalCompletionText() {
        return this.goalCompletionText;
    }
    /**
     * Sets the goal completion text of the form.
     * @param goalCompletionText - The goal completion text of the form.
     */
    setGoalCompletionText(goalCompletionText) {
        this.goalCompletionText = goalCompletionText;
        this.setInteractiveData({ goalCompletionText });
    }
    static fromJSON(json) {
        var _a;
        const data = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.interactiveData;
        const formFields = ((data === null || data === void 0 ? void 0 : data.formFields) || []).map((field) => {
            return ElementEntity.fromJSON(field);
        });
        const submitElement = ButtonElement.fromJSON(data.submitElement);
        const goalCompletionText = data === null || data === void 0 ? void 0 : data.goalCompletionText;
        const formMessage = new FormMessage(json.receiver, json.receiverType, data === null || data === void 0 ? void 0 : data.title, formFields, submitElement);
        if (goalCompletionText) {
            formMessage.setGoalCompletionText(goalCompletionText);
        }
        Object.assign(formMessage, json);
        return formMessage;
    }
}

/**
 * Represents a card message for CometChat.
 * @extends CometChat.InteractiveMessage
 */
class CardMessage extends chatSdkJavascript.CometChat.InteractiveMessage {
    /**
     * Creates a new instance of CardMessage.
     * @param receiverId - The ID of the receiver.
     * @param receiverType - The type of the receiver.
     * @param text - The text to display on the card.
     * @param cardActions - The actions to perform when the card is interacted with.
     */
    constructor(receiverId, receiverType, text, cardActions) {
        super(receiverId, receiverType, CometChatUIKitConstants.MessageTypes.card, {});
        this.text = text;
        this.cardActions = cardActions;
        this.setInteractiveData({ text, cardActions });
    }
    /**
     * Gets the URL of the image for the card.
     * @returns The URL of the image.
     */
    getImageUrl() {
        return this.imageUrl;
    }
    /**
     * Sets the image URL for the interactive card data.
     * @param imageUrl - The URL of the image to be set.
     */
    setImageUrl(imageUrl) {
        this.imageUrl = imageUrl;
        this.setInteractiveData({ imageUrl });
    }
    /**
     * Gets the text to display on the card.
     * @returns The text to display.
     */
    getText() {
        return this.text;
    }
    /**
     * Gets the actions to perform when the card is interacted with.
     * @returns The actions to perform.
     */
    getCardActions() {
        return this.cardActions;
    }
    /**
     * Sets the interactive data for the card message.
     * @param json - The partial data to set.
     */
    setInteractiveData(json) {
        const text = json.text || this.text;
        const cardActions = json.cardActions || this.cardActions;
        const imageUrl = json.imageUrl || this.imageUrl;
        const data = {
            text: text,
            cardActions: cardActions,
        };
        if (imageUrl) {
            data.imageUrl = imageUrl;
        }
        super.setInteractiveData(data);
        if (text)
            this.text = text;
        if (cardActions)
            this.cardActions = cardActions;
        if (imageUrl)
            this.imageUrl = imageUrl;
    }
    /**
     * Gets the interactive data for the card message.
     * @returns The interactive data.
     */
    getInteractiveData() {
        const data = {
            text: this.text,
            cardActions: this.cardActions,
        };
        if (this.imageUrl) {
            data.imageUrl = this.imageUrl;
        }
        return data;
    }
    /**
     * Creates a new instance of CardMessage from the provided JSON.
     * @param json - The JSON to create the instance from.
     * @returns The new instance of CardMessage.
     */
    static fromJSON(json) {
        var _a;
        const data = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.interactiveData;
        const cardActions = ((data === null || data === void 0 ? void 0 : data.cardActions) || []).map((action) => {
            return ButtonElement.fromJSON(action);
        });
        const imageUrl = data === null || data === void 0 ? void 0 : data.imageUrl;
        const cardMessage = new CardMessage(json.receiverId, json.receiverType, data === null || data === void 0 ? void 0 : data.text, cardActions);
        if (imageUrl)
            cardMessage.setImageUrl(imageUrl);
        Object.assign(cardMessage, json);
        return cardMessage;
    }
}

/**
 * Represents a custom interactive message that extends CometChat's InteractiveMessage class.
 * @extends CometChat.InteractiveMessage
 */
class CustomInteractiveMessage extends chatSdkJavascript.CometChat.InteractiveMessage {
    /**
     * Creates a new instance of CustomInteractiveMessage.
     * @param receiverId - The ID of the receiver of the message.
     * @param receiverType - The type of the receiver of the message.
     * @param json - The JSON object to create the CustomInteractiveMessage object from.
     */
    constructor(receiverId, receiverType, json) {
        super(receiverId, receiverType, CometChatUIKitConstants.MessageTypes.customInteractive, json);
    }
    /**
     * Static method to create a CustomInteractiveMessage object from a JSON object.
     * @param json - JSON object to create the CustomInteractiveMessage object from.
     * @returns CustomInteractiveMessage object.
     */
    static fromJSON(json) {
        var _a;
        const data = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.interactiveData;
        const customInteractiveMessage = new CustomInteractiveMessage(json.receiverId, json.receiverType, data);
        Object.assign(customInteractiveMessage, json);
        return customInteractiveMessage;
    }
}

class CometChatUIEvents {
}
CometChatUIEvents.ccHidePanel = new rxjs.Subject();
CometChatUIEvents.ccShowPanel = new rxjs.Subject();
CometChatUIEvents.ccShowModal = new rxjs.Subject();
CometChatUIEvents.ccHideModal = new rxjs.Subject();
CometChatUIEvents.ccShowDialog = new rxjs.Subject();
CometChatUIEvents.ccHideDialog = new rxjs.Subject();
CometChatUIEvents.ccActiveChatChanged = new rxjs.Subject();
CometChatUIEvents.ccShowOngoingCall = new rxjs.Subject();
CometChatUIEvents.ccOpenChat = new rxjs.Subject();
CometChatUIEvents.ccComposeMessage = new rxjs.Subject();

class CometChatCallEvents {
}
CometChatCallEvents.ccOutgoingCall = new rxjs.Subject();
CometChatCallEvents.ccCallAccepted = new rxjs.Subject();
CometChatCallEvents.ccCallRejected = new rxjs.Subject();
CometChatCallEvents.ccCallEnded = new rxjs.Subject();

class CometChatConversationEvents {
    /**
     * @param  {any} event
     * @param  {any} item
     */
    static publishEvent(event, conversation) {
        event.next(conversation);
    }
}
CometChatConversationEvents.ccConversationDeleted = new rxjs.Subject();

class CometChatGroupEvents {
    /**
     * @param  {any} event
     * @param  {any} item
     */
    static publishEvent(event, group) {
        event.next(group);
    }
}
CometChatGroupEvents.ccGroupCreated = new rxjs.Subject();
CometChatGroupEvents.ccGroupDeleted = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberJoined = new rxjs.Subject();
CometChatGroupEvents.ccGroupLeft = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberAdded = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberScopeChanged = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberKicked = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberBanned = new rxjs.Subject();
CometChatGroupEvents.ccGroupMemberUnbanned = new rxjs.Subject();
CometChatGroupEvents.ccOwnershipChanged = new rxjs.Subject();

class CometChatMessageEvents {
    /**
     * name of the event to publish
     * @param  {any} event
     * item to pass in that event
     * @param  {any} item
     */
    static publishEvent(event, item = null) {
        event.next(item);
    }
}
CometChatMessageEvents.ccMessageSent = new rxjs.Subject();
CometChatMessageEvents.ccMessageEdited = new rxjs.Subject();
CometChatMessageEvents.ccMessageTranslated = new rxjs.Subject();
CometChatMessageEvents.ccLiveReaction = new rxjs.Subject();
CometChatMessageEvents.ccMessageRead = new rxjs.Subject();
CometChatMessageEvents.ccMessageDeleted = new rxjs.Subject();
CometChatMessageEvents.onTextMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onMediaMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onCustomMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onTypingStarted = new rxjs.Subject();
CometChatMessageEvents.onTypingEnded = new rxjs.Subject();
CometChatMessageEvents.onMessagesDelivered = new rxjs.Subject();
CometChatMessageEvents.onMessagesRead = new rxjs.Subject();
CometChatMessageEvents.onMessageEdited = new rxjs.Subject();
CometChatMessageEvents.onMessageDeleted = new rxjs.Subject();
CometChatMessageEvents.onTransientMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onCustomInteractiveMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onFormMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onCardMessageReceived = new rxjs.Subject();
CometChatMessageEvents.onInteractionGoalCompleted = new rxjs.Subject();

class CometChatUserEvents {
    /**
     * @param  {Subject<CometChat.User>} event
     * @param  {any} item
     */
    static publishEvent(event, item) {
        event.next(item);
    }
}
CometChatUserEvents.ccUserBlocked = new rxjs.Subject();
CometChatUserEvents.ccUserUnblocked = new rxjs.Subject();

class ChatSdkEventInitializer {
    static attachListeners() {
        chatSdkJavascript.CometChat.addMessageListener(this.messageListenerId, this.getMessageListenerObject());
    }
    static detachListeners() {
        chatSdkJavascript.CometChat.removeMessageListener(this.messageListenerId);
    }
    static getMessageListenerObject() {
        return new chatSdkJavascript.CometChat.MessageListener({
            onTextMessageReceived: (textMessage) => {
                CometChatMessageEvents.onTextMessageReceived.next(textMessage);
            },
            onMediaMessageReceived: (mediaMessage) => {
                CometChatMessageEvents.onMediaMessageReceived.next(mediaMessage);
            },
            onCustomMessageReceived: (customMessage) => {
                CometChatMessageEvents.onCustomMessageReceived.next(customMessage);
            },
            onTypingStarted: (typingIndicator) => {
                CometChatMessageEvents.onTypingStarted.next(typingIndicator);
            },
            onTypingEnded: (typingIndicator) => {
                CometChatMessageEvents.onTypingEnded.next(typingIndicator);
            },
            onMessagesDelivered: (messageReceipt) => {
                CometChatMessageEvents.onMessagesDelivered.next(messageReceipt);
            },
            onMessagesRead: (messageReceipt) => {
                CometChatMessageEvents.onMessagesRead.next(messageReceipt);
            },
            onMessageEdited: (message) => {
                message = classRectifier(message);
                CometChatMessageEvents.onMessageEdited.next(message);
            },
            onMessageDeleted: (message) => {
                message = classRectifier(message);
                CometChatMessageEvents.onMessageDeleted.next(message);
            },
            onTransientMessageReceived: (message) => {
                CometChatMessageEvents.onTransientMessageReceived.next(message);
            },
            onInteractionGoalCompleted: (receipt) => {
                CometChatMessageEvents.onInteractionGoalCompleted.next(receipt);
            },
            onInteractiveMessageReceived: (message) => {
                switch (message.getType()) {
                    case CometChatUIKitConstants.MessageTypes.form:
                        const formMessage = FormMessage.fromJSON(message);
                        CometChatMessageEvents.onFormMessageReceived.next(formMessage);
                        break;
                    case CometChatUIKitConstants.MessageTypes.card:
                        const cardMessage = CardMessage.fromJSON(message);
                        CometChatMessageEvents.onCardMessageReceived.next(cardMessage);
                        break;
                    default:
                        const customInteractiveMessage = CustomInteractiveMessage.fromJSON(message);
                        CometChatMessageEvents.onCustomInteractiveMessageReceived.next(customInteractiveMessage);
                        break;
                }
            },
        });
    }
}
ChatSdkEventInitializer.messageListenerId = `message_listener_${new Date().getTime()}`;
function classRectifier(message) {
    if (message.getCategory() === CometChatUIKitConstants.MessageCategory.interactive) {
        switch (message.getType()) {
            case CometChatUIKitConstants.MessageTypes.form:
                return FormMessage.fromJSON(message);
            case CometChatUIKitConstants.MessageTypes.card:
                return CardMessage.fromJSON(message);
            default:
                return CustomInteractiveMessage.fromJSON(message);
        }
    }
    else {
        return message;
    }
}

exports.APIAction = APIAction;
exports.ActionEntity = ActionEntity;
exports.BaseInputElement = BaseInputElement;
exports.BaseInteractiveElement = BaseInteractiveElement;
exports.ButtonElement = ButtonElement;
exports.CardMessage = CardMessage;
exports.ChatSdkEventInitializer = ChatSdkEventInitializer;
exports.CheckboxElement = CheckboxElement;
exports.CometChatActions = CometChatActions;
exports.CometChatActionsIcon = CometChatActionsIcon;
exports.CometChatActionsView = CometChatActionsView;
exports.CometChatCallDetailsOption = CometChatCallDetailsOption;
exports.CometChatCallDetailsTemplate = CometChatCallDetailsTemplate;
exports.CometChatCallEvents = CometChatCallEvents;
exports.CometChatConversationEvents = CometChatConversationEvents;
exports.CometChatDetailsOption = CometChatDetailsOption;
exports.CometChatDetailsTemplate = CometChatDetailsTemplate;
exports.CometChatFont = CometChatFont;
exports.CometChatGroupEvents = CometChatGroupEvents;
exports.CometChatLocalize = CometChatLocalize;
exports.CometChatMessageComposerAction = CometChatMessageComposerAction;
exports.CometChatMessageEvents = CometChatMessageEvents;
exports.CometChatMessageOption = CometChatMessageOption;
exports.CometChatMessageTemplate = CometChatMessageTemplate;
exports.CometChatOption = CometChatOption;
exports.CometChatPalette = CometChatPalette;
exports.CometChatTabItem = CometChatTabItem;
exports.CometChatTheme = CometChatTheme;
exports.CometChatTypography = CometChatTypography;
exports.CometChatUIEvents = CometChatUIEvents;
exports.CometChatUIKitConstants = CometChatUIKitConstants;
exports.CometChatUserEvents = CometChatUserEvents;
exports.CustomAction = CustomAction;
exports.CustomInteractiveMessage = CustomInteractiveMessage;
exports.DropdownElement = DropdownElement;
exports.ElementEntity = ElementEntity;
exports.FormMessage = FormMessage;
exports.LabelElement = LabelElement;
exports.OptionElement = OptionElement;
exports.PaletteItem = PaletteItem;
exports.RadioButtonElement = RadioButtonElement;
exports.SingleSelectElement = SingleSelectElement;
exports.TextInputElement = TextInputElement;
exports.URLNavigationAction = URLNavigationAction;
exports.fontHelper = fontHelper;
exports.localize = localize;
